/* eslint-disable */
import React from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * @file 工具函数
 * @author zhanglili
 */
var memoize = function memoize(fn) {
  var cache = {};
  return function (n) {
    if (!cache[n]) {
      cache[n] = fn(n);
    }

    return cache[n];
  };
};
var merge = function merge(x, y) {
  if (!x) {
    return y;
  }

  if (!y) {
    return x;
  }

  return _objectSpread({}, x, y);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ee-icon-svg {\n    fill: currentColor;\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n}\n";
styleInject(css);

var computeScaleStyle = memoize(function (n) {
  return {
    display: 'inline-block',
    width: "".concat(n, "em"),
    height: "".concat(n, "em")
  };
});
var createIcon = (function (type, svg) {
  var baseClassName = "ee-icon-svg icon-".concat(type);
  var IconComponent = svg;
  return function (_ref) {
    var className = _ref.className,
        scale = _ref.scale,
        style = _ref.style,
        props = _objectWithoutProperties(_ref, ["className", "scale", "style"]);

    var iconClassName = className ? baseClassName + ' ' + className : baseClassName;
    var scaleStyle = scale ? computeScaleStyle(scale) : null;
    var iconStyle = merge(scaleStyle, style);
    return React.createElement(IconComponent, _extends({}, props, {
      style: iconStyle,
      className: iconClassName
    }));
  };
});

var SVG = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M710.5 303.6c5.5 0 10.1 4.5 10.1 10.1v645.1c0 5.5-4.5 10.1-10.1 10.1H74.1c-5.5 0-10.1-4.5-10.1-10.1V313.7c0-5.5 4.5-10.1 10.1-10.1h636.4zm238.7 0c5.5 0 10.1 4.5 10.1 10.1v39.6c0 5.5-4.5 10.1-10.1 10.1h-49.6v545.8h49.6c5.5 0 10.1 4.5 10.1 10.1v39.6c0 5.5-4.5 10.1-10.1 10.1h-159c-5.5 0-10.1-4.5-10.1-10.1v-39.6c0-5.5 4.5-10.1 10.1-10.1h49.6V363.3h-49.6c-5.5 0-10.1-4.5-10.1-10.1v-39.6c0-5.5 4.5-10.1 10.1-10.1h159zm-288.3 59.7H123.7v545.8h537.2V363.3zM113.6 64.9c5.5 0 10.1 4.5 10.1 10.1v49.5h537.2V75c0-5.5 4.5-10.1 10.1-10.1h39.6c5.5 0 10.1 4.5 10.1 10.1v159c0 5.5-4.5 10.1-10.1 10.1H671c-5.5 0-10.1-4.5-10.1-10.1v-49.7H123.7V234c0 5.5-4.5 10.1-10.1 10.1H74.1c-5.6-.1-10.1-4.6-10.1-10.2V75c0-5.6 4.5-10.1 10.1-10.1h39.5z"
  }));
});

/**
* @file 图标adaptive-width
* @author zhanglili
*/
var IconAdaptiveWidth =
/*#__PURE__*/
createIcon('adaptive-width', SVG);

var SVG$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M918 480.1H544V108.2c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v371.9H108c-5.5 0-10 4.5-10 10v44c0 5.5 4.5 10 10 10h372v374.1c0 5.5 4.5 10 10 10h44c5.5 0 10-4.5 10-10V544.1h374c5.5 0 10-4.5 10-10v-44c0-5.5-4.5-10-10-10z"
  }));
});

/**
* @file 图标add
* @author zhanglili
*/
var IconAdd =
/*#__PURE__*/
createIcon('add', SVG$1);

var SVG$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M900 320.2C900 214 814 128 707.8 128s-192.2 86.1-192.2 192.2c0 85.4 55.8 157.9 132.9 182.9-66.2 157.2-128.7 245.7-265.4 269-13.6-31.2-39.1-56.1-71.9-69.1V319.9c48.6-21.4 83-68.9 83-124.4 0-73.1-59.7-132.6-133.1-132.6s-133.2 59.5-133.2 132.6c0 55.4 34.5 103 83.1 122.8V703c-50.1 19.8-82.9 67.3-82.9 122.7 0 73.1 59.7 132.6 133.1 132.6 63.3 0 116.4-44.3 129.8-103.4 176.5-27.6 262.6-143.8 344.3-344.4C828.4 497.1 900 417.1 900 320.2zM203.5 195.5c0-31.7 25.8-57.5 57.6-57.5s57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5-57.6-25.8-57.6-57.5zm57.6 687.7c-31.8 0-57.6-25.8-57.6-57.5s25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5zM704 448.3c-70.8 0-128.2-57.4-128.2-128.2S633.2 192 704 192s128.2 57.4 128.2 128.2S774.8 448.3 704 448.3z"
  }), React.createElement("path", {
    d: "M724.7 227h-42.4c-2.2 0-4 1.8-4 4v63.1h-63.2c-2.2 0-4 1.8-4 4v42.4c0 2.2 1.8 4 4 4h63.2v63.3c0 2.2 1.8 4 4 4h42.4c2.2 0 4-1.8 4-4v-63.3h63.2c2.2 0 4-1.8 4-4v-42.4c0-2.2-1.8-4-4-4h-63.2V231c0-2.2-1.8-4-4-4z"
  }));
});

/**
* @file 图标add-branch
* @author zhanglili
*/
var IconAddBranch =
/*#__PURE__*/
createIcon('add-branch', SVG$2);

var SVG$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M547.4 479.4V234.1c0-5.5-4.5-10-10-10h-45.3c-5.5 0-10 4.5-10 10v245.3H236.8c-5.5 0-10 4.5-10 10v45.3c0 5.5 4.5 10 10 10h245.3V790c0 5.5 4.5 10 10 10h45.3c5.5 0 10-4.5 10-10V544.7h245.3c5.5 0 10-4.5 10-10v-45.3c0-5.5-4.5-10-10-10H547.4z"
  }), React.createElement("path", {
    d: "M513.8 66.6c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445-199.3-445-445-445zm-3.3 825.6c-210.4 0-381-170.6-381-381s170.6-381 381-381 381 170.6 381 381-170.6 381-381 381z"
  }));
});

/**
* @file 图标add-circle-o
* @author zhanglili
*/
var IconAddCircleO =
/*#__PURE__*/
createIcon('add-circle-o', SVG$3);

var SVG$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510.8 66.6c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445-199.3-445-445-445zm292.9 467.1c0 5.5-4.5 10-10 10H548.4V789c0 5.5-4.5 10-10 10h-45.3c-5.5 0-10-4.5-10-10V543.7H237.8c-5.5 0-10-4.5-10-10v-45.3c0-5.5 4.5-10 10-10h245.3V233.1c0-5.5 4.5-10 10-10h45.3c5.5 0 10 4.5 10 10v245.3h245.3c5.5 0 10 4.5 10 10v45.3z"
  }));
});

/**
* @file 图标add-circle-solid
* @author zhanglili
*/
var IconAddCircleSolid =
/*#__PURE__*/
createIcon('add-circle-solid', SVG$4);

var SVG$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M944.3 65.2H82.4c-8.9 0-16 7.1-16 16.1l-.5 874.4 189.9-190.9h688.6c8.8 0 16-7.2 17-18V79.1c-1.1-6.9-8.3-13.9-17.1-13.9zM735.5 437.6c0 6.2-5.1 11.3-11.3 11.3h-180V628c0 6.2-5.1 11.3-11.3 11.3h-43.6c-6.2 0-11.3-5.1-11.3-11.3V448.9H299.3c-6.2 0-11.3-5.1-11.3-11.3V394c0-6.2 5.1-11.3 11.3-11.3l178.7-1V201.1c0-6.2 5.1-11.3 11.3-11.3H533c6.2 0 11.3 5.1 11.3 11.3v181.6h180c6.2 0 11.3 5.1 11.3 11.3v43.6z"
  }));
});

/**
* @file 图标add-comment-solid
* @author zhanglili
*/
var IconAddCommentSolid =
/*#__PURE__*/
createIcon('add-comment-solid', SVG$5);

var SVG$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M927 227.5H593.9l-59.7-98.9H100.3c-17.8 0-32.7 14.8-32.7 33.1v700.7c0 18.6 14.7 33.1 32.8 33.1h827c18.1 0 32.8-14.7 32.8-32.9V260.3c0-17.9-14.9-32.8-33.2-32.8zM750.9 574.7c0 5.5-4.5 10-10 10H546.6V780c0 5.5-4.5 10-10 10h-45.3c-5.5 0-10-4.5-10-10V584.7H286c-5.5 0-10-4.5-10-10v-45.3c0-5.5 4.5-10 10-10h195.3V325.1c0-5.5 4.5-10 10-10h45.3c5.5 0 10 4.5 10 10v194.3h194.3c5.5 0 10 4.5 10 10v45.3z"
  }));
});

/**
* @file 图标add-folder-solid
* @author zhanglili
*/
var IconAddFolderSolid =
/*#__PURE__*/
createIcon('add-folder-solid', SVG$6);

var SVG$7 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M739.3 461c62.2 0 112.1-50.2 112.1-112.5S801.5 236 739.3 236c-10 0-19.7 1.3-28.7 3.6-2.7.7-3.8 3.8-2.3 6.1 19.5 29.5 30.6 64.5 30.6 102.7s-11.5 73-30.8 102.8c-1.5 2.3-.3 5.3 2.3 6 9.1 2.5 18.9 3.8 28.9 3.8zm-228.1 24.3c115.4 0 198.1-132.3 107.9-254-.2-.3-.5-.6-.9-.9-121.6-90.8-253.8-7.1-253.8 108.2.1 81.3 65.7 146.7 146.8 146.7zM795 577c31.1 27.4 51.7 62.2 51.7 106.5v71c0 2.2 1.8 4 4 4h104.5c2.2 0 4-1.8 4-4v-71c0-57.8-88.8-93.4-164.2-106.5zm-283.8 9.1c-97.8 0-293.4 48.9-293.4 146.7v93.8c0 2.2 1.8 4 4 4h578.8c2.2 0 4-1.8 4-4v-93.8c0-97.8-195.6-146.7-293.4-146.7zM203.5 485.6V403c0-2.2-1.8-4-4-4h-43.6c-2.2 0-4 1.8-4 4v82.5H68c-2.2 0-4 1.8-4 4v43.6c0 2.2 1.8 4 4 4h83.9v85.2c0 2.2 1.8 4 4 4h43.6c2.2 0 4-1.8 4-4v-85.2h83.9c2.2 0 4-1.8 4-4v-43.6c0-2.2-1.8-4-4-4l-83.9.1z"
  }));
});

/**
* @file 图标add-group
* @author zhanglili
*/
var IconAddGroup =
/*#__PURE__*/
createIcon('add-group', SVG$7);

var SVG$8 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M172 85.35h-57.1v-57.1H86.35v57.1h-57.1v28.551h57.1V171h28.55v-57.099H172z"
  }));
});

/**
* @file 图标add-solid
* @author zhanglili
*/
var IconAddSolid =
/*#__PURE__*/
createIcon('add-solid', SVG$8);

var SVG$9 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M618.3 831.7H64.1v-81.9c0-109 218.4-163.9 327.8-163.9 45.5 0 110 9.5 169.7 28.5-3.8 17.2-5.8 35.1-5.8 53.4-.1 63 23.6 120.4 62.5 163.9zM384.5 486.5c81.2 0 147.1-65.8 147.1-147.1s-65.8-147.1-147.1-147.1-147.1 65.8-147.1 147.1 65.9 147.1 147.1 147.1zM919.8 684c.7-5.2 1.3-10.4 1.3-16s-.3-10.8-1.3-16l34.5-27c2.9-2.6 3.9-6.8 2-10.4l-32.6-56.4c-2-3.6-6.2-4.9-10.1-3.6l-40.4 16.3c-8.5-6.5-17.6-12.1-27.7-16l-6.2-43c-.3-3.9-3.9-6.8-7.8-6.8h-65.2c-3.9 0-7.5 2.9-8.1 6.8l-6.2 43c-9.8 4.2-19.2 9.5-27.7 16l-40.4-16.3c-3.6-1.3-7.8 0-10.1 3.6l-32.6 56.4c-2 3.6-1.3 7.8 2 10.4l34.5 27c-.7 5.2-1 10.4-1 16s.3 10.8 1 16l-34.5 27c-2.9 2.6-3.9 6.8-2 10.4l32.6 56.4c2 3.6 6.2 4.9 10.1 3.6l40.4-16.3c8.5 6.5 17.6 12.1 27.7 16l6.2 43c.7 3.9 3.9 6.8 8.1 6.8h65.2c3.9 0 7.5-2.9 8.1-6.8l6.2-43c9.8-4.2 19.2-9.5 27.4-16l40.7 16.3c3.6 1.3 7.8 0 10.1-3.6l32.6-56.4c2-3.6 1-7.8-2-10.4l-34.8-27zm-118.3 48.5c-34.3 0-61.9-27.7-61.9-61.9s27.7-61.9 61.9-61.9 61.9 27.7 61.9 61.9-27.6 61.9-61.9 61.9z"
  }));
});

/**
* @file 图标admin
* @author zhanglili
*/
var IconAdmin =
/*#__PURE__*/
createIcon('admin', SVG$9);

var SVG$a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510.2 67.2c-247.3 0-447.7 200.4-447.7 447.7s200.4 447.7 447.7 447.7 447.7-200.4 447.7-447.7S757.5 67.2 510.2 67.2zm1.1 831.7c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5 383.5 171.7 383.5 383.5c0 211.9-171.7 383.5-383.5 383.5z"
  }), React.createElement("path", {
    d: "M510.5 513.2c70.2 0 126.6-56.7 126.6-127.1S580.9 259 510.5 259c-70.3 0-127.1 56.6-127.1 127s56.9 127.2 127.1 127.2zm.1 71.8c-84.7 0-254.2 42.4-254.2 127.1v58.7h508.4l.1-58.7c0-84.7-169.6-127.1-254.3-127.1z"
  }));
});

/**
* @file 图标admin-circle-o
* @author zhanglili
*/
var IconAdminCircleO =
/*#__PURE__*/
createIcon('admin-circle-o', SVG$a);

var SVG$b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510.2 67.2c-247.3 0-447.7 200.4-447.7 447.7s200.4 447.7 447.7 447.7 447.7-200.4 447.7-447.7S757.5 67.2 510.2 67.2zm.3 191.8c70.4 0 126.6 56.7 126.6 127.1s-56.4 127.1-126.6 127.1S383.4 456.4 383.4 386s56.8-127 127.1-127zm254.3 511.8H256.4v-58.7c0-84.7 169.5-127.1 254.2-127.1s254.3 42.4 254.3 127.1l-.1 58.7z"
  }));
});

/**
* @file 图标admin-circle-solid
* @author zhanglili
*/
var IconAdminCircleSolid =
/*#__PURE__*/
createIcon('admin-circle-solid', SVG$b);

var SVG$c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M623.8 191.2h1.1c79.5 0 143.9 64.4 143.9 143.9v351.6c0 79.5-64.4 143.9-143.9 143.9H622c-59.9 0-116.3-28-152.6-75.6L256.2 513l213.3-243.9c36.2-49 93.4-77.9 154.3-77.9z"
  }));
});

/**
* @file 图标agile-pipeline-left
* @author zhanglili
*/
var IconAgilePipelineLeft =
/*#__PURE__*/
createIcon('agile-pipeline-left', SVG$c);

var SVG$d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M654.9 211s-15.9-18.4-44.6-18.4h-204s-23-5.1-50 37.2S67.1 755.5 67.1 755.5s-20.5 62.6 44.8 74.6H915s52.5-8.3 42.3-71.1c-27.6-48.5-154.2-272.1-154.2-272.1s-28.7-38-69.2-38c-40.6 0-179.2.4-179.2.4s-33.2-.4-25.7 34.8c15.9 32.3 22.8 43.4 22.8 43.4s6.3 8.4 20.6 8.4 141.4-.3 141.4-.3 21.2-.3 37.4 27.2 84.4 147.9 84.4 147.9 16.2 34.1-16.6 42.7l-615 1.1s-30.9-8.3-16.6-42c13.9-21.2 224.5-410.9 224.5-410.9s7.8-21.7 23.9-21.7c19 0 212.2-1.5 212.2-1.5s31.6-10 24-34.4-17.1-33-17.1-33z"
  }));
});

/**
* @file 图标agroup
* @author zhanglili
*/
var IconAGroup =
/*#__PURE__*/
createIcon('agroup', SVG$d);

var SVG$e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M169 115.9c-2.7 0-5.1 1.6-6.1 4.2-8.9 26.2-33.8 45.2-62.9 45.2-26.8 0-49.9-16.1-60.4-39 6.1-3 10.2-9.2 10.2-16.4 0-10.1-8.2-18.3-18.3-18.3s-18.3 8.2-18.3 18.3c0 8.2 5.5 15.2 13 17.5 11.5 29.5 40.2 50.6 73.9 50.6 34.8 0 64.5-22.5 75.1-53.9 1.3-3.9-1.9-8.2-6.2-8.2zM31.5 104.7c3 0 5.5 2.5 5.5 5.5s-2.5 5.5-5.5 5.5-5.5-2.5-5.5-5.5 2.5-5.5 5.5-5.5zM173.8 70c-11.5-29.3-40.2-50.3-73.8-50.3-34.8 0-64.5 22.6-75.1 53.9-1.3 4.1 1.8 8.4 6.2 8.4 2.7 0 5.1-1.6 6.1-4.2 8.9-26.2 33.8-45.2 62.9-45.2 26.6 0 49.5 15.7 60.1 38.3-6.2 3-10.5 9.2-10.5 16.5 0 10.1 8.2 18.3 18.3 18.3s18.3-8.2 18.3-18.3c0-8.2-5.3-15-12.5-17.4zm-5.9 22.9c-3 0-5.5-2.5-5.5-5.5s2.5-5.5 5.5-5.5c3.1 0 5.5 2.5 5.5 5.5s-2.5 5.5-5.5 5.5zM91.9 60c-1.5-6.3-11.1-6.3-12.8 0l-18.8 73.2c-.8 3.3 1.3 6.4 4.7 7.2 3.5.7 6.9-1.2 7.7-4.4l3.8-14.4h17.9l3.8 14.4c.8 3.3 4.2 5.1 7.7 4.4 3.5-.7 5.6-3.9 4.7-7.2L91.9 60zm-12.3 51.3l6-24.7 6 24.6-12 .1zm49.1-55.9c-3.6 0-6.4 2.7-6.4 6v73.3c0 3.3 2.9 6 6.4 6 3.6 0 6.4-2.7 6.4-6V61.4c0-3.3-2.9-6-6.4-6z"
  }));
});

/**
* @file 图标aiassemblylineo
* @author zhanglili
*/
var IconAIassemblylineo =
/*#__PURE__*/
createIcon('aiassemblylineo', SVG$e);

var SVG$f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M958.5 513.2c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.3 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z"
  }), React.createElement("path", {
    d: "M703 448.4c1.6-1.6 1.6-4.1 0-5.7l-26-26c-1.6-1.6-4.1-1.6-5.7 0l-158 158-157.5-157.6c-1.6-1.6-4.1-1.6-5.7 0L324 443.2c-1.6 1.6-1.6 4.1 0 5.7l186.7 186.7c1.6 1.6 4.1 1.6 5.7 0"
  }));
});

/**
* @file 图标angle-down-circle-o
* @author zhanglili
*/
var IconAngleDownCircleO =
/*#__PURE__*/
createIcon('angle-down-circle-o', SVG$f);

var SVG$g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M68.5 513.2c0 245.8 199.2 445 445 445s445-199.2 445-445-199.2-445-445-445-445 199.2-445 445zm64 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z"
  }), React.createElement("path", {
    d: "M392 511.3c-1.6 1.6-1.6 4.1 0 5.7l186.7 186.7c1.6 1.6 4.1 1.6 5.7 0l26.1-26.1c1.6-1.6 1.6-4.1 0-5.7L453 514.4l158-158c1.6-1.6 1.6-4.1 0-5.7l-26-26c-1.6-1.6-4.1-1.6-5.7 0"
  }));
});

/**
* @file 图标angle-left-circle-o
* @author zhanglili
*/
var IconAngleLeftCircleO =
/*#__PURE__*/
createIcon('angle-left-circle-o', SVG$g);

var SVG$h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513.5 68.2c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445-199.2-445-445-445zm0 826c-210.4 0-381-170.6-381-381s170.6-381 381-381 381 170.6 381 381-170.6 381-381 381z"
  }), React.createElement("path", {
    d: "M448.8 323.7c-1.6-1.6-4.1-1.6-5.7 0l-26 26c-1.6 1.6-1.6 4.1 0 5.7l158 158-157.7 157.5c-1.6 1.6-1.6 4.1 0 5.7l26.1 26.1c1.6 1.6 4.1 1.6 5.7 0L636 516c1.6-1.6 1.6-4.1 0-5.7"
  }));
});

/**
* @file 图标angle-right-circle-o
* @author zhanglili
*/
var IconAngleRightCircleO =
/*#__PURE__*/
createIcon('angle-right-circle-o', SVG$h);

var SVG$i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513.5 68.2c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445c0-245.7-199.2-445-445-445zm0 64c210.4 0 381 170.6 381 381s-170.6 381-381 381-381-170.6-381-381 170.6-381 381-381z"
  }), React.createElement("path", {
    d: "M516.4 390.7c-1.6-1.6-4.1-1.6-5.7 0L324 577.5c-1.6 1.6-1.6 4.1 0 5.7l26.1 26.1c1.6 1.6 4.1 1.6 5.7 0l157.5-157.6 158 158c1.6 1.6 4.1 1.6 5.7 0l26-26c1.6-1.6 1.6-4.1 0-5.7"
  }));
});

/**
* @file 图标angle-up-circle-o
* @author zhanglili
*/
var IconAngleUpCircleO =
/*#__PURE__*/
createIcon('angle-up-circle-o', SVG$i);

var SVG$j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M223.5 319.7h77.3l159.8 383.9h-77.9l-38.9-78.9H178.2l-38.9 78.9h-75l159.2-383.9zm-25.6 249.9h126.7l-62.2-178.4h-1.7l-62.8 178.4zm302.2-249.9h183c29.4 0 53.5 4.3 72 12.8s32.9 19.2 43 32 16.9 26.7 20.6 41.8c3.7 15.1 5.5 29 5.5 41.8s-1.8 26.6-5.5 41.5-10.6 28.8-20.6 41.5c-10.1 12.8-24.4 23.3-43 31.7s-42.6 12.5-72 12.5H572.7v128.3h-72.6V319.7zm72.6 196.4H679c8.1 0 16.5-1.2 25-3.5s16.4-6.1 23.5-11.3c7.2-5.2 13-12.2 17.4-20.9 4.5-8.7 6.7-19.7 6.7-32.8 0-13.6-1.9-24.8-5.8-33.7-3.9-8.9-9.1-16-15.7-21.2-6.6-5.2-14.1-8.8-22.7-10.8-8.5-1.9-17.6-2.9-27.3-2.9H572.7v137.1zm314.9-196.4h72.6v383.9h-72.6V319.7z"
  }));
});

/**
* @file 图标api
* @author zhanglili
*/
var IconAPI =
/*#__PURE__*/
createIcon('api', SVG$j);

var SVG$k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M490.9 730.7c0 108.6-87.9 196.6-196.3 196.6s-196.3-88-196.3-196.6 87.9-196.6 196.3-196.6h196.2v196.6h.1zm43.6 0c0 108.6 87.9 196.6 196.3 196.6S927 839.3 927 730.7s-87.9-196.6-196.3-196.6H534.5v196.6zm-43.6-436.9c0-108.6-87.9-196.6-196.3-196.6s-196.3 88-196.3 196.6 87.9 196.6 196.3 196.6h196.2V293.8h.1zm43.6 0c0-108.6 87.9-196.6 196.3-196.6S927 185.2 927 293.8s-87.9 196.6-196.3 196.6H534.5V293.8z"
  }));
});

/**
* @file 图标application
* @author zhanglili
*/
var IconApplication =
/*#__PURE__*/
createIcon('application', SVG$k);

var SVG$l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.6 1000.7"
  }, props), React.createElement("path", {
    d: "M400.3 689c-4.7 0-9.3-1.8-12.9-5.3-.4-.4-40-39.9-79.6-79.6-81.5-81.8-83.2-84.6-84.9-87.3-7.8-12.5-4.2-25.6 2.4-32.4l162-164c7.1-7.2 18.6-7.2 25.8-.2 7.2 7.1 7.2 18.6.2 25.8L258.8 502.4c22.9 23.9 102.9 104.2 154.4 155.5 7.1 7.1 7.2 18.7 0 25.8-3.5 3.5-8.2 5.3-12.9 5.3zM252.9 496zm512.9-129.5H504.5c-10.1 0-18.2-8.2-18.2-18.2 0-10.1 8.2-18.2 18.2-18.2h261.2c10.1 0 18.2 8.2 18.2 18.2.1 10-8.1 18.2-18.1 18.2zm0 148.8H504.5c-10.1 0-18.2-8.2-18.2-18.2 0-10.1 8.2-18.2 18.2-18.2h261.2c10.1 0 18.2 8.2 18.2 18.2.1 10.1-8.1 18.2-18.1 18.2zm0 148.9H504.5c-10.1 0-18.2-8.2-18.2-18.2 0-10.1 8.2-18.2 18.2-18.2h261.2c10.1 0 18.2 8.2 18.2 18.2.1 10-8.1 18.2-18.1 18.2z"
  }));
});

/**
* @file 图标arrow-collapse
* @author zhanglili
*/
var IconArrowCollapse =
/*#__PURE__*/
createIcon('arrow-collapse', SVG$l);

var SVG$m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.3 958.1l44.7-44.7m-262.3-173l212.1 212.1c3.9 3.9 10.2 3.9 14.1 0L732 740.4c3.9-3.9 3.9-10.2 0-14.1l-31.1-31.1c-3.9-3.9-10.2-3.9-14.1 0L545.2 836.6V73.9c0-5.5-4.5-10-10-10h-44.8c-5.5 0-10 4.5-10 10v762.7L338.9 695.1c-3.9-3.9-10.2-3.9-14.1 0l-31.1 31.1c-3.9 3.9-3.9 10.3 0 14.2z"
  }));
});

/**
* @file 图标arrow-down
* @author zhanglili
*/
var IconArrowDown =
/*#__PURE__*/
createIcon('arrow-down', SVG$m);

var SVG$n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M282.7 730.9L70.6 518.8c-3.9-3.9-3.9-10.2 0-14.1l212.1-212.1c3.9-3.9 10.2-3.9 14.1 0l31.1 31.1c3.9 3.9 3.9 10.2 0 14.1L186.5 479.4h762.7c5.5 0 10 4.5 10 10v44.8c0 5.5-4.5 10-10 10H186.5L328 685.7c3.9 3.9 3.9 10.2 0 14.1l-31.1 31.1c-4 3.9-10.3 3.9-14.2 0z"
  }));
});

/**
* @file 图标arrow-left
* @author zhanglili
*/
var IconArrowLeft =
/*#__PURE__*/
createIcon('arrow-left', SVG$n);

var SVG$o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M740.5 730.8l212.1-212.1c3.9-3.9 3.9-10.2 0-14.1L740.5 292.5c-3.9-3.9-10.2-3.9-14.1 0l-31.1 31.1c-3.9 3.9-3.9 10.2 0 14.1l141.5 141.5H74.1c-5.5 0-10 4.5-10 10V534c0 5.5 4.5 10 10 10h762.7L695.3 685.5c-3.9 3.9-3.9 10.2 0 14.1l31.1 31.1c3.9 4 10.2 4 14.1.1z"
  }));
});

/**
* @file 图标arrow-right
* @author zhanglili
*/
var IconArrowRight =
/*#__PURE__*/
createIcon('arrow-right', SVG$o);

var SVG$p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M293.7 283.4l212-212.1c3.9-3.9 10.2-3.9 14.1 0l212.1 212.1c3.9 3.9 3.9 10.2 0 14.1l-31.1 31.1c-3.9 3.9-10.2 3.9-14.1 0L545.2 187.1v762.7c0 5.5-4.5 10-10 10h-44.8c-5.5 0-10-4.5-10-10V187.1L338.9 328.6c-3.9 3.9-10.2 3.9-14.1 0l-31.1-31.1c-3.9-3.9-3.9-10.2 0-14.1z"
  }));
});

/**
* @file 图标arrow-up
* @author zhanglili
*/
var IconArrowUp =
/*#__PURE__*/
createIcon('arrow-up', SVG$p);

var SVG$q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.6 1000.7"
  }, props), React.createElement("path", {
    d: "M501.2 224.6l-153.8 271h103.2v277.7h103V495.6h101.5z"
  }));
});

/**
* @file 图标arrow-up-solid
* @author zhanglili
*/
var IconArrowUpSolid =
/*#__PURE__*/
createIcon('arrow-up-solid', SVG$q);

var SVG$r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513.7 96.9l191.8 445.4-132.7-58.2-59.1 442.1-63.3-442.1-132.6 58.2z"
  }));
});

/**
* @file 图标arrow-wide-up
* @author zhanglili
*/
var IconArrowWideUp =
/*#__PURE__*/
createIcon('arrow-wide-up', SVG$r);

var SVG$s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M800.5 146.5L545.8 401.2l75 74.9 254.7-254.7zm149.9-45l-30-30c-12-12-33-12-44.9 0l-59.9 59.9 74.9 74.9 59.9-59.9c11.9-11.9 11.9-33 0-44.9zM503.5 507.8c-1.7 5.3 3.2 10.4 8.5 8.9l91.8-24.9-72.1-72-28.2 88z"
  }), React.createElement("path", {
    d: "M861.4 383.8v495.4c0 6.6-5.4 12-12 12h-707c-6.6 0-12-5.4-12-12v-707c0-6.6 5.4-12 12-12h499.2V93.8H76c-6.6 0-12 5.4-12 12v839.8c0 6.6 5.4 12 12 12h839.8c6.6 0 12-5.4 12-12V383.8h-66.4z"
  }), React.createElement("path", {
    d: "M219.4 703h554.3c5.5 0 10 4.5 10 10v43.9c0 5.5-4.5 10-10 10H219.4c-5.5 0-10-4.5-10-10V713c0-5.5 4.5-10 10-10zm0-159h554.3c5.5 0 10 4.5 10 10v43.9c0 5.5-4.5 10-10 10H219.4c-5.5 0-10-4.5-10-10V554c0-5.5 4.5-10 10-10zm0-160h218.7c5.5 0 10 4.5 10 10v45.9c0 5.5-4.5 10-10 10H219.4c-5.5 0-10-4.5-10-10V394c0-5.5 4.5-10 10-10z"
  }));
});

/**
* @file 图标article
* @author zhanglili
*/
var IconArticle =
/*#__PURE__*/
createIcon('article', SVG$s);

var SVG$t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M693.3 148.8c-62.3 0-112.2 22.4-156.2 66.4 0 0-.1 0-.1.1l-25 31.5-25-29.6-.1-.1c-44-44-93.9-68.3-156.2-68.3s-120.8 24.3-164.9 68.3c-44 44.1-68.3 102.6-68.3 164.9 0 62.2 24.2 120.8 68.2 164.8L475.1 859c9.7 9.8 23 15.3 36.8 15.3 13.8 0 27.1-5.5 36.8-15.3l309.5-312.1c44-44.1 68.2-102.6 68.2-164.8 0-62.3-24.3-120.8-68.3-164.9-43.9-44.1-102.5-68.4-164.8-68.4z"
  }));
});

/**
* @file 图标attention-solid
* @author zhanglili
*/
var IconAttentionSolid =
/*#__PURE__*/
createIcon('attention-solid', SVG$t);

var SVG$u = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M818.26 202.35c-168.59-168.59-441.92-168.59-610.51 0s-168.59 441.92 0 610.51 441.92 168.59 610.51 0 168.58-441.92 0-610.51zM750.42 745c-128.6 128.6-335.57 131.08-467.19 7.42l-7.65-7.42 474.84-474.82c131.13 131.13 131.13 343.72 0 474.82z"
  }));
});

/**
* @file 图标automatic
* @author zhanglili
*/
var IconAutomatic =
/*#__PURE__*/
createIcon('automatic', SVG$u);

var SVG$v = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M216.7 496.5c-8.6 8.6-8.6 22.5 0 31.1l256.1 256.1V240.4L216.7 496.5zm597.8-256.1L558.3 496.5c-8.6 8.6-8.6 22.5 0 31.1l256.1 256.1V240.4z"
  }));
});

/**
* @file 图标backoff
* @author zhanglili
*/
var IconBackoff =
/*#__PURE__*/
createIcon('backoff', SVG$v);

var SVG$w = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M256 82.9V228h512V82.9c0-11-9-20-20-20H276c-11 0-20 8.9-20 20zm448.1 108.9h-384v-62.9h384v62.9z"
  }), React.createElement("path", {
    d: "M950.2 282h-876c-5.5 0-10-4.5-10-10v-70.2c0-5.5 4.5-10 10-10h876c5.5 0 10 4.5 10 10V272c0 5.5-4.5 10-10 10z"
  }), React.createElement("path", {
    d: "M800.2 256v605.1H225V256h-97v682.6c0 11 9 20 20 20h728.1c11 0 20-9 20-20V256h-95.9z"
  }), React.createElement("path", {
    d: "M447.8 767.8h-79.6c-4.4 0-8-3.6-8-8v-368c0-4.4 3.6-8 8-8h79.6c4.4 0 8 3.6 8 8v368c0 4.4-3.6 8-8 8zm208 0h-79.6c-4.4 0-8-3.6-8-8v-368c0-4.4 3.6-8 8-8h79.6c4.4 0 8 3.6 8 8v368c0 4.4-3.6 8-8 8z"
  }));
});

/**
* @file 图标basket
* @author zhanglili
*/
var IconBasket =
/*#__PURE__*/
createIcon('basket', SVG$w);

var SVG$x = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M767.2 253.7V891H130V253.7h637.2zm-51 51H180.9V840h535.3V304.7z"
  }), React.createElement("path", {
    d: "M894.6 132.7v637.2h-102v-51h51V183.7H308.4v44.6h-51v-95.6h637.2z"
  }), React.createElement("path", {
    d: "M330.3 562.2l67.6 67.6L574.7 453l36 36-212.8 212.9-103.6-103.6 36-36.1z"
  }));
});

/**
* @file 图标batch
* @author zhanglili
*/
var IconBatch =
/*#__PURE__*/
createIcon('batch', SVG$x);

var SVG$y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "18",
    height: "20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.267 11.588a5.18 5.18 0 0 1-2.424 3.159 5.185 5.185 0 0 1-3.946.52 5.18 5.18 0 0 1-2.876-1.985l8.965-5.177a5.197 5.197 0 0 1 .28 3.483M4.08 10.886a5.18 5.18 0 0 1 .139-1.99A5.178 5.178 0 0 1 6.64 5.738a5.186 5.186 0 0 1 3.946-.52 5.178 5.178 0 0 1 2.876 1.985L4.5 12.378a5.135 5.135 0 0 1-.42-1.492m2.042-6.05a6.241 6.241 0 1 0 6.242 10.812A6.241 6.241 0 1 0 6.12 4.836"
  }));
});

/**
* @file 图标block
* @author zhanglili
*/
var IconBlock =
/*#__PURE__*/
createIcon('block', SVG$y);

var SVG$z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M80.247 31.65H44.37c-6.98 0-12.703 5.724-12.703 12.703V80.23c0 6.98 5.724 12.703 12.703 12.703h35.877A12.66 12.66 0 0 0 92.95 80.23V44.354c0-6.98-5.723-12.704-12.703-12.704zm2.931 48.58a2.95 2.95 0 0 1-2.931 2.932H44.37a2.95 2.95 0 0 1-2.932-2.932V44.354a2.95 2.95 0 0 1 2.932-2.932h35.877a2.949 2.949 0 0 1 2.931 2.932V80.23zm-2.931 23.802H44.37c-6.98 0-12.703 5.724-12.703 12.703v35.877c0 6.98 5.724 12.703 12.703 12.703h35.877c7.05 0 12.703-5.724 12.703-12.703v-35.877c0-6.98-5.723-12.703-12.703-12.703zm2.931 48.58a2.95 2.95 0 0 1-2.931 2.932H44.37a2.95 2.95 0 0 1-2.932-2.932v-35.877a2.949 2.949 0 0 1 2.932-2.931h35.877a2.949 2.949 0 0 1 2.931 2.931v35.877zm72.452-48.58h-35.877c-6.98 0-12.703 5.724-12.703 12.703v35.877c0 6.98 5.724 12.703 12.703 12.703h35.877c7.05 0 12.703-5.724 12.703-12.703v-35.877c0-6.98-5.723-12.703-12.703-12.703zm2.931 48.58a2.95 2.95 0 0 1-2.931 2.932h-35.877a2.95 2.95 0 0 1-2.932-2.932v-35.877a2.949 2.949 0 0 1 2.932-2.931h35.877a2.949 2.949 0 0 1 2.931 2.931v35.877zm4.886-98.417a4.856 4.856 0 0 0 4.886-4.886v-4.956c0-7.05-5.723-12.703-12.703-12.703h-35.877c-7.05 0-12.703 5.724-12.703 12.703V80.23c0 7.05 5.724 12.703 12.703 12.703h35.877c7.05 0 12.703-5.724 12.703-12.703v-8.167a4.856 4.856 0 0 0-4.886-4.886c-2.652 0-4.886 2.234-4.886 4.886v8.167a2.95 2.95 0 0 1-2.931 2.932h-35.877a2.95 2.95 0 0 1-2.932-2.932V44.354a2.95 2.95 0 0 1 2.932-2.932h35.877a2.949 2.949 0 0 1 2.931 2.932v4.956a4.855 4.855 0 0 0 4.886 4.885z"
  }));
});

/**
* @file 图标board-dash
* @author zhanglili
*/
var IconBoardDash =
/*#__PURE__*/
createIcon('board-dash', SVG$z);

var SVG$A = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M885.15 894.57l-32.45 32.55v-32.55h32.45zm-32.45-13.22h32.45v45.77h-622c-68.7 0-124.4-58.29-124.4-130.2s55.7-130.2 124.4-130.2l522.66.99v32.55l-522.66-.99c-50.47 0-91.95 43.42-91.95 97.65s41.48 97.65 91.95 97.65H852.7v-13.22zm32.45 13.22l-32.45 32.55v-32.55h32.45zm-32.45-13.22h32.45v45.77h-622c-68.7 0-124.4-58.29-124.4-130.2s55.7-130.2 124.4-130.2l522.66.99v32.55l-522.66-.99c-50.47 0-91.95 43.42-91.95 97.65s41.48 97.65 91.95 97.65H852.7v-13.22z"
  }), React.createElement("path", {
    d: "M885.15 909.13c0 8.99-7.26 16.27-16.23 16.27-8.96 0-16.23-7.29-16.23-16.27V243.57c0-8.99 7.26-16.27 16.23-16.27 8.96 0 16.23 7.29 16.23 16.27v665.56zM247.29 828.25c-8.96-.02-16.21-7.33-16.19-16.31.02-8.99 7.3-16.26 16.26-16.24l512.53 1.22c8.96.02 16.21 7.33 16.19 16.31-.02 8.99-7.3 16.26-16.26 16.24l-512.53-1.22zM785.81 700.26H282.87c-73.05 0-111.27 40.35-111.67 96.66h-32.45l.4-553.35c0-86.88 62.83-146.47 143.72-146.47h502.94v603.16zm-32.46-32.55V129.65H282.87c-63.36 0-111.27 45.44-111.27 113.92v463.69c24.24-26.14 49.15-40.51 111.09-40.51l470.66.96z"
  }));
});

/**
* @file 图标book-o
* @author zhanglili
*/
var IconBookO =
/*#__PURE__*/
createIcon('book-o', SVG$A);

var SVG$B = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M851.748 460.429H148.887V309.395c0-33.712 27.427-61.139 61.139-61.139H790.61c33.712 0 61.139 27.427 61.139 61.139l-.001 151.034zm-650.861-52h598.861v-99.034c0-5.039-4.1-9.139-9.139-9.139H210.026c-5.039 0-9.139 4.1-9.139 9.139v99.034zm417.226 235.515h-235.59c-27.121 0-49.185-22.064-49.185-49.185v-45.58c0-27.12 22.064-49.185 49.185-49.185h235.59c27.12 0 49.185 22.064 49.185 49.185v45.58c-.001 27.12-22.065 49.185-49.185 49.185zm-232.775-52h229.959v-39.949H385.338v39.949z"
  }), React.createElement("path", {
    d: "M775.266 656.442v110.791a9.185 9.185 0 0 1-9.185 9.185H234.553a9.185 9.185 0 0 1-9.185-9.185V460.324h549.897v93.3c0 14.359 11.641 26 26 26s26-11.641 26-26v-145.3H173.369v358.909c0 33.791 27.393 61.185 61.185 61.185h531.529c33.791 0 61.184-27.393 61.184-61.184V656.442c0-14.359-11.641-26-26-26-14.361 0-26.001 11.641-26.001 26z"
  }));
});

/**
* @file 图标box
* @author zhanglili
*/
var IconBox =
/*#__PURE__*/
createIcon('box', SVG$B);

var SVG$C = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M678.5 504.1c-66.2 157.2-128.7 245.7-265.4 269-13.6-31.2-39.1-56.1-71.9-69.1V320.9c48.6-21.4 83-68.9 83-124.4 0-73.1-59.7-132.6-133.1-132.6s-133.2 59.5-133.2 132.6c0 55.4 34.5 103 83.1 122.8V704c-50.1 19.8-82.9 67.3-82.9 122.7 0 73.1 59.7 132.6 133.1 132.6 63.3 0 116.4-44.3 129.8-103.4 176.5-27.6 262.6-143.8 344.3-344.4m-531.8-315c0-31.7 25.8-57.5 57.6-57.5s57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5-57.6-25.8-57.6-57.5zm57.6 687.7c-31.8 0-57.6-25.8-57.6-57.5s25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5z"
  }), React.createElement("path", {
    d: "M732.5 251.2c-72.9 0-132 59.1-132 132s59.1 132 132 132 132-59.1 132-132-59-132-132-132zm0 189.6c-31.8 0-57.6-25.8-57.6-57.5s25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5z"
  }));
});

/**
* @file 图标branch
* @author zhanglili
*/
var IconBranch =
/*#__PURE__*/
createIcon('branch', SVG$C);

var SVG$D = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "20",
    height: "20"
  }, props), React.createElement("path", {
    d: "M15 2a2 2 0 0 1 .5 3.937v4.08l-10 3.011.001 1.035a2 2 0 1 1-1.001 0V5.937a2 2 0 1 1 1.001 0L5.5 11.984l9-2.711-.001-3.336A2 2 0 0 1 15 2zM5 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM5 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }));
});

/**
* @file 图标branch-create
* @author zhanglili
*/
var IconBranchCreate =
/*#__PURE__*/
createIcon('branch-create', SVG$D);

var SVG$E = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props), React.createElement("path", {
    d: "M20.324 27.216l-3.37 3.366a8.115 8.115 0 0 1-5.766 2.386 8.121 8.121 0 0 1-5.77-2.386 8.15 8.15 0 0 1 0-11.522l3.37-3.37-2.118-2.113-3.368 3.36c-4.35 4.355-4.35 11.405 0 15.76a11.092 11.092 0 0 0 7.886 3.263c2.98 0 5.779-1.16 7.885-3.264l3.37-3.363-2.119-2.117zM15.706 8.784l3.367-3.364a8.106 8.106 0 0 1 5.77-2.386c2.177 0 4.224.847 5.766 2.386a8.152 8.152 0 0 1 0 11.52l-3.365 3.364 2.116 2.117 3.368-3.361c4.35-4.354 4.35-11.405 0-15.759a11.087 11.087 0 0 0-7.886-3.26 11.084 11.084 0 0 0-7.885 3.263l-3.37 3.36 2.119 2.12zM30.002 31.47a1.493 1.493 0 0 1-1.06-.436L4.972 7.083a1.496 1.496 0 0 1 0-2.117 1.5 1.5 0 0 1 2.119 0l23.972 23.946a1.495 1.495 0 0 1-1.058 2.555l-.003.003z"
  }));
});

/**
* @file 图标break-line
* @author zhanglili
*/
var IconBreakLine =
/*#__PURE__*/
createIcon('break-line', SVG$E);

var SVG$F = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M466.6 508.3l-95-95c-3-3-7.9-3-10.9-.1L66.2 707.8c-3 3-3 7.9.1 10.9L305.6 958c3 3 7.9 3 10.9.1L611 663.5c3-3 3-7.9-.1-10.9l-97-97-47.5 47.5 50.9 50.9-211.7 208.9-144-145 209.8-209.8 47.7 47.7m136.6-41.9l97 97c3 3 7.9 3 10.9.1l294.5-294.5c3-3 3-7.9-.1-10.9L718.8 66.1c-3-3-7.9-3-10.9-.1L413.3 360.6c-3 3-3 7.9.1 10.9l95 95 47.9-47.9-47.5-47.8L718.5 161l146 145.9-211.8 208.9-49.3-49.6m-375.2-261l3.4-2.8c12.7-10.7 31.6-9 42.3 3.6l43.3 51.4c10.7 12.7 9 31.6-3.6 42.3l-3.4 2.8c-12.7 10.7-31.6 9-42.3-3.6l-43.3-51.4c-10.7-12.7-9-31.7 3.6-42.3zM109.4 336.3l2-3.9c7.6-14.7 25.7-20.5 40.4-12.9l59.7 30.9c14.7 7.6 20.5 25.7 12.9 40.4l-2 3.9c-7.6 14.7-25.7 20.5-40.4 12.9l-59.7-30.9c-14.7-7.6-20.5-25.7-12.9-40.4zM376.9 109l4.2-1.3c15.8-5 32.7 3.8 37.6 19.6l20.2 64.1c5 15.8-3.8 32.7-19.6 37.6l-4.2 1.3c-15.8 5-32.7-3.8-37.6-19.6l-20.2-64.1c-5-15.8 3.8-32.6 19.6-37.6zM711.7 727.4l3.4-2.8c12.7-10.7 31.6-9 42.3 3.6l43.3 51.4c10.7 12.7 9 31.6-3.6 42.3l-3.4 2.8c-12.7 10.7-31.6 9-42.3-3.6L708 769.6c-10.6-12.6-9-31.6 3.7-42.2zm89.1-91.4l2-3.9c7.6-14.7 25.7-20.5 40.4-12.9l59.7 30.9c14.7 7.6 20.5 25.7 12.9 40.4l-2 3.9c-7.6 14.7-25.7 20.5-40.4 12.9l-59.7-30.9c-14.8-7.6-20.6-25.7-12.9-40.4zM605.9 797.9l4.2-1.3c15.8-5 32.7 3.8 37.6 19.6l20.2 64.1c5 15.8-3.8 32.7-19.6 37.6l-4.2 1.3c-15.8 5-32.7-3.8-37.6-19.6l-20.2-64.1c-5-15.7 3.8-32.6 19.6-37.6z"
  }));
});

/**
* @file 图标break-link
* @author zhanglili
*/
var IconBreakLink =
/*#__PURE__*/
createIcon('break-link', SVG$F);

var SVG$G = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M889.889 536.758c0 8.113-2.964 15.134-8.893 21.062-5.929 5.929-12.949 8.893-21.062 8.893H755.089c0 53.358-10.453 98.603-31.359 135.735l97.355 97.823c5.929 5.929 8.893 12.949 8.893 21.062 0 8.113-2.964 15.134-8.893 21.062-5.617 5.929-12.637 8.893-21.062 8.893s-15.446-2.964-21.062-8.893l-92.675-92.206c-1.56 1.56-3.9 3.588-7.021 6.085-3.12 2.496-9.673 6.943-19.658 13.339s-20.126 12.091-30.423 17.084c-10.297 4.993-23.091 9.517-38.38 13.573-15.29 4.056-30.423 6.085-45.401 6.085V386.981h-59.911v419.376c-15.914 0-31.75-2.106-47.507-6.319-15.758-4.212-29.331-9.361-40.721-15.446-11.389-6.085-21.686-12.169-30.892-18.254s-15.992-11.155-20.36-15.212l-7.021-6.553-85.654 96.887c-6.241 6.553-13.73 9.829-22.467 9.829-7.489 0-14.198-2.496-20.126-7.489-5.929-5.617-9.127-12.559-9.595-20.828-.468-8.269 1.95-15.524 7.255-21.764L302.95 694.96c-18.098-35.572-27.147-78.321-27.147-128.247H170.959c-8.113 0-15.134-2.964-21.062-8.893-5.929-5.929-8.893-12.949-8.893-21.062s2.964-15.134 8.893-21.062c5.929-5.929 12.949-8.893 21.062-8.893h104.844V369.195l-80.973-80.973c-5.929-5.929-8.893-12.949-8.893-21.062 0-8.113 2.964-15.134 8.893-21.062s12.949-8.893 21.062-8.893c8.113 0 15.134 2.964 21.062 8.893l80.973 80.973h395.037l80.973-80.973c5.929-5.929 12.949-8.893 21.062-8.893 8.113 0 15.134 2.964 21.062 8.893 5.929 5.929 8.893 12.949 8.893 21.062s-2.964 15.134-8.893 21.062l-80.973 80.973v137.608h104.844c8.113 0 15.134 2.964 21.062 8.893 5.93 5.929 8.895 12.95 8.895 21.062zM665.223 267.16H365.669c0-41.501 14.588-76.839 43.763-106.014s64.513-43.763 106.014-43.763c41.501 0 76.839 14.588 106.014 43.763 29.176 29.175 43.763 64.513 43.763 106.014z"
  }));
});

/**
* @file 图标bug-solid
* @author zhanglili
*/
var IconBugSolid =
/*#__PURE__*/
createIcon('bug-solid', SVG$G);

var SVG$H = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M924.4 236.2c-.1-38-31.7-68.8-69.5-68.7l-157.7.4V98.2h-53.6v69.7H536.4V98.2h-53.6v69.7H375.6V98.2H322v69.7H168.9c-38.1 0-69 30.7-68.9 68.8l1.2 622.8c.1 38 31.4 68.8 69 68.8h686.7c38 0 68.8-30.8 68.7-68.9l-1.2-623.2zm-69.8 596.3c0 14.8-12 26.8-26.8 26.8H189.3c-14.8 0-26.8-12-26.8-26.8V261.9c0-14.8 12-26.8 26.8-26.8h134.1v53.6H377v-53.6h107.2v53.6h53.6v-53.6H645v53.6h53.6v-53.6h129.2c14.8 0 26.8 12 26.8 26.8v570.6z"
  }), React.createElement("path", {
    d: "M272.5 365.4h110.8v55.4H272.5zm184.6 0h110.8v55.4H457.1zm183.6 0h110.8v55.4H640.7zM272.5 526.3h110.8v55.4H272.5zm184.6 0h110.8v55.4H457.1zm183.6 0h110.8v55.4H640.7zM272.5 687.1h110.8v55.4H272.5zm184.6 0h110.8v55.4H457.1zm183.6 0h110.8v55.4H640.7z"
  }));
});

/**
* @file 图标calendar-o
* @author zhanglili
*/
var IconCalendarO =
/*#__PURE__*/
createIcon('calendar-o', SVG$H);

var SVG$I = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.3 65.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5 383.5 171.7 383.5 383.5c0 211.9-171.7 383.5-383.5 383.5z"
  }), React.createElement("path", {
    d: "M315.7 665.3L661.1 320c3.9-3.9 10.2-3.9 14.1 0l32.2 32.2c3.9 3.9 3.9 10.2 0 14.1L362 711.7c-3.9 3.9-10.2 3.9-14.1 0l-32.2-32.2c-3.9-3.9-3.9-10.3 0-14.2z"
  }));
});

/**
* @file 图标cancel-o
* @author zhanglili
*/
var IconCancelO =
/*#__PURE__*/
createIcon('cancel-o', SVG$I);

var SVG$J = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.3 65.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zM347.8 711.6l-32.2-32.2c-3.9-3.9-3.9-10.2 0-14.1L661 320c3.9-3.9 10.2-3.9 14.1 0l32.2 32.2c3.9 3.9 3.9 10.2 0 14.1L362 711.6c-3.9 3.9-10.3 3.9-14.2 0z"
  }));
});

/**
* @file 图标cancel-solid
* @author zhanglili
*/
var IconCancelSolid =
/*#__PURE__*/
createIcon('cancel-solid', SVG$J);

var SVG$K = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M959.8 423.9V839H70.2V423.9h889.6zM841.2 542.5H722.6v118.6h118.6V542.5zm118.6-355.9v177.9H70.2V186.6h889.6z"
  }));
});

/**
* @file 图标card
* @author zhanglili
*/
var IconCard =
/*#__PURE__*/
createIcon('card', SVG$K);

var SVG$L = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M118.1 576.6h308.8c11 0 20 9 20 20V813c0 11-9 20-20 20H118.1c-11 0-20-9-20-20V596.6c0-11 9-20 20-20zM597 190h308.8c11 0 20 9 20 20v216.4c0 11-9 20-20 20H597c-11 0-20-9-20-20V210c0-11 9-20 20-20zm-477.7 1.8h308.8c11 0 20 9 20 20v216.4c0 11-9 20-20 20H119.3c-11 0-20-9-20-20V211.8c0-11 9-20 20-20zm476.5 383h308.8c11 0 20 9 20 20v216.4c0 11-9 20-20 20H595.8c-11 0-20-9-20-20V594.8c0-11 9-20 20-20z"
  }));
});

/**
* @file 图标card-show
* @author zhanglili
*/
var IconCardShow =
/*#__PURE__*/
createIcon('card-show', SVG$L);

var SVG$M = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M223.5 223.4h647.4v84.2H223.5zm0 232.4h227V540h-227zm0 232.3h227v84.2h-227zm555.815-9.752l59.537-59.538 121.48 121.48-59.538 59.538zM107.5 223.4c23.2 0 42.1 18.8 42.1 42.1v.1c0 23.2-18.8 42.1-42.1 42.1-23.2 0-42.1-18.8-42.1-42.1v-.1c0-23.3 18.8-42.1 42.1-42.1zm0 232.4c23.2 0 42.1 18.8 42.1 42.1v.1c0 23.2-18.8 42.1-42.1 42.1-23.2 0-42.1-18.8-42.1-42.1v-.1c0-23.3 18.8-42.1 42.1-42.1zm0 232.3c23.2 0 42.1 18.8 42.1 42.1v.1c0 23.2-18.8 42.1-42.1 42.1-23.2 0-42.1-18.8-42.1-42.1v-.1c0-23.2 18.8-42.1 42.1-42.1z"
  }), React.createElement("path", {
    d: "M723.8 378c102.8 0 186.1 83.3 186.1 186.1s-83.3 186.1-186.1 186.1-186.1-83.3-186.1-186.1S621.1 378 723.8 378zm0 68.7c-64.8 0-117.4 52.6-117.4 117.4S659 681.5 723.8 681.5s117.4-52.6 117.4-117.4-52.5-117.4-117.4-117.4z"
  }));
});

/**
* @file 图标card-zoom
* @author zhanglili
*/
var IconCardZoom =
/*#__PURE__*/
createIcon('card-zoom', SVG$M);

var SVG$N = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M497.5 129.4c203.1 0 367.8 164.7 367.8 367.8 0 90.5-32.7 173.4-86.9 237.5L887 843.3l2.7 3.1c9.1 12 8.2 29.2-2.7 40.2-12 12-31.4 12-43.3 0L735 778c-64.1 54.3-147 87-237.5 87-203.1 0-367.8-164.7-367.8-367.8s164.7-367.8 367.8-367.8zm0 61.3C328.2 190.7 191 327.9 191 497.2s137.2 306.5 306.5 306.5S804 666.5 804 497.2 666.8 190.7 497.5 190.7z"
  }), React.createElement("path", {
    d: "M497.5 314.9c53.2 0 96.7 41.4 100.1 93.7l.2 6.6H397.2c0-55.4 44.9-100.3 100.3-100.3zm0 32.7c-23.6 0-44.3 12.1-56.4 30.4l-2.8 4.5h118.4L554 378c-11.1-16.8-29.5-28.3-50.6-30.1l-5.9-.3zM615.7 440v121.3c0 65.3-52.9 118.2-118.2 118.2s-118.2-52.9-118.2-118.2V440h236.4zM583 472.7H412v88.6c0 45.2 35 82.2 79.4 85.3l6.1.2c45.2 0 82.2-35 85.3-79.4l.2-6.1v-88.6z"
  }), React.createElement("path", {
    d: "M517.9 516.2c0 9-7.3 16.3-16.3 16.3-7.9 0-14.5-5.6-16-13.1l-.3-3.3v-33.4c0-9 7.3-16.3 16.3-16.3 7.9 0 14.5 5.6 16 13.1l.3 3.3v33.4z"
  }), React.createElement("path", {
    d: "M628 411.6c3-8.5 12.4-12.9 20.9-9.9 8.5 3 12.9 12.4 9.9 20.9-11.1 31-39.5 51.9-72.9 54.4l-6.7.2H414.7c-34.3 0-65.2-22.1-78.2-53.9-3.4-8.3.6-17.9 8.9-21.3 8.3-3.4 17.9.6 21.3 8.9 7.5 18.2 24.2 31.3 42.9 33.4l5.1.3h164.5c22.7 0 41.7-13.1 48.8-33zM648.9 686.9c8.5-3 12.9-12.4 9.9-20.9-11.8-33.1-43.3-54.6-79.6-54.6-9 0-16.3 7.3-16.3 16.3s7.3 16.3 16.3 16.3c22.7 0 41.7 13 48.9 32.9 3 8.7 12.3 13.1 20.8 10zm-282.2-9.1c8.2-19.9 27.4-33.6 48-33.6 9 0 16.3-7.3 16.3-16.3s-7.3-16.3-16.3-16.3c-34.3 0-65.2 22.1-78.2 53.9-3.4 8.3.6 17.9 8.9 21.3 8.3 3.3 17.9-.7 21.3-9zM378.8 528.6c9 0 16.3 7.3 16.3 16.3 0 7.9-5.6 14.5-13.1 16l-3.3.3h-33.4c-9 0-16.3-7.3-16.3-16.3 0-7.9 5.6-14.5 13.1-16l3.3-.3h33.4zM649.7 528.6c9 0 16.3 7.3 16.3 16.3 0 7.9-5.6 14.5-13.1 16l-3.3.3h-33.4c-9 0-16.3-7.3-16.3-16.3 0-7.9 5.6-14.5 13.1-16l3.3-.3h33.4z"
  }));
});

/**
* @file 图标case
* @author zhanglili
*/
var IconCase =
/*#__PURE__*/
createIcon('case', SVG$N);

var SVG$O = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M872.5 816.2H403.8c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h468.7c29.9 0 54.1 24 54.1 53.7v35.8c0 29.7-24.2 53.7-54.1 53.7zm0-232.6H403.8c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h468.7c29.9 0 54.1 24 54.1 53.7v35.8c0 29.6-24.2 53.7-54.1 53.7zm0-232.7H403.8c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h468.7c29.9 0 54.1 24 54.1 53.7v35.8c0 29.7-24.2 53.7-54.1 53.7zM223.6 816.2h-72.1c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h72.1c29.9 0 54.1 24 54.1 53.7v35.8c0 29.7-24.2 53.7-54.1 53.7zm0-232.6h-72.1c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h72.1c29.9 0 54.1 24 54.1 53.7v35.8c0 29.6-24.2 53.7-54.1 53.7zm0-232.7h-72.1c-29.9 0-54.1-24-54.1-53.7v-35.8c0-29.7 24.2-53.7 54.1-53.7h72.1c29.9 0 54.1 24 54.1 53.7v35.8c0 29.7-24.2 53.7-54.1 53.7z"
  }));
});

/**
* @file 图标category
* @author zhanglili
*/
var IconCategory =
/*#__PURE__*/
createIcon('category', SVG$O);

var SVG$P = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M15 1v14H1V1zM8 12a3 3 0 0 1-2.83-2H2v4h12v-4h-3.17A3 3 0 0 1 8 12zM6 9a2 2 0 0 0 4 0h4V2H2v7zm6-3v1H4V6zm0-2v1H4V4z"
  }))));
});

/**
* @file 图标ccos
* @author zhanglili
*/
var IconCCOS =
/*#__PURE__*/
createIcon('ccos', SVG$P);

var SVG$Q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M160.3 32.3h-24.2c-10.2 0-18.5 8.3-18.5 18.5v16.7H91.7c-1 0-8.3-.3-10.7-8.8 5.5-3.9 9.1-10.3 9.1-17.6 0-11.9-9.7-21.6-21.6-21.6S47 29.2 47 41.1s9.7 21.6 21.6 21.6c2.2 7.5 6.8 11.8 10.8 14.2 5.9 3.5 11.7 3.6 12.4 3.6h25.9v10.7H62.5C59.7 82.4 51.6 76.1 42 76.1c-11.9 0-21.6 9.7-21.6 21.6s9.7 21.6 21.6 21.6c9.6 0 17.8-6.3 20.6-15.1h55.1v9.9h-26c-.6 0-6.5.1-12.4 3.6-4.6 2.7-9.8 7.9-11.6 17.6-11.5.4-20.8 9.9-20.8 21.5 0 11.9 9.7 21.6 21.6 21.6s21.6-9.7 21.6-21.6c0-7.5-3.9-14.1-9.7-18 1.3-10.6 8.9-11.7 11.3-11.8h25.9v15.5c0 10.2 8.3 18.5 18.5 18.5h24.2c10.2 0 18.5-8.3 18.5-18.5V50.8c0-10.2-8.3-18.5-18.5-18.5zM60 41.1c0-4.7 3.8-8.6 8.6-8.6s8.6 3.8 8.6 8.6-3.8 8.6-8.6 8.6-8.6-3.9-8.6-8.6zm-18 65.1c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.8 8.6 8.6c-.1 4.7-3.9 8.6-8.6 8.6zm26.6 59.1c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6 8.6 3.8 8.6 8.6-3.9 8.6-8.6 8.6zm97.2-22.8c0 3-2.5 5.5-5.5 5.5h-24.2c-3 0-5.5-2.5-5.5-5.5V50.8c0-3 2.5-5.5 5.5-5.5h24.2c3 0 5.5 2.5 5.5 5.5v91.7z"
  }));
});

/**
* @file 图标centralizedassemblylineo
* @author zhanglili
*/
var IconCentralizedassemblylineo =
/*#__PURE__*/
createIcon('centralizedassemblylineo', SVG$Q);

var SVG$R = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("g", {
    fill: "#020202"
  }, React.createElement("path", {
    d: "M865.051 131.014c-13.799-12.855-32.296-20.73-52.598-20.73H758.31c-8.543 0-16.252 3.571-21.715 9.301a29.9 29.9 0 0 0-8.285 20.699c0 8.284 3.358 15.784 8.787 21.213s12.929 8.787 21.213 8.787h54.19c4.736 0 9.03 1.926 12.141 5.037s5.037 7.405 5.037 12.141v593.633c0 4.739-1.928 9.037-5.041 12.149a17.14 17.14 0 0 1-12.15 5.04h-593.62c-7.109 0-13.224-4.337-15.837-10.505a17.097 17.097 0 0 1-1.353-6.685v-593.62c0-4.739 1.928-9.037 5.04-12.149a17.135 17.135 0 0 1 12.149-5.04h422.553c9.562 0 18.08-4.474 23.574-11.443a29.871 29.871 0 0 0 6.426-18.557c0-8.291-3.364-15.797-8.801-21.227-5.428-5.421-12.922-8.773-21.199-8.773H218.855c-21.278 0-40.572 8.655-54.547 22.63s-22.63 33.269-22.63 54.547V781.06c0 21.291 8.661 40.597 22.644 54.58s33.29 22.644 54.581 22.644h593.55c23.805 0 45.129-10.827 59.306-27.814 11.183-13.4 17.919-30.633 17.919-49.41V187.509c0-22.28-9.484-42.387-24.627-56.495z"
  }), React.createElement("path", {
    d: "M466.336 593.333a3.71 3.71 0 0 1-2.552 1.275 3.709 3.709 0 0 1-2.705-.906l-.435-.379-4.469-3.894-112.868-98.339c-5.938-5.146-13.401-7.471-20.716-7.093-7.705.398-15.246 3.795-20.667 10.05-4.461 5.148-6.802 11.442-7.1 17.792-.407 8.69 3.011 17.485 10.057 23.59l142.756 124.275c5.523 4.787 12.366 7.132 19.181 7.132 8.23 0 16.421-3.419 22.201-10.089.101-.116.193-.237.291-.354.102-.114.208-.223.309-.339L729.046 379.78c5.214-6.016 7.531-13.597 7.076-21.003-.467-7.605-3.856-15.026-10.033-20.38-5.278-4.574-11.76-6.918-18.271-7.118-8.533-.262-17.118 3.159-23.111 10.075l-213.73 246.623-4.641 5.356z"
  })));
});

/**
* @file 图标checkbox-o
* @author zhanglili
*/
var IconCheckboxO =
/*#__PURE__*/
createIcon('checkbox-o', SVG$R);

var SVG$S = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M865.051 131.014c-13.799-12.855-32.296-20.73-52.598-20.73H218.855c-21.278 0-40.572 8.655-54.547 22.63s-22.63 33.269-22.63 54.547V781.06c0 21.291 8.661 40.597 22.644 54.58s33.29 22.644 54.581 22.644h593.55c23.805 0 45.129-10.827 59.306-27.814 11.183-13.4 17.919-30.633 17.919-49.41V187.509c0-22.28-9.484-42.387-24.627-56.495zM729.046 379.78L489.62 656.055c-.101.116-.207.225-.309.339-.099.117-.191.238-.291.354-5.78 6.67-13.971 10.089-22.201 10.089-6.815 0-13.658-2.346-19.181-7.132L304.881 535.43c-7.045-6.106-10.464-14.9-10.057-23.59.298-6.35 2.638-12.644 7.1-17.792 5.421-6.255 12.962-9.652 20.667-10.05 7.315-.378 14.778 1.947 20.716 7.093l112.869 98.339 4.469 3.894.435.379a3.709 3.709 0 0 0 2.705.906 3.71 3.71 0 0 0 2.552-1.275l4.641-5.355 213.729-246.623c5.993-6.916 14.578-10.337 23.111-10.075 6.512.2 12.994 2.545 18.271 7.118 6.177 5.353 9.567 12.774 10.033 20.38.455 7.404-1.863 14.985-7.076 21.001z"
  }));
});

/**
* @file 图标checkbox-solid
* @author zhanglili
*/
var IconCheckboxSolid =
/*#__PURE__*/
createIcon('checkbox-solid', SVG$S);

var SVG$T = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M432.1 861.9L66.9 566.7c-2.5-2.1-2.9-6-.6-8.6l94.9-104.2c2.1-2.3 5.7-2.5 8-.6l252.7 204.8 415.2-492c2.1-2.5 5.7-2.7 8.2-.8L958.2 258c2.5 2.1 2.9 5.8.8 8.4L440.1 861.1c-2.2 2.3-5.7 2.7-8 .8z"
  }));
});

/**
* @file 图标check-solid
* @author zhanglili
*/
var IconCheckSolid =
/*#__PURE__*/
createIcon('check-solid', SVG$T);

var SVG$U = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M859.148 477.801c0-186.119-137.542-340.114-316.526-365.885v103.829c122.185 24.648 214.189 132.608 214.189 262.057 0 90.257-44.728 170.068-113.226 218.476l-45.756-88.773-72.48 225.42 201.51 24.916-36.051-69.945c101.334-65.932 168.34-180.189 168.34-310.095zM173.687 205.752c0 51.888 130.212 94.252 293.897 96.802V108.95c-163.684 2.549-293.897 44.914-293.897 96.802zm293.898 146.863c-152.682-2.288-293.897-49.94-293.897-49.94v118.81s145.678 48.296 293.897 49.98v-118.85zm0 187.593c-152.682-2.289-293.897-49.94-293.897-49.94v118.81s145.678 48.296 293.897 49.98v-118.85zM173.687 677.863v118.81s145.678 48.296 293.897 49.98V727.802c-152.681-2.288-293.897-49.939-293.897-49.939z"
  }));
});

/**
* @file 图标ci
* @author zhanglili
*/
var IconCI =
/*#__PURE__*/
createIcon('ci', SVG$U);

var SVG$V = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("circle", {
    cx: "513",
    cy: "512.4",
    r: "445"
  }));
});

/**
* @file 图标circle-o
* @author zhanglili
*/
var IconCircleO =
/*#__PURE__*/
createIcon('circle-o', SVG$V);

var SVG$W = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M957.7 512.5c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.2 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z"
  }));
});

/**
* @file 图标circle-solid
* @author zhanglili
*/
var IconCircleSolid =
/*#__PURE__*/
createIcon('circle-solid', SVG$W);

var SVG$X = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1025 1024"
  }, props), React.createElement("path", {
    d: "M978.714 933.542h-437.56l142.74-171.651 319.814-380.946a90.343 90.343 0 0 0-11.142-127.383l-276.75-232.18a90.343 90.343 0 0 0-127.383 11.141l-566.45 674.56a90.343 90.343 0 0 0 11.143 127.383l97.871 94.86 94.559 87.633a30.114 30.114 0 0 0 21.983 6.926h732.078a45.171 45.171 0 0 0 0-90.343zM637.218 113.531a30.114 30.114 0 0 1 42.762-3.614l230.374 193.334a30.114 30.114 0 0 1 3.915 42.762L615.536 714.61 332.46 477.01zM113.53 784.778a30.114 30.114 0 0 1-3.614-42.763L274.34 546.273l284.28 238.806L450.81 919.99a30.114 30.114 0 0 1-20.477 10.84H276.148a30.114 30.114 0 0 1-22.285-6.925z"
  }));
});

/**
* @file 图标clean-format
* @author zhanglili
*/
var IconCleanFormat =
/*#__PURE__*/
createIcon('clean-format', SVG$X);

var SVG$Y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M428.1 416.6L260.5 582.7c-28.6 28.3-44 65.1-44 104.9 0 39.8 15.4 76.6 44 104.9 58.7 58.2 153.7 58.2 211.6 0l378.4-375.1c39.4-39 61-91.1 61-146.2S890 164 850.6 124.9c-81.9-81.2-213.9-81.2-295.8 0L177.1 499.3c-51 50.5-78.8 117.1-78.8 188.3s27.8 138.6 78.8 188.3c51 50.5 118.2 78.1 190 78.1s139.8-27.6 190-78.1l167.6-166.1-44.8-44.4-167.6 166.2c-38.6 38.3-90.4 59.7-145.2 59.7s-106.6-21.4-145.2-59.7-60.2-89.6-60.2-143.9c0-54.4 21.6-105.6 60.2-143.9l377.7-374.4c27.8-27.6 64.1-42.1 102.7-42.1s75.7 15.2 102.7 42c27.8 27.6 42.5 63.5 42.5 101.8s-15.4 75-42.5 101.8L426.6 748.1c-33.2 32.9-88 32.9-122 0-16.3-16.1-25.6-37.5-25.6-60.5s9.3-44.4 25.5-60.5L472.9 461l-44.8-44.4z"
  }));
});

/**
* @file 图标clip
* @author zhanglili
*/
var IconClip =
/*#__PURE__*/
createIcon('clip', SVG$Y);

var SVG$Z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M358.7 931.4c-137 0-248.1-111.1-248.2-248.1 0-65.8 26.1-128.9 72.7-175.5l364.1-364.1c68.7-67.7 179.3-66.9 247 1.8 67 68 67 177.2 0 245.2L412.6 772.4c-41.3 40.2-107.4 39.3-147.6-2-39.5-40.5-39.5-105.2 0-145.7l396.9-396.9 45.2 45.2-396.9 397c-15.6 15.9-15.4 41.5.5 57.2 15.7 15.4 40.9 15.4 56.6 0L749 345.5c42.7-43.8 41.8-113.8-2-156.5-43-41.9-111.5-41.9-154.5 0l-364 364.1c-71.8 71.8-71.8 188.6 0 260.4 71.9 71.9 188.5 71.9 260.4 0l379.3-379.3 45.3 45.3-379.3 379.3c-46.5 46.6-109.7 72.8-175.5 72.6z"
  }));
});

/**
* @file 图标clip-alt
* @author zhanglili
*/
var IconClipAlt =
/*#__PURE__*/
createIcon('clip-alt', SVG$Z);

var SVG$_ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M775.8 203.5L511.3 467.9 248.3 205c-3.9-3.9-10.2-3.9-14.1 0l-31.1 31c-3.9 3.9-3.9 10.2 0 14.1l262.9 263-263 263c-3.9 3.9-3.9 10.2 0 14.1l31.2 31.2c3.9 3.9 10.2 3.9 14.1 0l263-263L775.8 823c3.9 3.9 10.2 3.9 14.1 0l31.2-31.2c3.9-3.9 3.9-10.2 0-14.1L556.6 513.2 821 248.7c3.9-3.9 3.9-10.2 0-14.1l-31-31.1c-3.9-3.9-10.3-3.9-14.2 0z"
  }));
});

/**
* @file 图标close
* @author zhanglili
*/
var IconClose =
/*#__PURE__*/
createIcon('close', SVG$_);

var SVG$$ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M957.7 517.5c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.2 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z"
  }), React.createElement("path", {
    d: "M687.2 733.1L513.7 559.7 340.3 733.1c-3.9 3.9-10.2 3.9-14.1 0L294.1 701c-3.9-3.9-3.9-10.2 0-14.1l173.5-173.4-173.5-173.4c-3.9-3.9-3.9-10.2 0-14.1l32.1-32.1c3.9-3.9 10.2-3.9 14.1 0l173.4 173.4 173.5-173.4c3.9-3.9 10.2-3.9 14.1 0l32.1 32.1c3.9 3.9 3.9 10.2 0 14.1L559.9 513.5l173.5 173.4c3.9 3.9 3.9 10.2 0 14.1l-32.1 32.1c-3.8 3.9-10.2 3.9-14.1 0z"
  }));
});

/**
* @file 图标close-circle-o
* @author zhanglili
*/
var IconCloseCircleO =
/*#__PURE__*/
createIcon('close-circle-o', SVG$$);

var SVG$10 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M828 197.1c-173.8-173.8-455.5-173.8-629.3 0s-173.8 455.5 0 629.3 455.5 173.8 629.3 0 173.8-455.5 0-629.3zM687.3 732.7L513.6 559 340 732.7c-3.8 3.8-10 3.8-13.9 0l-32.3-32.3c-3.8-3.8-3.8-10 0-13.9l173.6-173.6-173.6-173.7c-3.8-3.8-3.8-10 0-13.9l32.3-32.3c3.8-3.8 10-3.8 13.9 0l173.6 173.6L687.2 293c3.8-3.8 10-3.8 13.9 0l32.3 32.3c3.8 3.8 3.8 10 0 13.9L559.8 512.8l173.6 173.6c3.8 3.8 3.8 10 0 13.8l-32.3 32.4c-3.8 3.9-10 3.9-13.8.1z"
  }));
});

/**
* @file 图标close-circle-solid
* @author zhanglili
*/
var IconCloseCircleSolid =
/*#__PURE__*/
createIcon('close-circle-solid', SVG$10);

var SVG$11 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M144.6 49.3c-1.9-.5-3.3-1.9-3.8-3.8-4.5-18.2-21.3-31.8-41.4-31.8S62.4 27.3 58 45.5c-.5 1.9-1.9 3.4-3.8 3.8-18.5 4.5-32.4 20.8-32.4 40 0 22.8 19.1 41.2 42.5 41.2 1.4 0 2.8-.1 4.2-.2 2.6-.2 4.6-2.5 4.6-5v-3.6c0-3-2.7-5.3-5.7-4.9-.9.1-2 .1-3 .1-15.7 0-28.4-12.3-28.4-27.6 0-15 12.6-27.3 28.2-27.6h2c2.7 0 4.9-2.2 4.9-5v-1.8c0-15.2 12.8-27.6 28.4-27.6s28.4 12.3 28.4 27.6v1.8c0 2.7 2.2 5 4.9 5h2c15.5.2 28.2 12.6 28.2 27.6 0 15.2-12.8 27.6-28.4 27.6-1.1 0-2 0-3-.1-3-.4-5.7 2-5.7 4.9v3.6c0 2.6 2 4.8 4.6 5 1.4.1 2.8.2 4.2.2 23.5 0 42.5-18.5 42.5-41.2-.2-19.2-14-35.5-32.6-40z"
  }), React.createElement("path", {
    d: "M120.1 150.1c-.9-.9-2.3-.9-3.3 0l-10.6 10.6V92.3c0-2.3-1.9-4.1-4.1-4.1H96c-2.3 0-4.1 1.9-4.1 4.1v69l-10.4-10.4c-1.1-1.1-2.7-1.1-3.6 0l-6.2 6.2c-1.1 1.1-1.1 2.7 0 3.6l23.1 23.1c2.3 2.3 6.1 2.3 8.3 0l23.8-23.8c.9-.9.9-2.3 0-3.3l-6.8-6.6z"
  }));
});

/**
* @file 图标cloud-download
* @author zhanglili
*/
var IconCloudDownload =
/*#__PURE__*/
createIcon('cloud-download', SVG$11);

var SVG$12 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M10 3a6.5 6.5 0 0 1 6.49 6.144 3.5 3.5 0 0 1-.798 6.851L15.5 16h-11a3.5 3.5 0 0 1-.99-6.858A6.5 6.5 0 0 1 10 3zm0 1.5a5 5 0 0 0-4.975 4.504l-.017.219-.057 1.059-1.017.299a2.001 2.001 0 0 0 .417 3.914l.149.005h10.96l.151-.003a2 2 0 0 0 .612-3.862l-.155-.052-1.018-.299-.057-1.06A5 5 0 0 0 10 4.5z"
  }), React.createElement("path", {
    d: "M7.447 8.307l.92.919-1.662 1.662 1.661 1.661-.919.92-2.58-2.581zm5.19 0l-.92.919 1.663 1.661-1.663 1.662.92.92 2.58-2.581zm-2.241.284l1.106.556-2.164 4.81-1.106-.555z"
  }));
});

/**
* @file 图标cloud-ide
* @author zhanglili
*/
var IconCloudIDE =
/*#__PURE__*/
createIcon('cloud-ide', SVG$12);

var SVG$13 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M374.3 422.7l-245.5 90.1 245.6 90.9c3.9 1.5 6.5 5.2 6.5 9.4v30.8c0 7-7 11.8-13.6 9.3l-298-113.6c-3.9-1.5-6.4-5.2-6.4-9.3v-34.9c0-4.2 2.6-7.9 6.5-9.4l298-112.7c6.5-2.5 13.5 2.4 13.5 9.4v30.6c0 4.2-2.6 8-6.6 9.4zm84.5 308.8h-26.5c-6.8 0-11.6-6.6-9.5-13L555.5 296c1.3-4.2 5.2-7 9.5-7h27c6.8 0 11.6 6.6 9.5 13L468.3 724.5c-1.3 4.2-5.2 7-9.5 7zm500.5-194.3l-304.4 116c-6.5 2.5-13.6-2.3-13.6-9.3v-30.8c0-4.2 2.6-7.9 6.5-9.4l245.6-90.9-245.5-90.1c-3.9-1.4-6.6-5.2-6.6-9.4v-30.7c0-7 7-11.8 13.5-9.4l298 112.7c3.9 1.5 6.5 5.2 6.5 9.4v41.9z"
  }));
});

/**
* @file 图标code
* @author zhanglili
*/
var IconCode =
/*#__PURE__*/
createIcon('code', SVG$13);

var SVG$14 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M73.1 922l31.1 31.1c3.9 3.9 10.2 3.9 14.1 0l263.5-263.4v265.5c0 5.5 4.5 10 10 10h43.3c5.5 0 10-4.5 10-10V591.7c0-5.5-4.5-10-10-10H71.6c-5.5 0-10 4.5-10 10v44.2c0 5.5 4.5 10 10 10h263.6L73.1 907.8c-3.9 3.9-3.9 10.3 0 14.2zM924.7 70.3l31.1 31.1c3.9 3.9 3.9 10.2 0 14.1L692.3 379h265.5c5.5 0 10 4.5 10 10v43.3c0 5.5-4.5 10-10 10H594.4c-5.5 0-10-4.5-10-10V68.9c0-5.5 4.5-10 10-10h44.2c5.5 0 10 4.5 10 10v263.5L910.5 70.3c3.9-3.9 10.3-3.9 14.2 0z"
  }));
});

/**
* @file 图标collapse-all
* @author zhanglili
*/
var IconCollapseAll =
/*#__PURE__*/
createIcon('collapse-all', SVG$14);

var SVG$15 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510.5 832.9L281.9 953c-27.4 14.4-61.2 3.8-75.6-23.6-5.7-10.9-7.7-23.3-5.6-35.4l43.7-254.5-185-180.3c-22.1-21.6-22.5-57.1-.9-79.2 8.6-8.8 19.8-14.5 31.9-16.3l255.6-37L460.3 95.1c13.7-27.7 47.3-39.1 75-25.3 11 5.4 19.9 14.3 25.3 25.3L675 326.7l255.6 37.1c30.6 4.5 51.8 32.9 47.3 63.5-1.8 12.1-7.5 23.3-16.3 31.9l-185 180.3L820.3 894c5.2 30.5-15.3 59.4-45.8 64.6-12.1 2.1-24.5.1-35.4-5.6L510.5 832.9zm0-69.8l246.9 129.8-47.2-275L910 423.2l-276-40.1L510.5 133 387 383.1l-276 40.1L310.7 618l-47.2 275 247-129.9z"
  }));
});

/**
* @file 图标collection
* @author zhanglili
*/
var IconCollection =
/*#__PURE__*/
createIcon('collection', SVG$15);

var SVG$16 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "20",
    height: "20"
  }, props), React.createElement("path", {
    d: "M10.048 2c.074 0 .148.043.176.127l2.531 5.207 5.64.638c.18 0 .255.226.11.33l-4.395 3.699 1.273 5.76a.181.181 0 0 1-.067.204.188.188 0 0 1-.218 0l-5.05-2.947-5.05 2.948a.189.189 0 0 1-.217-.002.182.182 0 0 1-.068-.203l1.273-5.76L1.59 8.302a.18.18 0 0 1 .063-.324l5.686-.644L9.87 2.127A.182.182 0 0 1 10.048 2zm1.717 6.735L10.047 5.2 8.33 8.735l-3.43.387 2.75 2.315-.823 3.719 3.221-1.878 3.221 1.879-.822-3.72 2.748-2.315-3.43-.387z"
  }));
});

/**
* @file 图标collection-o
* @author zhanglili
*/
var IconCollectionO =
/*#__PURE__*/
createIcon('collection-o', SVG$16);

var SVG$17 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "20",
    height: "20"
  }, props), React.createElement("path", {
    d: "M10.048 2c.074 0 .148.043.176.127l2.531 5.207 5.64.638c.18 0 .255.226.11.33l-4.395 3.699 1.273 5.76a.181.181 0 0 1-.067.204.188.188 0 0 1-.218 0l-5.05-2.947-5.05 2.948a.189.189 0 0 1-.217-.002.182.182 0 0 1-.068-.203l1.273-5.76L1.59 8.302a.18.18 0 0 1 .063-.324l5.686-.644L9.87 2.127A.182.182 0 0 1 10.048 2z"
  }));
});

/**
* @file 图标collection-solid
* @author zhanglili
*/
var IconCollectionSolid =
/*#__PURE__*/
createIcon('collection-solid', SVG$17);

var SVG$18 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M927.72 135.22l.28 631.2H671.73L512.52 907.76 353.31 766.42H96l-.28-631.2zm-64 63.95H159.68l.26 503.23h217.68l134.89 119.74 134.92-119.72h216.51zM512 512v64H256v-64zm256-192v64H256v-64z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标comment-alt
* @author zhanglili
*/
var IconCommentAlt =
/*#__PURE__*/
createIcon('comment-alt', SVG$18);

var SVG$19 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M945.4 66.1H81.1c-8.9 0-16 7.1-16 16.1L64.6 959 255 767.6h690.5c8.8 0 16-7.2 16-16V82.1c-.1-8.9-7.3-16-16.1-16zm-46.4 621c0 8.8-7.2 16-16 16H228.5l-99.4 101.4.4-658.8c0-9 7.2-16.1 16-16.1h737.3c8.8 0 16 7.2 16 16v541.5h.2z"
  }), React.createElement("path", {
    d: "M266 256h492.1c5.5 0 10 4.5 10 10v44.3c0 5.5-4.5 10-10 10H266c-5.5 0-10-4.5-10-10V266c0-5.5 4.5-10 10-10zm1 128h492.1c5.5 0 10 4.5 10 10v44.3c0 5.5-4.5 10-10 10H267c-5.5 0-10-4.5-10-10V394c0-5.5 4.5-10 10-10zm-2 128h492.1c5.5 0 10 4.5 10 10v44.3c0 5.5-4.5 10-10 10H265c-5.5 0-10-4.5-10-10V522c0-5.5 4.5-10 10-10z"
  }));
});

/**
* @file 图标comment-o
* @author zhanglili
*/
var IconCommentO =
/*#__PURE__*/
createIcon('comment-o', SVG$19);

var SVG$1a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M52.8 172.3c-.9 0-1.9-.2-2.8-.6-2.9-1.2-4.7-4-4.7-7.2v-15.9h-8.5c-5.9 0-10.8-5-10.8-11.2V68.1c0-6.2 4.8-11.2 10.8-11.2h101.8c5.9 0 10.8 5 10.8 11.2v69.3c0 6.2-4.8 11.2-10.8 11.2h-61l-19.4 21.2c-1.5 1.6-3.4 2.5-5.4 2.5zM37 137.2h19.3v18.1l16.5-18.1h65.5V68.4H37v68.8z"
  }), React.createElement("path", {
    d: "M174.8 38.5v68.6c0 6.5-5.1 11.8-11.3 11.8H155v-11.5h8.5c.2 0 .3-.1.3-.3V38.5c0-.2-.1-.3-.3-.3H62.1c-.2 0-.3.1-.3.3v12.8h-11V38.5c0-6.5 5.1-11.8 11.3-11.8h101.3c6.3 0 11.4 5.3 11.4 11.8zm-114 55.6c-4.5 0-8.2 3.7-8.2 8.2s3.7 8.2 8.2 8.2c4.5 0 8.2-3.7 8.2-8.2s-3.7-8.2-8.2-8.2zm35.1 8.2c0 4.5-3.7 8.2-8.2 8.2s-8.2-3.7-8.2-8.2 3.7-8.2 8.2-8.2 8.2 3.6 8.2 8.2zm26.8 0c0 4.5-3.7 8.2-8.2 8.2s-8.2-3.7-8.2-8.2 3.7-8.2 8.2-8.2 8.2 3.6 8.2 8.2z"
  }));
});

/**
* @file 图标comments-o
* @author zhanglili
*/
var IconCommentsO =
/*#__PURE__*/
createIcon('comments-o', SVG$1a);

var SVG$1b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M945.4 66.1H81.1c-8.9 0-16 7.1-16 16.1L64.6 959 255 767.6h690.5c8.8 0 16-7.2 16-16V82.1c-.1-8.9-7.3-16-16.1-16zM266 256h492.1c5.5 0 10 4.5 10 10v44.3c0 5.5-4.5 10-10 10H266c-5.5 0-10-4.5-10-10V266c0-5.5 4.5-10 10-10zm491.1 320.3H265c-5.5 0-10-4.5-10-10V522c0-5.5 4.5-10 10-10h492.1c5.5 0 10 4.5 10 10v44.3c0 5.5-4.5 10-10 10zm2-128H267c-5.5 0-10-4.5-10-10V394c0-5.5 4.5-10 10-10h492.1c5.5 0 10 4.5 10 10v44.3c0 5.5-4.5 10-10 10z"
  }));
});

/**
* @file 图标comment-solid
* @author zhanglili
*/
var IconCommentSolid =
/*#__PURE__*/
createIcon('comment-solid', SVG$1b);

var SVG$1c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M255.7 642.9h544.7V253.8H920c5.5 0 10 4.5 10 10v664.4L774.4 772.6l-508.8-6.3c-5.5-.1-9.9-4.5-9.9-10V642.9zm312.2-280.6c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3 45.3 20.3 45.3 45.3c-.1 25-20.3 45.3-45.3 45.3zM100 108.2v612.5l155.6-155.6h456.9c5.5 0 10-4.5 10-10V108.2c0-5.5-4.5-10-10-10H110c-5.5 0-10 4.5-10 10zm317.9 254.1c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3 45.3 20.3 45.3 45.3c0 25-20.3 45.3-45.3 45.3zm-155.5 0c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3 45.3 20.3 45.3 45.3c-.1 25-20.3 45.3-45.3 45.3z"
  }));
});

/**
* @file 图标comments-solid
* @author zhanglili
*/
var IconCommentsSolid =
/*#__PURE__*/
createIcon('comments-solid', SVG$1c);

var SVG$1d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M701.6 478.2c-15.6-90.4-94.4-159.1-189.2-159.1s-173.6 68.8-189.2 159.1H73.3c-5.5 0-10 4.5-10 10v44c0 5.5 4.5 10 10 10h249.6c14.9 91.2 94 160.8 189.5 160.8S687 633.4 701.9 542.2h247.4c5.5 0 10-4.5 10-10v-44c0-5.5-4.5-10-10-10H701.6zM512.4 608.7c-53.9 0-97.7-43.7-97.7-97.7s43.7-97.7 97.7-97.7 97.7 43.7 97.7 97.7-43.7 97.7-97.7 97.7z"
  }));
});

/**
* @file 图标commit
* @author zhanglili
*/
var IconCommit =
/*#__PURE__*/
createIcon('commit', SVG$1d);

var SVG$1e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M138.9 63.9c-5.5 0-10 4.5-10 10v876.7c0 5.5 4.5 10 10 10h747c5.5 0 10-4.5 10-10V256.1h-61.8v641.5H193.9V128h510.5V64.6"
  }), React.createElement("path", {
    d: "M704.3 256V125.7l-65.9-61.1v240.5c0 5.5 4.5 10 10 10h247.5L835.1 256H704.3zm5.9 274.6c-6.6-1.2-19.8-1.9-39.6-1.9H644V606h30.1c21.7 0 36.2-1.4 43.5-4.3 7.3-2.8 13-7.3 17.2-13.4 4.2-6.1 6.2-13.1 6.2-21.2 0-9.9-2.9-18.1-8.7-24.5-5.8-6.3-13.2-10.4-22.1-12z"
  }), React.createElement("path", {
    d: "M64.4 437.1v363.5c0 5.5 4.5 10 10 10h876c5.5 0 10-4.5 10-10V437.1c0-5.5-4.5-10-10-10h-876c-5.5 0-10 4.5-10 10zm384.1 318H227.1v-49.6l143.1-176.8H243.3v-46.1h199.4v42.7L293.5 709.2h155v45.9zm88.1 0h-55V482.7h55v272.4zm252-146.4c-6.1 11.4-13.8 20.4-23.1 26.9-9.4 6.5-18.9 10.8-28.5 12.9-13.1 2.6-32.2 3.9-57.1 3.9H644v102.8h-55V482.7h88.3c33.5 0 55.3 1.4 65.4 4.1 15.6 4.1 28.7 13 39.2 26.7 10.5 13.7 15.8 31.4 15.8 53.1.1 16.6-3 30.7-9.1 42.1zM657 63.9h47.4l191.8 191.9v45.8z"
  }));
});

/**
* @file 图标compress
* @author zhanglili
*/
var IconCompress =
/*#__PURE__*/
createIcon('compress', SVG$1e);

var SVG$1f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M86.8 384.3c-9 0-16.3-7.3-16.3-16.3V207.5c0-9 7.3-16.3 16.3-16.3h302.4c9 0 16.3 7.3 16.3 16.3v36.8h519c9 0 16.3 7.3 16.3 16.3v107.3c0 9-7.3 16.3-16.3 16.3h-45V326c0-13.5-11-24.5-24.5-24.5H156.3c-13.5 0-24.5 11-24.5 24.5v58.3h-45zm-21.7 32.4c-.2-2 1.2-3.8 3.2-4h887.4c2.2 0 3.8 1.9 3.6 4l-44.2 409.8c-.2 2.2-2.2 4-4.5 4h-801c-2.2 0-4.2-1.9-4.4-4L65.1 416.7z"
  }));
});

/**
* @file 图标contents
* @author zhanglili
*/
var IconContents =
/*#__PURE__*/
createIcon('contents', SVG$1f);

var SVG$1g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M750.8 107.8c-5.6-5.7-13.3-8.8-21.3-8.8l-303.6.8c-5.5 0-10 4.5-10 10l-.1 19.3v608.5l.1 20c0 5.5 4.5 10 10 10h489.5c5.5 0 10-4.5 10-10V295.9c0-7.9-3.1-15.5-8.7-21.1l-165.9-167zm114.8 201H715.8V158.9h1.3l148.5 149.9zM476 707.4V158.9h179.8v179.2c0 16.6 12.7 30.6 29.3 30.6h180.5v338.7H476zM105.9 257.8c-5.5 0-10 4.5-10 10v649.4c0 5.5 4.5 10 10 10h489.8c5.5 0 9.9-4.4 10-9.8l-.7-83.3h-59l-.5 33.1H155.9V317.7h162.5v-59.9"
  }));
});

/**
* @file 图标copy
* @author zhanglili
*/
var IconCopy =
/*#__PURE__*/
createIcon('copy', SVG$1g);

var SVG$1h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("g", {
    fill: "#0A0101"
  }, React.createElement("path", {
    d: "M923.683 219.093L756.79 50.625h-1.501v168.468z"
  }), React.createElement("path", {
    d: "M485.74 50.625v606.487h438.019V286.481H720.805c-18.608 0-32.902-15.761-32.902-34.368V50.625H485.74zm291.15-66.824l-.134-.134h-.633c.256.041.512.087.767.134zM418.394 707.637v16.434h.039z"
  })), React.createElement("path", {
    d: "M417.532 724.5V174.598H107.21v740.403h572.713V724.5z"
  }));
});

/**
* @file 图标copy-solid
* @author zhanglili
*/
var IconCopySolid =
/*#__PURE__*/
createIcon('copy-solid', SVG$1h);

var SVG$1i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M8 1l3 1.75v3.5l-1.1.65L11 8.57 12 8l3 1.75v3.5L12 15l-3-1.76v-.75H7v.75L4 15l-3-1.76v-3.5L4 8l1 .52 1-1.67-1-.6v-3.5zM4 9.15l-2 1.16v2.35l2 1.17 2-1.17v-2.35zm8 0l-2 1.16v2.35l2 1.17 2-1.17v-2.35zM4 10l1.28.71v1.43L4 12.86l-1.29-.72v-1.43zm8 0l1.28.71v1.43l-1.28.72-1.29-.72v-1.43zM6.87 7.35L5.82 9 7 9.74v1.75h2V9.74l1.13-.66L9 7.4 8 8zM8 2.15L6 3.33v2.34l2 1.17 2-1.17V3.33zM8 3l1.28.71v1.43L8 5.86l-1.27-.72V3.71z"
  }))));
});

/**
* @file 图标cos
* @author zhanglili
*/
var IconCOS =
/*#__PURE__*/
createIcon('cos', SVG$1i);

var SVG$1j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M99.8 18L28.5 57.5v84.2L99.8 181l71.4-39.5v-84L99.8 18zm-6.6 143.9l-50.1-26.1V66l50.1 24.1v71.8zM58.4 56.5l41.4-21.9L142.1 58 99.8 78.4 58.4 56.5zm98.8 78l-49.7 27.4V90.8l49.7-24.7v68.4z"
  }));
});

/**
* @file 图标cube-o
* @author zhanglili
*/
var IconCubeO =
/*#__PURE__*/
createIcon('cube-o', SVG$1j);

var SVG$1k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M151.4 245.2C73.7 351.6 40.6 493.3 85.3 644.7c41.2 141.5 153.3 252.7 293.9 294.8 146.4 43.8 287.1 13 392.8-62.3 3.5-2.5 4-7.5.9-10.7L702 795.6c-2.3-2.3-6-2.6-8.8-.9-51.9 33-113.6 52.4-179.8 52.4-185.5 0-335.1-149.6-336-334.3l1.8-1.8H344c1.8 0 3.5-.7 4.9-1.9 5.4-5.3 20.3-20 28.1-27.9 2.6-2.8 2.6-7.2 0-9.8m490.3 296.4c3.2 3.2 8.2 2.6 10.7-.9 74.2-105.8 104.2-245.3 61.2-391.8C898 233.6 785.9 122.4 644.4 81.2c-146.4-42.1-284.3-12.1-390 62.3-3.5 2.5-4 7.7-.9 10.7l70.9 70.9c2.3 2.3 6 2.6 8.8.9 51.7-32.3 112.9-51.7 178.9-51.7 185.4 0 336 150.5 336 336H683.3c-1.8 0-3.5.7-4.9 1.9-5.4 5.3-20.3 20-28.1 27.9-2.6 2.8-2.6 7.2 0 9.8"
  }));
});

/**
* @file 图标cycle
* @author zhanglili
*/
var IconCycle =
/*#__PURE__*/
createIcon('cycle', SVG$1k);

var SVG$1l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M305.7 360.5C261.4 421.2 242.5 502 268 588.3c23.5 80.7 87.4 144.1 167.6 168.1 83.5 25 163.7 7.4 224-35.5 2-1.4 2.3-4.3.5-6.1l-40.4-40.4c-1.3-1.3-3.4-1.5-5-.5-29.6 18.8-64.8 29.9-102.5 29.9-105.8 0-191.1-85.3-191.6-190.6l1-1h93.9c1 0 2-.4 2.8-1.1 3.1-3 11.6-11.4 16-15.9 1.5-1.6 1.5-4.1 0-5.6m153 42zm126.6 126.9c1.8 1.8 4.7 1.5 6.1-.5 42.3-60.3 59.4-139.9 34.9-223.4-23.5-80.7-87.4-144.1-168.1-167.6-83.5-24-162.1-6.9-222.4 35.5-2 1.4-2.3 4.4-.5 6.1l40.4 40.4c1.3 1.3 3.4 1.5 5 .5 29.5-18.4 64.4-29.5 102-29.5 105.7 0 191.6 85.8 191.6 191.6H609c-1 0-2 .4-2.8 1.1-3.1 3-11.6 11.4-16 15.9-1.5 1.6-1.5 4.1 0 5.6"
  }), React.createElement("path", {
    d: "M508.8 63.9c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445c0-245.7-199.2-445-445-445zm0 826c-210.4 0-381-170.6-381-381s170.6-381 381-381 381 170.6 381 381c0 210.5-170.6 381-381 381z"
  }));
});

/**
* @file 图标cycle-circle-o
* @author zhanglili
*/
var IconCycleCircleO =
/*#__PURE__*/
createIcon('cycle-circle-o', SVG$1l);

var SVG$1m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M508.8 63.9c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445c0-245.7-199.2-445-445-445zm-74.5 425.7c1.6 1.6 1.6 4.1 0 5.6-4.4 4.5-12.9 12.8-16 15.9-.7.7-1.7 1.1-2.8 1.1h-93.9l-1 1c.5 105.3 85.8 190.6 191.6 190.6 37.6 0 72.9-11.1 102.5-29.9 1.6-1 3.7-.8 5 .5l40.4 40.4c1.8 1.8 1.5 4.7-.5 6.1-60.3 42.9-140.4 60.5-224 35.5-80.2-24-144.1-87.4-167.6-168.1-25-84.5-7.4-163.7 34.9-223.9 1.4-2 4.4-2.3 6.1-.5m281.1 170.3c-1.5-1.6-1.6-4.1 0-5.6 4.4-4.5 12.9-12.8 16-15.9.7-.7 1.7-1.1 2.8-1.1h93.9c0-105.8-85.9-191.6-191.6-191.6-37.6 0-72.5 11.1-102 29.5-1.6 1-3.6.8-5-.6l-40.4-40.4c-1.8-1.8-1.5-4.7.5-6.1 60.3-42.4 138.9-59.5 222.4-35.5 80.7 23.5 144.6 86.9 168.1 167.6 24.5 83.5 7.4 163.2-34.9 223.4-1.4 2-4.4 2.3-6.1.5"
  }));
});

/**
* @file 图标cycle-circle-solid
* @author zhanglili
*/
var IconCycleCircleSolid =
/*#__PURE__*/
createIcon('cycle-circle-solid', SVG$1m);

var SVG$1n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M108 788.7h146c5.5 0 10 4.5 10 10v129H98v-129c0-5.5 4.5-10 10-10zM329.3 678h146c5.5 0 10 4.5 10 10v239.7h-166V688c0-5.5 4.5-10 10-10zm221.4-55.3h146c5.5 0 10 4.5 10 10v295h-166v-295c0-5.5 4.5-10 10-10zm221.3-166h146c5.5 0 10 4.5 10 10v461H762v-461c0-5.5 4.5-10 10-10zm-674 83l274.1-274.1c1.5-1.5 3.8-1.6 5.4-.2l163.2 136 249-221.3-83-83H924c2.2 0 4 1.8 4 4v217.3l-83-83-301.7 274.3c-1.5 1.3-3.7 1.4-5.3.1L374.7 373.7 153.3 595 98 539.7z"
  }));
});

/**
* @file 图标da
* @author zhanglili
*/
var IconDA =
/*#__PURE__*/
createIcon('da', SVG$1n);

var SVG$1o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 804.96 551.96"
  }, props), React.createElement("path", {
    d: "M48.89 420.49a27.11 27.11 0 0 1-43.55-32.3L130.46 219.5a27.11 27.11 0 0 1 47.07 6.41l60.78 158 141-262.16c10.75-20 39.86-18.71 48.79 2.17l135.38 316.16L668.12 20.55c6.23-24.95 40.44-28 51-4.59l83.41 184.9a27.11 27.11 0 1 1-49.42 22.29l-51.3-113.7-105.25 422c-6.28 25.21-41 28-51.22 4.11L400.4 196.98 258.08 461.55c-11 20.41-40.85 18.52-49.17-3.11l-64.27-167z"
  }));
});

/**
* @file 图标daily-active-user
* @author zhanglili
*/
var IconDailyActiveUser =
/*#__PURE__*/
createIcon('daily-active-user', SVG$1o);

var SVG$1p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 829.99 749"
  }, props), React.createElement("path", {
    d: "M601.6 240.65l-334.2 302c-10.47 9.46-27.45 9.46-37.93 0s-10.47-24.81 0-34.28l334.19-302c10.47-9.47 27.46-9.47 37.93 0s10.47 24.81 0 34.27zm-10.12 137.74l147.64-133.23c49.85-45 49.85-118.15 0-163.16s-130.93-45-180.8 0L410.68 215.23c-10.55 9.53-27.67 9.53-38.23 0s-10.55-25 0-34.49L520.1 47.5c71.13-63.56 185.81-63.3 256.6.57s71.1 167.36.68 231.57L629.74 412.87c-10.56 9.53-27.68 9.53-38.23 0s-10.56-25 0-34.49zm-173 156.11c10.62-9.2 27.45-9 37.85.35s10.56 24.59.35 34.16L309 702.26c-71.23 62.84-185.27 62.24-255.72-1.35s-71.11-166.49-1.47-230.81l147.64-133.23c10.56-9.52 27.67-9.52 38.23 0s10.56 25 0 34.5L90 504.6c-49.84 45-49.87 118.18 0 163.16s131 45 180.8 0z"
  }));
});

/**
* @file 图标daily-average-adjustment
* @author zhanglili
*/
var IconDailyAverageAdjustment =
/*#__PURE__*/
createIcon('daily-average-adjustment', SVG$1p);

var SVG$1q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M342.87 253.09c0 237.4 192.45 429.85 429.85 429.85A428.79 428.79 0 0 0 928 654c-62.21 160.65-218.25 274.57-400.9 274.57-237.4 0-429.85-192.45-429.85-429.85 0-182.65 113.92-338.69 274.58-401a428.26 428.26 0 0 0-28.96 155.37z"
  }));
});

/**
* @file 图标dark-mode
* @author zhanglili
*/
var IconDarkMode =
/*#__PURE__*/
createIcon('dark-mode', SVG$1q);

var SVG$1r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M789 833.3c-71.5 37.3-159.7 9.5-196.9-62-37.3-71.5-9.5-159.7 62-196.9 71.5-37.2 159.7-9.5 196.9 62 22 42.3 22 92.7 0 134.9l105.2 105.2c1.6 1.6 1.6 4.1 0 5.7l-56.3 56.3c-1.6 1.6-4.1 1.6-5.7 0L789 833.3zm-5.5-67.5c34.2-34.2 34.2-89.7 0-123.9s-89.7-34.2-123.9 0-34.2 89.7 0 123.9 89.6 34.2 123.9 0c-.1 0-.1 0 0 0zM860 533.5V369.6c0-2.2-1.8-4-4-4h-92c-2.2 0-4 1.8-4 4v125.6c35.9 4.5 70.2 17.6 100 38.3zm-236.7-12.1V177.6c0-2.2-1.8-4-4-4h-92c-2.2 0-4 1.8-4 4v456.6c19.4-47.9 54.7-87.8 100-112.8zm-100 280.8v11.4H386.6V306.1c0-2.2-1.8-4-4-4h-92c-2.2 0-4 1.8-4 4v507.5h-95.8v-640h64l-93.1-90.9c-1.6-1.5-4-1.5-5.6 0L63 173.6h63.8v703.9h446.4c-21.6-21.5-38.6-47.1-49.9-75.3z"
  }));
});

/**
* @file 图标da-search
* @author zhanglili
*/
var IconDASearch =
/*#__PURE__*/
createIcon('da-search', SVG$1r);

var SVG$1s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M288.934 445.163a29.442 29.442 0 0 0 14.688 3.926c10.04 0 19.823-5.141 25.27-14.349l95.405-161.995h189.498c16.144 0 29.206-12.937 29.206-28.925s-13.063-28.925-29.206-28.925h-204.13c-.716 0-1.315.353-2.018.403-10.047.011-19.876 4.671-25.306 13.862L278.41 405.59c-8.101 13.813-3.395 31.523 10.524 39.573zm589.657 174.423l-91.85-155.971c-4.3-10.663-14.717-18.226-27.028-18.226H544.717c-16.144 0-29.206 12.937-29.206 28.925 0 15.988 13.062 28.925 29.206 28.925h197.794l85.655 145.499c3.936 6.666 4.963 14.462 3.024 21.919-1.997 7.457-6.788 13.728-13.577 17.626a29.11 29.11 0 0 1-14.66 3.955H228.069c-16.115 0-29.206-12.994-29.206-28.925a28.452 28.452 0 0 1 3.993-14.576l68.11-115.642c8.129-13.785 3.451-31.523-10.468-39.573-13.947-8.022-31.83-3.39-39.958 10.366L152.43 619.53c-7.843 13.22-11.979 28.359-11.979 43.782 0 47.85 39.303 86.774 87.619 86.774h574.883a88.194 88.194 0 0 0 44.152-11.864c41.697-24.122 55.844-77.339 31.486-118.636z"
  }));
});

/**
* @file 图标dash-agroup
* @author zhanglili
*/
var IconDashAGroup =
/*#__PURE__*/
createIcon('dash-agroup', SVG$1s);

var SVG$1t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M514.3 63.9L127.5 273.3l386.7 209.4L901 273.3 514.3 63.9zm-252.7 208l251.3-135.4 251.3 135.4-251.3 135.4-251.3-135.4zM549.2 549v411.2l390.9-208.7V340.3L549.2 549zm55.8 35.7L875.9 438v275L605 859.7v-275zM82.9 751.5l390.9 208.7V549L82.9 340.3v411.2zm64.2-38.5V438L418 584.7v275L147.1 713z"
  }));
});

/**
* @file 图标dashboard-o
* @author zhanglili
*/
var IconDashboardO =
/*#__PURE__*/
createIcon('dashboard-o', SVG$1t);

var SVG$1u = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M142.198 111.008H277.31c.55 0 1.009.183 1.375.642l44.855 49.164c.275.367.459.733.459 1.192v132.728a1.84 1.84 0 0 1-1.834 1.833H142.197a1.84 1.84 0 0 1-1.833-1.834V112.842a1.84 1.84 0 0 1 1.834-1.834zm0 250.227H277.31c.55 0 1.009.184 1.375.642l44.855 49.074c.275.367.459.733.459 1.192v132.728a1.839 1.839 0 0 1-1.834 1.833H142.197a1.84 1.84 0 0 1-1.833-1.834v-181.8a1.84 1.84 0 0 1 1.834-1.835zm-1.927 249.862h136.945c.55 0 1.009.184 1.375.642l44.855 49.166c.275.366.459.732.459 1.191v132.728a1.84 1.84 0 0 1-1.834 1.833H142.106a1.839 1.839 0 0 1-1.834-1.834l-.001-183.726zm254.265-502.2h135.112c.55 0 1.009.184 1.375.642l44.854 49.166c.275.366.459.732.459 1.191v132.728a1.84 1.84 0 0 1-1.834 1.833H394.536a1.839 1.839 0 0 1-1.834-1.834V110.731c0-1.008.824-1.834 1.834-1.834zm250.686 1.376h135.112c.551 0 1.009.184 1.375.642l44.854 49.166c.275.366.459.732.459 1.191V294a1.84 1.84 0 0 1-1.834 1.833H645.222a1.839 1.839 0 0 1-1.834-1.834V112.108a1.84 1.84 0 0 1 1.834-1.835zM521.026 471.857H654.67c.459 0 .917.184 1.284.55l64.849 63.474c.368.367.551.826.551 1.284v144.744a1.839 1.839 0 0 1-1.834 1.834H521.026a1.839 1.839 0 0 1-1.834-1.834V473.691a1.84 1.84 0 0 1 1.834-1.834z"
  }), React.createElement("path", {
    d: "M882.592 812.654l-76.141-75.468c33.931-42.655 55.064-95.909 55.064-154.524 0-48.145-13.773-94.911-39.784-135.305-7.88-12.236-24.088-15.664-36.26-7.847-12.172 7.847-15.696 24.088-7.815 36.293 20.5 31.873 31.328 68.805 31.328 106.86 0 108.782-88.474 197.255-197.255 197.255-108.75 0-197.255-88.474-197.255-197.255s88.506-197.287 197.255-197.287c31.519 0 61.63 7.207 89.434 21.397 12.749 6.598 28.637 1.442 35.299-11.436 6.598-12.909 1.474-28.733-11.468-35.331-34.723-17.714-73.931-27.1-113.266-27.1-137.707 0-249.724 112.049-249.724 249.756 0 137.739 112.017 249.788 249.724 249.788 60.201 0 114.755-22.274 157.931-57.874l76.033 75.364c5.125 5.061 11.788 7.624 18.45 7.624a26.208 26.208 0 0 0 18.643-7.816c10.185-10.251 10.121-26.908-.193-37.094z"
  }));
});

/**
* @file 图标dash-card-zoom
* @author zhanglili
*/
var IconDashCardZoom =
/*#__PURE__*/
createIcon('dash-card-zoom', SVG$1u);

var SVG$1v = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.6 1000.7"
  }, props), React.createElement("path", {
    d: "M390.3 592.5c-2.7 0-5.4-.5-8.1-1.4-168.8-60.6-174.6-63.8-176.6-64.9-7.8-4.3-13.2-11.5-14.8-20-2.5-13.6 5.4-24.3 7.9-27.2 2.6-3.1 6-5.5 9.8-6.9l173.2-65.6c12.4-4.7 26.2 1.6 30.9 13.9 4.7 12.4-1.6 26.2-13.9 30.9L271 499.7c37 13.5 89.7 32.5 127.5 46.1 12.5 4.5 19 18.2 14.5 30.7-3.6 9.9-12.8 16-22.7 16zm224.8-.4c2.7 0 5.4-.5 8.1-1.4 168.8-60.6 174.6-63.8 176.6-64.9 7.8-4.3 13.2-11.5 14.8-20 2.5-13.6-5.4-24.3-7.9-27.2-2.6-3.1-6-5.5-9.8-6.9l-173.2-65.6c-12.4-4.7-26.2 1.6-30.9 13.9-4.7 12.4 1.6 26.2 13.9 30.9l127.8 48.4c-37 13.5-89.7 32.5-127.5 46.1-12.5 4.5-19 18.2-14.5 30.7 3.5 9.9 12.7 16 22.6 16zm-160.8 84.5c-2.3 0-4.7-.3-7.1-1.1-12.7-3.9-19.8-17.4-15.8-30L526.7 337c3.9-12.7 17.4-19.8 30-15.8 12.7 3.9 19.8 17.4 15.8 30l-95.3 308.5c-3.1 10.3-12.6 16.9-22.9 16.9z"
  }));
});

/**
* @file 图标dash-code
* @author zhanglili
*/
var IconDashCode =
/*#__PURE__*/
createIcon('dash-code', SVG$1v);

var SVG$1w = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M255.774 368.731c-.01 25.881 20.962 46.87 46.843 46.88 25.881.01 46.87-20.962 46.88-46.843v-.037c.01-25.881-20.962-46.87-46.843-46.88-25.881-.01-46.87 20.962-46.88 46.843v.037zm159.497 0c-.01 25.881 20.962 46.87 46.843 46.88 25.881.01 46.87-20.962 46.88-46.843v-.037c.01-25.881-20.962-46.87-46.843-46.88-25.881-.01-46.87 20.962-46.88 46.843v.037zm159.496 0c-.01 25.881 20.962 46.87 46.843 46.88 25.881.01 46.87-20.962 46.88-46.843v-.037c.01-25.881-20.962-46.87-46.843-46.88-25.881-.01-46.87 20.962-46.88 46.843v.037z"
  }), React.createElement("path", {
    d: "M140.841 304.362c0 17.23 13.97 31.2 31.2 31.2s31.2-13.97 31.2-31.2V187.568c0-.522-.271-.956-.297-1.47v-14.359H709.79v15.638c0 .068-.038.122-.038.19v116.795c0 17.23 13.966 31.2 31.2 31.2 17.23 0 31.2-13.97 31.2-31.2v-4.932h.038V171.74c0-34.465-27.936-62.401-62.401-62.401H202.945c-34.465 0-62.401 27.936-62.401 62.401v131.111h.297v1.511zM772.19 580.178l-.049-163.199c-.381-16.899-14.199-30.481-31.188-30.481-17.234 0-31.2 13.966-31.2 31.2v116.79c0 .537.011 1.066.038 1.596v44.092H468.96a30.933 30.933 0 0 0-2.529-.103H280.716c-9.03-.952-18.399 2.022-25.331 8.931l-52.144 51.979V417.699c0-17.234-13.97-31.2-31.2-31.2s-31.2 13.966-31.2 31.2v295.114c0 17.23 13.97 31.2 31.2 31.2.56 0 1.119-.015 1.676-.046 8.512.453 17.177-2.567 23.69-9.057l92.626-92.332H709.79c34.464.001 62.4-27.935 62.4-62.4z"
  }), React.createElement("path", {
    d: "M858.194 247.924c-17.253 0-31.241 13.984-31.241 31.241v473.51l-52.212-52.048c-6.121-6.102-14.141-9.141-22.153-9.114a31.33 31.33 0 0 0-5.545-.492H352.342c-17.253 0-31.241 13.988-31.241 31.241s13.988 31.241 31.241 31.241h386.94l93.513 93.22c6.521 6.498 15.198 9.523 23.721 9.069.557.03 1.117.046 1.678.046 17.253 0 31.241-13.988 31.241-31.241V279.165c.001-17.257-13.988-31.241-31.241-31.241z"
  }));
});

/**
* @file 图标dash-comments
* @author zhanglili
*/
var IconDashComments =
/*#__PURE__*/
createIcon('dash-comments', SVG$1w);

var SVG$1x = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M242.845 645.273c-35.985 0-65.275 29.259-65.275 65.275v65.275c0 36.016 29.291 65.275 65.275 65.275s65.275-29.259 65.275-65.275v-65.275c.001-36.016-29.29-65.275-65.275-65.275zm182.439-65.275c-35.985 0-65.275 29.259-65.275 65.275v130.551c0 36.016 29.291 65.275 65.275 65.275s65.275-29.259 65.275-65.275V645.273c.001-36.016-29.29-65.275-65.275-65.275zm182.439-65.275c-35.985 0-65.244 29.259-65.244 65.275v195.826c0 36.016 29.259 65.275 65.244 65.275 36.016 0 65.275-29.259 65.275-65.275V579.998c.001-36.015-29.259-65.275-65.275-65.275zm182.503-68.717c-36.016 0-65.275 29.291-65.275 65.275v261.1c0 36.016 29.259 65.275 65.275 65.275 36.016 0 65.275-29.259 65.275-65.275v-261.1c-.001-35.984-29.259-65.275-65.275-65.275zm0 32.642v-.004.004zm83.976-352.013c-3.585-1.805-7.462-3.191-11.689-3.722l-78.726 1.339c-14.406.255-25.88 12.144-25.689 26.55.255 14.279 11.92 25.658 26.136 25.658h.446l8.88-.151L530.922 390.64 419.197 252.635c-1.343-1.666-3.159-2.602-4.741-3.932-.678-1.067-.912-2.295-1.729-3.303-11.378-13.992-31.872-16.128-45.896-4.845L152.36 414.229c-14.024 11.347-16.191 31.904-4.845 45.896 6.47 7.968 15.872 12.112 25.402 12.112a32.508 32.508 0 0 0 20.494-7.267l189.487-153.442 115.789 143.02c6.438 7.968 15.872 12.112 25.402 12.112.877 0 1.725-.367 2.602-.438.877.072 1.681.565 2.562.565a32.508 32.508 0 0 0 20.494-7.267l268.909-217.786 18.61-16.12-.06 3.403c-.191 14.406 11.283 26.295 25.689 26.55h.446c14.216 0 25.88-11.378 26.136-25.658l1.339-78.726c.147-11.174-6.801-20.656-16.614-24.548z"
  }));
});

/**
* @file 图标dash-da
* @author zhanglili
*/
var IconDashDA =
/*#__PURE__*/
createIcon('dash-da', SVG$1x);

var SVG$1y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M242.449 298.066c-14.543-9.28-33.772-4.96-42.99 9.644-37.849 59.725-57.838 128.82-57.838 199.832 0 17.221 13.935 31.155 31.155 31.155s31.155-13.935 31.155-31.155c0-59.177 16.642-116.741 48.163-166.486 9.219-14.543 4.899-33.772-9.645-42.99zm273.035-164.387c-77.827 0-152.46 23.701-215.805 68.517-14.026 9.949-17.373 29.39-7.424 43.447 9.919 14.057 29.33 17.343 43.447 7.424 52.757-37.331 114.916-57.077 179.782-57.077 171.781 0 311.553 139.773 311.553 311.553 0 17.22 13.935 31.155 31.155 31.155s31.155-13.935 31.155-31.155c0-206.16-167.702-373.864-373.863-373.864z"
  }), React.createElement("path", {
    d: "M515.302 258.3c-98.791 0-188.393 58.447-228.219 148.87-6.937 15.76.213 34.137 15.943 41.074 15.79 6.998 34.106-.274 41.074-15.943 29.877-67.848 97.087-111.691 171.202-111.691 74.481 0 141.781 44.117 171.537 112.421 5.051 11.714 16.551 18.712 28.539 18.712a30.91 30.91 0 0 0 12.413-2.586c15.82-6.876 23.002-25.223 16.125-41.013C704.302 317.112 614.61 258.3 515.302 258.3z"
  }), React.createElement("path", {
    d: "M555.421 653.854l34.483-175.062c3.347-16.886-7.667-33.255-24.523-36.602-16.734-3.347-33.255 7.667-36.602 24.553l-35.643 180.805c-40.724 10.082-71.119 46.665-71.119 90.465 0 51.54 41.926 93.466 93.466 93.466s93.466-41.926 93.466-93.466c.001-37.199-21.996-69.126-53.528-84.159zm-39.937 115.314c-17.19 0-31.155-13.996-31.155-31.155s13.965-31.155 31.155-31.155 31.155 13.996 31.155 31.155c0 17.16-13.964 31.155-31.155 31.155z"
  }));
});

/**
* @file 图标dash-dashboard
* @author zhanglili
*/
var IconDashDashboard =
/*#__PURE__*/
createIcon('dash-dashboard', SVG$1y);

var SVG$1z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.6 1000.7"
  }, props), React.createElement("path", {
    d: "M715.5 854.7H297.8c-34.7 0-54.7-14.3-65.4-26.2-24-26.8-22.5-63.6-21.7-72.2V224.4c0-29.6 11.9-47.1 21.9-56.6 21.3-20.2 49.6-20.4 55.3-20.2h248.7c38.4 0 56.8 18.5 62.9 26.4 16.2 15.8 154.4 150.7 172.5 169.7 23.3 24.5 20.6 59 19.3 68.7v79.8c0 12.4-10.1 22.5-22.5 22.5s-22.5-10.1-22.5-22.5v-81.5c0-1.4.1-2.5.3-3.8.2-1.3 2.8-21.6-7.2-32.2-18.2-19.1-171.1-168.4-172.7-169.9-1.1-1.1-2.2-2.4-3.1-3.7-.9-1-7.8-8.6-27.1-8.6H286.4c-4.2-.1-16 1.2-23.1 8.1-5.1 5-7.7 13-7.7 23.8v532.9c0 .9 0 1.6-.1 2.5-.7 6.9-.1 27.2 10.6 38.9 6.8 7.5 17.1 11.1 31.7 11.1h417.1c1.7-.1 10.6-1 18.9-5.6 10-5.5 14.5-13.9 14.5-27.2V580.8c0-12.4 10.1-22.5 22.5-22.5s22.5 10.1 22.5 22.5V777c0 30.4-14.1 54.4-39.8 67.6-17.8 9.2-35.3 10-37.2 10-.3.1-.6.1-.8.1zM563.9 201.3zm-.6-.8zm0-.1zm0 0z"
  }), React.createElement("path", {
    d: "M754.8 409.8H581.6c-46.6 0-67.8-37-72.4-56.6-.4-1.7-.6-3.5-.6-5.2V170.1c0-12.4 10.1-22.5 22.5-22.5s22.5 10.1 22.5 22.5v174.5c.9 2.4 2.8 6.5 6 10.4 5.5 6.7 12.6 9.9 22.1 9.9H755c12.4 0 22.5 10.1 22.5 22.5s-10.2 22.4-22.7 22.4zm-85.2 193.5H339c-12.4 0-22.5-10.1-22.5-22.5s10.1-22.5 22.5-22.5h330.6c12.4 0 22.5 10.1 22.5 22.5s-10.1 22.5-22.5 22.5zm0 123.4H339c-12.4 0-22.5-10.1-22.5-22.5s10.1-22.5 22.5-22.5h330.6c12.4 0 22.5 10.1 22.5 22.5 0 12.5-10.1 22.5-22.5 22.5z"
  }));
});

/**
* @file 图标dash-document
* @author zhanglili
*/
var IconDashDocument =
/*#__PURE__*/
createIcon('dash-document', SVG$1z);

var SVG$1A = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M62.487 51.966h101.448c4.447 0 8.065-3.618 8.065-8.065s-3.618-8.065-8.065-8.065H62.487c-4.447 0-8.065 3.618-8.065 8.065s3.618 8.065 8.065 8.065zm103.182 40.022H85.852c-3.467 0-6.331 3.618-6.331 8.065s2.864 8.065 6.331 8.065h79.817c3.467 0 6.331-3.618 6.331-8.065-.001-4.448-2.865-8.065-6.331-8.065zm1.733 56.226h-58.261c-2.563 0-4.597 3.618-4.597 8.065s2.11 8.065 4.597 8.065h58.185c2.563 0 4.597-3.618 4.597-8.065.001-4.448-2.034-8.065-4.521-8.065zM42.289 35.837H30.23c-.528 0-.98 3.618-.98 8.065s.452 8.065.98 8.065h12.059c.528 0 .98-3.618.98-8.065s-.453-8.065-.98-8.065zm25.172 56.151H55.403c-.528 0-.98 3.618-.98 8.065s.452 8.065.98 8.065h12.059c.528 0 .98-3.618.98-8.065s-.453-8.065-.981-8.065zm25.024 56.226h-12.06c-.528 0-.98 3.618-.98 8.065s.452 8.065.98 8.065h12.059c.528 0 .98-3.618.98-8.065s-.452-8.065-.979-8.065z"
  }));
});

/**
* @file 图标dash-list-level
* @author zhanglili
*/
var IconDashListLevel =
/*#__PURE__*/
createIcon('dash-list-level', SVG$1A);

var SVG$1B = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.6 1000.7"
  }, props), React.createElement("path", {
    d: "M604.5 471.3H665c11.9-46.4 54-80.6 104.1-80.6 59.4 0 107.5 48.1 107.5 107.5s-48.1 107.5-107.5 107.5c-50.1 0-92.2-34.2-104.1-80.6h-60.5c-11.9 46.4-54 80.6-104.1 80.6s-92.2-34.2-104.1-80.6h-59.9c-11.9 46.4-54 80.6-104.1 80.6-59.4 0-107.5-48.1-107.5-107.5s48.1-107.5 107.5-107.5c50.1 0 92.2 34.2 104.1 80.6h59.9c11.9-46.4 54-80.6 104.1-80.6s92.2 34.3 104.1 80.6zm-372 80.6c29.7 0 53.8-24.1 53.8-53.8s-24.1-53.8-53.8-53.8-53.8 24.1-53.8 53.8 24.1 53.8 53.8 53.8zm536.6 0c29.7 0 53.8-24.1 53.8-53.8s-24.1-53.8-53.8-53.8c-29.7 0-53.8 24.1-53.8 53.8s24.1 53.8 53.8 53.8zm-268.6 0c29.7 0 53.8-24.1 53.8-53.8s-24.1-53.8-53.8-53.8-53.8 24.1-53.8 53.8 24.1 53.8 53.8 53.8z"
  }));
});

/**
* @file 图标dash-pipeline
* @author zhanglili
*/
var IconDashPipeline =
/*#__PURE__*/
createIcon('dash-pipeline', SVG$1B);

var SVG$1C = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.6 1000.7"
  }, props), React.createElement("path", {
    d: "M756.3 396.3c-13.3 0-24-10.7-24-24V245.6c0-5.2-1.5-8.4-5.2-11-1.7-1.2-3.6-2-4.8-2.5h-39.7c-13.3 0-24-10.7-24-24s10.7-24 24-24h43c1.5 0 3 .1 4.5.4 17.4 3.3 50.2 20.3 50.2 61.1v126.7c0 13.2-10.8 24-24 24zM696.9 870H294.1c-29.1 0-51.3-8.8-66-26.1-18.5-21.9-17.1-49-16.1-57.6V246.6c0-25.2 14.5-45.4 39.7-55.4 15.9-6.3 31.4-6.8 33.1-6.8h55.8c13.1 0 23.7 10.6 23.7 23.7s-10.6 23.7-23.7 23.7h-55c-2.7.1-10.5 1-17.1 3.8-9 3.8-9 7.9-9 11v541.3c0 1.5 0 2.4-.3 3.8-.2 1.4-1.3 14 5.4 21.7 6.5 7.5 19.7 9.1 29.6 9.1h402.1c1.8-.1 11.5-1.1 20.4-6.1 10.9-6.1 16-15.8 16-30.5V462.3c0-13.1 10.6-23.7 23.7-23.7s23.7 10.6 23.7 23.7v323.6c0 32.8-15.1 58.7-42.4 73.1-19.1 10-37.9 10.9-39.9 11h-.9z"
  }), React.createElement("path", {
    d: "M645.6 286.2H358.9c-19.6 0-35.6-16-35.6-35.6v-87.1c0-19.6 16-35.6 35.6-35.6h286.7c19.6 0 35.6 16 35.6 35.6v87.1c0 19.6-16 35.6-35.6 35.6zm-274.8-47.5h262.9v-63.3H370.8v63.3zm77.7 421.5c-11.5 0-19.2-6.6-38.1-25.5-10.1-10.1-23.5-24-39.8-41.4-27.7-29.5-54.7-59.4-54.9-59.7-8.8-9.7-8-24.8 1.7-33.5 9.7-8.8 24.8-8 33.5 1.7 36.4 40.3 77.5 84.3 97.8 104.1 33.1-30.3 122.2-118.6 201.7-198.8 9.2-9.3 24.3-9.4 33.6-.2 9.3 9.2 9.4 24.3.2 33.6-.5.5-53.4 53.9-106.5 106.5-31.3 31-56.5 55.7-75.1 73.4-11.2 10.7-20.1 19-26.4 24.7-10.5 9.1-17.2 15.1-27.7 15.1z"
  }));
});

/**
* @file 图标dash-plan
* @author zhanglili
*/
var IconDashPlan =
/*#__PURE__*/
createIcon('dash-plan', SVG$1C);

var SVG$1D = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M638.522 559.288H511.106V430.514c0-16.019-12.963-28.982-28.982-28.982s-28.982 12.962-28.982 28.982v153.405c-.234 1.479-.877 2.805-.877 4.351 0 16.019 12.962 28.982 28.982 28.982h157.275c16.019 0 28.982-12.963 28.982-28.982s-12.963-28.982-28.982-28.982z"
  }), React.createElement("path", {
    d: "M846.77 529.713c-9.232-8.886-23.911-8.633-32.831.566l-2.862 2.961c-4.033-151.99-115.44-277.121-260.931-303.18 12.205-12.973 20-30.187 20-49.37 0-39.963-32.491-72.453-72.453-72.453s-72.453 32.491-72.453 72.453c0 18.595 7.536 35.172 19.083 48.011-44.523 7.15-86.025 23.448-122.389 47.106-1.652-2.211-2.515-4.804-4.525-6.814-22.585-22.585-59.378-22.585-81.963 0l-22.953 22.953c-22.614 22.585-22.614 59.378 0 81.963 2.76 2.76 6.233 4.125 9.368 6.212-28.21 47.388-44.718 102.517-44.718 161.563 0 174.907 142.275 317.154 317.183 317.154 86.633 0 167.52-34.245 227.691-96.397 10.925-11.208 20.943-23.151 30.396-36.34l8.434-12.566c8.887-13.302 5.265-31.302-8.038-40.189-13.189-8.831-31.246-5.321-40.189 8.038l-7.529 11.32a271.148 271.148 0 0 1-24.68 29.377c-49.189 50.831-115.304 78.793-186.086 78.793-142.926 0-259.219-116.265-259.219-259.191s116.293-259.219 259.219-259.219c140.941 0 255.416 113.191 258.625 253.346l-5.349-5.533c-9-9.312-23.547-9.425-32.831-.566-9.17 8.887-9.453 23.576-.566 32.802l49.133 50.831c4.585 4.698 10.642 7.076 16.698 7.076.251 0 .485-.135.736-.142.251.007.485.142.736.142 6.057 0 12.114-2.377 16.699-7.076l49.133-50.831c8.884-9.224 8.601-23.913-.569-32.8zM497.691 137.219c23.972 0 43.472 19.501 43.472 43.473s-19.501 43.472-43.472 43.472-43.473-19.501-43.473-43.472 19.501-43.473 43.473-43.473z"
  }));
});

/**
* @file 图标dash-plantrack
* @author zhanglili
*/
var IconDashPlantrack =
/*#__PURE__*/
createIcon('dash-plantrack', SVG$1D);

var SVG$1E = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M162.727 156.955l-29.408-29.408c9.065-10.35 14.561-23.912 14.561-38.758 0-10.992-2.998-21.271-8.28-30.122-2.07-3.426-6.781-3.997-9.636-1.142-1.999 1.999-2.427 5.068-.999 7.423 4.283 7.209 6.638 15.56 6.495 24.554-.428 25.696-21.056 45.967-46.753 45.967-25.767 0-46.753-20.985-46.753-46.753.071-25.625 20.486-46.324 46.182-46.61 8.994-.143 17.416 2.355 24.625 6.638 2.427 1.428 5.496.999 7.495-.928 2.855-2.855 2.284-7.566-1.142-9.636-9.351-5.639-20.343-8.78-32.12-8.423-30.549.859-55.674 25.342-57.244 55.891-1.784 34.047 25.411 62.313 59.03 62.313 12.348 0 23.769-3.783 33.262-10.278l29.979 29.979c2.141 2.141 5.71 2.141 7.923 0l2.784-2.784c2.141-2.141 2.141-5.71-.001-7.923z"
  }));
});

/**
* @file 图标dash-search
* @author zhanglili
*/
var IconDashSearch =
/*#__PURE__*/
createIcon('dash-search', SVG$1E);

var SVG$1F = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M216.194 346.213c0 17.175 13.898 31.073 31.073 31.073s31.073-13.898 31.073-31.073V197.687l5.947 6.152c4.885 5.067 11.379 7.586 17.873 7.586 6.22 0 12.441-2.306 17.266-6.979 9.892-9.528 10.135-25.276.607-35.138l-52.677-54.499c-5.105-5.28-11.914-7.617-18.677-7.393-6.763-.224-13.572 2.112-18.677 7.393l-52.677 54.499c-9.528 9.862-9.285 25.61.607 35.138 4.825 4.673 11.045 6.979 17.266 6.979 6.493 0 12.988-2.519 17.873-7.586l3.126-3.232-.003 145.606zm704.55 433.861c-.004-.413-.186-.796-.212-1.21-.212-5.913-2.298-11.792-6.725-16.389-.611-.626-1.418-.868-2.074-1.418l-53.03-51.259c-9.831-9.346-25.489-9.225-35.199.607-9.528 9.892-9.225 25.61.607 35.199l3.831 3.702H278.339V465.193c0-17.175-13.898-31.073-31.073-31.073s-31.073 13.898-31.073 31.073v309.966c0 .925.447 1.703.527 2.61-.08.906-.527 1.684-.527 2.609 0 17.175 13.898 31.073 31.073 31.073H827.31l-3.202 3.095c-9.831 9.589-10.135 25.307-.607 35.199 4.916 5.037 11.409 7.586 17.903 7.586 6.251 0 12.441-2.366 17.296-6.979l53.06-51.289c.645-.542 1.445-.774 2.044-1.388 4.427-4.597 6.512-10.476 6.725-16.389.029-.415.211-.798.215-1.212z"
  }), React.createElement("path", {
    d: "M360.274 667.069h155.362c17.16 0 31.073-13.909 31.073-31.073 0-17.16-13.913-31.073-31.073-31.073H360.274c-17.164 0-31.073 13.913-31.073 31.073.001 17.164 13.91 31.073 31.073 31.073zm261.028 0h155.362c17.16 0 31.073-13.909 31.073-31.073 0-17.16-13.913-31.073-31.073-31.073H621.302c-17.16 0-31.073 13.913-31.073 31.073 0 17.164 13.913 31.073 31.073 31.073zM360.274 512.628h155.362c17.16 0 31.073-13.913 31.073-31.073s-13.913-31.073-31.073-31.073H360.274c-17.164 0-31.073 13.913-31.073 31.073.001 17.161 13.91 31.073 31.073 31.073zm261.028 0h155.362c17.16 0 31.073-13.913 31.073-31.073s-13.913-31.073-31.073-31.073H621.302c-17.16 0-31.073 13.913-31.073 31.073 0 17.161 13.913 31.073 31.073 31.073zM391.346 358.185h93.218c34.319 0 62.145-27.822 62.145-62.145 0-34.319-27.826-62.145-62.145-62.145h-93.218c-34.323 0-62.145 27.826-62.145 62.145.001 34.323 27.823 62.145 62.145 62.145zm261.028 0h93.218c34.323 0 62.145-27.822 62.145-62.145 0-34.319-27.822-62.145-62.145-62.145h-93.218c-34.323 0-62.145 27.826-62.145 62.145 0 34.323 27.822 62.145 62.145 62.145z"
  }));
});

/**
* @file 图标dash-story-mapping
* @author zhanglili
*/
var IconDashStoryMapping =
/*#__PURE__*/
createIcon('dash-story-mapping', SVG$1F);

var SVG$1G = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M515.485 641.106c-86.621 0-157.102-70.451-157.102-157.102 0-86.621 70.481-157.102 157.102-157.102 9.727 0 19.239.89 28.475 2.577 17.06 3.099 28.383 19.484 25.253 36.545-3.13 17.091-19.392 28.72-36.545 25.253a95.941 95.941 0 0 0-17.183-1.534c-51.979 0-94.261 42.282-94.261 94.261s42.282 94.261 94.261 94.261 94.261-42.282 94.261-94.261a95.08 95.08 0 0 0-6.321-34.152c-6.321-16.202 1.78-34.397 17.919-40.656 16.202-6.229 34.366 1.719 40.625 17.95 7.058 18.165 10.617 37.281 10.617 56.858.001 86.651-70.449 157.101-157.101 157.102z"
  }), React.createElement("path", {
    d: "M848.74 529.662l-.511-.399-47.164-35.923c.127-3.193.191-6.259.191-9.316 0-3.058-.064-6.163-.191-9.324l47.458-36.211.359-.279a61.462 61.462 0 0 0 22.4-36.658 60.519 60.519 0 0 0-7.528-42.358l-63.711-107.64c-15.415-26.057-47.594-37.194-76.508-26.479l-.511.199-56.256 22.081a280.77 280.77 0 0 0-17.195-9.787l-8.438-58.052-.055-.367c-4.702-29.625-31.277-51.968-61.804-51.968H451.717c-30.918 0-56.911 21.913-61.821 52.104 0 .16-.023.32-.071.479l-8.406 57.82a292.148 292.148 0 0 0-17.211 9.787l-56.439-22.192-.44-.167c-28.307-10.594-61.125.798-76.34 26.535l-63.759 107.65c-15.766 26.639-9.38 59.92 15.192 79.222l.296.224 47.211 36.043a233.228 233.228 0 0 0-.191 9.332c0 3.074.064 6.163.191 9.316l-47.515 36.212-.511.398a61.606 61.606 0 0 0-22.137 36.618 60.474 60.474 0 0 0 7.528 42.229l63.8 107.77a62.457 62.457 0 0 0 33.225 26.903 63.525 63.525 0 0 0 43.531-.679l.208-.079 56.263-22.08a284.778 284.778 0 0 0 17.171 9.763l8.438 58.148c0 .165.024.327.072.488 4.885 30.015 30.853 51.809 61.748 51.809h127.495c21.098 0 38.094-10.625 45.351-15.167l.718-.447a28.742 28.742 0 0 0 15.824-21.681l9.636-66.306a72.8 72.8 0 0 1 16.445-16.357l55.969 22.008.375.144c28.524 10.742 60.652-.373 76.436-26.448l.064-.103 63.608-107.545c15.789-26.43 9.522-59.734-14.93-79.268l-.001-.002zm-34.374 49.749l-.103.176-63.593 107.53a5.542 5.542 0 0 1-4.654 2.451 5.935 5.935 0 0 1-2.029-.327l-69.978-27.517a28.74 28.74 0 0 0-26.895 3.129c-1.357.942-2.723 1.868-4.096 2.802-12.643 8.575-28.37 19.255-43.841 43.332a28.75 28.75 0 0 0-4.263 11.399l-8.566 58.946c-2.475 1.149-5.029 2.035-7.073 2.035H451.717c-2.563 0-4.598-1.405-4.997-3.44l-10.57-72.82a28.743 28.743 0 0 0-16.628-22.073 226.525 226.525 0 0 1-35.604-20.197 28.736 28.736 0 0 0-26.847-3.113l-69.907 27.43c-2.922 1.086-5.828-.471-6.682-1.916l-63.783-107.77-.072-.12c-1.03-1.724-.184-3.369.998-4.383l59.488-45.335a28.743 28.743 0 0 0 11.177-25.745 184.74 184.74 0 0 1 0-39.755 28.74 28.74 0 0 0-11.177-25.729l-59.336-45.296c-1.006-.798-2.395-2.458-1.101-4.63l63.768-107.665c.894-1.517 4.359-2.785 6.617-2.019l69.883 27.478a28.743 28.743 0 0 0 26.847-3.105 229.242 229.242 0 0 1 35.7-20.261 28.74 28.74 0 0 0 16.597-22.049l10.536-72.493c.431-2.258 2.396-3.712 5.062-3.712h127.583c2.523 0 4.702 1.79 5.029 3.426l10.584 72.78a28.738 28.738 0 0 0 16.613 22.058 224.339 224.339 0 0 1 35.571 20.212 28.741 28.741 0 0 0 26.896 3.146l69.715-27.366c3.146-1.085 5.843.12 6.905 1.916l63.782 107.698.048.088c.895 1.493.52 3.122-.997 4.374l-59.529 45.43a28.737 28.737 0 0 0-11.177 25.714 184.641 184.641 0 0 1 0 39.786 28.74 28.74 0 0 0 11.177 25.729l59.153 45.079c1.08.909 2.525 2.633 1.327 4.692z"
  }));
});

/**
* @file 图标dash-wheel
* @author zhanglili
*/
var IconDashWheel =
/*#__PURE__*/
createIcon('dash-wheel', SVG$1G);

var SVG$1H = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M722.841 343.732H484.364c-16.389 0-29.65 13.261-29.65 29.65s13.261 29.65 29.65 29.65h238.477c16.389 0 29.65-13.261 29.65-29.65.001-16.389-13.261-29.65-29.65-29.65zm0 144.024H524.815c-16.389 0-29.65 13.261-29.65 29.65s13.261 29.65 29.65 29.65h198.026c16.389 0 29.65-13.261 29.65-29.65.001-16.388-13.261-29.65-29.65-29.65z"
  }), React.createElement("path", {
    d: "M859.687 422.385c17.034 0 30.817-13.783 30.817-30.817V289.453c0-50.981-41.472-92.453-92.453-92.453H389.657c-50.981 0-92.453 41.472-92.453 92.453v22.625c-66.368 14.705-116.319 75.713-116.319 148.649 0 45.628 19.938 86.137 50.812 114.031C159.98 610.771 110.13 684.73 110.13 770.86c0 17.034 13.783 30.817 30.817 30.817s30.817-13.783 30.817-30.817c0-87.115 69.938-157.926 155.966-158.091.098 0 .188.03.289.03s.192-.03.289-.03c86.028.166 155.966 70.976 155.966 158.091 0 17.034 13.783 30.817 30.817 30.817.636 0 1.166-.323 1.791-.362.625.037 1.155.362 1.791.362h199.623c17.034 0 30.817-13.783 30.817-30.817s-13.783-30.817-30.817-30.817h-78.188v-49.96h157.94c50.981 0 92.453-41.472 92.453-92.453v-99.345c0-17.034-13.783-30.817-30.817-30.817s-30.817 13.783-30.817 30.817v99.345c0 16.974-13.843 30.817-30.817 30.817H492.58c-18.949-22.24-41.96-40.497-68.234-53.691 30.873-27.895 50.812-68.403 50.812-114.031 0-72.937-49.951-133.942-116.319-148.649v-22.624c0-17.004 13.813-30.817 30.817-30.817H798.05c16.974 0 30.817 13.813 30.817 30.817v102.114c.003 17.034 13.787 30.819 30.82 30.819zm-281.21 267.697v49.958h-35.651c-2.445-17.35-6.388-34.151-12.621-49.958h48.272zM413.523 460.725c0 49.74-38.108 90.166-85.068 90.422-.148 0-.286-.045-.432-.045-.148 0-.286.045-.432.045-46.96-.256-85.068-40.682-85.068-90.422 0-49.898 38.341-90.497 85.501-90.497s85.499 40.599 85.499 90.497z"
  }));
});

/**
* @file 图标dash-workplace
* @author zhanglili
*/
var IconDashWorkplace =
/*#__PURE__*/
createIcon('dash-workplace', SVG$1H);

var SVG$1I = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M897 264v64h-97v567H228V328H126v-64zm-161 64H292v503h444zM545 456.5v256h-64v-256zM674 129v64H354v-64z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标delete
* @author zhanglili
*/
var IconDelete =
/*#__PURE__*/
createIcon('delete', SVG$1I);

var SVG$1J = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M129.3 127.9v536.3H297V597H196.6V194.3h402.7V597h-112v67.3H666V127.9H129.3zm600 231v67.3h100.4v402.7H427.1V426.2H539v-67.3H360.3v536.7H897V358.9H729.3z"
  }));
});

/**
* @file 图标dependency
* @author zhanglili
*/
var IconDependency =
/*#__PURE__*/
createIcon('dependency', SVG$1J);

var SVG$1K = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M193.7 616.7l317.7 206.5 317.7-206.5V406.4L511.5 199.9 193.7 406.4v210.3zm317.8 276.1c-6 0-12.1-1.6-17.2-5.1L144.8 660.6c-9.1-5.8-14.6-15.9-14.6-26.7V389.2c0-10.8 5.4-20.7 14.6-26.7l349.5-227.2c10.5-7 24.1-7 34.6 0l349.5 227.2c8.9 6 14.3 15.9 14.3 26.7v244.6c0 10.8-5.4 20.6-14.6 26.7L528.6 887.7c-5.1 3.5-11.1 5.1-17.1 5.1z"
  }), React.createElement("path", {
    d: "M511.5 892.8c-17.5 0-31.8-14.3-31.8-31.8V633.9c0-17.5 14.3-31.8 31.8-31.8s31.8 14.3 31.8 31.8V861c-.1 17.5-14.4 31.8-31.8 31.8"
  }), React.createElement("path", {
    d: "M511.5 665.7c-6.4 0-12.7-1.9-18.1-5.7L143.9 415.3c-14.3-10.2-17.8-29.9-7.9-44.2 10.2-14.3 29.9-18.1 44.2-7.9l331.4 231.9L843 363.2c14.1-10.1 33.7-6.7 43.8 7.4.1.2.3.4.4.6 10.2 14.3 6.7 34.3-7.9 44.2L529.6 659.9c-5.4 3.8-11.8 5.8-18.1 5.8"
  }), React.createElement("path", {
    d: "M860.9 665.612c-6.4 0-12.7-1.9-18.1-5.7l-331.3-231.9-331.4 231.9c-14.1 10-33.7 6.7-43.8-7.4-.1-.2-.3-.4-.4-.6-10.1-14.1-6.7-33.7 7.4-43.8.2-.1.4-.3.6-.4l349.5-244.6c10.8-7.6 25.4-7.6 36.5 0l349.5 244.6c14.3 10.2 17.8 29.9 7.9 44.2-6.7 9-16.5 13.7-26.4 13.7"
  }), React.createElement("path", {
    d: "M511.5 421c-17.5 0-31.8-14.3-31.8-31.8V162.1c0-17.5 14.3-31.8 31.8-31.8s31.8 14.3 31.8 31.8v227.2c-.1 17.4-14.4 31.7-31.8 31.7"
  }));
});

/**
* @file 图标dependent
* @author zhanglili
*/
var IconDependent =
/*#__PURE__*/
createIcon('dependent', SVG$1K);

var SVG$1L = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M828.4 553.5c1.7-13.3 3-26.6 3-40.7s-1.3-27.4-3-40.7l90.1-68.6c8.1-6.2 10.3-17.4 5.1-26.6l-85.4-143.7c-5.1-9.1-16.7-12.5-26.1-9.1l-106.4 41.5c-22.2-16.6-46.1-30.3-72.2-40.7l-16.2-110.1c-1.3-10-10.3-17.4-20.9-17.4H425.6c-10.7 0-19.6 7.5-20.9 17.4l-16.2 110.1c-26.1 10.4-50 24.5-72.2 40.7L209.9 224c-9.8-3.7-20.9 0-26.1 9.1L98.4 376.9c-5.6 9.1-3 20.4 5.1 26.6l90.1 68.6c-1.7 13.3-3 27-3 40.7 0 13.7 1.3 27.4 3 40.7L103.5 622c-8.1 6.2-10.3 17.4-5.1 26.6l85.4 143.7c5.1 9.1 16.7 12.5 26.1 9.1L316.2 760c22.2 16.6 46.1 30.3 72.2 40.7l16.2 110.1c1.3 10 10.2 17.4 20.9 17.4h170.8c10.7 0 19.6-7.5 20.9-17.4l16.2-110.1c26.1-10.4 50-24.5 72.2-40.7L812 801.5c9.8 3.7 20.9 0 26.1-9.1l85.4-143.7c5.1-9.1 3-20.4-5.1-26.6l-90-68.6zm-488.3-42.7c0-95.5 77.7-173.1 173.1-173.1 95.5 0 173.1 77.7 173.1 173.1s-77.7 173.1-173.1 173.1c-95.5 0-173.1-77.7-173.1-173.1z"
  }));
});

/**
* @file 图标deploy
* @author zhanglili
*/
var IconDeploy =
/*#__PURE__*/
createIcon('deploy', SVG$1L);

var SVG$1M = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M123.1 82.5c-3.7 1.4-5.6 5.6-4.1 9.4 1 2.5 1.5 5.2 1.5 7.9 0 12-9.7 21.7-21.7 21.7S77 111.7 77 99.7 86.7 78 98.7 78c1.3 0 2.7.1 4 .4 4 .8 7.7-1.9 8.4-5.8.7-3.9-1.9-7.7-5.8-8.4-2.1-.4-4.3-.6-6.6-.6-20 0-36.2 16.2-36.2 36.2 0 20 16.2 36.2 36.2 36.2 20 0 36.2-16.2 36.2-36.2 0-4.5-.8-8.9-2.4-13.1-1.5-3.8-5.7-5.7-9.4-4.2z"
  }), React.createElement("path", {
    d: "M175.5 110.2l-.1-.1-10.9-8.3v-4.2l10.9-8.3.1-.1c2.7-2.1 4.5-5.1 5.2-8.4.6-3.4 0-6.8-1.7-9.8l-14.7-24.8c-3.6-6-11-8.6-17.6-6.1h-.1l-13 5.1c-1.3-.8-2.6-1.5-4-2.3l-1.9-13.4v-.1c-1.1-6.8-7.2-12-14.2-12H84c-7.1 0-13.1 5-14.2 12v.1l-1.9 13.3c-1.3.7-2.7 1.5-4 2.3l-13-5.1h-.1c-6.5-2.4-14.1.2-17.6 6.1L18.5 70.9C14.9 77 16.3 84.7 22 89.1l.1.1L33 97.5v4.2l-11 8.5-.1.1c-2.7 2.1-4.5 5.1-5.1 8.4-.6 3.3 0 6.8 1.7 9.7l14.7 24.8c1.7 2.9 4.5 5.1 7.7 6.2 3.3 1.1 6.8 1.1 10-.2l13-5.1c1.3.8 2.6 1.5 4 2.2l1.9 13.4v.1c1.1 6.9 7.1 11.9 14.2 11.9h29.4c4.9 0 8.8-2.4 10.4-3.5l.2-.1c2-1 3.3-2.8 3.6-5l2.2-15.3c1.1-1.5 2.3-2.7 3.8-3.8l12.9 5.1h.1c6.6 2.5 14-.1 17.6-6.1l14.7-24.8c3.7-5.8 2.2-13.5-3.4-18zm-7.9 11.5l-14.7 24.8c-.2.4-.6.6-1.1.6-.2 0-.3 0-.5-.1l-16.1-6.3a6.8 6.8 0 0 0-6.2.7l-.9.6c-2.9 2-6.5 4.4-10.1 10-.5.8-.8 1.7-1 2.6l-2 13.6c-.6.3-1.2.5-1.6.5H84c-.6 0-1.1-.3-1.2-.8l-2.4-16.8c-.3-2.2-1.8-4.2-3.8-5.1-2.9-1.3-5.6-2.9-8.2-4.7-1.8-1.3-4.1-1.5-6.2-.7l-16.1 6.3c-.7.3-1.3-.1-1.5-.4l-14.7-24.8c-.2-.4 0-.8.2-1l13.7-10.4c1.8-1.4 2.8-3.6 2.6-5.9-.3-3-.3-6.1 0-9.2.2-2.3-.7-4.5-2.6-5.9L30.1 78.8c-.2-.2-.6-.6-.3-1.1l14.7-24.8c.2-.3 1-.6 1.5-.5l16.1 6.3c2.1.8 4.4.5 6.2-.7 2.6-1.8 5.3-3.4 8.2-4.7 2.1-.9 3.5-2.8 3.8-5.1l2.4-16.7c.1-.5.6-.9 1.2-.9h29.4c.6 0 1.1.4 1.2.8l2.4 16.8c.3 2.2 1.8 4.2 3.8 5.1 2.9 1.3 5.6 2.9 8.2 4.7 1.8 1.3 4.1 1.5 6.2.7l16.1-6.3c.7-.3 1.3 0 1.6.4l14.7 24.8c.2.3.1.7-.2 1l-13.7 10.5c-1.8 1.4-2.8 3.6-2.6 5.9.3 3 .3 6.1 0 9.2-.2 2.3.7 4.5 2.6 5.9l13.6 10.4c.3.3.6.7.4 1.2z"
  }));
});

/**
* @file 图标deploy-o
* @author zhanglili
*/
var IconDeployO =
/*#__PURE__*/
createIcon('deploy-o', SVG$1M);

var SVG$1N = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513 467.7c-58.8 0-106.7 47.9-106.7 106.7S454.2 681.1 513 681.1s106.7-47.9 106.7-106.7S571.9 467.7 513 467.7z"
  }), React.createElement("path", {
    d: "M883.1 79.1c-3.9-8.2-14.5-14.9-23.6-14.9H155.2c-9.1 0-19.5 6.8-23.1 15.2l-69 159.2L100 943.2c.5 9.1 8.3 16.4 17.3 16.4H905c9.1 0 16.8-7.4 17.3-16.4l36.9-704.6-76.1-159.5zm-174 496.6c0 8.7-.8 16.9-1.8 25.1l55.5 42.2c5 3.8 6.3 10.8 3.2 16.4L713.3 748c-3.2 5.6-10 7.9-16.1 5.6L631.7 728c-13.7 10-28.4 18.7-44.5 25.1l-10 67.9c-.8 6.1-6.3 10.8-12.9 10.8H459c-6.6 0-12.1-4.6-12.9-10.8l-10-67.9c-16.1-6.4-30.8-14.9-44.5-25.1l-65.5 25.6c-5.8 2-12.9 0-16.1-5.6l-52.6-88.6c-3.2-5.6-1.8-12.5 3.2-16.4l55.5-42.2c-1.1-8.2-1.8-16.6-1.8-25.1s.8-16.9 1.8-25.1l-55.5-42.2c-5-3.8-6.6-10.8-3.2-16.4l52.6-88.6c3.2-5.6 10-7.9 16.1-5.6l65.5 25.6c13.7-10 28.4-18.7 44.5-25.1l10-67.9c.8-6.1 6.3-10.8 12.9-10.8h105.3c6.6 0 12.1 4.6 12.9 10.8l10 67.9c16.1 6.4 30.8 14.9 44.5 25.1l65.5-25.6c5.8-2 12.9 0 16.1 5.6l52.6 88.6c3.2 5.6 1.8 12.5-3.2 16.4l-55.5 42.2c1.1 8.2 1.9 16.4 1.9 25.1zm150.4-345.9h-694c-9.1 0-14.1-7-11.2-15.7l26.8-80.5c2.9-8.7 12.5-15.7 21.7-15.7H812c9.1 0 19.4 6.8 22.9 15.2l34.6 81.5c3.6 8.4-.8 15.2-10 15.2z"
  }));
});

/**
* @file 图标depot-deploy
* @author zhanglili
*/
var IconDepotDeploy =
/*#__PURE__*/
createIcon('depot-deploy', SVG$1N);

var SVG$1O = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M802.5 304.7c45.8 0 83-37.2 83-83s-37.2-83-83-83-83 37.2-83 83 37.2 83 83 83zm0 41.5c-68.8 0-124.5-55.7-124.5-124.5S733.7 97.2 802.5 97.2 927 152.9 927 221.7s-55.7 124.5-124.5 124.5zm-581-41.5c45.8 0 83-37.2 83-83s-37.2-83-83-83-83 37.2-83 83 37.2 83 83 83zm0 41.5C152.7 346.2 97 290.4 97 221.7S152.7 97.2 221.5 97.2 346 152.9 346 221.7s-55.7 124.5-124.5 124.5zm581 539.5c45.8 0 83-37.2 83-83s-37.2-83-83-83-83 37.2-83 83 37.2 83 83 83zm0 41.5c-68.8 0-124.5-55.7-124.5-124.5s55.7-124.5 124.5-124.5S927 733.9 927 802.7s-55.7 124.5-124.5 124.5zm-581-41.5c45.8 0 83-37.2 83-83s-37.2-83-83-83-83 37.2-83 83 37.2 83 83 83zm0 41.5C152.7 927.2 97 871.4 97 802.7s55.7-124.5 124.5-124.5S346 733.9 346 802.7s-55.7 124.5-124.5 124.5zm-19.3-518.5c0-11.5 9.3-20.7 20.7-20.7 11.5 0 20.7 9.3 20.7 20.7v207.4c0 11.5-9.3 20.7-20.7 20.7-11.5 0-20.7-9.3-20.7-20.7V408.7zm580.3.5c0-11.5 9.3-20.7 20.7-20.7 11.5 0 20.7 9.3 20.7 20.7v206.7c0 11.5-9.3 20.7-20.7 20.7-11.5 0-20.7-9.3-20.7-20.7V409.2zM408.6 243.3c-11.5 0-20.7-9.3-20.7-20.7 0-11.5 9.3-20.7 20.7-20.7h207.1c11.5 0 20.7 9.3 20.7 20.7 0 11.5-9.3 20.7-20.7 20.7H408.6zm.2 582.5c-11.5 0-20.7-9.3-20.7-20.7s9.3-20.7 20.7-20.7h207c11.5 0 20.7 9.3 20.7 20.7s-9.3 20.7-20.7 20.7h-207z"
  }));
});

/**
* @file 图标development-ecology
* @author zhanglili
*/
var IconDevelopmentEcology =
/*#__PURE__*/
createIcon('development-ecology', SVG$1O);

var SVG$1P = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M700.605 423.953c-97-112.31-245.27-149-359.55-98.27 87.634-95.733 236.283-102.299 332.016-14.664a234.998 234.998 0 0 1 76.323 173.804c0 3.71-.11 7.4-.28 11.07a364.145 364.145 0 0 0-48.509-71.94zm-391.83 80.92c91.23 126.8 251.6 177.87 383.9 131.3-84.137 98.691-232.348 110.489-331.038 26.353-59.111-50.394-89.476-126.758-81.112-203.983a355.038 355.038 0 0 0 28.25 46.33z"
  }), React.createElement("path", {
    d: "M357.355 711.753c-127.88-79.82-216.55-225.91-216.37-225.71.18.2 88.43-145.46 215.89-225.36-124.465 91.025-151.573 265.714-60.549 390.178a279.19 279.19 0 0 0 61.019 60.892h.01zm376.43-407.19c94.53 80 156.09 181.46 156.2 181.48s-61.67 101.85-156.54 181.87c89.695-104.464 89.835-258.723.33-363.35h.01zm-313.08 219.72c4.036 11.794-2.253 24.626-14.046 28.662-11.794 4.036-24.626-2.253-28.662-14.046-4.036-11.794 2.253-24.626 14.046-28.662 10.762-3.683 22.584 1.219 27.582 11.436l30.27-12.55c-13.808-32.8-.47-70.724 30.83-87.66l-18.38-35c-8.62 3.637-18.556-.403-22.193-9.022s.403-18.556 9.022-22.193c8.62-3.637 18.556.403 22.193 9.022a16.94 16.94 0 0 1-6.522 20.883l18.39 35c34.32-16.727 75.702-2.465 92.429 31.855a69.127 69.127 0 0 1 3.131 53.055l25.44 9.13c4.96-11.424 18.242-16.664 29.665-11.704s16.664 18.242 11.704 29.665c-4.731 10.897-17.105 16.254-28.289 12.248l-16.33 32.71c5.21 4.655 5.659 12.652 1.004 17.862-4.655 5.209-12.652 5.659-17.862 1.004s-5.659-12.652-1.004-17.862a12.65 12.65 0 0 1 15.532-2.654l16.1-32.2c-9.648-4.916-14.451-15.986-11.45-26.39l-25.47-9.14c-14.065 35.482-54.231 52.845-89.713 38.78a69.11 69.11 0 0 1-37.047-34.78l-30.37 12.551z"
  }));
});

/**
* @file 图标dev-profile
* @author zhanglili
*/
var IconDevProfile =
/*#__PURE__*/
createIcon('dev-profile', SVG$1P);

var SVG$1Q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M708.1 576.6c-8.3 7.9-18.4 11.8-30.4 11.8h-415l-77.1 76.9c-20.3 20.2-53.1 20.2-73.3-.1-9.7-9.7-15.1-22.9-15.1-36.6V179.5c0-11.1 4-20.6 11.9-28.5s17.6-11.8 28.9-11.8h539.6c11.9 0 22.1 3.9 30.4 11.8 8.3 7.9 12.5 17.3 12.5 28.5v368.6c.1 11.2-4 20.7-12.4 28.5zm178-274.2c11.3 0 20.9 3.9 28.9 11.8s11.9 17.3 11.9 28.5v490.5c0 28.6-23.2 51.9-51.9 51.9-13.6 0-26.7-5.4-36.4-14.9L761.3 794H303.6c-11.3 0-20.9-3.9-28.9-11.8s-11.9-17.3-11.9-28.5V671h539.6V302.4h83.7z"
  }));
});

/**
* @file 图标discussion-solid
* @author zhanglili
*/
var IconDiscussionSolid =
/*#__PURE__*/
createIcon('discussion-solid', SVG$1Q);

var SVG$1R = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M738.766 599.117c38.414 0 67.225 14.405 91.233 38.414 24.009 24.009 38.414 57.621 38.414 91.233 0 72.026-57.621 129.647-129.647 129.647S609.119 800.79 609.119 728.764c0-14.405 4.802-28.811 4.802-43.216l-139.251-81.63-4.802 4.802c-38.414 33.612-81.63 52.819-129.647 52.819-96.035 0-177.665-81.63-177.665-177.665s81.63-177.665 177.665-177.665c48.018 0 96.035 19.207 124.846 52.819l4.802 4.802L609.12 282.2c0-14.405-4.802-28.811-4.802-43.216 0-72.026 57.621-129.647 129.647-129.647s129.647 57.621 129.647 129.647-57.621 129.647-129.647 129.647c-38.414 0-67.224-14.405-91.233-38.414l-139.251 81.63c9.603 24.009 14.405 48.018 14.405 72.026 0 24.009-4.802 48.018-14.405 72.026l139.251 81.63c24.008-24.007 57.62-38.412 96.034-38.412z"
  }));
});

/**
* @file 图标distribution
* @author zhanglili
*/
var IconDistribution =
/*#__PURE__*/
createIcon('distribution', SVG$1R);

var SVG$1S = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M257.8 590c14.3 0 25.9 11.6 25.9 25.9s-11.6 25.9-25.9 25.9H148.9v142.7c0 50.1 40.6 90.8 90.8 90.8s90.8-40.6 90.8-90.8V616c0-14.3 11.6-25.9 25.9-25.9 14.3 0 25.9 11.6 25.9 25.9v168.6c0 78.8-63.9 142.7-142.7 142.7S97 863.3 97 784.6V641.9c0-28.6 23.2-51.9 51.9-51.9h108.9z"
  }), React.createElement("path", {
    d: "M382.3 616h-51.9V149.1c0-28.6 23.2-51.9 51.9-51.9h492.8c28.6 0 51.9 23.2 51.9 51.9v622.5c0 85.9-69.7 155.6-155.6 155.6H252.6v-51.9h518.7c57.3 0 103.7-46.4 103.7-103.7V149.1H382.3V616z"
  }), React.createElement("path", {
    d: "M512 330.7c-14.3 0-25.9-11.6-25.9-25.9s11.6-25.9 25.9-25.9h259.4c14.3 0 25.9 11.6 25.9 25.9s-11.6 25.9-25.9 25.9H512zm0 103.7c-14.3 0-25.9-11.6-25.9-25.9s11.6-25.9 25.9-25.9h259.4c14.3 0 25.9 11.6 25.9 25.9s-11.6 25.9-25.9 25.9H512zm0 103.8c-14.3 0-25.9-11.6-25.9-25.9s11.6-25.9 25.9-25.9h259.4c14.3 0 25.9 11.6 25.9 25.9s-11.6 25.9-25.9 25.9H512zm-51.9 259.3c-14.3 0-25.9-11.6-25.9-25.9 0-14.3 11.6-25.9 25.9-25.9h415c14.3 0 25.9 11.6 25.9 25.9 0 14.3-11.6 25.9-25.9 25.9h-415z"
  }));
});

/**
* @file 图标doc-o
* @author zhanglili
*/
var IconDocO =
/*#__PURE__*/
createIcon('doc-o', SVG$1S);

var SVG$1T = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M729.207 630.029H290.845c-2.609 0-2.609 0-2.609-2.946V574.05c0-2.946 0-2.946 2.609-2.946h438.363c2.609 0 2.609 0 2.609 2.946v53.033l-2.61 2.946zm0 147.314H290.845c-2.609 0-2.609 0-2.609-2.946v-53.033c0-2.946 0-2.946 2.609-2.946h438.363c2.609 0 2.609 0 2.609 2.946v53.033l-2.61 2.946z"
  }), React.createElement("path", {
    d: "M686.089 65.606H231.77c-30.5 0-55.346 24.857-55.346 55.358v791.968c0 30.535 24.846 55.358 55.346 55.358h556.501c30.535 0 55.358-24.823 55.358-55.358V236.776l-157.54-171.17zm13.062 82.838l69.058 75.037h-69.058v-75.037zm97.99 764.475c0 4.888-3.994 8.882-8.882 8.882H231.77c-4.888 0-8.859-3.994-8.859-8.882V120.963c0-4.888 3.971-8.847 8.859-8.847h420.882v134.621c0 12.818 10.438 23.209 23.255 23.209h121.234v642.973z"
  }));
});

/**
* @file 图标document-o
* @author zhanglili
*/
var IconDocumentO =
/*#__PURE__*/
createIcon('document-o', SVG$1T);

var SVG$1U = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.2 639.3L170.7 259.6c-2-2.2-4.8-3.5-7.7-3.5H74.3c-8.8 0-13.6 10.4-7.7 17.1l437.3 488.9c4.1 4.7 11.4 4.7 15.5 0l438.3-488.9c5.8-6.6 1.1-17.1-7.7-17.1h-87.6c-3 0-5.8 1.3-7.7 3.5L512.2 639.3z"
  }));
});

/**
* @file 图标down
* @author zhanglili
*/
var IconDown =
/*#__PURE__*/
createIcon('down', SVG$1U);

var SVG$1V = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M460.6 603.4H359l150.7 141.1c1.5 1.4 3.9 1.4 5.5 0l150.6-141.1H565V105.2c0-2.2-1.8-4-4-4l-95.2.1c-2.2 0-4 1.8-4 4l-1.2 498.1zm-358-118.9c-3.8 0-6.9 3.2-6.9 7.1v428.2c0 3.8 3.1 7.1 6.9 7.1H921c3.8 0 6.9-3.2 6.9-7.1V491.6c0-3.8-3.1-7.1-6.9-7.1H754.6v80.1H850v282.2H173.7V564.7h95.4v-80.1H102.6v-.1z"
  }));
});

/**
* @file 图标download
* @author zhanglili
*/
var IconDownload =
/*#__PURE__*/
createIcon('download', SVG$1V);

var SVG$1W = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M64.8 319.9l431.7 431.7c7.8 7.8 20.5 7.8 28.3 0l431.6-431.7"
  }));
});

/**
* @file 图标down-solid
* @author zhanglili
*/
var IconDownSolid =
/*#__PURE__*/
createIcon('down-solid', SVG$1W);

var SVG$1X = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M484.93 856v105.46h-112V856zM653 856v105.46H541V856zM484.93 697.83v105.45h-112V697.83zm168.07 0v105.45H541V697.83zM484.93 539.65V645.1h-112V539.65zm168.07 0V645.1H541V539.65zM484.93 381.47v105.45h-112V381.47zm168.07 0v105.45H541V381.47zM484.93 223.29v105.45h-112V223.29zm168.07 0v105.45H541V223.29zM484.93 65.11v105.45h-112V65.11zm168.07 0v105.45H541V65.11z"
  }));
});

/**
* @file 图标drag
* @author zhanglili
*/
var IconDrag =
/*#__PURE__*/
createIcon('drag', SVG$1X);

var SVG$1Y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M140.1 181.8H18.9V48.3H140v133.5zm-106.2-15H125V63.3H33.9v103.5zM59.4 18.6V41h15v-7.4h91.1v103.5h-17v15h32V18.6H59.4zm49.1 67.7h-58v15h58v-15zm0 41.5h-58v15h58v-15z"
  }));
});

/**
* @file 图标dual-paper-o
* @author zhanglili
*/
var IconDualPaperO =
/*#__PURE__*/
createIcon('dual-paper-o', SVG$1Y);

var SVG$1Z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M140.1 181.8H18.9V48.3H140v133.5h.1zM59.4 18.6V41h15v-7.4h91.1v103.5h-17v15h32V18.6H59.4zm49.1 67.7h-58v15h58v-15zm0 41.5h-58v15h58v-15z"
  }));
});

/**
* @file 图标dual-paper-solid
* @author zhanglili
*/
var IconDualPaperSolid =
/*#__PURE__*/
createIcon('dual-paper-solid', SVG$1Z);

var SVG$1_ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M948.6 413.2c-6.3-29.4-15.1-51.9-24.3-75.9-67.8-160.4-226.6-273-411.7-273-246.7 0-446.7 200-446.7 446.7s200 446.7 446.7 446.7 446.7-200 446.7-446.7c0-33.6-3.7-66.3-10.7-97.8zm-799.8 97.7c0-45.5 8.4-89 23.6-129.1 19.3 10.9 45.2 12.9 45.2 34.7 0 71.9 2.7 149 71.7 150.2 1.9 0 38.5 13.1 55.8 55.8 6 14.8 29.8 0 55.8 0 13 0 0 20.8 0 65.7 0 44.8 101.8 113.7 101.8 113.7-.5 29.6.8 53.6 3.4 72.7-197.9-3.4-357.3-164.9-357.3-363.7zm452 353.1c14.3-57.9 21.3-90.4 51.3-115 43.3-35.6 5.2-75.2-27.8-70.5-26 3.7-9.6-30.5-32.8-32.4-23.2-1.8-53.5-45.6-86.9-60.6-17.7-8-35.1-29.3-62.4-30.3-24.2-.9-59.6 19.4-59.6 3.8 0-50.4-5.4-86.3-6.5-100.6-.9-11.5-8-3.9 24.8-3.1 17.8.5 9.1-33.9 26.7-35.2 17.3-1.3 58.5 15.4 69.1 8.7 9.8-6.2 71.7 154.2 71.7 26.5 0-15.1-8.3-41.5 0-55.8 32.7-56.7 63.4-102.9 60.7-109.7-1.6-3.8-33.5-7-59.1 1.2-8.6 2.7 2.7 15.5-9.6 18.3-46.4 10.2-87.4-11.9-73.1-32.6 14.7-21.2 68-9.3 72.7-51.8 2.7-24.4 4.9-52.6 6.4-73.6 130.2 19.3 237.9 107.6 284.8 226.4C727.3 468 759 530.9 799.7 567c21.4 18.9 41.8 47.4 55.1 67.9-40.8 112.7-136 199.7-254 229.1z"
  }));
});

/**
* @file 图标earth
* @author zhanglili
*/
var IconEarth =
/*#__PURE__*/
createIcon('earth', SVG$1_);

var SVG$1$ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M829.3 155.2L957 419 553.1 878.4c-18.6 21.2-50.9 23.3-72.1 4.6l-4.2-4.2L63 419l127.7-263.8h638.6zm-40.1 63.9H230.7l-91.5 189.1 375.5 417.2L881 408.7l-91.8-189.6zm-45.9 137.5c11.8 10.3 14.2 27.4 6.4 40.4l-3.4 4.7-209.5 238.8c-.3.3-.7.6-1.2 1.2-14 12.6-34.7 13-49 1.9l-5.1-4.7-213.4-237c-11.8-13.1-10.7-33.3 2.4-45.1 11.6-10.5 28.9-10.8 40.9-1.6l4.2 3.9 194.1 215.5 188.6-215.1c11.6-13.2 31.7-14.6 45-2.9z"
  }));
});

/**
* @file 图标edition
* @author zhanglili
*/
var IconEdition =
/*#__PURE__*/
createIcon('edition', SVG$1$);

var SVG$20 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M574.69 128v64H191.87l.1 640.08h638.62l.41-383.34h64V896H128l.35-767.65zm265.23 7.66l45.35 45.15-415.2 417.69-45.35-45.14z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标editor-p
* @author zhanglili
*/
var IconEditorP =
/*#__PURE__*/
createIcon('editor-p', SVG$20);

var SVG$21 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fillRule: "nonzero",
    d: "M14.988 1.396c-.059-.275-.31-.446-.562-.383l-2.442.618a.488.488 0 0 0-.343.353.545.545 0 0 0 .112.5l.533.601-2.847 2.772L7.96 4.33a.441.441 0 0 0-.66.019l-3.172 3.63c0 .247.35.616.695.685l2.832-3.241 1.452 1.5a.44.44 0 0 0 .634.01l3.196-3.11.607.686c.117.132.29.185.454.14a.491.491 0 0 0 .335-.363l.65-2.642a.554.554 0 0 0 .005-.247z"
  }), React.createElement("circle", {
    cx: "4.5",
    cy: "8.2",
    r: "1.5"
  }), React.createElement("path", {
    fillRule: "nonzero",
    d: "M14.5 7.038a.5.5 0 0 0-.5.5V11.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h8.291a.5.5 0 1 0 0-1H1.5A1.5 1.5 0 0 0 0 1.5v10A1.5 1.5 0 0 0 1.5 13h12a1.5 1.5 0 0 0 1.5-1.5V7.538a.5.5 0 0 0-.5-.5zM14.769 15H.73a.491.491 0 0 0-.481.5c0 .276.216.5.481.5h14.04a.491.491 0 0 0 .481-.5c0-.276-.216-.5-.481-.5z"
  })));
});

/**
* @file 图标effectiveness
* @author zhanglili
*/
var IconEffectiveness =
/*#__PURE__*/
createIcon('effectiveness', SVG$21);

var SVG$22 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M64 511.9C64 572.7 113.3 622 174.1 622s110.1-49.3 110.1-110.1-49.3-110.1-110.1-110.1S64 451.1 64 511.9zm673.5.8c0 60.8 49.3 110.1 110.1 110.1s110.1-49.3 110.1-110.1-49.3-110.1-110.1-110.1-110.1 49.3-110.1 110.1zm-335.8-.6c0 60.8 49.3 110.1 110.1 110.1s110.1-49.3 110.1-110.1S572.5 402 511.7 402s-110 49.3-110 110.1z"
  }));
});

/**
* @file 图标ellipsis-solid
* @author zhanglili
*/
var IconEllipsisSolid =
/*#__PURE__*/
createIcon('ellipsis-solid', SVG$22);

var SVG$23 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.6 1000.7"
  }, props), React.createElement("circle", {
    cx: "507.3",
    cy: "491.2",
    r: "43.2"
  }), React.createElement("circle", {
    cx: "364.5",
    cy: "491.2",
    r: "43.2"
  }), React.createElement("circle", {
    cx: "644.2",
    cy: "491.2",
    r: "43.2"
  }));
});

/**
* @file 图标ellipsis-solid-slim
* @author zhanglili
*/
var IconEllipsisSolidSlim =
/*#__PURE__*/
createIcon('ellipsis-solid-slim', SVG$23);

var SVG$24 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M31.4 174.2H65c3.2 0 5.8-2.6 5.8-5.8v-1c0-3.2-2.6-5.8-5.8-5.8H47.2l33.4-33.4c2.2-2.2 2.2-5.9 0-8.2l-.7-.6c-2.2-2.2-5.9-2.2-8.2 0L38 153.1v-19c0-3.2-2.6-5.8-5.8-5.8h-1c-3.2 0-5.8 2.6-5.8 5.8v33.6c0 .9.2 1.7.5 2.4.8 2.5 2.9 4.2 5.5 4.1zM169.8 24.9h-33.6c-3.2 0-5.8 2.6-5.8 5.8v1c0 3.2 2.6 5.8 5.8 5.8h18l-33.5 33.4c-2.2 2.2-2.2 5.9 0 8.2l.6.6c2.2 2.2 5.9 2.2 8.2 0L163.3 46v19c0 3.2 2.6 5.8 5.8 5.8h1c3.2 0 5.8-2.6 5.8-5.8V31.4c-.2-.9-.3-1.7-.6-2.4-.8-2.5-3-4.2-5.5-4.1z"
  }));
});

/**
* @file 图标enlarge-arrow
* @author zhanglili
*/
var IconEnlargeArrow =
/*#__PURE__*/
createIcon('enlarge-arrow', SVG$24);

var SVG$25 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M127.9 89.5c0 3.4-2.8 6.2-6.2 6.2H98.2v23.4c0 3.4-2.8 6.2-6.2 6.2-3.4 0-6.2-2.8-6.2-6.2V95.7H62.3c-3.4 0-6.2-2.8-6.2-6.2s2.8-6.2 6.2-6.2h23.4V59.8c0-3.4 2.8-6.2 6.2-6.2 3.4 0 6.2 2.8 6.2 6.2v23.4h23.4c3.6 0 6.4 2.8 6.4 6.3zm40.7 77.6c-2.4 2.4-6.4 2.4-8.8 0l-28.2-28c-10.9 8.8-24.7 14.2-39.8 14.2-34.8 0-63.1-28.3-63.1-63.1S57 27.1 91.8 27.1s63.1 28.3 63.1 63.1c0 15.2-5.4 29.2-14.4 40.1l28.1 28c2.4 2.4 2.5 6.4 0 8.8zm-25.7-76.9c0-28.2-22.9-51.1-51.1-51.1S40.7 62 40.7 90.2c0 28.2 22.9 51.1 51.1 51.1s51.1-23 51.1-51.1z"
  }));
});

/**
* @file 图标enlarge-glass
* @author zhanglili
*/
var IconEnlargeGlass =
/*#__PURE__*/
createIcon('enlarge-glass', SVG$25);

var SVG$26 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M15 1v14H1V1zm-1 4H2v9h12zm-7 5v3H3v-3zm6 2v1H8v-1zm-7-1H4v1h2zm7-1v1H8v-1zm0-4v3H3V6zm-1 1H4v1h8zm2-5H2v2h12z"
  }))));
});

/**
* @file 图标ens
* @author zhanglili
*/
var IconENS =
/*#__PURE__*/
createIcon('ens', SVG$26);

var SVG$27 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 872.69 476.01"
  }, props), React.createElement("path", {
    d: "M793.36 238.01H238.03V79.34L.03 277.67l238 198.34V317.34h634.66V0h-79.33z"
  }));
});

/**
* @file 图标enter
* @author zhanglili
*/
var IconEnter =
/*#__PURE__*/
createIcon('enter', SVG$27);

var SVG$28 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M456.414 109.793h118.193c8.126 0 14.774 6.648 14.774 14.774v443.37c0 8.126-6.648 14.774-14.774 14.774H456.414c-8.126 0-14.774-6.648-14.774-14.774v-443.37c0-8.126 6.648-14.774 14.774-14.774zm-31.765 658.186c0 50.181 40.68 90.861 90.861 90.861s90.861-40.68 90.861-90.861c0-50.181-40.68-90.861-90.861-90.861s-90.861 40.68-90.861 90.861z"
  }));
});

/**
* @file 图标exclamation
* @author zhanglili
*/
var IconExclamation =
/*#__PURE__*/
createIcon('exclamation', SVG$28);

var SVG$29 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M76.3 117.8H42.8c-3.2 0-5.8 2.6-5.8 5.8v1c0 3.2 2.6 5.8 5.8 5.8h17.7l-33.4 33.4c-2.2 2.2-2.2 5.9 0 8.2l.7.6c2.2 2.2 5.9 2.2 8.2 0l33.7-33.7v19c0 3.2 2.6 5.8 5.8 5.8h1c3.2 0 5.8-2.6 5.8-5.8v-33.6c0-.9-.2-1.7-.5-2.4-.7-2.5-2.9-4.2-5.5-4.1zm48.9-36.5h33.6c3.2 0 5.8-2.6 5.8-5.8v-1c0-3.2-2.6-5.8-5.8-5.8h-18l33.5-33.4c2.2-2.2 2.2-5.9 0-8.2l-.6-.6c-2.2-2.2-5.9-2.2-8.2 0l-33.8 33.7v-19c0-3.2-2.6-5.8-5.8-5.8h-1c-3.2 0-5.8 2.6-5.8 5.8v33.6c.2.9.3 1.7.6 2.4.8 2.5 3 4.2 5.5 4.1zM76.7 35.5h-1c-3.2 0-5.8 2.6-5.8 5.8v18.9L36.2 26.5c-2.2-2.2-5.9-2.2-8.2 0l-.7.5c-2.2 2.2-2.2 5.9 0 8.2l33.5 33.5h-18c-3.2 0-5.8 2.6-5.8 5.8v1c0 3.2 2.6 5.8 5.8 5.8h33.6c2.6 0 4.8-1.8 5.5-4.1.3-.7.5-1.5.5-2.4V41.2c.1-3.2-2.6-5.7-5.7-5.7zm64.1 95h18c3.2 0 5.8-2.6 5.8-5.8v-1c0-3.2-2.6-5.8-5.8-5.8h-33.6c-2.6 0-4.8 1.8-5.5 4.1-.3.7-.5 1.5-.5 2.4V158c0 3.2 2.5 5.8 5.7 5.8h1c3.2 0 5.8-2.6 5.8-5.8v-19l33.7 33.7c2.2 2.2 5.9 2.2 8.2 0l.6-.6c2.2-2.2 2.2-5.9 0-8.2l-33.4-33.4z"
  }));
});

/**
* @file 图标exit-fullscreen
* @author zhanglili
*/
var IconExitFullscreen =
/*#__PURE__*/
createIcon('exit-fullscreen', SVG$29);

var SVG$2a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M401.5 587.5l31.1 31.1c3.9 3.9 3.9 10.2 0 14.1L169.1 896.2h265.5c5.5 0 10 4.5 10 10v43.3c0 5.5-4.5 10-10 10H71.2c-5.5 0-10-4.5-10-10V586.1c0-5.5 4.5-10 10-10h44.2c5.5 0 10 4.5 10 10v263.6l261.9-262.2c3.9-3.9 10.3-3.9 14.2 0zm219-148.8l-31.1-31.1c-3.9-3.9-3.9-10.2 0-14.1L852.9 130H587.4c-5.5 0-10-4.5-10-10V76.7c0-5.5 4.5-10 10-10h363.4c5.5 0 10 4.5 10 10v363.5c0 5.5-4.5 10-10 10h-44.2c-5.5 0-10-4.5-10-10V176.6L634.7 438.7c-3.9 3.9-10.3 3.9-14.2 0z"
  }));
});

/**
* @file 图标expand-all
* @author zhanglili
*/
var IconExpandAll =
/*#__PURE__*/
createIcon('expand-all', SVG$2a);

var SVG$2b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M69.9 80.3L34.5 105c-2.5 1.8-6.1 1.2-7.9-1.4-1.8-2.5-1.2-6.1 1.4-7.9L63.4 71c2.5-1.8 6.1-1.2 7.9 1.4 1.8 2.5 1.1 6-1.4 7.9z"
  }), React.createElement("path", {
    d: "M71.3 128.6c-1.8 2.5-5.3 3.2-7.9 1.4l-35.3-24.7c-2.5-1.8-3.2-5.3-1.4-7.9 1.8-2.5 5.3-3.2 7.9-1.4l35.3 24.7c2.5 1.9 3.2 5.4 1.4 7.9zm60-7.9L166.6 96c2.5-1.8 6.1-1.2 7.9 1.4 1.8 2.5 1.2 6.1-1.4 7.9L137.8 130c-2.5 1.8-6.1 1.2-7.9-1.4-1.8-2.5-1.2-6 1.4-7.9z"
  }), React.createElement("path", {
    d: "M129.9 72.4c1.8-2.5 5.3-3.2 7.9-1.4l35.3 24.7c2.5 1.8 3.2 5.3 1.4 7.9-1.8 2.5-5.3 3.2-7.9 1.4l-35.3-24.7c-2.6-1.9-3.2-5.4-1.4-7.9zM105.7 31.4v55.8c0 3.1-2.5 5.7-5.7 5.7-3.1 0-5.7-2.5-5.7-5.7V31.4c0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.6 5.7 5.7z"
  }), React.createElement("path", {
    d: "M104 35.4L88.5 50.9c-2.2 2.2-5.8 2.2-8 0s-2.2-5.8 0-8L96 27.4c2.2-2.2 5.8-2.2 8 0s2.2 5.8 0 8z"
  }), React.createElement("path", {
    d: "M104.5 27.4L120 42.9c2.2 2.2 2.2 5.8 0 8s-5.8 2.2-8 0L96.5 35.4c-2.2-2.2-2.2-5.8 0-8s5.8-2.2 8 0z"
  }), React.createElement("g", null, React.createElement("path", {
    d: "M94.8 169v-55.8c0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7V169c0 3.1-2.5 5.7-5.7 5.7-3.1 0-5.7-2.6-5.7-5.7z"
  }), React.createElement("path", {
    d: "M96.5 165l15.5-15.5c2.2-2.2 5.8-2.2 8 0s2.2 5.8 0 8L104.5 173c-2.2 2.2-5.8 2.2-8 0s-2.2-5.8 0-8z"
  }), React.createElement("path", {
    d: "M96 173l-15.5-15.5c-2.2-2.2-2.2-5.8 0-8s5.8-2.2 8 0L104 165c2.2 2.2 2.2 5.8 0 8s-5.8 2.2-8 0z"
  })));
});

/**
* @file 图标expand-code
* @author zhanglili
*/
var IconExpandCode =
/*#__PURE__*/
createIcon('expand-code', SVG$2b);

var SVG$2c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M680.3 127.9l238.2 216.2c4.4 4 4.4 10.8 0 14.8L680.3 575.1V439.9c-69.7 0-278.8 0-371.7 209.1v-23.2c0-92.9 92.9-391.5 371.7-371.7V127.9zM108 306.6h184.9v70.8H176.2v439.1h670.3v-191h77.7v259.1c0 5.3-4.2 9.6-9.5 9.6H108c-5.3 0-9.6-4.2-9.6-9.6V316.2c0-5.3 4.3-9.6 9.6-9.6z"
  }));
});

/**
* @file 图标export
* @author zhanglili
*/
var IconExport =
/*#__PURE__*/
createIcon('export', SVG$2c);

var SVG$2d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.8 639.2c67.5 0 122.1-54.5 122.1-122.1 0-11.7-1.6-22.9-4.7-33.6L475.8 633.8c11.4 3.5 23.4 5.4 36 5.4z"
  }), React.createElement("path", {
    d: "M804.6 311.6L691.7 422.2c15 28.3 23.5 60.6 23.5 94.9 0 112.3-91.1 203.4-203.4 203.4-35.7 0-69.3-9.2-98.5-25.4l-90.4 88.6c58 24.8 121.8 38.6 188.9 38.6 203.4 0 377.2-126.5 447.6-305.2-32.3-81.8-86.2-152.7-154.8-205.5zM789 159.2l-91.7 89.9C640.2 225.2 577.5 212 511.8 212c-203.4 0-377.2 126.5-447.6 305.2 31.8 80.7 84.7 150.8 152 203.4l-65.3 64 41.9 42.8L830.9 202 789 159.2zM308.3 517.1c0-112.3 91.1-203.4 203.4-203.4 34.4 0 66.9 8.6 95.3 23.7l-63.2 61.9c-10.2-2.8-21-4.3-32.2-4.3-67.5 0-122.1 54.5-122.1 122.1 0 10.3 1.3 20.2 3.6 29.8l-63.2 61.9c-13.7-27.6-21.6-58.7-21.6-91.7z"
  }));
});

/**
* @file 图标eye-ignore
* @author zhanglili
*/
var IconEyeIgnore =
/*#__PURE__*/
createIcon('eye-ignore', SVG$2d);

var SVG$2e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.8 212c-203.4 0-377.2 126.5-447.6 305.2 70.4 178.6 244.1 305.2 447.6 305.2S889 695.9 959.4 517.2C888.9 338.5 715.2 212 511.8 212zm0 508.6c-112.3 0-203.4-91.1-203.4-203.4s91.1-203.4 203.4-203.4 203.4 91.1 203.4 203.4c0 112.2-91.1 203.4-203.4 203.4zm0-325.5c-67.5 0-122.1 54.5-122.1 122.1 0 67.5 54.5 122.1 122.1 122.1s122.1-54.5 122.1-122.1c-.1-67.6-54.6-122.1-122.1-122.1z"
  }));
});

/**
* @file 图标eye-open
* @author zhanglili
*/
var IconEyeOpen =
/*#__PURE__*/
createIcon('eye-open', SVG$2e);

var SVG$2f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513 127.459c210.643 0 381.541 170.899 381.541 381.541S723.643 890.541 513 890.541 131.459 719.643 131.459 509 302.357 127.459 513 127.459m0-63.591C267.383 63.868 67.868 263.383 67.868 509S267.383 954.132 513 954.132 958.132 754.617 958.132 509 758.617 63.868 513 63.868z"
  }), React.createElement("path", {
    d: "M481.205 704.048h63.59v63.59h-63.59v-63.59zm0-446.86h63.59v381.541h-63.59V257.188z"
  }));
});

/**
* @file 图标fail-circle-o
* @author zhanglili
*/
var IconFailCircleO =
/*#__PURE__*/
createIcon('fail-circle-o', SVG$2f);

var SVG$2g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.3 63.9c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445c0-245.7-199.2-445-445-445zM462.1 266c0-5.5 4.5-10 10-10h80.2c5.5 0 10 4.5 10 10v300c0 5.5-4.5 10-10 10h-80.2c-5.5 0-10-4.5-10-10V266zm52.5 497.1c-34 0-61.5-27.6-61.5-61.5s27.6-61.5 61.5-61.5 61.5 27.6 61.5 61.5-27.5 61.5-61.5 61.5z"
  }));
});

/**
* @file 图标fail-circle-solid
* @author zhanglili
*/
var IconFailCircleSolid =
/*#__PURE__*/
createIcon('fail-circle-solid', SVG$2g);

var SVG$2h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.3 61.9c247.4 0 448 200.6 448 448s-200.6 448-448 448-448-200.6-448-448 200.6-448 448-448zm306.3 754.7c20.7 3.5 38-15.9 31.8-36.2.1.2.1.3.2.4l-.3-.8v-.2l-3.2-9.8-38.6-118.4c20.6-43 32.5-90.9 32.5-141.8 0-181.5-147.2-328.7-328.7-328.7S182.6 328.3 182.6 509.8c0 181.6 147.2 328.7 328.7 328.7 63.7 0 123-18.4 173.3-49.7l33.7 7.1c.1 0 .2.1.4.1l97.7 20.5h.4l1.4.3c-.2 0-.4-.2-.6-.2zm-92.1-322.4c0 116.8-94.7 211.5-211.5 211.5S302.5 611 302.5 494.2 397.2 282.7 514 282.7s211.5 94.7 211.5 211.5zm-202.9-81c0 37.6 30.5 68.2 68.2 68.2s68.2-30.5 68.2-68.2-30.5-68.2-68.2-68.2c-37.6.1-68.2 30.6-68.2 68.2zm-32.9 98.1c0 13.4 10.9 24.4 24.3 24.4s24.3-10.9 24.3-24.4c0-13.4-10.9-24.3-24.3-24.3s-24.3 10.9-24.3 24.3z"
  }));
});

/**
* @file 图标farseer
* @author zhanglili
*/
var IconFarseer =
/*#__PURE__*/
createIcon('farseer', SVG$2h);

var SVG$2i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.8 116.2c-229.1 0-413.3 146.4-413.3 346.2 0 122.3 68.9 213.6 172.2 279 10.3 6.9 17.2 17.2 17.2 29.3v120.6c0 10.3 8.6 17.2 17.2 17.2 3.4 0 8.6-1.7 12.1-5.2l94.7-89.6c6.9-6.9 15.5-8.6 24.1-8.6h5.2c22.4 3.4 46.5 5.2 70.6 5.2 229.1 0 413.3-146.4 413.3-346.2.1-201.5-184.2-347.9-413.3-347.9zM340.6 514c-18.9 0-34.4-15.5-34.4-34.4s15.5-34.4 34.4-34.4 34.4 15.5 34.4 34.4-15.4 34.4-34.4 34.4zm172.2 0c-18.9 0-34.4-15.5-34.4-34.4s15.5-34.4 34.4-34.4 34.4 15.5 34.4 34.4-15.4 34.4-34.4 34.4zm172.3 0c-18.9 0-34.4-15.5-34.4-34.4s15.5-34.4 34.4-34.4 34.4 15.5 34.4 34.4S704 514 685.1 514z"
  }));
});

/**
* @file 图标feedback-solid
* @author zhanglili
*/
var IconFeedbackSolid =
/*#__PURE__*/
createIcon('feedback-solid', SVG$2i);

var SVG$2j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M620.446 57.844c-7.329-7.46-17.406-11.517-27.876-11.517l-397.334 1.047c-7.198 0-13.087 5.889-13.087 13.087l-.131 25.259v796.368l.131 26.175c0 7.198 5.889 13.087 13.087 13.087h640.628c7.198 0 13.087-5.889 13.087-13.087V304.018c0-10.339-4.057-20.285-11.386-27.614L620.446 57.844zm150.243 263.057H574.64v-196.18h1.701l194.348 196.18zM260.804 842.565V124.721h235.311v234.526c0 21.725 16.621 40.047 38.346 40.047h236.228v443.27H260.804z"
  }));
});

/**
* @file 图标file
* @author zhanglili
*/
var IconFile =
/*#__PURE__*/
createIcon('file', SVG$2j);

var SVG$2k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M275 842V331H97V97h420v234H339v149h173v-85h420v234H512v-85H339v234h173v-85h420v234H512v-85H275zm593-85H576v106h292V757zm0-298H576v106h292V459zM453 161H161v106h292V161z"
  }));
});

/**
* @file 图标file-tree
* @author zhanglili
*/
var IconFileTree =
/*#__PURE__*/
createIcon('file-tree', SVG$2k);

var SVG$2l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M168.185 24.5H35.343c-3.207 0-4.971 3.688-2.966 6.173l46.338 58.124c1.684 2.164 2.646 4.81 2.646 7.536v75.761c0 2.164 2.566 3.207 4.089 1.684l33.431-33.03a5.398 5.398 0 0 0 1.604-3.848V97.214c0-2.806.962-5.452 2.725-7.616l10.101-12.426c2.164-2.725 1.684-6.734-1.202-8.739-2.566-1.844-6.093-1.363-8.098 1.123l-13.789 16.916a7.78 7.78 0 0 0-1.764 4.891v42.651c0 .16-.08.241-.16.321l-14.191 13.95a.463.463 0 0 1-.802-.321V90.641c0-1.764-.561-3.448-1.684-4.81L53.62 38.129c-.481-.641-.08-1.523.721-1.523h94.441c.802 0 1.282.962.721 1.523l-11.304 13.869c-2.164 2.725-1.684 6.734 1.202 8.739 2.566 1.844 6.093 1.363 8.098-1.123l23.65-28.862c2.006-2.484.242-6.252-2.964-6.252z"
  }));
});

/**
* @file 图标filter-dash
* @author zhanglili
*/
var IconFilterDash =
/*#__PURE__*/
createIcon('filter-dash', SVG$2l);

var SVG$2m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M837.4 135.9c13.7 0 20-10.3 14.2-22.7l-17.2-36.4-295.5 354.5-8.2 9v326.8l10.6-25.5-115.4 115.3 61.6 25.5V440.6l-8.1-10L190.9 77l-28 58.9h674.5zM111 63.7c-13.3 0-16.6 9.2-8.9 18.6l32.9 40.3 288.4 353.7-8.1-22.8v491.4c0 13.7 7.6 17.2 17.5 7.2l44.1-44.1 115.4-115.4 10.6-10.6V458.3l-8.2 23 295.5-358.5 33.3-40.4c8.5-10.3 4.8-18.7-8.8-18.7H111z"
  }));
});

/**
* @file 图标filter-o
* @author zhanglili
*/
var IconFilterO =
/*#__PURE__*/
createIcon('filter-o', SVG$2m);

var SVG$2n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M890.2 122.8l33.3-40.4c8.5-10.3 4.8-18.7-8.8-18.7H111c-13.3 0-16.6 9.2-8.9 18.6l32.9 40.3 280.5 344 7.9 9.7-8.1-22.8v491.4c0 13.7 7.6 17.2 17.5 7.2l44.1-44.1 115.4-115.4 10.6-10.6V471.5"
  }));
});

/**
* @file 图标filter-solid
* @author zhanglili
*/
var IconFilterSolid =
/*#__PURE__*/
createIcon('filter-solid', SVG$2n);

var SVG$2o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M165.807 54.754H146.6a6.04 6.04 0 0 0-6.033 6.033 6.04 6.04 0 0 0 6.033 6.034h13.173v10.553H41.226V44.136l34.025-.063 20.982 20.982a5.996 5.996 0 0 0 4.266 1.768h24.557a6.04 6.04 0 0 0 6.033-6.034 6.04 6.04 0 0 0-6.033-6.034h-22.058L82.013 33.768A6.005 6.005 0 0 0 77.734 32l-42.553.079a6.043 6.043 0 0 0-6.022 6.034v124.852a6.04 6.04 0 0 0 6.034 6.034h130.616a6.04 6.04 0 0 0 6.033-6.034V60.787a6.042 6.042 0 0 0-6.035-6.033zm-6.034 34.688v67.491H41.226V89.442h118.547z"
  }));
});

/**
* @file 图标folder-dash
* @author zhanglili
*/
var IconFolderDash =
/*#__PURE__*/
createIcon('folder-dash', SVG$2o);

var SVG$2p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.183 11.077c0 .504-.37.916-.825.916H1.648c-.453 0-.825-.41-.825-.916V2.83c0-.504.37-.915.825-.915h2.19l2.29 3.512a.407.407 0 0 0 .348.198h6.349c.195 0 .356.01.356.209.002.065.002 5.244.002 5.244zm-.569-8.426l-.006 2.117H6.702L5.268 2.651h7.346zM14 5.63c0-.307-.081-.694-.567-.812V2.68c0-.585-.25-.883-.733-.883H4.745l-.325-.53C4.33 1.133 4.209 1 3.982 1H1.648C.742 1 0 1.821 0 2.83v8.249c0 1.01.742 1.82 1.648 1.82h10.71c.908 0 1.64-.81 1.64-1.82V5.68c0-.029.002-.05.002-.05z"
  }));
});

/**
* @file 图标folder-o
* @author zhanglili
*/
var IconFolderO =
/*#__PURE__*/
createIcon('folder-o', SVG$2p);

var SVG$2q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M927.2 227.5H594.1l-59.7-98.9H100.5c-17.8 0-32.7 14.8-32.7 33.1v700.7c0 18.6 14.7 33.1 32.8 33.1h827c18.1 0 32.8-14.7 32.8-32.9V260.3c0-17.9-14.9-32.8-33.2-32.8z"
  }));
});

/**
* @file 图标folder-solid
* @author zhanglili
*/
var IconFolderSolid =
/*#__PURE__*/
createIcon('folder-solid', SVG$2q);

var SVG$2r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M549.9 240.4v543.4l264.6-264.6c3.9-3.9 3.9-10.2 0-14.1L549.9 240.4zM208.3 783.8l264.6-264.6c3.9-3.9 3.9-10.2 0-14.1L208.3 240.4v543.4z"
  }));
});

/**
* @file 图标forward
* @author zhanglili
*/
var IconForward =
/*#__PURE__*/
createIcon('forward', SVG$2r);

var SVG$2s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M180.1 352.8l-.9-113.7 189.1 189.2c3.9 3.9 10.2 3.9 14.1 0l43.9-43.8c3.9-3.9 3.9-10.2 0-14.2l-189.9-190h106.1c5.5 0 10-4.5 10-10v-62.2c0-5.5-4.5-10-10-10H108c-5.5 0-10 4.5-10 10v234.6c0 5.5 4.5 10 10 10h72.1v.1zm664 0l.9-113.7-189.1 189.1c-3.9 3.9-10.2 3.9-14.1 0l-43.9-43.8c-3.9-3.9-3.9-10.2 0-14.2l189.9-190H681.6c-5.5 0-10-4.5-10-10v-62.1c0-5.5 4.5-10 10-10h234.6c5.5 0 10 4.5 10 10v234.6c0 5.5-4.5 10-10 10h-72.1v.1zM180 683.8l-.8 103.6 189.1-189.2c3.9-3.9 10.2-3.9 14.1 0l43.9 43.8c3.9 3.9 3.9 10.2 0 14.2l-189.9 190h106.1c5.5 0 10 4.5 10 10v62.1c0 5.5-4.5 10-10 10H108c-5.5 0-10-4.5-10-10V683.7c0-5.5 4.5-10 10-10h62c5.6 0 10.1 4.5 10 10.1zm664.1-10.1l.9 113.7-189.1-189.1c-3.9-3.9-10.2-3.9-14.1 0l-44 43.7c-3.9 3.9-3.9 10.2 0 14.2l189.9 190H681.6c-5.5 0-10 4.5-10 10v62.1c0 5.5 4.5 10 10 10h234.6c5.5 0 10-4.5 10-10V683.7c0-5.5-4.5-10-10-10h-72.1z"
  }));
});

/**
* @file 图标fullscreen
* @author zhanglili
*/
var IconFullscreen =
/*#__PURE__*/
createIcon('fullscreen', SVG$2s);

var SVG$2t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M80.831 118.337c-2.118-2.118-5.598-2.118-7.792 0l-32.001 32.001v-18.005c0-3.026-2.497-5.523-5.523-5.523h-.908c-3.026 0-5.523 2.497-5.523 5.523v31.849c0 .833.152 1.589.454 2.27.681 2.27 2.799 3.934 5.22 3.934h31.849c3.026 0 5.523-2.497 5.523-5.523v-.908c0-3.026-2.497-5.523-5.523-5.523h-16.87l31.697-31.697c2.118-2.118 2.118-5.598 0-7.792l-.603-.606zm85.484 8.548h-.908c-3.026 0-5.523 2.497-5.523 5.523v18.005l-32.001-32.001c-2.118-2.118-5.598-2.118-7.792 0l-.606.606c-2.118 2.118-2.118 5.598 0 7.792l31.697 31.697h-17.097c-3.026 0-5.523 2.497-5.523 5.523v.908c0 3.026 2.497 5.523 5.523 5.523h31.849c2.497 0 4.539-1.664 5.22-3.934.302-.681.454-1.437.454-2.27v-31.849c.155-3.102-2.267-5.523-5.293-5.523zm4.994-94.335c-.681-2.27-2.799-3.934-5.22-3.934H134.24c-3.026 0-5.523 2.497-5.523 5.523v.908c0 3.026 2.497 5.523 5.523 5.523h17.097l-31.773 31.697c-2.118 2.118-2.118 5.598 0 7.792l.606.606c2.118 2.118 5.598 2.118 7.792 0l32.001-32.001v18.004c0 3.026 2.497 5.523 5.523 5.523h.908c3.026 0 5.523-2.497 5.523-5.523v-31.85c-.154-.831-.306-1.587-.608-2.268zM49.738 40.493h17.097c3.026 0 5.523-2.497 5.523-5.523v-.908c0-3.026-2.497-5.523-5.523-5.523H34.986c-2.497 0-4.539 1.664-5.22 3.934-.302.681-.454 1.437-.454 2.27v31.849c0 3.026 2.497 5.523 5.523 5.523h.908c3.026 0 5.523-2.497 5.523-5.523v-17.93l32.001 32.001c2.118 2.118 5.598 2.118 7.792 0l.606-.606c2.118-2.118 2.118-5.598 0-7.792L49.738 40.493z"
  }));
});

/**
* @file 图标fullscreen-dash
* @author zhanglili
*/
var IconFullscreenDash =
/*#__PURE__*/
createIcon('fullscreen-dash', SVG$2t);

var SVG$2u = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.3 678.3c92.1 0 164-75.4 164-168.2 0-92.8-74.8-168.2-164-168.2-92.1 0-164 75.4-164 168.2 0 92.8 74.8 168.2 164 168.2zm0-46.4c-66.2 0-120.9-55.1-120.9-121.8 0-66.7 54.7-121.8 120.9-121.8s120.9 55.1 120.9 121.8c0 66.7-54.7 121.8-120.9 121.8zM275.8 810.3c31.7 26.1 66.2 46.4 100.7 60.9 37.4-34.8 86.3-55.1 135.3-55.1 51.8 0 97.8 20.3 135.3 55.1 37.4-14.5 71.9-34.8 100.7-60.9-11.5-49.3-2.9-101.5 20.1-147.9 25.9-43.5 66.2-78.3 115.1-92.8 2.9-20.3 5.8-40.6 5.8-60.9 0-20.3-2.9-40.6-5.8-60.9-48.9-14.5-89.2-49.3-115.1-92.8-25.9-43.5-31.7-98.6-20.1-147.9-31.7-26.1-66.2-46.4-100.7-60.9-37.4 34.8-83.5 55.1-135.3 55.1-48.9 0-97.8-20.3-135.3-55.1-37.4 14.5-71.9 34.8-100.7 60.9 11.5 49.3 2.9 101.5-20.1 147.9-25.9 43.5-66.2 78.3-115.1 92.8-2.9 20.3-5.8 40.6-5.8 60.9 0 20.3 2.9 40.6 5.8 60.9 48.9 14.5 89.2 49.3 115.1 92.8 23 46.4 31.6 98.6 20.1 147.9m100.7 104.4c-48.9-17.4-95-43.5-135.3-81.2-5.8-5.8-8.6-14.5-5.8-20.3 14.4-43.5 8.6-89.9-14.4-127.6-23-40.6-57.6-66.7-100.7-75.4-8.6-2.9-14.4-8.7-14.4-17.4-5.8-26.1-8.6-55.1-8.6-81.2s2.9-52.2 8.6-81.2c2.9-8.7 8.6-14.5 14.4-17.4 43.2-11.6 80.6-37.7 100.7-75.4 23-40.6 25.9-84.1 14.4-127.6-2.9-8.7 0-17.4 5.8-20.3 40.3-34.8 86.3-60.9 135.3-81.2 8.6-2.9 14.4 0 20.1 5.8 31.7 31.9 71.9 52.2 115.1 52.2 43.2 0 86.3-17.4 115.1-52.2 5.8-5.8 14.4-8.7 20.1-5.8 48.9 17.4 95 43.5 135.3 81.2 5.8 5.8 8.6 14.5 5.8 20.3-14.4 43.5-8.6 89.9 14.4 127.6 23 40.6 57.6 66.7 100.7 75.4 8.6 2.9 14.4 8.7 14.4 17.4 5.8 26.1 8.6 55.1 8.6 81.2s-2.9 52.2-8.6 81.2c-2.9 8.7-8.6 14.5-14.4 17.4-43.2 11.6-80.6 37.7-100.7 75.4-23 40.6-25.9 84.1-14.4 127.6 2.9 8.7 0 17.4-5.8 20.3C742 868.3 696 894.4 647 914.7c-8.6 2.9-14.4 0-20.1-5.8-31.7-31.9-71.9-52.2-115.1-52.2-43.2 0-86.3 17.4-115.1 52.2-2.9 2.9-8.6 5.8-14.4 5.8h-5.8zm0 0"
  }));
});

/**
* @file 图标gear-o
* @author zhanglili
*/
var IconGearO =
/*#__PURE__*/
createIcon('gear-o', SVG$2u);

var SVG$2v = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M543.3 711.8l.4.3L707.5 855c12.7 11.1 13.3 29.3 1.6 41.1l-.4.4-.4.3c-12 11.3-31.7 11.8-44.4 1.1l-.4-.3-106.8-93.1v127.7c0 15.4-14.3 27.9-32 27.9s-32-12.5-32-27.9V797.7L373.6 898.2c-12.9 10.8-32.9 10.2-44.8-1.4l-.4-.4-.4-.4c-11.4-11.8-10.7-29.9 1.9-40.8l.4-.3 169.8-143.2c12.2-10.3 31-10.3 43.2.1zM895.5 576c.3 0 .5.2.5.5v63c0 .3-.2.5-.5.5h-767c-.3 0-.5-.2-.5-.5v-63c0-.3.2-.5.5-.5h767zm0-192c.3 0 .5.2.5.5v63c0 .3-.2.5-.5.5h-767c-.3 0-.5-.2-.5-.5v-63c0-.3.2-.5.5-.5h767zM524.8 64c17.6 0 32 12.5 32 27.9v127.7l106.8-93.1.4-.3c12.6-10.7 32.3-10.2 44.4 1.1l.4.3.4.4c11.8 11.8 11.1 30-1.6 41.1L543.7 311.9l-.4.3c-12.2 10.4-31 10.3-43.2.1L330.3 169.1l-.4-.3c-12.5-10.9-13.3-29-1.9-40.8l.4-.4.4-.4c12-11.6 31.9-12.2 44.8-1.4l119.2 100.6V91.9c0-15.4 14.4-27.9 32-27.9z"
  }));
});

/**
* @file 图标group-expansion
* @author zhanglili
*/
var IconGroupExpansion =
/*#__PURE__*/
createIcon('group-expansion', SVG$2v);

var SVG$2w = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M496 920L101 683.5c-5-3-6.8-9.4-4-14.6l21.7-40.1c2.9-5.3 9.5-7.3 14.8-4.4.1.1.3.1.4.2l372.5 223c3.5 2.1 7.8 2.1 11.2 0l371.8-223c5.2-3.1 11.9-1.4 15 3.7.1.1.1.2.2.4l22 39.9c2.8 5.1 1.1 11.6-3.9 14.6L528.3 919.9l-10.9 6c-3.3 1.8-7.2 1.8-10.5 0L496 920zm0-176.7L115.3 516c-5-3-6.8-9.4-4-14.6l21.7-40.1c2.9-5.3 9.5-7.3 14.8-4.4.1.1.3.1.4.2l358.5 214.3c3.4 2 7.7 2.1 11.1 0l363.8-214.5c5.2-3.1 11.9-1.3 14.9 3.9.1.1.1.2.2.3l22 39.9c2.8 5.2 1.1 11.7-4 14.7L528.3 743.2l-10.9 6c-3.3 1.8-7.2 1.8-10.5 0l-10.9-5.9zM150.4 309.8l-36.6 19.6c-10.3 5.6-10.1 14.7 0 20.1l36.6 19.6L497.3 576c8.7 4.7 23.7 4.3 31.6.2l343.8-206.9 39-20.4c10-5.2 9.1-14.1 0-18.9l-39-20.4-343.8-207.1c-8.7-4.6-23.7-4.1-31.6.2L150.4 309.8z"
  }));
});

/**
* @file 图标grouping-solid
* @author zhanglili
*/
var IconGroupingSolid =
/*#__PURE__*/
createIcon('grouping-solid', SVG$2w);

var SVG$2x = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M959 320H832V65c0-.6-.4-1-1-1H193c-.6 0-1 .4-1 1v255H64v448h128v191c0 .6.4 1 1 1h638c.6 0 1-.4 1-1V768h127c.6 0 1-.4 1-1V321c0-.6-.4-1-1-1zM256 128h512v192H256V128zm512 768H256V640h512v256zm128-192h-64V576H192v128h-64V384h768v320z"
  }));
});

/**
* @file 图标group-print
* @author zhanglili
*/
var IconGroupPrint =
/*#__PURE__*/
createIcon('group-print', SVG$2x);

var SVG$2y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M524.8 704c17.6 0 32 12.5 32 27.9v127.7l106.8-93.1.4-.3c12.6-10.7 32.3-10.2 44.4 1.1l.4.3.4.4c11.8 11.8 11.1 30-1.6 41.1L543.7 951.9l-.4.3c-12.2 10.4-31 10.3-43.2.1L330.3 809.1l-.4-.3c-12.5-10.9-13.3-29-1.9-40.8l.4-.4.4-.4c12-11.6 31.9-12.2 44.8-1.4l119.2 100.6V731.9c0-15.4 14.4-27.9 32-27.9zm370.7-128c.3 0 .5.2.5.5v63c0 .3-.2.5-.5.5h-767c-.3 0-.5-.2-.5-.5v-63c0-.3.2-.5.5-.5h767zm0-192c.3 0 .5.2.5.5v63c0 .3-.2.5-.5.5h-767c-.3 0-.5-.2-.5-.5v-63c0-.3.2-.5.5-.5h767zM543.3 71.8l.4.3L707.5 215c12.7 11.1 13.3 29.3 1.6 41.1l-.4.4-.4.3c-12 11.3-31.7 11.8-44.4 1.1l-.4-.3-106.8-93.1v127.7c0 15.4-14.3 27.9-32 27.9s-32-12.5-32-27.9V157.7L373.6 258.2c-12.9 10.8-32.9 10.2-44.8-1.4l-.4-.4-.4-.4c-11.4-11.8-10.7-29.9 1.9-40.8l.4-.3L500.1 71.7c12.2-10.3 31-10.3 43.2.1z"
  }));
});

/**
* @file 图标group-retract
* @author zhanglili
*/
var IconGroupRetract =
/*#__PURE__*/
createIcon('group-retract', SVG$2y);

var SVG$2z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M181.6 528.5c-20.4 16.8-25.6 45.7-12.2 68.5l159.3 271.7c8.8 14.9 24.2 23.7 41.6 23.7h443.2c26.5 0 48.2-21.7 48.4-48.4l2.3-371.5c0-16.2-12.2-29.8-28.4-31.4l-329.4-16c-33.4-2.3-59.4-30.5-59.1-64.1l1.8-183c.1-13.2-4.9-25.6-14.1-34.9-9.1-9.2-21.3-14.4-34.2-14.4-27.2 0-49.1 21.9-49.1 48.8v498.3L254.5 536c-15.5-21.4-48.2-26.7-70-10.2l-2.9 2.7zm188.7 427.6c-39.5 0-76.5-21.2-96.4-55.2L114.5 629.2c-28.7-49-18.4-110.6 24.3-147.7l3.5-3.3c41.6-34.2 105.6-33 145.8 1.2V177.6c0-62 50.4-112.4 112.4-112.4 30.4 0 58.6 11.8 79.8 33.2 21.3 21.5 32.8 50.1 32.6 80.4l-1.8 183 330.2 16.1c49.8 5 86.6 45.8 86.6 95l-2.3 371.7c-.4 61.6-50.7 111.7-112 111.7H370.3z"
  }));
});

/**
* @file 图标hand-up-o
* @author zhanglili
*/
var IconHandUpO =
/*#__PURE__*/
createIcon('hand-up-o', SVG$2z);

var SVG$2A = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M899.89 461.52c-15.6-24.88-35.93-40.52-58.28-45.19-4.94-16.26-17.07-29.11-32.38-34.3-7.43-76.6-40.66-147.44-94.07-200.13-55.4-54.66-127.55-84.75-203.16-84.75-75.52 0-147.62 30.04-203 84.58-53.5 52.7-86.81 123.6-94.22 200.3-15.33 5.18-27.46 18.03-32.4 34.29-22.35 4.66-42.67 20.31-58.27 45.19C106.63 489.39 97 526.12 97 564.95c0 38.8 9.63 75.53 27.11 103.41 15.6 24.89 35.92 40.53 58.27 45.2 6.47 21.31 25.3 36.76 47.47 36.76 27.5 0 49.86-23.78 49.86-53.01V432.58c0-22.37-13.08-41.53-31.54-49.31 7.04-67.2 36.5-129.26 83.48-175.53 49.19-48.46 113.25-75.15 180.36-75.15 67.18 0 131.29 26.74 180.51 75.3 46.9 46.27 76.3 108.27 83.33 175.39-18.45 7.77-31.54 26.94-31.54 49.3v264.74c0 22.83 13.64 42.33 32.69 49.77-4.97 69.52-46.48 109.02-115.62 109.02h-52.59c-6.87-20.55-25.34-35.3-46.99-35.3h-82.99c-27.49 0-49.85 23.79-49.85 53.02 0 29.24 22.37 53.02 49.85 53.02h82.99c21.65 0 40.11-14.75 46.99-35.3h52.59c87.43 0 143.46-54.78 148.98-144.07h.01c14.79-5.42 26.45-18.05 31.25-33.9 22.35-4.67 42.67-20.31 58.28-45.21 17.47-27.88 27.1-64.61 27.1-103.41 0-38.84-9.64-75.57-27.11-103.44zm-653.5 235.8c0 9.71-7.41 17.58-16.54 17.58-9.12 0-16.53-7.88-16.53-17.58 0-9.77-7.46-17.71-16.66-17.71-35.95 0-66.33-52.5-66.33-114.65 0-62.16 30.38-114.66 66.33-114.66 9.2 0 16.66-7.94 16.66-17.72 0-9.7 7.42-17.58 16.53-17.58 9.12 0 16.54 7.88 16.54 17.58v264.74zM561.8 891.41h-82.99c-9.12 0-16.53-7.88-16.53-17.58s7.41-17.59 16.53-17.59h82.99c9.12 0 16.53 7.88 16.53 17.59 0 9.7-7.42 17.58-16.53 17.58zm265.56-211.8c-9.21 0-16.66 7.95-16.66 17.71 0 9.71-7.42 17.58-16.53 17.58-9.12 0-16.53-7.88-16.53-17.58V432.58c0-9.7 7.41-17.58 16.53-17.58 9.11 0 16.53 7.88 16.53 17.58 0 9.78 7.45 17.72 16.66 17.72 35.95 0 66.32 52.5 66.32 114.66 0 62.14-30.37 114.65-66.32 114.65z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标headphone
* @author zhanglili
*/
var IconHeadphone =
/*#__PURE__*/
createIcon('headphone', SVG$2A);

var SVG$2B = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.2 63.3c247.5 0 448.1 200.6 448.1 448.1S759.6 959.5 512.2 959.5 64.1 758.9 64.1 511.4 264.7 63.3 512.2 63.3zm0 64c-212.1 0-384.1 172-384.1 384.1S300 895.5 512.2 895.5s384.1-172 384.1-384.1-172-384.1-384.1-384.1zM496.1 705c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.2-36 36-36zm0-417.7c79.5-.2 144.2 64.1 144.4 143.6.2 67.5-46.5 126-112.4 140.8v67.6c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32 44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-79.4 64.5-143.9 144-144 0 .1 0 .1 0 0z"
  }));
});

/**
* @file 图标help
* @author zhanglili
*/
var IconHelp =
/*#__PURE__*/
createIcon('help', SVG$2B);

var SVG$2C = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M120.1 63.6c4.6 4.2 7 9.9 7 17 0 5.8-1.5 10.7-4.4 14.5-1.1 1.3-4.4 4.4-10.1 9.3-2.1 1.9-3.8 3.9-4.9 6.1-1.3 2.4-1.9 5-1.9 8v2H93.1v-2c0-4.4.7-8.2 2.3-11.3 1.7-3.3 6.2-8.2 13.5-14.7l2-2.3c2.1-2.7 3.2-5.6 3.2-8.7 0-4.2-1.2-7.4-3.4-9.7-2.4-2.4-5.7-3.6-10-3.6-5.3 0-9.3 1.7-11.6 5-2.1 2.8-3.2 7-3.2 12.2H73.3c0-8.7 2.5-15.4 7.6-20.4 5-5.1 11.9-7.6 20.5-7.6 7.7-.1 13.9 2 18.7 6.2zm-14.4 65.5c1.7 1.5 2.5 3.6 2.5 6.1 0 2.5-.8 4.5-2.5 6.2-1.8 1.5-3.9 2.4-6.3 2.4-2.5 0-4.5-.8-6.1-2.5-1.8-1.7-2.6-3.7-2.6-6.1 0-2.5.8-4.5 2.6-6.1 1.5-1.7 3.6-2.4 6.1-2.4s4.6.8 6.3 2.4z"
  }), React.createElement("path", {
    d: "M153.3 64.9c7.2 10.8 11.1 24 10.3 38.2-1.7 32.4-28.3 58.5-60.8 59.6-35.1 1.2-64.2-26.5-65.2-61.1-1.1-35.8 27.1-65 62.9-65 13.1 0 25.3 4 35.4 10.9 2.1 1.5 5 1.4 7-.2 3.5-2.5 3.3-7.7-.2-10.1-12.8-8.7-28.5-13.5-45.2-12.9-38.9 1.6-70.5 33-72.3 71.8-2 44.3 34.5 80.9 78.8 78.9 39.2-1.8 70.7-33.8 71.9-73.1.5-16.2-4.2-31.3-12.5-43.8-2-3-6-3.7-8.8-1.6-2.5 1.9-3.1 5.6-1.3 8.4z"
  }));
});

/**
* @file 图标help-dash
* @author zhanglili
*/
var IconHelpDash =
/*#__PURE__*/
createIcon('help-dash', SVG$2C);

var SVG$2D = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "20",
    height: "20"
  }, props), React.createElement("path", {
    d: "M10 1.75a8.25 8.25 0 1 1 0 16.5 8.25 8.25 0 0 1 0-16.5zm0 1.5a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5zm1 9.7v1.5H9.5v-1.5H11zm-1-7.7a2.75 2.75 0 0 1 1 5.312v1.7H9.5V10.32a1 1 0 0 1 .831-.986A1.376 1.376 0 1 0 8.626 8H7.25A2.75 2.75 0 0 1 10 5.25z"
  }));
});

/**
* @file 图标help-o
* @author zhanglili
*/
var IconHelpO =
/*#__PURE__*/
createIcon('help-o', SVG$2D);

var SVG$2E = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M10 1.75A8.25 8.25 0 1 1 1.75 10 8.25 8.25 0 0 1 10 1.75zm0 1.5A6.75 6.75 0 1 0 16.75 10 6.75 6.75 0 0 0 10 3.25zM11 13v1.5H9.5V13zm-1-7.7a2.75 2.75 0 0 1 1 5.31v1.7H9.5v-1.99a1 1 0 0 1 .83-1A1.36 1.36 0 0 0 11.38 8a1.38 1.38 0 0 0-2.76 0H7.25A2.75 2.75 0 0 1 10 5.25z"
  }))));
});

/**
* @file 图标help-title
* @author zhanglili
*/
var IconHelpTitle =
/*#__PURE__*/
createIcon('help-title', SVG$2E);

var SVG$2F = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M265.7 421.371V172.324H140.677v624.118H265.7V546.395h250.047v250.047H640.77V172.324H515.747v249.047H265.7zm500.094 0h125.023v375.07H765.794v-375.07zm0-187.535h125.023v125.023H765.794V233.836z"
  }));
});

/**
* @file 图标hi
* @author zhanglili
*/
var IconHi =
/*#__PURE__*/
createIcon('hi', SVG$2F);

var SVG$2G = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 17 16"
  }, props), React.createElement("path", {
    d: "M13.4 11.882a.5.5 0 0 1 .078-.39 6.031 6.031 0 0 0 1.085-3.46c0-.812-.16-1.6-.465-2.332a.5.5 0 0 1 .269-.654 1.844 1.844 0 1 0-2.338-2.57.5.5 0 0 1-.676.204A6.033 6.033 0 0 0 8.5 1.97c-1.01 0-1.983.246-2.853.711a.5.5 0 0 1-.676-.205 1.843 1.843 0 1 0-2.338 2.57.5.5 0 0 1 .269.655 6.062 6.062 0 0 0 8.495 7.658.5.5 0 0 1 .387-.039c.73.225 1.62.327 2.371.304-.347-.396-.595-.982-.756-1.741zm1.82 1.3c.588.196.983.705.362 1.15-.208.149-.548.227-1.008.268a8.71 8.71 0 0 1-2.883-.267 7.063 7.063 0 0 1-9.874-8.59 2.843 2.843 0 1 1 3.77-4.147A7.039 7.039 0 0 1 8.5.969c1.019 0 2.007.216 2.913.627a2.844 2.844 0 1 1 3.77 4.148c.25.729.38 1.5.38 2.287 0 1.386-.4 2.712-1.139 3.847.193.78.474 1.196.797 1.304z"
  }), React.createElement("path", {
    d: "M6 7.5h2V5h1v6H8V8.5H6V11H5V5h1v2.5zM10.5 5h1v4h-1V5zm0 5h1v1h-1v-1z"
  }));
});

/**
* @file 图标hi-logo
* @author zhanglili
*/
var IconHiLogo =
/*#__PURE__*/
createIcon('hi-logo', SVG$2G);

var SVG$2H = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M275.93 708.15c62.81 87.26 163.48 140.01 273.03 140.01v51.72c-126.36 0-242.58-60.89-315.01-161.51l41.98-30.22zm273.04-584.03c214.22 0 387.88 173.66 387.88 387.88h-51.72c0-185.66-150.5-336.16-336.16-336.16S212.8 326.34 212.8 512h-51.72c.01-214.22 173.67-387.88 387.89-387.88zM87.16 512h206.86L187.88 615.43zM600.68 599.55h336.16v51.72H600.68zM600.68 702.99h336.16v51.72H600.68zM600.68 806.42h336.16v51.72H600.68zM343.09 563.72V512h180.85v51.72z"
  }), React.createElement("path", {
    d: "M523.94 356.85h51.72v206.87h-51.72z"
  }));
});

/**
* @file 图标history
* @author zhanglili
*/
var IconHistory =
/*#__PURE__*/
createIcon('history', SVG$2H);

var SVG$2I = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    stroke: "#333",
    strokeWidth: ".5",
    d: "M805.8 895.6h-234V685.2H451v210.4H217V474.8h-81c-9.7 0-18.3-5.8-21.7-14.5s-.9-18.6 6.3-24.9L511.4 98.2l390.9 337c7.2 6.2 9.7 16.2 6.3 24.9s-12.1 14.6-21.8 14.6h-81v420.9zm-189-43.6h144V431.2h69.1L511.4 156.6 193 431.2h69.1V852h144V641.6h210.8V852z"
  }));
});

/**
* @file 图标home
* @author zhanglili
*/
var IconHome =
/*#__PURE__*/
createIcon('home', SVG$2I);

var SVG$2J = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M567 161.4s-22-63.5-76.6-15.5C435.9 194 305.6 313.8 305.6 313.8H66.1c-1.7 0-3.1 1.4-3.1 2.9l1.3 382c0 1.6 1.3 2.9 2.9 2.9H295L492.5 873c28.7 24.9 74.5 37.8 74.5-20V161.4zm245.3 53.3c-31.4-21-77.5 22.1-58.4 48.3 80.8 67.9 128.8 163.3 123.4 267.3-4.9 94.5-52.8 178.6-127.2 239.4-25.9 31.1 35.6 66.2 56.1 50.3 89.2-72.8 146.7-173.6 152.5-286.7 6.4-123.8-50.5-237.5-146.4-318.6z"
  }), React.createElement("path", {
    d: "M639.3 675.2c-22.6 27.7 27 64.7 54.3 44.7 57.9-50.2 95-117.9 98.9-193.4 4.4-84.5-33.6-162.3-98-218.6-31.7-23.7-76.6 21.3-56.8 42.5 51.9 44.2 82.6 106 79.2 173.2-3.1 59.2-32.2 112.3-77.6 151.6z"
  }));
});

/**
* @file 图标horn
* @author zhanglili
*/
var IconHorn =
/*#__PURE__*/
createIcon('horn', SVG$2J);

var SVG$2K = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M500.5 308.8c-31.2 27.4-105.6 95.8-105.6 95.8H258.2c-1 0-1.7.8-1.7 1.7l.7 218.1c0 .9.7 1.7 1.7 1.7H389L501.7 724c16.4 14.2 42.5 21.6 42.5-11.4V317.7s-12.5-36.3-43.7-8.9zm183.8 39.3c-17.9-12-44.2 12.6-33.3 27.6 46.1 38.8 73.5 93.3 70.5 152.6-2.8 53.9-30.2 102-72.6 136.7-14.8 17.7 20.3 37.8 32 28.7 50.9-41.6 83.8-99.1 87.1-163.7 3.5-70.7-29-135.6-83.7-181.9z"
  }), React.createElement("path", {
    d: "M617 401.3c-18.1-13.5-43.7 12.2-32.5 24.3 29.6 25.3 47.2 60.6 45.2 98.9-1.7 33.8-18.4 64.1-44.3 86.6-12.9 15.8 15.4 37 31 25.5 33.1-28.6 54.2-67.3 56.5-110.5 2.6-48.2-19.1-92.6-55.9-124.8z"
  }), React.createElement("path", {
    d: "M511.3 63.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5 383.5 171.7 383.5 383.5c0 211.9-171.7 383.5-383.5 383.5z"
  }));
});

/**
* @file 图标horn-circle-o
* @author zhanglili
*/
var IconHornCircleO =
/*#__PURE__*/
createIcon('horn-circle-o', SVG$2K);

var SVG$2L = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.3 63.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm32.9 649.2c0 33-26.1 25.7-42.5 11.4l-112.8-97.9H258.8c-1 0-1.7-.7-1.7-1.7l-.7-218.1c0-.9.8-1.7 1.7-1.7h136.7s74.4-68.4 105.6-95.8c31.2-27.4 43.7 8.9 43.7 8.9v394.9h.1zm72.3-76c-15.6 11.5-43.9-9.7-31-25.5 25.9-22.4 42.5-52.7 44.3-86.6 2-38.4-15.6-73.7-45.2-98.9-11.3-12.1 14.3-37.8 32.5-24.3 36.7 32.2 58.4 76.6 55.9 124.8-2.3 43.2-23.4 81.8-56.5 110.5zM767.9 530c-3.3 64.6-36.2 122.1-87.1 163.7-11.7 9.1-46.8-11-32-28.7 42.4-34.7 69.8-82.8 72.6-136.7 3.1-59.4-24.3-113.8-70.5-152.6-10.9-14.9 15.4-39.6 33.3-27.6 54.8 46.3 87.3 111.2 83.7 181.9z"
  }));
});

/**
* @file 图标horn-circle-solid
* @author zhanglili
*/
var IconHornCircleSolid =
/*#__PURE__*/
createIcon('horn-circle-solid', SVG$2L);

var SVG$2M = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M324.5 916.3h537.2v40.3H324.5zM580.6 63.9c-.1 0-.1-.1 0 0zm-19.7 272.4c51.3-17-69.4 32.3 19.6-102.1 87.5-132.2 3-169 .1-170.2 2.1.9 29.2 13.8-.1 68-30.5 56.3-64.1 92.1-76.3 139.7-12.3 47.5 5.4 81.6 56.7 64.6zm98.1-1.6c32.1-10.6-43.5 20.2 12.3-63.9 55.7-84.1 0-106.5 0-106.5s19 7.4 0 42.6-40.1 57.6-47.7 87.4c-7.8 29.8 3.4 51.1 35.4 40.4zm284.1 63.7H234.6c-8.8 0-16.2 7.2-16.2 16.1v58.3c-12.5-4.7-26-7.3-40.2-7.3-63.1 0-114.2 51.2-114.2 114.3s51.1 114.3 114.2 114.3c33.5 0 63.7-14.5 84.6-37.5 41.2 74.1 108.2 132.6 189.4 164 42.6 17.1 89.1 26.6 137.8 26.6 75.5 0 145.6-22.6 204.1-61.5.4-.3.7-.5.9-.8C894.1 720.1 959.3 610 959.3 485v-70.6c0-8.8-7.2-16-16.2-16zM177.8 650.6c-39.4 0-71.4-32-71.4-71.4 0-39.5 32-71.4 71.4-71.4 15.9 0 30.6 5.2 42.5 14.1 3.2 31.1 10.5 61.1 21.3 89.4-11.7 23.2-35.9 39.3-63.8 39.3zm689.5-128.3c0 2.4-.1 4.9-.3 7.3v11.9c0 4.1-1 7.9-2.8 11.3C843 670.6 715.7 761.3 588.9 761.3c-126.6 0-255.5-92.7-275.2-208.5-1.8-3.4-2.8-7.3-2.8-11.3v-52.3c0-8.9 7.2-16.2 16.3-16.2h523.4c9 0 16.3 7.3 16.3 16.2v7.9c.3.2.4.4.4.6.1 9.4.1 19.3 0 24.6z"
  }));
});

/**
* @file 图标icafe
* @author zhanglili
*/
var IconICafe =
/*#__PURE__*/
createIcon('icafe', SVG$2M);

var SVG$2N = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M955 509.6c0-245.8-199.2-445-445-445S65 263.8 65 509.6s199.2 445 445 445 445-199.3 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z"
  }), React.createElement("path", {
    d: "M359.1 744.8h307.1v23H359.1zm146.4-487.2s-.1 0 0 0c-.1 0 0 0 0 0zm-11.3 155.7c29.3-9.7-39.7 18.5 11.2-58.4 50-75.5 1.7-96.6.1-97.3 1.2.5 16.7 7.9-.1 38.9-17.4 32.2-36.6 52.6-43.6 79.8-7 27.2 3.1 46.7 32.4 37zm56.1-.9c18.3-6.1-24.8 11.6 7-36.5s0-60.9 0-60.9 10.9 4.2 0 24.3-22.9 32.9-27.3 49.9c-4.4 17.1 2 29.3 20.3 23.2zm162.4 36.4h-405c-5 0-9.2 4.1-9.2 9.2v33.3c-7.1-2.7-14.9-4.2-23-4.2-36.1 0-65.3 29.3-65.3 65.3 0 36.1 29.2 65.3 65.3 65.3 19.2 0 36.4-8.3 48.3-21.4 23.5 42.4 61.9 75.8 108.2 93.7 24.3 9.8 50.9 15.2 78.8 15.2 43.1 0 83.2-12.9 116.7-35.1.2-.1.4-.3.5-.4 56.6-37 93.9-100 93.9-171.4V458c0-5.1-4.1-9.2-9.2-9.2zM275.3 592.9c-22.5 0-40.8-18.3-40.8-40.8s18.3-40.8 40.8-40.8c9.1 0 17.5 3 24.3 8 1.8 17.8 6 34.9 12.2 51.1-6.7 13.3-20.6 22.5-36.5 22.5zm394-73.3c0 1.4-.1 2.8-.2 4.2v6.8c0 2.3-.6 4.5-1.6 6.5-12.1 67.4-84.9 119.2-157.4 119.2-72.4 0-146-53-157.3-119.1-1-1.9-1.6-4.2-1.6-6.5v-29.9c0-5.1 4.1-9.3 9.3-9.3h299.1c5.2 0 9.3 4.2 9.3 9.3v4.5c.1.1.2.2.2.3.3 5.3.3 11 .2 14z"
  }));
});

/**
* @file 图标icafe-circle-o
* @author zhanglili
*/
var IconICafeCircleO =
/*#__PURE__*/
createIcon('icafe-circle-o', SVG$2N);

var SVG$2O = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M86.1 378.3c6.2 0 11.5 2.1 15.8 6.4s6.4 9.5 6.4 15.6-2.1 11.3-6.4 15.6c-4.3 4.3-9.5 6.4-15.6 6.4s-11.3-2.2-15.6-6.6c-4.3-4.4-6.4-9.5-6.4-15.4s2.1-11.1 6.4-15.4c4.2-4.4 9.4-6.6 15.4-6.6zm14.6 260.3H71.8V449.4h28.8l.1 189.2zM387 592.1c-27.3 35.2-64.8 52.8-112.5 52.8-40.3 0-73.2-12.7-98.9-38.2s-38.5-57.6-38.5-96.5c0-24.1 6-46.3 17.9-66.6 11.9-20.4 28.4-36.3 49.5-47.9s43.8-17.4 68.2-17.4 46.3 4.7 65.6 14.1c19.3 9.4 35.5 23.1 48.4 41.1l-22.9 17.7c-24.1-29.2-53.8-43.7-89.2-43.7-28.9 0-53.9 10.2-74.8 30.5s-31.4 45.3-31.4 74.8 10.2 54.1 30.7 73.9 47 29.7 79.7 29.7 61-14 85-42l23.2 17.7zm228.4 46.5h-28.1v-27.8c-20.6 22.7-44.3 34-71.2 34s-49.8-9.9-68.9-29.7-28.6-43.4-28.6-70.8 9.6-50.9 28.8-70.5 42.6-29.3 70.3-29.3c27.6 0 50.8 11.2 69.6 33.7v-28.8h28.1v189.2zm-97.2-20.5c19.2 0 35.7-6.9 49.6-20.8s20.8-31.2 20.8-51.9-6.8-38.1-20.5-52.1-30.4-21-50.2-21-36.5 7.2-50.2 21.7-20.5 31.5-20.5 51.2 6.9 36.7 20.8 51.2c14.1 14.5 30.8 21.7 50.2 21.7zm226.6-205.8c-11.1-4.6-19.8-6.9-26-6.9s-10.3 2-12.1 6.1c-1.9 4-2.8 10.8-2.8 20.3v17.7h38.5v25h-38.5v164.2h-28.8V474.4h-23.9v-25h23.9v-21.5c0-17.1 3.2-29.7 9.5-37.7 6.4-8 16.4-12 30-12 7.4 0 17.5 1.7 30.2 5.2v28.9zM959.3 549H793.4c1.2 20.8 8.2 37.5 21 50.2 12.8 12.6 28.2 18.9 46 18.9 30.3 0 53.5-14.9 69.4-44.8l24.3 12.5c-10.9 20.1-23.7 35-38.5 44.6s-32.5 14.4-53.1 14.4c-28.5 0-51.9-9.8-70.5-29.3-18.5-19.6-27.8-43.1-27.8-70.6s9.3-51.1 27.9-70.8c18.6-19.7 41.7-29.5 69.2-29.5s50.6 9.3 69.1 27.9 28.2 44.1 28.9 76.5zm-31.9-25.3c-3.5-16.2-11.3-28.8-23.6-37.8s-26.4-13.5-42.3-13.5c-32.4 0-53.9 17.1-64.6 51.4h130.5v-.1z"
  }));
});

/**
* @file 图标icafe-word
* @author zhanglili
*/
var IconICafeWord =
/*#__PURE__*/
createIcon('icafe-word', SVG$2O);

var SVG$2P = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "1024",
    height: "1024"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M424 129h-64v675.746l-217.2-217.2L97.546 632.8l262.336 262.337.137-.136L424 895V129zm502.454 263.2L664.118 129.863l-.138.138L600 130v766h64V220.255l217.2 217.2 45.254-45.255z"
  }));
});

/**
* @file 图标icode-compare
* @author zhanglili
*/
var IconICodeCompare =
/*#__PURE__*/
createIcon('icode-compare', SVG$2P);

var SVG$2Q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "20",
    height: "20"
  }, props), React.createElement("path", {
    d: "M8.008 3L10.1 4.876H18V17H2V3h6.008zm-.383 1H3v12h14V5.875H9.717L7.625 4zM14 12.5v1h-4v-1h4zM6.707 7l3.182 3.182-3.182 3.182L6 12.657l2.475-2.475L6 7.707 6.707 7z"
  }));
});

/**
* @file 图标icode-repo-add
* @author zhanglili
*/
var IconIcodeRepoAdd =
/*#__PURE__*/
createIcon('icode-repo-add', SVG$2Q);

var SVG$2R = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "1024",
    height: "1024"
  }, props), React.createElement("path", {
    d: "M879.72 144.523l-327.162-48.3L96.604 552.175l374.767 374.767 455.995-455.996-47.646-326.424zm-56.45 56.36l36.129 247.522L471.37 836.433 187.114 552.176l387.94-387.94 248.215 36.647zm-71.918 71.312c-37.49-37.49-98.274-37.49-135.764 0-37.49 37.49-37.49 98.274 0 135.764 37.49 37.49 98.274 37.49 135.764 0 37.49-37.49 37.49-98.274 0-135.764zm-45.255 45.255c12.497 12.496 12.497 32.758 0 45.254-12.497 12.497-32.758 12.497-45.255 0-12.496-12.496-12.496-32.758 0-45.254 12.497-12.497 32.758-12.497 45.255 0z"
  }));
});

/**
* @file 图标icode-tag
* @author zhanglili
*/
var IconICodeTag =
/*#__PURE__*/
createIcon('icode-tag', SVG$2R);

var SVG$2S = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M60.5 431.7H116v275.8H60.5V431.7zm0-111.5H116v55.5H60.5v-55.5zM341.2 621c0 12-2.3 23.4-6.8 34.3s-10.8 20.4-18.8 28.6c-8 8.2-17.3 14.7-28 19.6s-22.2 7.3-34.5 7.3c-10.5 0-21.2-1.5-32.1-4.4s-20.7-7.9-29.4-15-15.9-16.4-21.5-28-8.4-26.3-8.4-44.1V406.2c0-12.7 2.2-24.5 6.5-35.4s10.5-20.3 18.5-28.3 17.5-14.2 28.6-18.8c11.1-4.5 23.3-6.8 36.7-6.8 12.7 0 24.5 2.3 35.4 6.8s20.3 10.9 28.3 19c8 8.2 14.2 18 18.8 29.4 4.5 11.4 6.8 23.8 6.8 37.3v21.8h-55.5v-18.5c0-10.9-3.1-20.3-9.2-28.3s-14.5-12-25-12c-13.8 0-22.9 4.3-27.5 12.8-4.5 8.5-6.8 19.3-6.8 32.4v198c0 11.2 2.4 20.7 7.3 28.3 4.9 7.6 13.7 11.4 26.4 11.4 3.6 0 7.5-.6 11.7-1.9 4.2-1.3 8-3.4 11.4-6.3 3.4-2.9 6.3-6.9 8.4-12 2.2-5.1 3.3-11.4 3.3-19v-19h55.5l-.1 23.9zm37-96.8c0-11.2.7-21.6 2.2-31s4.2-17.8 8.2-25c6.5-12 16-21.6 28.3-28.8s27-10.9 44.1-10.9 31.7 3.6 44.1 10.9c12.3 7.3 21.8 16.9 28.3 28.8 4 7.3 6.7 15.6 8.2 25s2.2 19.8 2.2 31v90.9c0 11.2-.7 21.6-2.2 31s-4.2 17.8-8.2 25c-6.5 12-16 21.6-28.3 28.8s-27 10.9-44.1 10.9-31.7-3.6-44.1-10.9c-12.3-7.3-21.8-16.9-28.3-28.8-4-7.3-6.7-15.6-8.2-25s-2.2-19.8-2.2-31v-90.9zm55.5 99.6c0 10.5 2.4 18.4 7.3 23.7s11.5 7.9 19.9 7.9c8.3 0 15-2.6 19.9-7.9s7.3-13.1 7.3-23.7V515.5c0-10.5-2.4-18.4-7.3-23.7s-11.5-7.9-19.9-7.9-15 2.6-19.9 7.9-7.3 13.1-7.3 23.7v108.3zm206.2-6c0 11.2 2.2 20.3 6.5 27.2s11.2 10.3 20.7 10.3c8.3 0 15.1-3.2 20.1-9.5 5.1-6.3 7.6-14.6 7.6-24.8V513.9c0-8.7-2.6-15.9-7.9-21.5S675 484 667 484c-10.5 0-17.7 3.3-21.5 9.8s-5.7 14.1-5.7 22.8l.1 101.2zm54.9 64.7c-3.6 4-7.1 7.7-10.3 11.2-3.3 3.4-6.9 6.4-10.9 9-4 2.5-8.5 4.5-13.6 6s-11.1 2.2-18 2.2c-22.8 0-39-8.7-48.4-26.1-3.3-6.2-5.6-13.8-7.1-22.8-1.5-9.1-2.2-21.2-2.2-36.4v-105c0-19.9.5-34.6 1.6-44.1s3.4-17 7.1-22.8c4.7-7.3 10.8-13.2 18.2-18 7.4-4.7 17.9-7.1 31.3-7.1 10.9 0 20.6 2.4 29.1 7.3s15.9 11.9 22 20.9h1.1V320.2h55.5v387.3h-55.5l.1-25zm151.8-91.9v37.5c0 8.7 2.4 15.4 7.3 20.1s11.5 7.1 19.9 7.1c10.5 0 17.5-3.1 20.9-9.2s5.5-12.3 6.3-18.5h55.5c0 11.6-1.9 22.5-5.7 32.6-3.8 10.2-9.3 18.9-16.6 26.1-7.3 7.6-16 13.6-26.1 18-10.2 4.4-21.6 6.5-34.3 6.5-17 0-31.7-3.6-44.1-10.9-12.3-7.3-21.8-16.9-28.3-28.8-4-7.3-6.7-15.6-8.2-25s-2.2-19.8-2.2-31v-90.9c0-11.2.7-21.6 2.2-31s4.2-17.8 8.2-25c6.5-12 16-21.6 28.3-28.8s27-10.9 44.1-10.9c12.7 0 24.2 2.2 34.5 6.5 10.3 4.4 19 10.4 26.1 18.2s12.5 17 16.3 27.5 5.7 21.8 5.7 33.7v76.2H846.6zm0-43.5H901v-31.6c0-10.5-2.4-18.4-7.3-23.7s-11.5-7.9-19.9-7.9c-8.3 0-15 2.6-19.9 7.9s-7.3 13.1-7.3 23.7v31.6z"
  }));
});

/**
* @file 图标icode-word
* @author zhanglili
*/
var IconICodeWord =
/*#__PURE__*/
createIcon('icode-word', SVG$2S);

var SVG$2T = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M440.1 445.1l.1-323.4L63.5 344.5v328.8l356.8 217.4 204.2-386.2 62.9 38.4-106.9 67.7v289.9l378.6-240V365L600.6 147.2 440.1 445.1zm-63.9-208.3v182.9L218 522.3l203.9 93.3 202.6-376.2 270.7 164.5v218.5l-250.7 159V648.7L813.2 542 600.4 412 396.1 798.2 127.5 634.5V383.9l248.7-147.1zM430 463.9l-35.4 65.8-38.8-17.7 74.2-48.1z"
  }));
});

/**
* @file 图标ide
* @author zhanglili
*/
var IconIDE =
/*#__PURE__*/
createIcon('ide', SVG$2T);

var SVG$2U = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M440.1 445.1l.1-323.4L63.5 344.5v328.8l356.8 217.4 204.2-386.2 62.9 38.4-106.9 67.7v289.9l378.6-240V365L600.6 147.2 440.1 445.1zm-63.9-208.3v182.9L218 522.3l203.9 93.3 202.6-376.2 270.7 164.5v218.5l-250.7 159V648.7L813.2 542 600.4 412 396.1 798.2 127.5 634.5V383.9l248.7-147.1zM430 463.9l-35.4 65.8-38.8-17.7 74.2-48.1z"
  }));
});

/**
* @file 图标ide-client
* @author zhanglili
*/
var IconIDEClient =
/*#__PURE__*/
createIcon('ide-client', SVG$2U);

var SVG$2V = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513 127.459c210.643 0 381.541 170.899 381.541 381.541S723.643 890.541 513 890.541 131.459 719.643 131.459 509 302.357 127.459 513 127.459m0-63.591C267.383 63.868 67.868 263.383 67.868 509S267.383 954.132 513 954.132 958.132 754.617 958.132 509 758.617 63.868 513 63.868z"
  }), React.createElement("path", {
    d: "M481.205 255.992h63.59v63.59h-63.59v-63.59zm0 129.283h63.59v381.541h-63.59V385.275z"
  }));
});

/**
* @file 图标info-circle-o
* @author zhanglili
*/
var IconInfoCircleO =
/*#__PURE__*/
createIcon('info-circle-o', SVG$2V);

var SVG$2W = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510.6 65.6c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.3 445-445c0-245.8-199.2-445-445-445zm1.3 218.8c23.8 0 43.1 19.3 43.1 43.2s-19.3 43.2-43.1 43.2-43.1-19.3-43.1-43.2 19.3-43.2 43.1-43.2zM606.7 732H417.1v-53.7h68.3V468.9h-68.3v-53.7l121.3-.7v263.8h68.3V732z"
  }));
});

/**
* @file 图标info-circle-solid
* @author zhanglili
*/
var IconInfoCircleSolid =
/*#__PURE__*/
createIcon('info-circle-solid', SVG$2W);

var SVG$2X = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M682.146 603.497c-13.082 0-23.687-10.631-23.687-23.743s10.605-23.743 23.687-23.743 23.687 10.631 23.687 23.743-10.606 23.743-23.687 23.743zm-42.574 155.968V735.22h26.608v-94.545h-26.608V616.43l58.995-.317V735.22h26.608v24.245h-85.603zm42.813-260.874c-93.434 0-156.503 63.069-156.503 156.503s63.069 156.503 156.503 156.503c93.434 0 156.503-63.069 156.503-156.503s-63.069-156.503-156.503-156.503zm.713-45.815c112.147 0 203.031 90.885 203.031 203.031 0 112.1-90.885 203.031-203.031 203.031s-203.031-90.885-203.031-203.031 90.884-203.031 203.031-203.031zM252.586 217.697h594.809l.343 215.863h-53.98V270.896H306.66V758.79h161.554v53.204H252.586V217.697zM145.911 110.161h488.472v54.083H200.958v432.672H145.91V110.161z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标information
* @author zhanglili
*/
var IconInformation =
/*#__PURE__*/
createIcon('information', SVG$2X);

var SVG$2Y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }), React.createElement("path", {
    d: "M15 9l-1 6H2L1 9zm-1.18 1H2.18l.67 4h10.3zM10 11v1H9v-1zm2 0v1h-1v-1zM8 5a3 3 0 0 1 2.52 1.38l-.73.73a2 2 0 0 0-3.58 0l-.73-.73A3 3 0 0 1 8 5zm0-2a5 5 0 0 1 4 1.94l-.72.72a4 4 0 0 0-6.48 0L4 4.94A5 5 0 0 1 8 3zm0-2a7 7 0 0 1 5.38 2.52l-.71.71a6 6 0 0 0-9.34 0l-.71-.71A7 7 0 0 1 8 1z"
  }))));
});

/**
* @file 图标ip
* @author zhanglili
*/
var IconIP =
/*#__PURE__*/
createIcon('ip', SVG$2Y);

var SVG$2Z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 768 768"
  }, props), React.createElement("path", {
    d: "M384 0v240h-48v192h240v-48h192v384H576v-48H48V240H0V0h384zm336 432h-96v288h96V432zM288 240H96v432h480V480H288V240zm48-192H48v144h288V48z"
  }));
});

/**
* @file 图标ipipe
* @author zhanglili
*/
var IconIPipe =
/*#__PURE__*/
createIcon('ipipe', SVG$2Z);

var SVG$2_ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M98 599.8V296.4h60.9v303.4H98zm0-365v-61h60.9v61H98zm103.8 365V173.7h91.3c16.7 0 31.4 2.2 44.2 6.6 12.7 4.4 24.3 12.2 34.6 23.3 10.3 11.2 17.5 24.2 21.5 39.2 4 15 6 35.2 6 60.7 0 19.2-1.1 35.3-3.3 48.5-2.2 13.2-6.9 25.5-14 37.1-8.4 14-19.5 24.8-33.4 32.6s-32.2 11.7-54.9 11.7h-31v166.4h-61zm60.9-368.6V376H292c12.3 0 21.9-1.8 28.7-5.4 6.8-3.6 11.7-8.6 14.9-15 3.2-6 5.1-13.4 5.7-22.1.6-8.8.9-18.6.9-29.3 0-10-.2-19.4-.6-28.4-.4-9-2.2-16.9-5.4-23.6-3.2-6.8-8-12-14.3-15.6-6.4-3.6-15.5-5.4-27.5-5.4h-31.7zm167.6 368.6V296.4h60.9v303.4h-60.9zm0-365v-61h60.9v61h-60.9zm100.2 487.7V296.4h60.9V324c7.6-8.8 15.3-16.2 23.3-22.1s19.5-9 34.6-9c25.1 0 42.8 9.6 53.1 28.7 3.6 6.8 6.2 15.2 7.8 25.1 1.6 10 2.4 23.3 2.4 40.1v115.5c0 22.3-.6 38.5-1.8 48.5-2.4 19.9-11.5 34.9-27.5 44.9-8 5.2-19.5 7.8-34.6 7.8-11.9 0-22.6-2.7-31.9-8.1-9.4-5.4-17.4-13.1-24.2-23h-1.2v150.2h-60.9zm121.2-327.3c0-12.4-2.4-22.3-7.2-29.9-4.8-7.6-12.3-11.4-22.7-11.4-9.2 0-16.5 3.5-22.1 10.5-5.6 7-8.4 16.1-8.4 27.2v117.9c0 9.6 2.9 17.5 8.7 23.6 5.8 6.2 13 9.3 21.8 9.3 11.5 0 19.4-3.6 23.6-10.8 4.2-7.2 6.3-15.6 6.3-25.1V395.2zm276.3 76H807.4v41.3c0 9.6 2.7 17 8.1 22.1 5.4 5.2 12.6 7.8 21.8 7.8 11.5 0 19.2-3.4 23-10.2 3.8-6.8 6.1-13.6 6.9-20.3H928c0 26.7-8.2 48.3-24.5 64.6-8 8.4-17.5 15-28.7 19.7-11.1 4.8-23.7 7.2-37.6 7.2-19.1 0-35.3-4-48.7-12-13.3-8-23.6-18.6-30.7-31.7-4.4-8-7.4-17.2-9-27.5-1.6-10.4-2.4-21.7-2.4-34.1v-99.9c0-12.4.8-23.7 2.4-34.1 1.6-10.4 4.6-19.5 9-27.5 7.2-13.2 17.4-23.7 30.7-31.7s29.6-12 48.7-12c13.9 0 26.6 2.4 37.9 7.2 11.3 4.8 21 11.4 29 19.7 15.9 18 23.9 40.5 23.9 67.6v83.8zm-120.6-47.9h59.7v-34.7c0-11.6-2.7-20.2-8.1-26-5.4-5.8-12.6-8.7-21.8-8.7s-16.4 2.9-21.8 8.7c-5.4 5.8-8.1 14.5-8.1 26v34.7z"
  }));
});

/**
* @file 图标ipipe-word
* @author zhanglili
*/
var IconIPipeWord =
/*#__PURE__*/
createIcon('ipipe-word', SVG$2_);

var SVG$2$ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M358.52 156.86h127.53l261.78 710.17H627.98l-62.33-178.04H278.94l-62.33 178.04H96.74l261.78-710.17zM312.5 593.51h219.59l-107.4-311.32h-3.84L312.5 593.51zm502.46-436.65h112.19v710.17H814.96V156.86z"
  }));
});

/**
* @file 图标irepo
* @author zhanglili
*/
var IconIRepo =
/*#__PURE__*/
createIcon('irepo', SVG$2$);

var SVG$30 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "20",
    height: "20"
  }, props), React.createElement("path", {
    d: "M18 3v14H2V3h16zm-1 5H3v8h14V8zm-8 5v1H5v-1h4zm8-9H3v3h14V4z"
  }));
});

/**
* @file 图标issue-o
* @author zhanglili
*/
var IconIssueO =
/*#__PURE__*/
createIcon('issue-o', SVG$30);

var SVG$31 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M721.4 770.4l107.7 107.7c19.7 19.7 51.6 19.8 71.5-.2 19.8-19.8 19.7-52 .2-71.5L553.2 458.8c99-116.1 116.8-265.6 36.8-345.5-85.8-85.8-251.6-59-370.4 59.7S74.1 457.6 159.9 543.4c73.9 73.9 207.3 64.3 318.7-15.8l195 195-47.8 47.8-71.7-71.7-71.7 71.7 191.2 191.2 71.7-71.7-71.7-71.7 47.8-47.8zM477.2 324.3c-23.5 23.5-61.5 23.5-85 0s-23.5-61.5 0-85 61.5-23.5 85 0 23.4 61.6 0 85zM371 430.5c-23.5 23.5-61.5 23.5-85 0s-23.5-61.5 0-85 61.5-23.5 85 0c23.4 23.5 23.4 61.6 0 85z"
  }));
});

/**
* @file 图标key
* @author zhanglili
*/
var IconKey =
/*#__PURE__*/
createIcon('key', SVG$31);

var SVG$32 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M381.6 511l379.7-341.6c2.2-2 3.5-4.8 3.5-7.7V73c0-8.8-10.4-13.6-17.1-7.7L258.8 502.6c-4.7 4.1-4.7 11.4 0 15.5l488.9 438.3c6.6 5.8 17.1 1.1 17.1-7.7v-87.6c0-3-1.3-5.8-3.5-7.7L381.6 511z"
  }));
});

/**
* @file 图标left
* @author zhanglili
*/
var IconLeft =
/*#__PURE__*/
createIcon('left', SVG$32);

var SVG$33 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M736.5 63.1L304.8 494.7c-7.8 7.8-7.8 20.5 0 28.3l431.7 431.6"
  }));
});

/**
* @file 图标left-solid
* @author zhanglili
*/
var IconLeftSolid =
/*#__PURE__*/
createIcon('left-solid', SVG$33);

var SVG$34 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M82.1 37.6c-1.1-2.8-4.2-4.3-7-3.5-2.1.3-3.9 1.6-4.7 3.7L25.9 155.7c-1.1 3 .4 6.3 3.4 7.4 3 1.1 6.3-.4 7.4-3.4l16-42.5h47l16 42.6c1.1 3 4.4 4.5 7.4 3.4s4.5-4.4 3.4-7.4L82.1 37.6zm-24.9 67.8l19-50.5 19 50.5h-38zm117.2 48.5l-25.8-68.4c-.9-2.4-3.2-3.8-5.6-3.7-2.4-.1-4.7 1.3-5.6 3.7l-16.8 44.6 6.1 16.5 3.2-8.5h26.2l7.5 19.8c1.1 3 4.4 4.5 7.4 3.4 3.1-1.1 4.6-4.5 3.4-7.4zm-39.9-27.7l8.6-22.9 8.6 22.9h-17.2z"
  }));
});

/**
* @file 图标letter-difference
* @author zhanglili
*/
var IconLetterDifference =
/*#__PURE__*/
createIcon('letter-difference', SVG$34);

var SVG$35 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M513 62.37a64.13 64.13 0 1 1-64.13 64.13A64.13 64.13 0 0 1 513 62.37zm-301.18 201a64.13 64.13 0 1 1-87.61 23.47 64.13 64.13 0 0 1 87.61-23.48zm690 23.47a64.13 64.13 0 1 1-87.61-23.47 64.13 64.13 0 0 1 87.57 23.46zm-23.51 361.31a64.13 64.13 0 1 1-87.61 23.47 64.13 64.13 0 0 1 87.61-23.47zm-643 23.47a64.13 64.13 0 1 1-87.61-23.47 64.13 64.13 0 0 1 87.6 23.48zM513 254.77c141.68 0 256.53 114.85 256.53 256.53S654.68 767.83 513 767.83 256.47 653 256.47 511.3 371.32 254.77 513 254.77zM513 832a64.13 64.13 0 1 1-64.13 64.13A64.13 64.13 0 0 1 513 832z"
  }));
});

/**
* @file 图标light-mode
* @author zhanglili
*/
var IconLightMode =
/*#__PURE__*/
createIcon('light-mode', SVG$35);

var SVG$36 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M3 3v10h10V3h-3V2h4v12H2V2h4v1z"
  }), React.createElement("path", {
    d: "M8 11.18L5.15 8.33l.71-.71L8 9.77l2.15-2.15.7.71L8 11.18z"
  }), React.createElement("path", {
    d: "M7.5 4.35h1v5.71h-1z"
  }), React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }));
});

/**
* @file 图标limit-download
* @author zhanglili
*/
var IconLimitDownload =
/*#__PURE__*/
createIcon('limit-download', SVG$36);

var SVG$37 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M610.9 652.5c3 3 3.1 7.9.1 10.9L316.5 958c-3 3-7.9 3-10.9-.1L66.3 718.7c-3-3-3.1-7.9-.1-10.9l294.5-294.5c3-3 7.9-3 10.9.1l95 95 41.7-41.7-95-95c-3-3-3.1-7.9-.1-10.9L707.9 66.1c3-3 7.9-3 10.9.1l239.3 239.3c3 3 3.1 7.9.1 10.9L663.6 610.9c-3 3-7.9 3-10.9-.1l-97-97-41.7 41.8 96.9 96.9zM371.4 508.1L161.6 717.9l144 145L517.3 654l-50.9-50.9-68.7 68.7-47.3-47.3 68.7-68.7-47.7-47.7zm281.3 7.7l211.7-208.9L718.5 161 508.7 370.8l47.5 47.8 57.3-57.3 47.3 47.3-57.5 57.5 49.4 49.7z"
  }));
});

/**
* @file 图标link
* @author zhanglili
*/
var IconLink =
/*#__PURE__*/
createIcon('link', SVG$37);

var SVG$38 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M741.6 191.6H512.2v-128h448v448h-128V282.1L429.4 684.8l-90.5-90.5 402.7-402.7zm-549.4 640h511.9v-192h128v320H64.2v-768h320v128h-192v512z"
  }));
});

/**
* @file 图标link-blank
* @author zhanglili
*/
var IconLinkBlank =
/*#__PURE__*/
createIcon('link-blank', SVG$38);

var SVG$39 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M961.2 143H65.1v128h896.1V143zm-1 321H65.1v128h895.1V464zm0 319H65.1v128h895.1V783z"
  }));
});

/**
* @file 图标list
* @author zhanglili
*/
var IconList =
/*#__PURE__*/
createIcon('list', SVG$39);

var SVG$3a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M960.2 130H320.1v128h640.1V130zM245 191.6c0 50.4-40.9 91.4-91.4 91.4-50.4 0-91.4-40.9-91.4-91.4s40.9-91.4 91.4-91.4c50.5 0 91.4 41 91.4 91.4zM959.2 451H320.1v128h639.1V451zM244 512.6c0 50.4-40.9 91.4-91.4 91.4-50.4 0-91.4-40.9-91.4-91.4s40.9-91.4 91.4-91.4 91.4 41 91.4 91.4zM959.2 770H320.1v128h639.1V770zM249 832.6c0 50.4-40.9 91.4-91.4 91.4-50.4 0-91.4-40.9-91.4-91.4s40.9-91.4 91.4-91.4c50.5 0 91.4 41 91.4 91.4z"
  }));
});

/**
* @file 图标list-header
* @author zhanglili
*/
var IconListHeader =
/*#__PURE__*/
createIcon('list-header', SVG$3a);

var SVG$3b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M960.2 128H320.1v128h640.1V128zM245 189.6c0 50.4-40.9 91.4-91.4 91.4-50.4 0-91.4-40.9-91.4-91.4s40.9-91.4 91.4-91.4c50.5 0 91.4 41 91.4 91.4zM959.2 449H448.1v128h511.1V449zM368 510.6c0 50.4-40.9 91.4-91.4 91.4-50.4 0-91.4-40.9-91.4-91.4s40.9-91.4 91.4-91.4 91.4 41 91.4 91.4zM959.2 768H576.1v128h383.1V768zM499 830.6c0 50.4-40.9 91.4-91.4 91.4-50.4 0-91.4-40.9-91.4-91.4s40.9-91.4 91.4-91.4c50.5 0 91.4 41 91.4 91.4z"
  }));
});

/**
* @file 图标list-level
* @author zhanglili
*/
var IconListLevel =
/*#__PURE__*/
createIcon('list-level', SVG$3b);

var SVG$3c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100",
    style: {
      background: "0 0"
    }
  }, props), React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "25",
    fill: "none",
    stroke: "#6471B4",
    strokeDasharray: "117.81 41.27",
    strokeWidth: "8",
    transform: "rotate(180 50 50)"
  }, React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    calcMode: "linear",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 50 50;360 50 50"
  })));
});

/**
* @file 图标loading
* @author zhanglili
*/
var IconLoading =
/*#__PURE__*/
createIcon('loading', SVG$3c);

var SVG$3d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.3 892.7c-211.8 0-383.6-171.2-383.6-382.3s171.8-382.3 383.6-382.3h.3V63.9h-.3c-247.5 0-448 199.9-448 446.5s200.5 446.5 448 446.5 448-199.9 448-446.5h-64.4c0 211.1-171.7 382.3-383.6 382.3z"
  }));
});

/**
* @file 图标loading-circle-solid
* @author zhanglili
*/
var IconLoadingCircleSolid =
/*#__PURE__*/
createIcon('loading-circle-solid', SVG$3d);

var SVG$3e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M127.8 511.6v-1.2c0-211.1 171.8-382.3 383.6-382.3h.3V63.9h-.3c-247.5 0-448 199.9-448 446.5v1.2h64.4z"
  }));
});

/**
* @file 图标loading-quarter-circle-solid
* @author zhanglili
*/
var IconLoadingQuarterCircleSolid =
/*#__PURE__*/
createIcon('loading-quarter-circle-solid', SVG$3e);

var SVG$3f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M753.8 384.6v-80.3c0-132.7-107.9-241.1-241-241.1-132.8 0-241 107.9-241 241.1v80.3h-60.3c-11 0-20 9-20 20v533.9c0 11 9 20 20 20h602.6c11 0 20-9 20-20V404.6c0-11-9-20-20-20h-60.3zM513 791.6c-66.6 0-120.5-54-120.5-120.5s54-120.5 120.5-120.5 120.5 54 120.5 120.5c.1 66.5-53.9 120.5-120.5 120.5zm160.6-407H352.2v-76.2c0-89.2 71.3-161.5 160.7-161.5 88.8 0 160.7 72.1 160.7 161.5v76.2z"
  }));
});

/**
* @file 图标lock-close-solid
* @author zhanglili
*/
var IconLockCloseSolid =
/*#__PURE__*/
createIcon('lock-close-solid', SVG$3f);

var SVG$3g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 744.53 629.98"
  }, props), React.createElement("path", {
    d: "M0 0h210.16L369.6 278.77 535.6 0h208.93v430.91c0 109.85-40.44 199.07-166.34 199.07h-5.47V262.44L369.6 572.71 171.82 266.24v363.74c-129 0-171.82-89-171.82-198.85z"
  }));
});

/**
* @file 图标m
* @author zhanglili
*/
var IconM =
/*#__PURE__*/
createIcon('m', SVG$3g);

var SVG$3h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M831.2 385v77.7L511.7 657 194.2 462.7V385l317.5 194.3L831.2 385"
  }), React.createElement("path", {
    d: "M943.5 256.2H81c-8.7 0-15.7 7.1-15.6 15.6l.4 70.7-.4 403.2v70.7c0 8.6 6.9 15.6 15.7 15.6h862.5c8.7 0 15.7-7.1 15.7-15.6V271.8c-.1-8.6-7.1-15.6-15.8-15.6zm-56.4 488.6c0 6.3-5.8 11.5-13.1 11.5H151.8c-7.3 0-13.1-5.2-13.1-11.5v-52.1l.4-297.4-.3-52.1c0-6.3 5.8-11.5 13-11.5h722.3c7.3 0 13.1 5.2 13.1 11.5v401.6z"
  }));
});

/**
* @file 图标mail-o
* @author zhanglili
*/
var IconMailO =
/*#__PURE__*/
createIcon('mail-o', SVG$3h);

var SVG$3i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M82 213.8c-9 0-16.2 7.3-16.2 16.2l.4 73.2-.4 417.4v73.2c0 8.9 7.2 16.2 16.3 16.2h861c9 0 16.3-7.3 16.3-16.2V230c0-8.9-7.2-16.2-16.3-16.2H82zm788 187.5L512.5 624.7 155.1 401.3V312l357.4 223.4L870 312v89.3z"
  }));
});

/**
* @file 图标mail-solid
* @author zhanglili
*/
var IconMailSolid =
/*#__PURE__*/
createIcon('mail-solid', SVG$3i);

var SVG$3j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M520.64 457.23c100.2 0 181.43-107.72 181.43-197.59S620.84 96.93 520.64 96.93s-181.43 72.85-181.43 162.72 81.23 197.58 181.43 197.58zM166.42 768.74c0-54.52 37.93-118.45 84.72-142.79l86.06-44.77 65.19 234.46s1.82 20.29 34.41 20.29 32.59-20.29 32.59-20.29V624.42s1.48-43.24 43.97-43.24 42.49 43.24 42.49 43.24v191.22s11.11 24.03 37.44 24.03 29.5-24.03 29.5-24.03l63.83-234.46 86.21 44.8c46.8 24.32 84.74 88.23 84.74 142.76v59.62c0 54.52-42.39 98.72-94.68 98.72H261.1c-52.29 0-94.68-44.19-94.68-98.72v-59.62z"
  }));
});

/**
* @file 图标manager
* @author zhanglili
*/
var IconManager =
/*#__PURE__*/
createIcon('manager', SVG$3j);

var SVG$3k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M927 97v863H97V97h830zm-64 64H161v735h702V161z"
  }), React.createElement("path", {
    d: "M256 325h448v64H256zM256 517h384v64H256z"
  }));
});

/**
* @file 图标manifest
* @author zhanglili
*/
var IconManifest =
/*#__PURE__*/
createIcon('manifest', SVG$3k);

var SVG$3l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M727 778.3l-9.2-4.6c-1-.5-2.2-.6-3.3-.1l-201.8 80.7-201.8-80.7c-1.1-.4-2.3-.4-3.3.1l-183.3 91.6 23.1-392.2 88.7-22.2-13.1-52.3-124.4 31.1c-1.7.4-2.9 1.9-3 3.6L65.2 948.4c-.2 3.1 3 5.2 5.8 3.8L311.5 832l201.1 80.4 212.3-84.9-22.1-.9 251.3 125.7c2.8 1.4 6-.7 5.8-3.8l-30.2-513.8c-.1-1.6-1.2-3-2.7-3.6l-95.6-31.8-17.1 50.2 63.6 22.2C894.4 754 898.1 817.6 901 865.5c-25.3-12.9-69-34.7-174-87.2z"
  }), React.createElement("path", {
    d: "M602.1 294.9c0-51.8-41.6-94.6-92.1-94.6s-92.1 42.7-92.1 94.6 41.6 94.6 92.1 94.6c53.5 0 92.1-42.7 92.1-94.6zm-121.7 0c0-18.3 14.8-33.6 32.7-33.6 17.9 0 32.7 15.3 32.7 33.6s-14.8 33.6-32.7 33.6-32.7-15.3-32.7-33.6zm31.8 402.3l21.7-21c23.8-24.4 219.8-237.9 219.8-366 0-137.3-106.9-247.1-240.6-247.1S272.4 172.9 272.4 310.2c0 128.1 196 341.6 219.8 366l20 21zm.8-573.1c101 0 181.2 82.3 181.2 186.1 0 79.3-115.8 225.7-181.2 301.9-65.4-73.2-181.2-222.6-181.2-301.9C328.9 206.5 412 124.1 513 124.1z"
  }));
});

/**
* @file 图标map
* @author zhanglili
*/
var IconMap =
/*#__PURE__*/
createIcon('map', SVG$3l);

var SVG$3m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M222.8 231.2v48.2h-48.2v481.7h48.2v48.2h-96.3v-578h96.3zm674.3 0v578h-96.3V761H849V279.4h-48.2v-48.2h96.3z"
  }), React.createElement("path", {
    d: "M439.8 587.3c-2.9-3-5-6.7-6.1-10.7-1.5-4.6-2.7-11.1-4.2-19.5l-30.6-184.4c-1.1-6.1-1.9-13-3.1-20.3-1.1-7.7-1.9-16.1-2.3-24.9l-18.4 2.3c-2.7 4.6-5.7 9.2-8.8 13.4-3.4 4.2-6.5 9.2-9.9 14.9L244.7 549.4c-5.7 9.6-10.7 17.2-14.9 23-4.2 5.7-8 10.3-12.2 13.4-4.2 3.4-8.4 5.7-13.4 6.9-5 1.1-11.1 2.3-18.4 2.7l-1.5 9.6c6.9 0 14.2 0 21.8-.4 7.7 0 14.5-.4 21.8-.4 8.4 0 16.8 0 25.6.4s16.4.4 23.3.4l2.7-10.3c-11.9-.4-19.9-1.9-24.1-3.8-4.2-1.9-6.1-5.4-5-10.3.4-2.7 3.4-9.6 9.2-20.3l31.4-55.5h94.1l9.6 60.1c.4 3.4.8 6.5 1.1 9.2s.4 5 0 7.3c-.8 5-3.8 8.4-8.4 9.9-5 1.9-12.6 3.1-23.3 3.8l-.8 9.6c8 0 16.1 0 24.1-.4 8 0 16.1-.4 24.1-.4 9.6 0 19.1 0 28.7.4s18 .4 26 .4l2.7-10.3c-5.9-.2-11.8-1-17.6-2.3-4.3-.4-8.3-2-11.5-4.8zm-139.7-98.7L364 376.9h.8L382 488.6h-81.9zm333.6-20.7c2.7-3.4 5.4-6.1 8.4-8 3.1-1.9 6.1-3.4 9.6-4.2 3.4-.8 8-1.9 14.2-2.7l1.1-9.2c-4.6 0-9.6 0-14.5.4-5 0-10.7.4-17.6.4-8.8 0-15.7 0-21.4-.4-5.7 0-11.5-.4-17.2-.4l-2.3 9.6c8.4.4 14.2 1.5 17.2 3.1 3.1 1.5 4.2 4.2 3.8 6.9-.4 1.5-.8 3.1-1.9 5.4-1.1 2.3-2.3 4.2-3.4 6.5L555.8 566l-20.4-90c-1-2.2-1.5-4.5-1.5-6.9-.4-1.8-.4-3.6 0-5.4.4-3.1 2.3-5.4 5.7-6.9 3.1-1.1 8.8-2.3 16.4-3.4l1.1-9.2c-5.4 0-11.1 0-17.6.4-6.1 0-13 .4-20.3.4-8.4 0-16.4 0-24.1-.4-7.7 0-14.5-.4-20.7-.4l-2.7 10.3c5.4.4 9.9.8 13 1.5 3.4.8 6.1 1.9 8.4 3.8s3.8 4.6 5.4 8c1.5 3.4 2.7 8 4.2 13.4 5.4 21 10.3 42.1 15.7 63.1 5 21 9.6 42.8 13.8 65.8l13-1.1c7.7-13.4 15.7-26.8 23-39.4 7.7-12.6 14.5-24.5 21.4-35.2 6.9-11.1 13-21 18.7-29.8 5.7-9.2 11.1-16.8 15.7-23.3 3.6-5.3 7-9.9 9.7-13.4zm200.8-17.6L833 448l-43.6 3.1c-.8 0-2.3 0-4.6.4-2.3 0-4.6-.4-6.1-.8s-3.4-1.5-5.4-2.7c-9.9-6.5-22.2-9.6-37.1-9.6-9.6 0-18.7 1.5-27.5 5-9.2 3.4-17.2 8-24.9 14.2-7.7 6.1-14.2 13-19.1 21.4-5.4 8-8.8 16.8-10.3 26.4-4.6 25.2 2.7 43.2 21.8 53.9-2.7 1.9-6.1 4.6-9.9 7.3-3.8 2.7-7.7 5.7-11.1 9.2-3.4 3.4-6.9 6.9-9.6 10.3-2.7 3.4-4.6 6.9-5 10.3-1.1 7.3.4 13 5.4 17.6 4.6 4.6 10.7 8.4 18 11.5-5.4 3.4-11.1 6.9-16.4 10.7-5.7 3.8-10.7 8-15.3 12.2-4.6 4.6-8.8 9.6-12.2 14.9-3.4 5.4-5.7 11.1-6.9 17.6-1.5 9.2-.8 16.8 2.3 23.7 3.1 6.5 8 12.2 14.2 16.8 6.1 4.6 13.4 7.7 21.4 9.9 8 2.3 16.4 3.1 24.5 3.1 15.7 0 30.2-2.3 44.4-6.5s26-10.3 37.1-18c10.7-7.7 19.5-16.8 26.8-27.2 7.3-10.3 11.9-21.4 13.8-33.3 1.9-9.9 1.1-18-1.5-24.1-2.3-6.2-6.6-11.5-12.2-14.9-5.4-3.8-11.9-6.1-19.1-7.7-7.3-1.5-14.5-2.3-22.2-2.3-6.9 0-14.5 0-22.6.4s-15.7.4-23 .4c-2.7 0-5.7-.4-8.8-.8-3-.5-6-1.4-8.8-2.7-2.7-1.1-5-3.1-6.5-5s-2.3-4.2-1.9-6.9c.8-3.4 2.7-7.3 6.5-11.5 3.4-4.2 7.7-7.3 12.6-9.2 8 1.9 15.7 2.7 23 2.7 8.4 0 16.8-1.5 26-4.2 9.2-3.1 17.6-7.3 25.6-13s14.9-13 21-21.4c5.7-8.4 9.9-18.4 11.9-29.5 2.3-11.9.4-23-5.7-32.9h39.8l2.7-16.5zM673.9 632.8c2.3-1.1 4.6-1.9 7.7-2.7 2.7-.4 6.1-.8 10.3-1.1h21c8.8 0 16.1.4 22.6.8s12.2 1.9 17.2 4.2c6.1 2.7 9.9 6.5 12.6 11.9s3.1 11.9 1.5 19.9c-1.5 8.8-4.6 16.1-8.8 22.2-4.2 6.1-9.6 11.5-16.1 15.3-6.5 3.8-13.4 6.9-21.4 8.8-14.8 3.4-30.2 3.5-45.1.4-6.9-1.5-13-3.8-18.4-7.3-5.1-3.2-9.3-7.7-12.2-13-2.8-6.1-3.6-12.9-2.3-19.5 1.1-6.5 3.8-13 7.7-19.1 3.8-6.1 9.2-11.5 16.1-16.4 3-1.7 5.3-3.3 7.6-4.4zm86.8-124.3c-1.1 5.4-2.7 10.7-5 16.4-2.3 5.7-5.4 10.7-8.8 15.3-3.4 4.6-7.7 8-12.6 11.1-5 2.7-10.3 4.2-16.4 4.2-7.3 0-13-1.9-17.2-5.4-4.4-3.6-7.8-8.4-9.6-13.8-2.3-5.7-3.4-11.9-3.4-18.7-.4-6.9 0-13.4 1.1-19.9 1.1-5.7 2.7-11.1 5-16.8 2.3-5.7 5-10.7 8.4-14.9 6.9-9.1 17.6-14.6 29.1-14.9 7.3 0 13.4 1.5 17.6 5 4.2 3.4 7.7 7.7 9.9 13.4 2.3 5.4 3.4 11.5 3.4 18.4 0 6.8-.4 13.7-1.5 20.6z"
  }));
});

/**
* @file 图标math-average
* @author zhanglili
*/
var IconMathAverage =
/*#__PURE__*/
createIcon('math-average', SVG$3m);

var SVG$3n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M230.7 224.1v46.8h-46.8v467.9h46.8v46.8h-93.6V224.1h93.6zm655 0v561.5h-93.6v-46.8H839V270.9h-46.8v-46.8h93.5z"
  }), React.createElement("path", {
    d: "M386.4 600.6l37.4-162.2c2.7-11.4 5.5-20.7 8.3-28 2.8-7.3 6.5-12.2 11-14.8 2.9-1.7 7.6-3.3 14-4.8 6.4-1.6 11-2.4 13.8-2.5l2.5-10.3h-89.6l-2.5 10.3c3.8.5 8.7 1.6 14.6 3.2s10.1 3.5 12.6 5.7c1.3 1.1 2.4 2.9 3 5.2.7 2.3 1 5.2 1 8.6 0 3.7-.4 8.2-1.2 13.4-.8 5.2-1.9 10.6-3.1 16.1l-25.3 109.8-84-172.3h-63.2l-2.5 10.3c4.1.4 8.8 1.4 14.1 3 5.2 1.6 9.7 4.5 13.3 8.6 2.1 2.5 3.4 4.8 4 7.1.6 2.2.9 4.6.9 7.1 0 2.1-.2 4.3-.5 6.8-.3 2.4-.8 5.4-1.6 8.8l-24.7 106.9c-3.1 13.9-6.1 24-9 30.2-2.9 6.3-6.4 10.8-10.6 13.6-2.2 1.6-6.6 3.2-13.2 4.9-6.6 1.7-11.7 2.7-15.1 3l-2.3 10.3h90.4l2.3-10.3c-2.3-.2-6.9-1.3-14-3.3-7-2-11.4-4-13.2-6.2-1.2-1.5-2.2-3.3-3-5.5-.7-2.2-1.1-5.2-1.1-8.8 0-3.4.4-7.9 1.2-13.4s1.9-10.9 3.1-16.3L282 414.5l90.4 186.1h14zm103 1.1c5.6 0 10.1-.5 13.5-1.4 3.4-.9 7.3-2.5 11.5-4.6 3.6-1.9 7.3-4.2 11-6.9s7.6-5.7 11.7-9h.8c0 5.6 1.7 10.4 5.2 14.6 3.5 4.2 8.8 6.2 16 6.2 4.2 0 8.7-.8 13.6-2.3s11-3.8 18.4-6.8l2-8.5c-1.7.6-4.1 1.2-7.2 1.7s-5.5.8-7.2.8c-5 0-8.6-.9-10.8-2.7-2.2-1.8-3.2-5.2-3.2-10.3 0-1.5.4-4.1 1.1-7.8.7-3.7 1.5-7.3 2.4-10.9l19.7-85.3-1.6-2-23.1 1.6-23.2 100c-6 6-12 10.5-18 13.5s-11.8 4.4-17.4 4.4c-5.6 0-9.6-1.7-12.2-5.2-2.6-3.4-3.8-8.1-3.8-14 0-1.7.3-4.1.9-7.4.6-3.2 1.3-6.7 2.2-10.4l11.8-49c.7-2.7 1.2-5.5 1.6-8.2s.5-4.9.5-6.5c0-6.1-1.7-10.8-5-14.1s-8.5-5-15.6-5c-3.2 0-7.4.8-12.7 2.4s-11.3 3.9-18.2 7l-2 8.5c1.7-.4 4-1 7-1.7s5.5-1.1 7.4-1.1c5 0 8.4.8 10 2.5 1.6 1.6 2.5 4.9 2.5 9.9 0 2.7-.3 5.6-.9 8.6-.6 3-1.3 6.4-2.2 10.3l-10.3 42c-1.3 5.7-2.2 10.1-2.5 13-.4 2.9-.5 5.4-.5 7.6 0 8 2.3 14.4 7 19.3 4.7 4.8 11.3 7.2 19.8 7.2zm307.9-1c3.4 0 7.6-.6 12.5-1.9s11.4-3.6 19.5-6.8l2-8.5c-1.7.6-4.1 1.1-7.3 1.6-3.2.4-5.6.7-7.3.7-5 0-8.6-.9-10.7-2.7-2.1-1.8-3.2-5.2-3.2-10.3 0-2 .4-4.9 1.1-8.5.7-3.7 1.5-6.9 2.3-9.7l11.1-42.5c1.1-4 1.8-8 2.3-12.1.5-4.1.7-6.9.7-8.5 0-8-2.3-14.4-6.8-19.3s-11.1-7.4-19.5-7.4c-9.8 0-18.4 2-25.8 6.1s-15.8 10-25.2 17.9h-.5c-.6-6.9-3.4-12.6-8.3-17.2s-11.3-6.8-19.1-6.8c-9.3 0-17.3 1.8-24 5.3-6.7 3.5-15.3 9.4-25.7 17.6h-.8c-.2-6.6-1.7-11.9-4.7-15.7-3-3.8-8-5.8-15-5.8-3.8 0-8.3.8-13.6 2.3-5.3 1.5-11.4 3.8-18.3 6.9l-2 8.5c1.7-.4 4-1 7.1-1.7 3-.7 5.5-1.1 7.5-1.1 4.9 0 8.1.8 9.8 2.5 1.7 1.6 2.5 5 2.5 10.1 0 2.5-.3 5.5-1 9s-1.3 6.8-2.1 9.9l-19.7 85.9h24.6l22.4-97.3c8-8.7 15.1-14.4 21.2-16.9 6.1-2.5 11.7-3.8 16.7-3.8 5.6 0 9.8 1.6 12.7 4.9 2.9 3.3 4.3 7.8 4.3 13.5 0 1.1-.2 2.7-.6 4.8s-.8 4.2-1.3 6.2l-20.8 88.5h24.6l23.1-98.2c7.2-7.6 13.6-12.8 19.3-15.6 5.7-2.8 11.5-4.2 17.4-4.2 5.6 0 9.6 1.7 12.2 5.2 2.6 3.4 3.8 8.1 3.8 14 0 1.9-.3 4.3-.9 7.4-.6 3.1-1.3 6.5-2.3 10.3l-13 49.4c-.8 3.2-1.4 5.9-1.7 8.3-.4 2.3-.5 4.5-.5 6.4 0 5.4 1.8 9.9 5.3 13.6 3.4 3.9 8.7 5.7 15.7 5.7z"
  }));
});

/**
* @file 图标math-count
* @author zhanglili
*/
var IconMathCount =
/*#__PURE__*/
createIcon('math-count', SVG$3n);

var SVG$3o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M219.7 234.1v47.4h-47.4v474.3h47.4v47.4h-94.9V234.1h94.9zm664.1 0v569.2h-94.9v-47.4h47.4V281.6h-47.4v-47.4h94.9z"
  }), React.createElement("path", {
    d: "M485.7 414.5c.7-5.9 2.1-10.5 3.1-14.3 1.4-3.8 3.5-6.6 5.9-8.7 2.4-2.1 5.9-3.8 10.5-4.9 4.2-1 10.1-1.7 17.1-2.1l1-8h-57.9c-3.5 6.3-7.3 12.2-10.8 18.5-3.5 6.3-7.3 12.2-11.2 18.5l-92.1 151.4h-.7L310.1 417c-1.7-6.6-3.5-13.6-5.2-19.9-1.7-6.6-3.5-13.3-5.2-20.2h-57.2l-2.1 8c5.9.3 11.2 1 15.3 2.1 4.5 1 7.7 3.1 10.1 6.3 1.4 1.7 2.4 3.5 3.1 5.6 1 2.1 1.4 4.5 1.7 7.3 0 2.8 0 6.3-.7 10.5s-1.4 8.7-2.8 14.6L240.6 553c-2.1 9.4-3.8 16.7-5.9 22.3-1.7 5.2-4.2 9.4-7 11.9-2.8 2.8-6.3 4.5-10.5 5.2-4.2.7-9.8 1.7-16 2.1l-.7 8.4c5.6 0 11.5 0 18.1-.3 6.6 0 12.9-.3 18.8-.3 7.7 0 14.3 0 19.9.3 5.9 0 11.2.3 16.4.3l2.1-8.4c-5.9-.3-10.8-1-14.3-1.7s-6.3-2.1-8-4.2c-1.7-2.1-2.4-5.2-2.4-9.4s1-9.8 2.4-17.4l28.6-136 1-.3c8.4 30.7 16.7 60.7 25.1 90 8.4 29.3 16.4 59.6 24.1 90.7l11.5-1.4c19.2-32.4 38-64.2 56.8-95.6 18.8-31.4 38-62.8 57.5-94.9l.7.7-22 149.6c-.7 5.9-1.7 10.5-2.8 14.3-1 3.8-2.8 6.6-4.9 8.7-2.1 2.1-5.2 3.8-8.7 4.9-3.5 1-8.4 1.7-14 2.1l-.7 8h83l2.1-8.4c-7-.3-12.2-.7-16.4-1.7-3.2-.5-6.3-1.7-9.1-3.5-1.9-1.6-3.2-3.8-3.5-6.3-.3-2.4-.3-5.6 0-9.4l23.9-158.8zm293.7 53.7c-4.5 0-9.1.3-14.3.3-4.9 0-10.1 0-15.3-.3-5.2 0-10.5-.3-15.3-.3l-1.7 8c8.7.7 12.6 2.8 12.2 6.3-.3 2.1-2.1 4.9-5.2 8.4L715.9 518l-15-29.6c-1.4-3.1-2.1-5.6-1.7-7.3.3-1.8 1.7-3.3 3.5-3.8 2.1-.7 5.2-1.4 9.8-1.7l1-7.7c-4.9 0-9.8 0-15.3.3-5.6 0-10.8.3-15.7.3-5.9 0-11.9 0-17.8-.3-5.9 0-11.5-.3-16.7-.3l-2.1 8.7c4.2.7 8.4 1 11.2 1.4 2.8.3 5.2 1.4 7.3 2.4 2.1 1.4 3.8 3.1 5.2 5.6l5.2 9.4 21.3 41.9-33.5 35.6c-4.2 4.2-7.7 7.7-10.8 10.5-3.1 2.8-6.3 4.9-9.4 6.6-3.1 1.7-6.3 2.8-9.8 3.5-.7 0-1.7.3-2.4.3l-2.4-4.9c-4.9 2.8-9.1 3.8-12.9 3.8-4.2 0-7.3-1.7-9.1-5.2-1.7-3.5-2.1-8.4-1-14.3 2.8-15 5.2-28.9 7.7-41.2 2.4-12.2 4.5-23.4 6.3-32.8 1-6.3 1-11.9 0-16.4-1.8-8.4-8.1-15.2-16.4-17.4-4.2-1.4-8.7-2.1-14-2.1-10.1 0-20.9 2.4-32.4 7-4.5 1.7-8.7 3.8-13.3 6.3-4.2 2.4-8.4 4.9-11.9 7.3-3.8 2.4-6.6 5.2-9.1 8-2.1 2.1-3.6 4.8-4.2 7.7-.7 3.1.7 5.9 3.5 7.3 2.8 1.7 6.3 2.4 9.8 2.4 4.5 0 8-1 10.8-3.1 1.3-7.4 4.7-14.3 9.8-19.9 5.4-6 13.2-9.4 21.3-9.1 8.4 0 14.3 2.8 17.1 8 2.8 5.2 3.8 11.9 2.4 19.9L590 517c-.3 2.1-.7 3.8-1 5.6-.3 1.7-.7 2.8-1 3.8-12.9 1.4-24.1 3.1-33.8 5.2-9.4 2.4-17.4 4.5-23.4 6.6-8 3.1-15 7.7-20.6 13.3s-9.1 12.6-10.5 20.6c-.7 4.9-.7 9.1 0 13.3 1 4.2 2.8 8 5.2 11.2 2.4 3.1 5.6 5.9 9.8 7.7 3.8 1.7 8.4 2.8 13.6 2.8 4.5 0 9.1-.7 14.3-2.4 5.2-1.7 10.1-3.8 14.6-5.9 4.5-2.4 8.7-4.5 12.6-6.6s6.3-3.8 8-4.9c.3 7.3 2.4 12.2 6.6 15.3 4.2 3.1 9.1 4.5 14.3 4.5s10.8-1 16.4-3.1c1.4-.7 2.4-1.4 3.8-2.1v1c4.9 0 9.8 0 14.3-.3 4.5 0 9.1-.3 14.3-.3 4.9 0 10.5 0 16 .3 5.9 0 11.2.3 16.4.3l1.7-8c-3.9 0-7.8-.7-11.5-2.1-2.1-1-3.1-2.8-2.8-4.9.3-2.4 2.4-5.6 5.9-9.8l26.9-31 16.7 33.1c1 2.1 1.4 3.8 1.7 5.2s.3 2.8.3 3.5c-.7 3.8-5.6 5.9-14.3 6.6l-.7 7.7c4.5 0 9.8 0 15.3-.3 5.6 0 11.5-.3 17.4-.3 5.9 0 12.2 0 18.8.3 6.6 0 12.6.3 17.4.3l2.1-8.7c-4.9-.3-9.1-.7-12.2-1.4-2.8-.6-5.6-1.6-8-3.1-2.3-1.7-4.3-3.9-5.9-6.3-1.7-2.8-3.8-6.3-6.3-10.8l-22.7-44.3 26.5-27.9c4.5-4.9 8.4-8.4 11.5-11.5 3.5-2.8 6.6-5.2 10.1-7 3.5-1.7 7-3.1 10.8-3.8s8.4-1.7 13.6-2.1l1-8h-13.8v-.1zm-196.7 88.2c-1.4 6.3-2.4 12.6-3.5 19.2-5.2 4.2-10.8 7.3-16.7 9.8-5.9 2.4-11.5 3.5-16.4 3.5-7 0-11.9-2.4-14.3-7-2.5-5.2-3.3-11.1-2.1-16.7 1-5.6 3.8-10.1 8.4-13.6 2.8-2.4 6.3-4.5 10.1-6.3 3.8-1.7 8-3.1 12.2-4.2 4.2-1 8.7-2.1 13.3-2.8 4.5-.7 8.7-1.4 13.3-1.7-1.9 7.3-3 13.5-4.3 19.8z"
  }));
});

/**
* @file 图标math-max
* @author zhanglili
*/
var IconMathMax =
/*#__PURE__*/
createIcon('math-max', SVG$3o);

var SVG$3p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M227 232v47.9h-47.9v478.7H227v47.9h-95.7V232H227zm670.1 0v574.4h-95.7v-47.9h47.9V279.9h-47.9V232h95.7z"
  }), React.createElement("path", {
    d: "M504.2 612.9c-2.1-1.8-3.5-4.3-3.9-7-.4-2.8-.4-6.3 0-10.6l25.7-177c1.1-6.3 2.1-12 3.5-16.2 1.4-4.2 3.5-7.4 6.3-9.9s6.7-4.2 11.6-5.3c4.9-1.1 11.3-2.1 19-2.5l1.1-8.8h-64.4c-3.9 7.4-8.1 14.4-12 21.1-4.2 7-8.1 13.7-12.3 20.8l-102.7 169h-.7L330 421.1c-1.8-7.7-3.9-15.1-5.6-22.5-2.1-7.4-3.9-14.8-5.6-22.2h-64.1l-2.5 8.8c6.7.4 12.3 1.1 17.2 2.5 4.9 1.1 8.8 3.5 11.6 6.7 1.7 1.8 2.9 4 3.5 6.3.7 2.5 1.4 4.9 1.4 8.4 0 3.2 0 7-.7 11.6s-1.8 9.9-2.8 15.8l-29.6 135.9c-2.1 10.6-4.2 18.7-6.3 24.6s-4.6 10.6-7.7 13.4c-3.4 3-7.5 5.1-12 6-4.6 1.1-10.9 1.8-18 2.5l-1.1 9.2c6 0 13 0 20.1-.4 7.4 0 14.4-.4 21.1-.4 8.4 0 15.8 0 22.2.4 6.3.4 12.3.4 18 .4l2.1-9.5c-5.3-.2-10.6-.9-15.8-2.1-3.4-.4-6.5-2-8.8-4.6-2-3.1-2.9-6.9-2.5-10.6 0-4.6 1.1-10.9 2.8-19.4l32-151.4 1.1-.7c9.5 34.1 18.7 67.6 27.8 100.3 9.2 32.7 18.3 66.5 27.1 101.4l13-1.4c21.1-36.3 42.6-71.8 63.7-106.6s42.6-70.4 64.4-105.9l.4 1.1-24.6 166.8c-1.1 6.3-2.1 12-3.2 15.8-.8 3.7-2.6 7.1-5.3 9.9-2.5 2.5-5.6 4.2-9.5 5.3-3.9 1.1-9.2 2.1-15.5 2.5l-.7 8.8h93.3l2.1-9.5c-7.7-.4-13.7-1.1-18.3-1.8-3.8-.2-7.4-1.4-10.5-3.6zm101.7-84.5c.7-3.2 1.4-7 2.1-11.3.7-4.2 1.8-8.8 2.8-13.7s2.1-9.9 3.5-14.4c1.1-4.9 2.5-9.5 3.9-14.1l-2.1-2.1c-2.1 1.1-5.3 1.8-9.2 2.8s-8.4 2.1-13.4 3.5c-4.9 1.1-10.6 2.5-16.2 3.5-6 1.4-12 2.5-17.2 3.5l-.7 7.7c5.3 1.1 9.2 1.8 12.3 2.5 3.2.7 5.3 2.1 6.7 3.5 1.4 1.4 2.1 3.9 2.1 6.7s-.4 6.7-1.4 11.6l-12.3 69.3c-1.1 6.7-2.5 12-3.9 15.8-1.4 3.9-3.2 7-5.6 9.5-2.5 2.1-5.3 3.9-8.8 4.9-3.5 1.1-8.4 1.8-14.1 2.1l-1.1 8.4c4.9 0 10.6 0 17.2-.4 6.7 0 13.4-.4 20.1-.4 8.4 0 16.5 0 24.3.4s14.4.4 20.1.4l2.1-9.9c-5.1-.2-10.1-.6-15.1-1.4-3.5-.4-6.3-1.4-7.7-2.8-1.8-1.4-2.5-3.5-2.5-6s.4-6 1.1-10.2l13-69.4zm2.8-98.9c6 0 11.3-1.8 15.5-5.3 4.2-3.5 6.7-8.4 7.7-14.1 1.1-5.6 0-10.6-2.8-14.1s-7.4-5.3-13.7-5.3c-5.6 0-10.9 1.8-14.8 5.3-4.2 3.5-6.7 8.4-7.7 14.1-1.1 5.6 0 10.6 2.8 14.1 2.8 3.2 7 5.3 13 5.3zm184.5 187.6c-2.6-.1-5.1-1.1-7-2.8-1.5-1.6-2.2-3.8-2.1-6 0-2.5.4-6 1.1-10.2l12.7-71.1c1.8-9.5 2.1-18 .7-24.6-1.1-6.7-3.5-12.3-6.7-16.5-3.2-4.4-7.6-7.7-12.7-9.5-5.3-2.1-10.9-3.2-17.2-3.2-9.5 0-20.1 2.1-31.3 6.3-11.3 4.2-22.5 10.2-33.1 17.6 0-3.9 1.1-7.4 1.8-10.9l3.2-10.9-2.8-2.1c-2.8 1.1-6.3 2.1-10.6 3.5-4.2 1.1-9.2 2.5-14.1 3.9s-10.2 2.5-15.1 3.9c-5.3.7-9.9 1.8-14.4 2.8l-.4 7.4c5.3.7 9.2 1.8 12.3 2.5 3.2 1.1 5.3 2.1 6.7 3.9s2.1 3.9 2.1 6.7c0 2.8-.4 6.7-1.4 11.6l-12 68.3c-1.1 6.7-2.5 12-3.9 15.8-1.4 3.9-3.2 7-5.6 9.2-2.5 2.1-5.6 3.9-9.2 4.9-3.9 1.1-8.8 1.8-14.8 2.5l-.7 8.4c4.9 0 10.9 0 17.6-.4 6.7 0 13.7-.4 20.4-.4 8.4 0 16.2 0 23.2.4s13.4.4 19 .4l2.5-9.9c-5.6-.4-10.2-.7-13.7-1.4-2.7-.2-5.2-1.2-7.4-2.8-1.5-1.6-2.2-3.8-2.1-6 0-2.5.4-6 1.1-10.2l15.8-89.1c8.4-4.9 16.5-8.8 24.6-11.6s15.5-4.2 22.2-4.2c9.5 0 16.9 3.2 21.8 9.5 5.3 6.3 6.3 16.2 3.9 30.3l-9.9 55.6c-1.1 6.7-2.5 12-3.5 15.5-1.1 3.9-2.8 6.7-4.9 8.8-2.1 2.1-4.9 3.5-8.4 4.2-3.5.7-8.1 1.4-13.4 2.1l-.7 8.4c4.9 0 10.6 0 16.9-.4 6.3 0 12.7-.4 19.7-.4 8.4 0 15.8 0 22.5.4 6.7.4 13 .4 18.7.4l1.8-9.2c-5.9-.3-10.1-.7-13.2-1.4z"
  }));
});

/**
* @file 图标math-min
* @author zhanglili
*/
var IconMathMin =
/*#__PURE__*/
createIcon('math-min', SVG$3p);

var SVG$3q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M226.9 229.6v47.9H179v478.7h47.9v47.9h-95.7V229.6h95.7zm670.2 0v574.5h-95.7v-47.9h47.9V277.5h-47.9v-47.9h95.7zM662.6 325.4v85.2h-47.9l-.1-37.3H423.1v5.9l128.4 134.6-128.4 143.5v3.2h191.5l.1-35.9h47.9v83.8H375.3v-69.3l111-124.3-111-116.4v-73z"
  }));
});

/**
* @file 图标math-sum
* @author zhanglili
*/
var IconMathSum =
/*#__PURE__*/
createIcon('math-sum', SVG$3q);

var SVG$3r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M195.3 148.8l183.8 175.4c10.4 9.9 10.8 26.3.9 36.7-9.9 10.4-26.3 10.8-36.7.9L112.6 141.6c-16.9-16.2-5.5-44.7 17.9-44.7h507.6c14.3 0 26 11.6 26 26s-11.6 26-26 26H195.3zm679.1-44.4c10.2-10.1 26.6-9.9 36.7.3s9.9 26.6-.3 36.7L674.3 374.6c-10.2 10.1-26.6 9.9-36.7-.3-10.1-10.2-9.9-26.6.3-36.7l236.5-233.2z"
  }), React.createElement("path", {
    d: "M510.9 927.3c-172 0-311.4-139.4-311.4-311.4 0-134.8 85.6-249.6 205.5-292.9 33.1-12 68.7-18.5 105.9-18.5 51.3 0 99.6 12.4 142.3 34.3 100.5 51.7 169.2 156.4 169.2 277.1-.1 172-139.6 311.4-311.5 311.4zm0-51.9c143.3 0 259.5-116.2 259.5-259.5S654.2 356.4 510.9 356.4 251.3 472.6 251.3 615.9s116.2 259.5 259.6 259.5z"
  }), React.createElement("path", {
    d: "M510.9 797.6c-100.3 0-181.7-81.3-181.7-181.7s81.3-181.7 181.7-181.7 181.7 81.3 181.7 181.7-81.4 181.7-181.7 181.7zm0-51.9c71.7 0 129.8-58.1 129.8-129.8s-58.1-129.8-129.8-129.8-129.8 58.1-129.8 129.8 58.1 129.8 129.8 129.8z"
  }), React.createElement("path", {
    d: "M510.9 693.8c-14.3 0-26-11.6-26-26s11.6-26 26-26c14.3 0 26-11.6 26-26 0-14.3-11.6-26-26-26-14.3 0-26-11.6-26-26 0-14.3 11.6-26 26-26 43 0 77.9 34.9 77.9 77.9s-34.9 78.1-77.9 78.1z"
  }));
});

/**
* @file 图标medal-o
* @author zhanglili
*/
var IconMedalO =
/*#__PURE__*/
createIcon('medal-o', SVG$3r);

var SVG$3s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M395.2 196.5c0-73.1-59.7-132.6-133.1-132.6s-133.2 59.5-133.2 132.6c0 55.4 34.5 103 83.1 122.8V704c-50.1 19.8-82.9 67.3-82.9 122.7 0 73.1 59.7 132.6 133.1 132.6s133-59.5 133-132.6c0-55.4-32.9-102.9-83-122.7V320.9c48.6-21.4 83-68.9 83-124.4zm-75.5 630.2c0 31.7-25.8 57.5-57.6 57.5s-57.6-25.8-57.6-57.5 25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5zM262.1 254c-31.8 0-57.6-25.8-57.6-57.5s25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5zm548.5 450V289.8c0-76.2-65.3-138.2-141.8-138.2h-40.3V64.2L502.2 198.6c-3.7 3.9-3.6 10 .1 13.8L628.5 342v-90.3h39.6c21.6 0 42.3 17.1 42.3 38V704c-37.6 19.8-79.1 67.3-79.1 122.7 0 73.1 61.6 132.6 135 132.6s130.1-59.5 130.1-132.6c0-55.4-35.7-102.9-85.8-122.7zm-42.5 180.2c-31.8 0-57.6-25.8-57.6-57.5s25.8-57.5 57.6-57.5 57.6 25.8 57.6 57.5-25.8 57.5-57.6 57.5z"
  }));
});

/**
* @file 图标merge
* @author zhanglili
*/
var IconMerge =
/*#__PURE__*/
createIcon('merge', SVG$3s);

var SVG$3t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1025 1025"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M230.9 102.9a102.41 102.41 0 0 1 25.6 201.57v416.06a102.4 102.4 0 1 1-51.2 0V304.47a102.41 102.41 0 0 1 25.6-201.57zm332.8 8.78V230.9h256v489.63a102.4 102.4 0 1 1-51.2 0V282.1H563.7v119.22L418.88 256.5zM230.9 768.5a51.2 51.2 0 1 0 51.2 51.2 51.2 51.2 0 0 0-51.2-51.2zm563.2 0a51.2 51.2 0 1 0 51.2 51.2 51.2 51.2 0 0 0-51.2-51.2zM230.9 154.1a51.2 51.2 0 1 0 51.2 51.2 51.2 51.2 0 0 0-51.2-51.2z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标merge-request
* @author zhanglili
*/
var IconMergeRequest =
/*#__PURE__*/
createIcon('merge-request', SVG$3t);

var SVG$3u = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M14 1v14H2V1zm-1 1H3v12h10zM6 4v1h1V4h2v1h1V4h2v2h-.75v1H12v2h-.75v1H12v2h-2v-.5H9v.5H7v-.5H6v.5H4v-2h.75V9H4V7h.75V6H4V4zm1 4.5H6V9h-.75v1H6v1h1v-1h.75V9H7zm1.4.5h-.15v1H9v1h1v-.4zm1.6-.5H9v.4l1.1 1.1h.65V9H10zM5.4 6h-.15v1H6v1h1v-.4zm4.6-.5H9V6h-.75v1H9v1h1V7h.75V6H10zm-3 0H6v.4L7.1 7h.65V6H7z"
  }))));
});

/**
* @file 图标mesh
* @author zhanglili
*/
var IconMesh =
/*#__PURE__*/
createIcon('mesh', SVG$3u);

var SVG$3v = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M514.2 847.8h-74.4L235.4 959.3V754.8C133.5 683.3 68.1 580.6 68.1 457.4 68.1 241.8 267.8 67 514.2 67c246.4 0 446.1 174.8 446.1 390.4.1 215.6-199.7 390.4-446.1 390.4zm0-725c-215.6 0-390.4 149.8-390.4 334.6 0 113.4 66.7 218.3 167.3 278.8v123.9L439.9 792h74.4c215.6 0 390.4-149.8 390.4-334.6-.1-184.8-174.9-334.6-390.5-334.6z"
  }));
});

/**
* @file 图标message
* @author zhanglili
*/
var IconMessage =
/*#__PURE__*/
createIcon('message', SVG$3v);

var SVG$3w = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M169.165 79.333c-.564-1.854-1.934-3.305-3.707-3.869-1.773-.645-3.788-.403-5.4.645-2.338 1.531-3.224 4.272-2.338 6.932 1.37 3.949 2.015 8.141 2.015 12.331 0 26.114-26.597 47.31-59.238 47.31-3.465 0-7.012-.242-10.397-.725-.564-.08-1.451-.162-2.176.08-12.977 2.902-24.905 5.158-34.011 6.448 4.514-6.367 5.561-13.299 3.063-20.069a5.4 5.4 0 0 0-1.531-2.338c-1.209-1.129-2.418-2.338-3.627-3.788-6.851-7.899-10.477-17.167-10.477-26.839 0-26.114 26.597-47.31 59.238-47.31 18.376 0 32.481 3.949 43.845 15.475 2.015 2.096 6.125 1.612 8.543 0 1.531-1.047 2.58-1.854 2.74-3.707.162-1.773-.725-2.902-2.015-4.11-13.702-13.944-31.675-19.746-53.193-19.746-39.331 0-71.328 26.677-71.328 59.4 0 12.573 4.674 24.663 13.54 34.818a63.895 63.895 0 0 0 3.305 3.547c1.854 8.785-11.526 16.039-11.606 16.119-2.66 1.37-3.949 4.514-2.982 7.334.725 2.096 2.498 3.627 4.836 4.03 1.612.242 3.547.403 5.481.403 11.848 0 32.481-4.03 47.794-7.496 3.627.484 7.334.725 10.961.725 39.331 0 71.328-26.677 71.328-59.4a46.583 46.583 0 0 0-2.663-16.2z"
  }));
});

/**
* @file 图标message-dash
* @author zhanglili
*/
var IconMessageDash =
/*#__PURE__*/
createIcon('message-dash', SVG$3w);

var SVG$3x = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M873.29 128v608H651.47L512.31 896 373.14 736H150.47V128zm-60.23 60.24H210.71v487.48h189.87L512.3 804.14 624 675.76h189zM572.12 448v64H331.18v-64zm120-128v64H331.18v-64z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标message-o
* @author zhanglili
*/
var IconMessageO =
/*#__PURE__*/
createIcon('message-o', SVG$3x);

var SVG$3y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M940.667 46.673H90.303c-6.683 0-12.151 5.468-12.151 12.151v850.364c0 6.683 5.468 12.151 12.151 12.151h850.364c1.671 0 3.266-.342 4.718-.959a12.252 12.252 0 0 0 4.649-3.475 12.088 12.088 0 0 0 2.784-7.718V58.824c0-6.683-5.468-12.151-12.151-12.151zm-795.28 79.386c0-6.683 5.468-12.151 12.151-12.151h715.894c6.683 0 12.151 5.468 12.151 12.151v715.894c0 3.341-1.367 6.379-3.569 8.582s-5.24 3.569-8.582 3.569H157.538c-6.683 0-12.151-5.468-12.151-12.151V126.059z"
  }), React.createElement("path", {
    d: "M790.68 451.679H240.29c-5.445 0-9.901 4.455-9.901 9.901v44.851c0 5.445 4.455 9.901 9.901 9.901h550.39c5.446 0 9.901-4.455 9.901-9.901V461.58c0-5.445-4.455-9.901-9.901-9.901z"
  }));
});

/**
* @file 图标minus-square
* @author zhanglili
*/
var IconMinusSquare =
/*#__PURE__*/
createIcon('minus-square', SVG$3y);

var SVG$3z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513.7 880.4h-.3c-58.9 0-116.1-9.1-169.9-27.1-52.6-17.6-100.1-42.8-141.2-75.1-42.1-33.1-75.2-71.9-98.7-115.4C78.7 616.3 66 566.9 66 515.9S78.6 415.1 103.4 368c23.3-44.4 56.4-84.2 98.1-118.4 41.1-33.7 88.6-60.1 141.2-78.6h.1c47.9-16.6 97.6-26.2 147.7-28.3h.7l14.2-.3.7-.3h7.4c107.7 0 212.2 33.3 294.3 93.8 40.4 29.8 73.8 64.9 99.4 104.3 26.8 41.2 43.9 85.6 50.6 132l.1.8 1.9 16.3.2 10.6c0 39.3-13.8 76.9-38.7 105.8-25.5 29.5-60 47.2-97.4 49.9l-1.2.1-9 .3h-61.5c-9.8.1-19.3 5.5-25.3 14.5-6.8 10.1-8.7 23.4-5.2 35.4l1.4 4.8c9.7 33.9 5.2 70.5-12.4 100.6-16 27.4-41.1 46.7-70.6 54.4l-1.6.4-7.8 1.6c-30.7 6.7-61.9 10.7-93 12.1h-.7l-23.3.6zm-149.8-649c-45.5 16-86.5 38.8-121.8 67.7-35.1 28.7-62.7 61.9-82 98.7-19.9 37.8-30 77.5-30 118.1 0 40.4 10.1 79.6 30 116.6 19.2 35.7 46.8 67.8 81.9 95.4 35.3 27.7 76.3 49.5 121.9 64.7 47.2 15.7 97.4 23.8 149.3 23.8l22.1-.5c27.3-1.2 54.9-4.8 82-10.7l.3-.1 7.1-1.5c12.7-3.5 23.6-12.2 30.9-24.6 8.8-15 11-33.4 6.2-50.5l-1.3-4.5c-8.8-30.1-3.8-63.4 13.5-89.2 18-26.7 47.2-42.7 78.2-42.9h61.2l6.6-.2c42.7-3.5 76.1-43.5 76.3-91.5l-.1-6.4-1.5-12.9c-5.4-37-19.2-72.6-40.9-105.9-21.4-33-49.6-62.4-83.7-87.7-70.5-52-160.6-80.8-253.8-81.3-1.5.2-2.8.2-3.6.2l-19.5.4c-44.1 1.9-87.5 10.3-129.3 24.8z"
  }), React.createElement("path", {
    d: "M279.1 502.6c32.2-3.2 61.2 22.5 64.8 57.3 3.4 34.8-20 65.7-52.3 68.9-32.3 3.2-61.3-22.5-64.8-57.3-3.4-34.8 20.1-65.7 52.3-68.9zm100.3-179.7c32.2-3.2 61.3 22.5 64.8 57.3s-20 65.7-52.3 68.9c-32.3 3.2-61.3-22.5-64.8-57.3-3.4-34.9 20.1-65.7 52.3-68.9zm214.5-42.3c32.3-3.2 61.3 22.5 64.8 57.3 3.4 34.8-20 65.7-52.3 68.9-32.3 3.2-61.3-22.5-64.8-57.3s20.1-65.7 52.3-68.9z"
  }));
});

/**
* @file 图标mode-switc
* @author zhanglili
*/
var IconModeSwitc =
/*#__PURE__*/
createIcon('mode-switc', SVG$3z);

var SVG$3A = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513.7 880.4h-.3c-58.9 0-116.1-9.1-169.9-27.1-52.6-17.6-100.1-42.8-141.2-75.1-42.1-33.1-75.2-71.9-98.7-115.4C78.7 616.3 66 566.9 66 515.9S78.6 415.1 103.4 368c23.3-44.4 56.4-84.2 98.1-118.4 41.1-33.7 88.6-60.1 141.2-78.6h.1c47.9-16.6 97.6-26.2 147.7-28.3h.7l14.2-.3.7-.3h7.4c107.7 0 212.2 33.3 294.3 93.8 40.4 29.8 73.8 64.9 99.4 104.3 26.8 41.2 43.9 85.6 50.6 132l.1.8 1.9 16.3.2 10.6c0 39.3-13.8 76.9-38.7 105.8-25.5 29.5-60 47.2-97.4 49.9l-1.2.1-9 .3h-61.5c-9.8.1-19.3 5.5-25.3 14.5-6.8 10.1-8.7 23.4-5.2 35.4l1.4 4.8c9.7 33.9 5.2 70.5-12.4 100.6-16 27.4-41.1 46.7-70.6 54.4l-1.6.4-7.8 1.6c-30.7 6.7-61.9 10.7-93 12.1h-.7l-23.3.6zm-149.8-649c-45.5 16-86.5 38.8-121.8 67.7-35.1 28.7-62.7 61.9-82 98.7-19.9 37.8-30 77.5-30 118.1 0 40.4 10.1 79.6 30 116.6 19.2 35.7 46.8 67.8 81.9 95.4 35.3 27.7 76.3 49.5 121.9 64.7 47.2 15.7 97.4 23.8 149.3 23.8l22.1-.5c27.3-1.2 54.9-4.8 82-10.7l.3-.1 7.1-1.5c12.7-3.5 23.6-12.2 30.9-24.6 8.8-15 11-33.4 6.2-50.5l-1.3-4.5c-8.8-30.1-3.8-63.4 13.5-89.2 18-26.7 47.2-42.7 78.2-42.9h61.2l6.6-.2c42.7-3.5 76.1-43.5 76.3-91.5l-.1-6.4-1.5-12.9c-5.4-37-19.2-72.6-40.9-105.9-21.4-33-49.6-62.4-83.7-87.7-70.5-52-160.6-80.8-253.8-81.3-1.5.2-2.8.2-3.6.2l-19.5.4c-44.1 1.9-87.5 10.3-129.3 24.8z"
  }), React.createElement("path", {
    d: "M279.1 502.6c32.2-3.2 61.2 22.5 64.8 57.3 3.4 34.8-20 65.7-52.3 68.9-32.3 3.2-61.3-22.5-64.8-57.3-3.4-34.8 20.1-65.7 52.3-68.9zm100.3-179.7c32.2-3.2 61.3 22.5 64.8 57.3s-20 65.7-52.3 68.9c-32.3 3.2-61.3-22.5-64.8-57.3-3.4-34.9 20.1-65.7 52.3-68.9zm214.5-42.3c32.3-3.2 61.3 22.5 64.8 57.3 3.4 34.8-20 65.7-52.3 68.9-32.3 3.2-61.3-22.5-64.8-57.3s20.1-65.7 52.3-68.9z"
  }));
});

/**
* @file 图标mode-switch
* @author zhanglili
*/
var IconModeSwitch =
/*#__PURE__*/
createIcon('mode-switch', SVG$3A);

var SVG$3B = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M179.87 96.15h665.14c28.26 0 51.16 23.23 51.16 51.88v726.31c0 28.65-22.91 51.88-51.16 51.88H179.87c-28.26 0-51.16-23.23-51.16-51.88V148.03c0-28.65 22.91-51.88 51.16-51.88zm0 25.94c-14.13 0-25.58 11.61-25.58 25.94v726.31c0 14.33 11.45 25.94 25.58 25.94h665.14c14.13 0 25.58-11.61 25.58-25.94V148.03c0-14.33-11.45-25.94-25.58-25.94H179.87z"
  }), React.createElement("path", {
    d: "M420.01 408.51l110.11 87.73c5.52 4.4 13.5 3.46 17.89-2.09l205.57-260.2c4.42-5.59 3.53-13.75-1.99-18.23s-13.56-3.58-17.98 2.01L535.96 467.91l-109.9-87.57c-5.43-4.33-13.28-3.5-17.71 1.87l-135.96 164.7c-4.53 5.49-3.82 13.67 1.6 18.27s13.48 3.87 18.02-1.62l128-155.05zM307.78 679.79H717.1c7.06 0 12.79 5.81 12.79 12.97 0 7.16-5.73 12.97-12.79 12.97H307.78c-7.06 0-12.79-5.81-12.79-12.97 0-7.16 5.73-12.97 12.79-12.97zm255.83-77.82H717.1c7.06 0 12.79 5.81 12.79 12.97 0 7.16-5.73 12.97-12.79 12.97H563.61c-7.06 0-12.79-5.81-12.79-12.97-.01-7.16 5.72-12.97 12.79-12.97zM307.78 757.61H717.1c7.06 0 12.79 5.81 12.79 12.97 0 7.16-5.73 12.97-12.79 12.97H307.78c-7.06 0-12.79-5.81-12.79-12.97 0-7.16 5.73-12.97 12.79-12.97z"
  }));
});

/**
* @file 图标monthly-report
* @author zhanglili
*/
var IconMonthlyReport =
/*#__PURE__*/
createIcon('monthly-report', SVG$3B);

var SVG$3C = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M511.531 856.912c-41.295 0-74.771-33.476-74.771-74.771s33.476-74.771 74.771-74.771 74.771 33.476 74.771 74.771-33.476 74.771-74.771 74.771zm0-299.085c-41.295 0-74.771-33.476-74.771-74.771s33.476-74.771 74.771-74.771 74.771 33.476 74.771 74.771-33.476 74.771-74.771 74.771zm0-299.084c-41.295 0-74.771-33.476-74.771-74.771s33.476-74.771 74.771-74.771 74.771 33.476 74.771 74.771-33.476 74.771-74.771 74.771z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标more
* @author zhanglili
*/
var IconMore =
/*#__PURE__*/
createIcon('more', SVG$3C);

var SVG$3D = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M797.5 757.8L460.7 654.2l336.8-388.6-440.4 388.6L98 550.6l829-440.4-129.5 647.6zM460.7 913.3V731.9l103.6 51.8-103.6 129.6z"
  }));
});

/**
* @file 图标my-publish
* @author zhanglili
*/
var IconMyPublish =
/*#__PURE__*/
createIcon('my-publish', SVG$3D);

var SVG$3E = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M101.1 65.9c-2.6-7.1-.7-14.8 5.6-23 9.6-12.3 10.5-24.8-2-32.4 5.2 9.4-3.2 16.8-10.8 30.1-6.8 11.5-4.4 19.9 7.2 25.3zM183 80.5H39c-1.2 0-2.1.9-2.1 2.1v11.1c-2.7-1.1-5.6-1.7-8.7-1.7-12.5 0-22.7 10.1-22.7 22.7s10.1 22.7 22.7 22.7c6.6 0 12.6-2.8 16.7-7.4 12.2 23.8 36.9 39.1 65.5 39.1 40.6 0 73.5-31.9 73.5-72.5v-15c.1-.6-.4-1.1-.9-1.1zM28.3 125.8c-6.1 0-11.1-5-11.1-11.1s5-11.1 11.1-11.1 11.1 5 11.1 11.1c-.1 6.1-5 11.1-11.1 11.1zm142.9-29.3c0 32.5-28.2 59.3-60.7 59.3S51.2 129 51.2 96.5v-2.8h120v2.8zm-48.3-30.6c-.8-5.3.8-10.5 5-15.7 6.3-7.7 5.5-17.5-2.5-22.3 2.5 7.4-3.5 11.8-8.8 20.9-3.9 8.4-1.8 14.1 6.3 17.1zM96.2 188.5c22.4 0 3.5-.2 27.9 0 16.3.2 26.7-3.9 31.4-12.3H64.8c6 8.2 16.4 12.3 31.4 12.3z"
  }));
});

/**
* @file 图标new-icafe
* @author zhanglili
*/
var IconNewICafe =
/*#__PURE__*/
createIcon('new-icafe', SVG$3E);

var SVG$3F = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M81.1 66.1c-8.9 0-16 7.1-16 16.1L64.6 959 255 767.6h690.5c8.8 0 16-7.2 16-16V82.1c0-8.8-7.2-16-16-16H81.1zm297.4 399.6h-89.7V376h89.7v89.7zm179.3 0h-89.7V376h89.7v89.7zm179.4 0h-89.7V376h89.7v89.7z"
  }));
});

/**
* @file 图标news-solid
* @author zhanglili
*/
var IconNewsSolid =
/*#__PURE__*/
createIcon('news-solid', SVG$3F);

var SVG$3G = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M944.4 65.1H80.1c-8.9 0-16 7.1-16 16.1L63.6 958 254 766.6h690.5c8.8 0 16-7.2 16-16V81.1c-.1-8.9-7.3-16-16.1-16zm-46.4 621c0 8.8-7.2 16-16 16H227.5l-99.4 101.4.4-658.8c0-9 7.2-16.1 16-16.1h737.3c8.8 0 16 7.2 16 16v541.5h.2z"
  }), React.createElement("path", {
    d: "M378.5 465.7h-89.7V376h89.7v89.7zm179.3 0h-89.7V376h89.7v89.7zm179.4 0h-89.7V376h89.7v89.7z"
  }));
});

/**
* @file 图标news-solid-o
* @author zhanglili
*/
var IconNewsSolidO =
/*#__PURE__*/
createIcon('news-solid-o', SVG$3G);

var SVG$3H = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M194.18 295.8c52.71 0 95.43-42.72 95.43-95.43 0-52.7-42.72-95.43-95.43-95.43-52.7 0-95.43 42.72-95.43 95.43.01 52.7 42.73 95.43 95.43 95.43zm636.2 0c52.7 0 95.43-42.72 95.43-95.43 0-52.7-42.72-95.43-95.43-95.43-52.71 0-95.43 42.72-95.43 95.43 0 52.7 42.73 95.43 95.43 95.43zm-318.1 0c52.7 0 95.43-42.72 95.43-95.43 0-52.7-42.73-95.43-95.43-95.43-52.7 0-95.43 42.72-95.43 95.43 0 52.7 42.73 95.43 95.43 95.43zm-318.1 318.1c52.71 0 95.43-42.72 95.43-95.43 0-52.7-42.72-95.43-95.43-95.43-52.7 0-95.43 42.72-95.43 95.43.01 52.71 42.73 95.43 95.43 95.43zm636.2 0c52.7 0 95.43-42.72 95.43-95.43 0-52.7-42.72-95.43-95.43-95.43-52.71 0-95.43 42.72-95.43 95.43 0 52.71 42.73 95.43 95.43 95.43zm-318.1 0c52.7 0 95.43-42.72 95.43-95.43 0-52.7-42.73-95.43-95.43-95.43-52.7 0-95.43 42.72-95.43 95.43 0 52.71 42.73 95.43 95.43 95.43zM194.18 932c52.71 0 95.43-42.72 95.43-95.43 0-52.71-42.72-95.43-95.43-95.43-52.7 0-95.43 42.72-95.43 95.43.01 52.7 42.73 95.43 95.43 95.43zm636.2 0c52.7 0 95.43-42.72 95.43-95.43 0-52.71-42.72-95.43-95.43-95.43-52.71 0-95.43 42.72-95.43 95.43 0 52.7 42.73 95.43 95.43 95.43zm-318.1 0c52.7 0 95.43-42.72 95.43-95.43 0-52.71-42.73-95.43-95.43-95.43-52.7 0-95.43 42.72-95.43 95.43 0 52.7 42.73 95.43 95.43 95.43z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标nine-dots
* @author zhanglili
*/
var IconNineDots =
/*#__PURE__*/
createIcon('nine-dots', SVG$3H);

var SVG$3I = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M14 2v4.61h-1V3H3v10.01h6v1H2V2h12z"
  }), React.createElement("path", {
    d: "M7.5 10a3.46 3.46 0 0 1 1-2.44V4.35h-1v4.92L5.85 7.62l-.7.71 2.45 2.45a3.59 3.59 0 0 1-.1-.78z"
  }), React.createElement("path", {
    d: "M11 7a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm0 1a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
  }), React.createElement("path", {
    d: "M8.918 8.767l.693-.72 3.278 3.155-.694.72z"
  }));
});

/**
* @file 图标not-download
* @author zhanglili
*/
var IconNotDownload =
/*#__PURE__*/
createIcon('not-download', SVG$3I);

var SVG$3J = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "20",
    height: "20"
  }, props), React.createElement("path", {
    d: "M11.5 17v1.5h-3V17h3zM3 16v-1.5h1.5v-6a5.501 5.501 0 0 1 4.75-5.45V1.526h1.5l.001 1.526A5.501 5.501 0 0 1 15.5 8.5v6H17V16H3zm7-11.5a4 4 0 0 0-3.995 3.8L6 8.5v6h8v-6a4 4 0 0 0-3.8-3.995L10 4.5z"
  }));
});

/**
* @file 图标notice
* @author zhanglili
*/
var IconNotice =
/*#__PURE__*/
createIcon('notice', SVG$3J);

var SVG$3K = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "20",
    height: "20"
  }, props), React.createElement("path", {
    d: "M11.5 17v1.5h-3V17h3zM3 16v-1.5h1.5v-6a5.501 5.501 0 0 1 4.75-5.45V1.526h1.5l.001 1.526A5.501 5.501 0 0 1 15.5 8.5v6H17V16H3zm7-11.5a4 4 0 0 0-3.995 3.8L6 8.5v6h8v-6a4 4 0 0 0-3.8-3.995L10 4.5z"
  }));
});

/**
* @file 图标notice-o
* @author zhanglili
*/
var IconNoticeO =
/*#__PURE__*/
createIcon('notice-o', SVG$3K);

var SVG$3L = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M508.4 925.2c45.5 0 82.7-37.2 82.7-82.7H425.7c0 45.5 37.2 82.7 82.7 82.7zm268.8-248.1V449.6c0-127-88.1-233.2-206.8-261.4V160c0-34.2-27.7-62-62-62h-.2c-34.2 0-61.9 27.7-61.9 61.9v28.2c-118.7 28.1-206.8 134.4-206.8 261.4v227.4l-136.8 80.4c-2.4 1.4-3.9 4.1-3.9 6.9V793c0 4.4 3.6 8 8 8h813c4.4 0 8-3.6 8-8v-28.6c0-2.9-1.6-5.6-4.2-7l-146.4-80.3z"
  }));
});

/**
* @file 图标notice-solid
* @author zhanglili
*/
var IconNoticeSolid =
/*#__PURE__*/
createIcon('notice-solid', SVG$3L);

var SVG$3M = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 829.99 830.07"
  }, props), React.createElement("path", {
    d: "M536.24 622.41a258.52 258.52 0 0 0 83.25-89.18c7.57-12.74 0-27.08-13.24-33.45-15.14-6.36-32.17 0-39.73 11.15a215.87 215.87 0 0 1-66.22 70.1c-26.49 15.93-56.76 25.48-85.13 25.48a155 155 0 0 1-85.14-25.48 215.87 215.87 0 0 1-66.22-70.07c-7.57-12.74-24.59-17.51-39.73-11.15s-20.81 20.71-13.24 33.45a258.59 258.59 0 0 0 83.24 89.18c36 23.89 77.57 35 121.09 35s85.13-11.14 121.07-35.03zM269.75 256.27c-34.58 0-62.25 26.74-62.25 60.17s27.67 60.18 62.25 60.18S332 349.88 332 316.44s-27.67-60.17-62.25-60.17zm290.49 0c-34.58 0-62.24 26.74-62.24 60.17s27.66 60.18 62.24 60.18 62.26-26.74 62.26-60.18-27.67-60.17-62.26-60.17z"
  }), React.createElement("path", {
    d: "M415 .03C185.8.03 0 185.84 0 415.03s185.8 415 415 415 415-185.81 415-415S644.2.03 415 .03zm0 788.56c-206.28 0-373.5-167.23-373.5-373.53S208.72 41.53 415 41.53s373.49 167.2 373.49 373.5S621.27 788.56 415 788.56z"
  }));
});

/**
* @file 图标nps
* @author zhanglili
*/
var IconNPS =
/*#__PURE__*/
createIcon('nps', SVG$3M);

var SVG$3N = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 808.47 829.56"
  }, props), React.createElement("path", {
    d: "M808.47 289.38v215.5a22.32 22.32 0 0 1-44.64 0v-211.2a30.36 30.36 0 0 0-5.49 2.07L519.15 421.11c-15.24 7.44-25.35 23.27-25.35 30.47v332.89a30.36 30.36 0 0 0 5.49-2.07l239.19-125.36v.07a22.3 22.3 0 1 1 19.47 40L519.14 822.38c-9.81 4.79-19.46 7.22-28.69 7.22-23.93 0-41.29-17.15-41.29-40.78V451.58c0-26.09 21.5-56.3 50.08-70.39L738.49 255.8c9.82-4.79 19.47-7.22 28.71-7.22 23.91 0 41.27 17.15 41.27 40.8zm-476.02 103c30.72 13.7 53.85 43.07 53.85 68.45v328c0 23-18.67 39.66-44.39 39.66-9.92 0-20.3-2.36-30.86-7l-257.2-122C23.13 685.78 0 656.41 0 631.03v-328c0-23 18.67-39.67 44.38-39.67 9.92 0 20.3 2.36 30.86 7zm5.84 392.24V460.84c0-7-10.87-22.39-27.25-29.63L53.91 309.23a34.82 34.82 0 0 0-5.89-2v323.79c0 7 10.87 22.4 27.25 29.63l251.97 119.06a33.31 33.31 0 0 0 11.05 4.86z"
  }), React.createElement("path", {
    d: "M747.24 215.59L457.08 348.77c-15.26 7-35 10.87-55.54 10.87-19.47 0-38.12-3.53-52.51-9.94L61.87 221.98c-19.66-8.74-31-22.77-31.12-38.49-.11-15.89 11.3-30.27 31.3-39.44L352.24 10.87c15.28-7 35-10.87 55.54-10.87 19.47 0 38.12 3.53 52.51 9.93l287.17 127.73c19.66 8.74 31 22.77 31.1 38.48.11 15.89-11.32 30.24-31.32 39.45zm-345.7 100.67c12.95 0 25.27-2.25 33.82-6.17l290.2-133.18.71-.33L439.09 48.84c-7.85-3.46-19.23-5.46-31.31-5.46-12.94 0-25.28 2.25-33.82 6.17L83.77 182.72l-.72.33 287.19 127.74c7.8 3.48 19.22 5.47 31.3 5.47z",
    "data-name": "Combined-Shape"
  }));
});

/**
* @file 图标number-of-access-products
* @author zhanglili
*/
var IconNumberOfAccessProducts =
/*#__PURE__*/
createIcon('number-of-access-products', SVG$3N);

var SVG$3O = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M895.5 512.3c0 211.7-171.6 383.3-383.3 383.3S128.8 724 128.8 512.3 300.5 129 512.2 129c17.2 0 31.1 13.9 31.1 31.1s-13.9 31.1-31.1 31.1C334.8 191.2 191 335 191 512.3s143.8 321.2 321.2 321.2 321.2-143.8 321.2-321.2c0-17.2 13.9-31.1 31.1-31.1 17.1 0 31 14 31 31.1z"
  }), React.createElement("path", {
    d: "M680.6 636.9c12.1 12.1 12.1 31.8 0 44-93.1 93.1-243.9 93.1-337 0s-93.1-243.9 0-337c12.1-12.1 31.8-12.1 44 0s12.1 31.8 0 44c-68.8 68.8-68.8 180.3 0 249.1s180.3 68.8 249.1 0c12.1-12.3 31.8-12.3 43.9-.1z"
  }), React.createElement("path", {
    d: "M686 294.5l44 44-158.7 158.6c3.5 17.7-1.6 36.7-15.3 50.5-21.8 21.8-57.3 21.8-79.1 0-21.8-21.8-21.8-57.3 0-79.1 13.7-13.7 32.8-18.8 50.5-15.3L686 294.5z"
  }), React.createElement("path", {
    d: "M736.2 142.6c10.5-10.5 28.4-6.9 33.9 7l29.9 74.9 74.9 30c13.8 5.5 17.5 23.4 7 33.9l-91.4 91.4c-5.9 5.9-14.7 7.7-22.3 4.6L685 351c-5.3-2.1-9.4-6.3-11.5-11.5l-33.3-83.1c-3.1-7.7-1.3-16.5 4.6-22.3l91.4-91.5z"
  }));
});

/**
* @file 图标objective
* @author zhanglili
*/
var IconObjective =
/*#__PURE__*/
createIcon('objective', SVG$3O);

var SVG$3P = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "30",
    height: "30"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.84 22.332c0 .518-.392.94-.872.94h-6.374c-.48 0-.872-.422-.872-.94v-.48h-2.607v.48c0 .518-.391.94-.871.94H6.872c-.48 0-.872-.422-.872-.94v-2.4c0-.519.392-.942.872-.942h6.373c.48 0 .872.423.872.941v.48h2.608v-.48c0-.518.392-.94.872-.94h6.374c.479 0 .871.422.871.94v2.401h-.003zM6 13.936c0-.518.392-.94.872-.94h6.373c.48 0 .872.422.872.94v.48h2.608v-.48c0-.518.392-.94.872-.94h6.374c.479 0 .871.422.871.94v2.4c0 .519-.391.942-.871.942h-6.376c-.479 0-.871-.423-.871-.942v-.48h-2.607v.48c0 .519-.392.942-.872.942H6.872c-.48 0-.872-.423-.872-.942v-2.4zm0-5.995C6 7.423 6.392 7 6.872 7h6.373c.48 0 .872.423.872.94v.481h2.608v-.48c0-.518.392-.941.872-.941h6.374c.479 0 .871.423.871.94v2.402c0 .518-.391.94-.871.94h-6.376c-.479 0-.871-.422-.871-.94v-.48h-2.607v.48c0 .518-.392.94-.872.94H6.872c-.48 0-.872-.422-.872-.94V7.94z"
  }));
});

/**
* @file 图标one-to-one-mapping
* @author zhanglili
*/
var IconOneToOneMapping =
/*#__PURE__*/
createIcon('one-to-one-mapping', SVG$3P);

var SVG$3Q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M835.241 304.587L139.614 405.163l-21.612-149.48c-4.824-33.365 18.396-64.435 51.761-69.259l574.609-83.079c33.365-4.824 64.434 18.396 69.259 51.761l21.61 149.481zm-651.603 41.67l592.698-85.695-14.171-98.015c-.721-4.987-5.366-8.458-10.353-7.737l-574.609 83.08c-4.987.721-8.458 5.366-7.737 10.353l14.172 98.014zm434.475 297.687h-235.59c-27.121 0-49.185-22.064-49.185-49.185v-45.58c0-27.12 22.064-49.185 49.185-49.185h235.59c27.12 0 49.185 22.064 49.185 49.185v45.58c-.001 27.12-22.065 49.185-49.185 49.185zm-232.775-52h229.959v-39.949H385.338v39.949z"
  }), React.createElement("path", {
    d: "M775.266 656.442v110.791a9.185 9.185 0 0 1-9.185 9.185H234.553a9.185 9.185 0 0 1-9.185-9.185V460.324h549.897v93.3c0 14.359 11.641 26 26 26s26-11.641 26-26v-145.3H173.369v358.909c0 33.791 27.393 61.185 61.185 61.185h531.529c33.791 0 61.184-27.393 61.184-61.184V656.442c0-14.359-11.641-26-26-26-14.361 0-26.001 11.641-26.001 26z"
  }));
});

/**
* @file 图标open-box
* @author zhanglili
*/
var IconOpenBox =
/*#__PURE__*/
createIcon('open-box', SVG$3Q);

var SVG$3R = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M192.116 75.961h-17.843V59.06a6.14 6.14 0 0 0-6.134-6.134H148.58a6.14 6.14 0 0 0-6.134 6.134 6.14 6.14 0 0 0 6.134 6.134h13.424v10.767H59.11c-2.166 0-4.193 1.162-5.239 2.951-.184.253-.324.53-.386.733a6.128 6.128 0 0 0-.381 1.197l-11.838 37.866V42.094l34.663-.064 21.369 21.369a6.091 6.091 0 0 0 4.337 1.797h25.006c3.382 0 6.134-2.752 6.134-6.135s-2.751-6.134-6.134-6.134h-22.466L82.803 31.553a6.1 6.1 0 0 0-4.349-1.797l-43.333.081A6.142 6.142 0 0 0 29 35.971V163.11a6.14 6.14 0 0 0 6.134 6.135H168.14a6.125 6.125 0 0 0 3.029-.802l.338-.193 1.406-4.5c.126-.207.225-.425.294-.649l24.521-78.432a2.44 2.44 0 0 0 .064-.248 6.063 6.063 0 0 0 .458-2.326 6.14 6.14 0 0 0-6.134-6.134zm-8.353 12.268l-21.495 68.747H42.156l21.492-68.747h120.115z"
  }));
});

/**
* @file 图标open-folder-dash
* @author zhanglili
*/
var IconOpenFolderDash =
/*#__PURE__*/
createIcon('open-folder-dash', SVG$3R);

var SVG$3S = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M975.138 419.435H290.065c-14.636 0-26.5-11.864-26.5-26.5s11.864-26.5 26.5-26.5h685.074c14.636 0 26.5 11.864 26.5 26.5s-11.865 26.5-26.501 26.5z"
  }), React.createElement("path", {
    d: "M316.32 398.26L192.758 793.479c-2.64 8.443-16.103 11.748-30.072 7.38s-23.153-14.752-20.513-23.195l123.562-395.219c2.64-8.443 16.103-11.748 30.072-7.38s23.153 14.752 20.513 23.195zm682.861 6.412L872.882 808.648c-2.698 8.63-16.209 12.086-30.178 7.719-13.969-4.367-23.105-14.904-20.407-23.534l126.299-403.975c2.698-8.63 16.209-12.086 30.178-7.719 13.969 4.366 23.106 14.903 20.407 23.533zM750.897 300.79h74.242v106.337h53V274.29c0-14.636-11.864-26.5-26.5-26.5H750.897c-14.636 0-26.5 11.864-26.5 26.5s11.864 26.5 26.5 26.5z"
  }), React.createElement("path", {
    d: "M878.139 783.717H193.065V181.816l185.737-.348 111.561 111.561a26.5 26.5 0 0 0 18.738 7.762H637.9c14.636 0 26.5-11.864 26.5-26.5s-11.864-26.5-26.5-26.5H520.079L408.497 136.209a26.5 26.5 0 0 0-18.738-7.762h-.05l-223.193.418c-14.616.027-26.45 11.884-26.45 26.5v654.852c0 14.636 11.864 26.5 26.5 26.5H851.64c4.759 0 9.222-1.261 13.082-3.458l13.418-42.917v-6.625z"
  }));
});

/**
* @file 图标open-folder-o
* @author zhanglili
*/
var IconOpenFolderO =
/*#__PURE__*/
createIcon('open-folder-o', SVG$3S);

var SVG$3T = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M645.385 617.403V348.462H381.644v268.809l-91.229 166.511c-90.848-68.234-149.613-176.875-149.613-299.241 0-206.559 167.449-374.008 374.008-374.008s374.008 167.449 374.008 374.008c0 111.433-48.733 211.483-126.049 280.002l-117.384-147.14zM491.702 857.847h46.217c-7.643.466-15.348.702-23.108.702-7.761 0-15.466-.236-23.109-.702z"
  }));
});

/**
* @file 图标open-source
* @author zhanglili
*/
var IconOpenSource =
/*#__PURE__*/
createIcon('open-source', SVG$3T);

var SVG$3U = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M515.2 63.6c-247.4 0-448 200.6-448 448 0 164.5 88.6 308.2 220.7 386.1l28.5-57.8c-.1 0-.1-.1-.2-.1l85.4-172.5h.1l28.4-57.4c-29.3-23.5-48-59.5-48-99.9 0-70.7 57.3-128 128-128s128 57.3 128 128c0 38.3-16.8 72.6-43.4 96.1l31.5 55.7c.1-.1.2-.1.2-.2l97.3 172.2s-.1 0-.1.1l31.7 56c125-79.5 207.9-219.2 207.9-378.3 0-247.4-200.6-448-448-448zm259 731.1L671.3 612.5c18.9-29.6 29.8-64.8 29.8-102.5 0-105.5-85.5-191-191.1-191s-191 85.5-191 191.1c0 41.2 13 79.3 35.2 110.5l-89.9 181.5c-81.4-70.4-133-174.4-133-290.5 0-212 171.8-383.8 383.8-383.8S899 299.6 899 511.6c0 112.1-48.1 213-124.8 283.1z"
  }));
});

/**
* @file 图标os-o
* @author zhanglili
*/
var IconOsO =
/*#__PURE__*/
createIcon('os-o', SVG$3U);

var SVG$3V = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M514.7 63.6c-247.4.3-447.5 200.6-447.5 448 0 160.5 84.4 301.3 211.2 380.4 5 3.1 11.7 1.3 14.3-4l23.7-48c-.1 0-.1-.1-.2-.1l85.4-172.5h.1l24.9-50.5c2-4 1.1-8.8-2.3-11.8-25.8-23.2-42-56.8-42.3-94.2-.5-70.4 56.7-128.3 127.1-128.8 71.1-.5 128.9 57 128.9 128 0 35.5-14.5 67.7-37.9 90.9-3.2 3.2-3.9 8.1-1.7 12l27.6 48.8c.1-.1.2-.1.2-.2l97.3 172.2s-.1 0-.1.1l26.4 46.7c2.9 5 9.4 6.6 14.2 3.4 120-80.4 198.9-217.2 198.9-372.4.3-247.6-200.6-448.3-448.2-448z"
  }));
});

/**
* @file 图标os-solid
* @author zhanglili
*/
var IconOsSolid =
/*#__PURE__*/
createIcon('os-solid', SVG$3V);

var SVG$3W = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.58 98.23C283.5 98.23 98 284.14 98 513.22s185.5 415 414.58 415c229.49 0 415.41-185.92 415.41-415S742.08 98.23 512.58 98.23zm.42 760.82c-191.07 0-345.83-154.76-345.83-345.83S321.93 167.39 513 167.39s345.83 154.76 345.83 345.83S704.07 859.05 513 859.05z"
  }), React.createElement("path", {
    d: "M374.67 328.78h92.22v415h-92.22zM559.11 328.78h92.22v415h-92.22z"
  }));
});

/**
* @file 图标pause-o
* @author zhanglili
*/
var IconPauseO =
/*#__PURE__*/
createIcon('pause-o', SVG$3W);

var SVG$3X = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M304.9 636.4v86.5h86.5l255.1-255.1-86.5-86.5-255.1 255.1zm408.4-235.5c9-9 9-23.5 0-32.5l-54-54c-9-9-23.5-9-32.5 0l-42.2 42.2 86.5 86.5 42.2-42.2z"
  }), React.createElement("path", {
    d: "M512.5 67.3c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5C300.7 898.8 129 727.1 129 515.3s171.7-383.5 383.5-383.5S896 303.5 896 515.3c0 211.9-171.7 383.5-383.5 383.5z"
  }));
});

/**
* @file 图标pen-circle-o
* @author zhanglili
*/
var IconPenCircleO =
/*#__PURE__*/
createIcon('pen-circle-o', SVG$3X);

var SVG$3Y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.5 67.3c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zM391.4 722.9h-86.5v-86.5L560 381.3l86.5 86.5-255.1 255.1zm321.9-322l-42.2 42.2-86.5-86.5 42.2-42.2c9-9 23.5-9 32.5 0l54 54c9 9 9 23.5 0 32.5z"
  }));
});

/**
* @file 图标pen-circle-solid
* @author zhanglili
*/
var IconPenCircleSolid =
/*#__PURE__*/
createIcon('pen-circle-solid', SVG$3Y);

var SVG$3Z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M64.2 773.3v186.3h186.3l549.3-549.3L613.5 224 64.2 773.3zm879.6-507.1c19.4-19.4 19.4-50.7 0-70L827.6 79.9c-19.4-19.4-50.7-19.4-70 0l-90.9 90.9L853 357.1l90.8-90.9z"
  }));
});

/**
* @file 图标pen-solid
* @author zhanglili
*/
var IconPenSolid =
/*#__PURE__*/
createIcon('pen-solid', SVG$3Z);

var SVG$3_ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M164.6 38.6l-19.2-16.3c-8.8-7.4-21.9-6.2-29.3 2.6l-29 34.6c-2.4 2.9-2 7.1.8 9.5 2.9 2.4 7.2 2 9.5-.8l14-16.7 30.2 25.6-56.5 67.4L54.9 119l25.3-30.2c2.4-2.9 2-7.1-.8-9.6-2.9-2.4-7.1-2-9.6.8l-32.1 38.2c-2.5 3-4.1 6.6-4.6 10.4l-7.6 35.7c-.3 2.1-.1 4.3.5 6.3 1.9 5.8 7.3 9.5 13.1 9.5 1.4 0 2.9-.2 4.3-.7l35.9-11.8c3.7-1.2 6.9-3.4 9.4-6.4l78.4-93.4c7.4-8.7 6.3-21.8-2.5-29.2zm-44.4 2.6l6.3-7.6c1.2-1.5 3-2.4 4.9-2.5 1.9-.2 3.8.4 5.3 1.7L155.9 49c3 2.6 3.4 7.1.9 10.2l-6.4 7.6-30.2-25.6zM38.9 166.3l7.6-35.7c0-.3.3-.5.3-.7l28.9 24.4c-.2.1-.4.4-.6.4l-36.2 11.6z"
  }));
});

/**
* @file 图标pen-solid-o
* @author zhanglili
*/
var IconPenSolidO =
/*#__PURE__*/
createIcon('pen-solid-o', SVG$3_);

var SVG$3$ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M786 280.8L611.4 105.7c-11.4-11.4-29.8-11.4-41.2 0-12.7 12.8-465.7 466.9-465.7 466.9-5.5 5.5-8.5 12.9-8.5 20.6v175.1c0 16.1 13 29.2 29.1 29.2h174.6c7.7 0 15.1-3.1 20.6-8.6l465.7-467c11.4-11.2 11.4-29.7 0-41.1zM287.7 739.2H154.2V605.4c40.1-40.2 213.4-213.9 334.7-335.6l133.5 133.8-334.7 335.6zm375.9-376.9L530.1 228.5c25.3-25.3 46.3-46.4 60.7-60.9l133.5 133.8-60.7 60.9zM122.7 876.1h596c14.3 0 25.9 11.4 25.9 25.6 0 14.1-11.6 25.6-25.9 25.6h-596c-14.3 0-25.9-11.4-25.9-25.6-.1-14.2 11.5-25.6 25.9-25.6zm699.6 0H900c14.3 0 25.9 11.4 25.9 25.6 0 14.1-11.6 25.6-25.9 25.6h-77.7c-14.3 0-25.9-11.4-25.9-25.6 0-14.2 11.6-25.6 25.9-25.6z"
  }));
});

/**
* @file 图标pen-with-paper-o
* @author zhanglili
*/
var IconPenWithPaperO =
/*#__PURE__*/
createIcon('pen-with-paper-o', SVG$3$);

var SVG$40 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M64.5 928.2h65.8v-830H64.5v830zM194 331.1h691.4c5.5 0 10-4.5 10-10V220.6c0-5.5-4.5-10-10-10H194v120.5zm0 241.1h401.1c5.5 0 10-4.5 10-10V461.7c0-5.5-4.5-10-10-10H194v120.5zm0 241.1h756.4c5.5 0 10-4.5 10-10V702.8c0-5.5-4.5-10-10-10H194v120.5z"
  }));
});

/**
* @file 图标phase
* @author zhanglili
*/
var IconPhase =
/*#__PURE__*/
createIcon('phase', SVG$40);

var SVG$41 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M258.9 128.3c0-35.6 29-64.4 63.8-64.4h384.2c35.2 0 63.8 28.8 63.8 64.4v766.9c0 35.6-29 64.4-63.8 64.4H322.7c-35.2 0-63.8-28.8-63.8-64.4V128.3zm258.7 230.1c45 0 81.4-36.4 81.4-81.4s-36.4-81.4-81.4-81.4-81.4 36.4-81.4 81.4 36.5 81.4 81.4 81.4zm-1.2 234.5c45 0 81.4-36.4 81.4-81.4s-36.4-81.4-81.4-81.4-81.4 36.4-81.4 81.4 36.4 81.4 81.4 81.4zm-2 237.1c45 0 81.4-36.4 81.4-81.4s-36.4-81.4-81.4-81.4-81.4 36.4-81.4 81.4c0 45 36.4 81.4 81.4 81.4z"
  }));
});

/**
* @file 图标pilotight
* @author zhanglili
*/
var IconPilotight =
/*#__PURE__*/
createIcon('pilotight', SVG$41);

var SVG$42 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M958.92 395.29l-92.63 92.63-58.66-58.65-128.69 243.54 91.64 91.64L678 857.08 477.48 656.61l-12.35 10.49-14.95 12.68L435.76 692l-8.39 7.09-8.2 6.91-8 6.75-7.82 6.56-10.12 8.49-7.36 6.17-7.17 6-7 5.82-4.55 3.78-8.83 7.33-6.4 5.3-6.21 5.13-6 5-5.82 4.67-5.63 4.6-5.43 4.44-5.25 4.26-5.05 4.09-3.26 2.63-3.17 2.55-3.1 2.51-3 2.4-4.35 3.45-2.79 2.21-4 3.17-2.57 2-2.49 1.94-2.41 1.86-2.31 1.79-2.24 1.7-2.14 1.64-2.06 1.55-1 .75c-1 .75-5.2 4.17-11.38 9-11.44 9-30.62 24-44.26 33.29-47.53 32.24-117.34 58.44-117.84 58.7q21.72-66.64 58.42-118.32 12.1-17.06 41-50.09l3.57-4.06 3.7-4.18q2.81-3.18 5.77-6.5l4-4.47q5.07-5.67 10.54-11.7l4.44-4.89 4.56-5 4.68-5.12 2.38-2.6 4.87-5.3 2.48-2.69 5.05-5.47 2.58-2.79 5.23-5.64 5.37-5.77 2.72-2.93 5.55-5.94c.93-1 1.87-2 2.82-3l5.73-6.12 5.86-6.24 6-6.35 6.1-6.47c1-1.09 2.06-2.19 3.1-3.28L311 636c1-1.12 2.12-2.24 3.19-3.37l6.47-6.82 6.6-6.94 3.34-3.52 6.78-7.11 6.91-7.24 3.5-3.66 10.68-11.16 7.28-7.58q1.83-1.92 3.69-3.84L380.66 563l1.59-1.65-214.83-214.8 92.63-92.63 92.14 92.14 243.54-128.69-59.65-59.66 92.63-92.63z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标pin
* @author zhanglili
*/
var IconPin =
/*#__PURE__*/
createIcon('pin', SVG$42);

var SVG$43 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M635 477.5h72.1c14.2-55.3 64.4-96.1 124.1-96.1 70.8 0 128.1 57.4 128.1 128.1S902 637.6 831.2 637.6c-59.7 0-109.9-40.8-124.1-96.1H635c-14.2 55.3-64.4 96.1-124.1 96.1S401 596.8 386.8 541.5h-71.4c-14.2 55.3-64.4 96.1-124.1 96.1-70.8 0-128.1-57.4-128.1-128.1s57.4-128.1 128.1-128.1c59.7 0 109.9 40.8 124.1 96.1h71.4c14.2-55.3 64.4-96.1 124.1-96.1s109.9 40.9 124.1 96.1zm-443.6 96.1c35.4 0 64.1-28.7 64.1-64.1s-28.7-64.1-64.1-64.1-64.1 28.7-64.1 64.1 28.8 64.1 64.1 64.1zm639.8 0c35.4 0 64.1-28.7 64.1-64.1s-28.7-64.1-64.1-64.1c-35.4 0-64.1 28.7-64.1 64.1s28.7 64.1 64.1 64.1zm-320.2 0c35.4 0 64.1-28.7 64.1-64.1s-28.7-64.1-64.1-64.1-64.1 28.7-64.1 64.1 28.7 64.1 64.1 64.1z"
  }));
});

/**
* @file 图标pipeline
* @author zhanglili
*/
var IconPipeline =
/*#__PURE__*/
createIcon('pipeline', SVG$43);

var SVG$44 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M845 737.2l115 90.7-115 90.7v-34.5H562.7c54-24.5 100.2-63.1 133.8-111.3h148.4l.1-35.6zm-70.4-621.5c70.8 31.5 102.6 114.4 71.1 185.2-11.9 26.8-31.3 48-54.5 62.3 1.4 3.7 2.9 7.6 4.5 11.6l.9 2.4-58.7-26.1 26.1-58.7v.1c.3.8 2.2 5.7 5.6 14.7l.3.9.4 1.1c10-8.1 18.3-18.6 23.9-31.2 18.9-42.5-.2-92.2-42.7-111.1-42.5-18.9-92.2.2-111.1 42.7-14.2 31.9-7 67.8 15.5 91.8.6.6 1.3 1.3 1.9 2 .5.5.9 1 1.4 1.4v.1c58.5 61.6 94.3 144.8 94.3 236.4 0 187.2-149.8 339.5-336.2 343.3v-6.5 6.6H103.2v-89.4h314.4v.1c137.1-3.8 247-116.2 247-254.1 0-140.4-113.8-254.2-254.2-254.2S156.1 400.9 156.1 541.3c0 40.9 9.7 79.5 26.8 113.8l53.3-53.3V759H79l36.7-36.7 1.7-1.7-1.2-1.9c-31.3-51.8-49.3-112.5-49.3-177.4 0-111.7 53.3-211 135.9-273.7-1.7.3-3.5.4-5.3.4-20 0-36.3-16.2-36.3-36.3 0-20 16.2-36.3 36.3-36.3 20 0 36.3 16.2 36.3 36.3 0 6.5-1.7 12.5-4.6 17.8 52.6-32.7 114.7-51.6 181.2-51.6 60.6 0 117.5 15.7 166.9 43.2.3-18.2 4.3-36.6 12.1-54.3 31.5-70.8 114.4-102.6 185.2-71.1z"
  }));
});

/**
* @file 图标plantrack
* @author zhanglili
*/
var IconPlantrack =
/*#__PURE__*/
createIcon('plantrack', SVG$44);

var SVG$45 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M899.657 93.184H124.343A124.343 124.343 0 0 0 0 217.527V700.27a124.343 124.343 0 0 0 124.343 124.343h775.314A124.343 124.343 0 0 0 1024 700.27V217.527A124.343 124.343 0 0 0 899.657 93.184zm-775.314 73.143h775.314a51.2 51.2 0 0 1 51.2 51.2V700.27a51.2 51.2 0 0 1-51.2 51.2H124.343a51.2 51.2 0 0 1-51.2-51.2V217.527a51.2 51.2 0 0 1 51.2-51.2z"
  }), React.createElement("path", {
    d: "M741.522 281.966a36.571 36.571 0 0 1 57.052 45.348l-4.096 5.12-221.111 231.644a36.571 36.571 0 0 1-47.762 4.461l-5.12-4.461-89.966-94.208-148.041 155.136a36.571 36.571 0 0 1-46.592 5.34l-5.12-4.097a36.571 36.571 0 0 1-5.34-46.592l4.096-5.12L404.114 391.68a36.571 36.571 0 0 1 47.763-4.462l5.12 4.389 89.892 94.208 194.633-203.85zm-401.7 694.784a36.571 36.571 0 0 0 46.665 4.169l5.12-4.17L512 856.284 632.393 976.75a36.571 36.571 0 0 0 46.665 4.169l5.12-4.17a36.571 36.571 0 0 0 4.17-46.664l-4.17-5.12-146.285-146.286a36.571 36.571 0 0 0-46.666-4.17l-5.12 4.17-146.285 146.286a36.571 36.571 0 0 0 0 51.785z"
  }));
});

/**
* @file 图标play
* @author zhanglili
*/
var IconPlay =
/*#__PURE__*/
createIcon('play', SVG$45);

var SVG$46 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510.2 61.8c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5S893.7 298 893.7 509.8c0 211.9-171.7 383.5-383.5 383.5z"
  }), React.createElement("path", {
    d: "M448.8 694.8l249.5-174.2c2.1-1.5 3.6-3.7 4-6.2.1-1 .1-1.9 0-2.9-.4-2.5-1.9-4.7-4-6.2L448.8 331.1v363.7z"
  }));
});

/**
* @file 图标play-circle-o
* @author zhanglili
*/
var IconPlayCircleO =
/*#__PURE__*/
createIcon('play-circle-o', SVG$46);

var SVG$47 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512 65.2C264.7 65.2 64.3 265.7 64.3 513s200.5 447.8 447.8 447.8S959.9 760.3 959.9 513 759.3 65.2 512 65.2zm172 468.7L447.9 686c-12.9 8.4-30.1 4.4-30.1-20.3V366.1c0-27 16.1-27.8 30.1-20.3L684 498c9.7 9.9 9.7 26 0 35.9z"
  }));
});

/**
* @file 图标play-circle-solid
* @author zhanglili
*/
var IconPlayCircleSolid =
/*#__PURE__*/
createIcon('play-circle-solid', SVG$47);

var SVG$48 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M136.5 833.4c-.3 14.8 5.8 29.1 17.2 39.8 10.5 10.7 24.8 16.6 39.8 16.5H615c14.9.3 29.3-5.7 40-16.8 10.6-10.4 16.6-24.7 16.4-39-1.1-24-1.7-41.9-1.7-53.8 0-6.4.2-11.2.5-14.7.3-2.7.6-4.9 1.4-7.3 1-3 1-3 5.2-8.5 10.2-6.8 10.2-6.8 23.5-3.5 2.6 1.4 5.2 2.6 8.2 3.7 31.5 12.6 66.8 12.2 98.1-1.1 15.7-6.7 30-16.3 42-28.6 12-12 21.6-26.2 28.4-41.6 7-16.3 10.5-33.8 10.3-51.7 0-17.6-3.5-35.1-10.3-51.2-6.8-15.8-16.4-30.2-28.3-42.3-12.1-12-26.5-21.6-42.3-28.3-31.1-13.6-66.4-14.1-96.7-2-1.7.8-3.2 1.5-5.8 2.6-2 .8-3 1.3-3.9 1.8-14.9 2.8-14.9 2.8-24.2-4.7-3.6-5.3-3.6-5.3-4.4-8.1-.7-2.2-1-4.5-1.3-7.2-.3-3.8-.5-8.9-.5-15.8 0-13 .6-32.5 1.6-58 .1-15.1-5.8-29.6-16.6-40.6-10.4-10.8-24.7-16.9-39.7-16.8-2.5 0-7.9 1.4-16.1 4.2-2.2.8-2.2.8-4.4 1.5-18.7 6.6-20.4 7.2-27 7.8-24.4 2.4-32.7-19.7-21.4-38.8 13.5-22.9 19.9-81.5 7.7-110.1-6.8-16-16.6-30.5-28.7-42.7-12.3-12.2-26.8-22.1-42.5-29.1-33.4-14.3-71.1-14.3-104.3-.1-15.9 7-30.4 16.9-42.5 29-12.2 12.4-22 26.9-28.9 43-7.3 16.7-11 34.8-10.8 53.3-.1 15.5 2.7 30.8 8.1 44.9 1.2 3.1 2.5 6.2 3.9 9.4.4 19 .4 19-8.1 25.2-4.5 2.2-4.5 2.2-6.9 2.7-2.1.5-4.4.8-7.3 1-4.5.3-10.8.5-19.2.5-16.3 0-40.8-.6-72.7-1.7-31.7.2-57.3 25.9-57.5 57.5v91.6c-.1 9.1 2.2 18.1 6.5 25.5 2.9 4.8 7.9 7.9 12.4 8.5 6.4.5 12.8-.7 18-3 6.1-3 12.6-6.2 20.9-10 3.6-1.8 7.3-3.2 8.1-3.1 27.3-12.6 58.6-12.9 85.8-1.2 13.2 5.4 25.2 13.4 34.9 23.4 10.1 10.1 18.1 22.1 23.4 35 5.8 13.7 8.6 28.4 8.5 42.8.2 14.6-2.7 29-8.4 42.4-5.5 13-13.4 24.7-23.2 34.4-10 10.2-21.9 18.2-34.5 23.4-28.1 12.5-60.4 11.5-86.7-2.1-.3-.1-.6-.2-4.6-1.3-3.9-1.5-7.8-3.4-14-7.4-9.1-7.7-22.3-8.4-30.7-2.8-8.3 6.8-13.9 16.2-16.2 27.5v96.1zm-10.4 68.1c-19-17.8-29.6-42.8-29.1-68.4v-95.4c0-3.1.4-6.3.9-8.5 3.9-19.5 14.4-37.1 31.2-50.8 24.5-16.5 57-14.8 77 2.3 1.8 1.1 3.7 2 1.9 1.7 3.4.6 6.8 1.6 11 3.6 16.7 8.6 36.5 9.2 54.2 1.3 8.2-3.3 15.6-8.3 22-14.9 6.3-6.2 11.4-13.7 14.8-21.9 3.6-8.4 5.3-17.4 5.2-27 .1-9.4-1.7-18.7-5.5-27.7-3.3-8.2-8.3-15.7-14.9-22.2-6.2-6.3-13.6-11.3-22.2-14.8-17.3-7.5-36.9-7.2-57 1.7-1.4.4-2.8.9-4.5 1.8-8.3 3.9-14.6 6.9-21.1 10.1-11.8 5.3-24.7 7.6-38.7 6.6-17.4-2.2-33-12.1-42.5-27.6-8.1-14.1-12.3-30-12.1-46v-91.5c.3-53.3 43.4-96.5 97.6-96.9 29.6 1 52.2 1.5 67.9 1.6-3.9-14.4-5.9-29.2-5.8-44.1-.1-23.7 4.7-47.3 14.1-69 8.8-20.5 21.4-39.2 37.2-55.2 15.8-15.7 34.3-28.3 54.8-37.3 43.3-18.5 92.3-18.5 135.8.1 20.3 9 38.8 21.6 54.7 37.4 15.7 15.9 28.3 34.6 37 55.2 13.1 30.9 11.9 79.4 2 115.6 9-2.8 15.8-4.3 22.5-4.3 25.8-.2 50.6 10.3 68.3 28.7 18 18.2 28 42.8 27.8 69.1-.8 19.5-1.3 35.1-1.5 46.9 37.1-10.8 77.1-8.4 112.7 7.2 20.3 8.6 38.8 21 54.7 36.7 15.5 15.8 28 34.3 36.7 54.8 8.9 21.1 13.5 43.8 13.4 66.5.2 23.1-4.4 46-13.6 67.5-8.8 20.1-21.2 38.3-36.6 53.7-15.6 15.8-34.2 28.5-54.7 37.1-35.8 15.3-75.7 17.5-112.6 6.8.2 10.5.7 24 1.5 40.8.3 25.7-9.9 50.4-27.9 67.9-18 18.6-42.9 29-68.4 28.5H193.8c-25.7.3-50.3-9.9-67.7-27.7z"
  }));
});

/**
* @file 图标plugin-list
* @author zhanglili
*/
var IconPluginList =
/*#__PURE__*/
createIcon('plugin-list', SVG$48);

var SVG$49 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M189.2 147.3c-25.5 0-46.1 20.6-46.1 46.1v184.4c0 25.5 20.6 46.1 46.1 46.1h184.4c25.5 0 46.1-20.6 46.1-46.1V193.4c0-25.5-20.6-46.1-46.1-46.1H189.2zm0-46.1h184.4c50.9 0 92.2 41.3 92.2 92.2v184.4c0 50.9-41.3 92.2-92.2 92.2H189.2c-50.9 0-92.2-41.3-92.2-92.2V193.4c0-50.9 41.3-92.2 92.2-92.2zm0 507.2c-25.5 0-46.1 20.6-46.1 46.1V839c0 25.5 20.6 46.1 46.1 46.1h184.4c25.5 0 46.1-20.6 46.1-46.1V654.6c0-25.5-20.6-46.1-46.1-46.1H189.2zm0-46.1h184.4c50.9 0 92.2 41.3 92.2 92.2V839c0 50.9-41.3 92.2-92.2 92.2H189.2c-50.9 0-92.2-41.3-92.2-92.2V654.6c0-51 41.3-92.3 92.2-92.3zm461.1 46.1c-25.5 0-46.1 20.6-46.1 46.1V839c0 25.5 20.6 46.1 46.1 46.1h184.4c25.5 0 46.1-20.6 46.1-46.1V654.6c0-25.5-20.6-46.1-46.1-46.1H650.3zm0-46.1h184.4c50.9 0 92.2 41.3 92.2 92.2V839c0 50.9-41.3 92.2-92.2 92.2H650.3c-50.9 0-92.2-41.3-92.2-92.2V654.6c0-51 41.3-92.3 92.2-92.3zm230.6-368.9c0-25.5-20.6-46.1-46.1-46.1H650.3c-25.5 0-46.1 20.6-46.1 46.1v184.4c0 25.5 20.6 46.1 46.1 46.1h184.4c25.5 0 46.1-20.6 46.1-46.1V193.4zm46.1 0v184.4c0 50.9-41.3 92.2-92.2 92.2H650.3c-50.9 0-92.2-41.3-92.2-92.2V193.4c0-50.9 41.3-92.2 92.2-92.2h184.4c51 0 92.3 41.3 92.3 92.2z"
  }));
});

/**
* @file 图标plugin-market
* @author zhanglili
*/
var IconPluginMarket =
/*#__PURE__*/
createIcon('plugin-market', SVG$49);

var SVG$4a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M72.2 20H39c-11 0-20 9-20 20v33.2c0 11 9 20 20 20h33.2c11 0 20-9 20-20V40c0-11-9-20-20-20zm4 53.2c0 2.2-1.8 4-4 4H39c-2.2 0-4-1.8-4-4V40c0-2.2 1.8-4 4-4h33.2c2.2 0 4 1.8 4 4v33.2zM160.9 20h-33.2c-11 0-20 9-20 20v33.2c0 11 9 20 20 20h33.2c11 0 20-9 20-20V40c0-11-9-20-20-20zm4 53.2c0 2.2-1.8 4-4 4h-33.2c-2.2 0-4-1.8-4-4V40c0-2.2 1.8-4 4-4h33.2c2.2 0 4 1.8 4 4v33.2zm-92.7 33.9H39c-11 0-20 9-20 20v33.2c0 11 9 20 20 20h33.2c11 0 20-9 20-20v-33.2c0-11-9-20-20-20zm4 53.2c0 2.2-1.8 4-4 4H39c-2.2 0-4-1.8-4-4v-33.2c0-2.2 1.8-4 4-4h33.2c2.2 0 4 1.8 4 4v33.2zm84.7-53.2h-33.2c-11 0-20 9-20 20v33.2c0 11 9 20 20 20h33.2c11 0 20-9 20-20v-33.2c0-11-9-20-20-20zm4 53.2c0 2.2-1.8 4-4 4h-33.2c-2.2 0-4-1.8-4-4v-33.2c0-2.2 1.8-4 4-4h33.2c2.2 0 4 1.8 4 4v33.2z"
  }));
});

/**
* @file 图标plugin-market-bold
* @author zhanglili
*/
var IconPluginMarketBold =
/*#__PURE__*/
createIcon('plugin-market-bold', SVG$4a);

var SVG$4b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M939.695 47.673H91.275c-6.668 0-12.123 5.455-12.123 12.123v848.419c0 6.668 5.455 12.123 12.123 12.123h848.42c1.667 0 3.258-.341 4.707-.957a12.235 12.235 0 0 0 4.639-3.467 12.06 12.06 0 0 0 2.777-7.7V59.796c0-6.668-5.456-12.123-12.123-12.123zm-793.462 79.204c0-6.668 5.455-12.123 12.123-12.123h714.257c6.668 0 12.123 5.455 12.123 12.123v714.257c0 3.334-1.364 6.365-3.561 8.562a12.086 12.086 0 0 1-8.562 3.561H158.357c-6.668 0-12.123-5.455-12.123-12.123V126.877z"
  }), React.createElement("path", {
    d: "M547.737 451.753V209.44c0-5.433-4.445-9.878-9.878-9.878h-44.748c-5.433 0-9.878 4.445-9.878 9.878v242.313H240.919c-5.433 0-9.878 4.445-9.878 9.878v44.748c0 5.433 4.445 9.878 9.878 9.878h242.313V758.57c0 5.433 4.445 9.878 9.878 9.878h44.749c5.433 0 9.878-4.445 9.878-9.878V516.258H790.05c5.433 0 9.878-4.445 9.878-9.878v-44.748c0-5.433-4.445-9.878-9.878-9.878.001-.001-242.313-.001-242.313-.001z"
  }));
});

/**
* @file 图标plus-square
* @author zhanglili
*/
var IconPlusSquare =
/*#__PURE__*/
createIcon('plus-square', SVG$4b);

var SVG$4c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "16",
    height: "16"
  }, props), React.createElement("path", {
    d: "M14 5h-1V2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v3H1v7h2v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM4 2h8v3H4V2zm8 12H4v-4h8v4zm2-3h-1V9H3v2H2V6h12v5z"
  }));
});

/**
* @file 图标print
* @author zhanglili
*/
var IconPrint =
/*#__PURE__*/
createIcon('print', SVG$4c);

var SVG$4d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M710.5 751.1C658.8 800.5 589.1 831 512.2 831s-146.6-30.5-198.3-79.8c-24.6 19.6-55.4 31.9-89.3 31.9-4.2 0-8.1-.9-12.2-1.2 70.3 88.2 178.4 145 299.7 145s229.4-56.8 299.7-145c-4.1.3-8 1.2-12.2 1.2-33.8-.1-64.6-12.3-89.1-32zM224.6 495.5c1.5 0 2.8.4 4.3.4 15.8-94.3 77.5-173.1 161.4-212.6-13.6-22-21.9-47.7-21.9-75.4 0-7 1.1-13.7 2.1-20.5-138 55.2-236.2 188.3-240.8 344.6 25.3-22.4 58.3-36.5 94.9-36.5zm431.6-287.6c0 28.1-8.4 54-22.2 76.1 83.8 39.5 146 117.5 161.8 211.8 1.5 0 2.8-.4 4.3-.4 36.7 0 69.9 14.2 95.3 36.9-4.5-156.5-103.1-289.7-241.1-344.9.8 6.8 1.9 13.5 1.9 20.5z"
  }), React.createElement("circle", {
    cx: "512.2",
    cy: "199.4",
    r: "102.2"
  }), React.createElement("circle", {
    cx: "811.9",
    cy: "644.1",
    r: "102.2"
  }), React.createElement("circle", {
    cx: "212.7",
    cy: "644.1",
    r: "102.2"
  }));
});

/**
* @file 图标process-solid
* @author zhanglili
*/
var IconProcessSolid =
/*#__PURE__*/
createIcon('process-solid', SVG$4d);

var SVG$4e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510.3 61.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5 383.5 171.7 383.5 383.5c0 211.9-171.7 383.5-383.5 383.5z"
  }), React.createElement("path", {
    d: "M266.3 477.1h488.4c5.5 0 10 4.5 10 10v45.5c0 5.5-4.5 10-10 10H266.3c-5.5 0-10-4.5-10-10v-45.5c0-5.5 4.5-10 10-10z"
  }));
});

/**
* @file 图标prohibit-circle-o
* @author zhanglili
*/
var IconProhibitCircleO =
/*#__PURE__*/
createIcon('prohibit-circle-o', SVG$4e);

var SVG$4f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510.3 61.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm254.4 471.1c0 5.5-4.5 10-10 10H266.3c-5.5 0-10-4.5-10-10v-45.4c0-5.5 4.5-10 10-10h488.4c5.5 0 10 4.5 10 10v45.4z"
  }));
});

/**
* @file 图标prohibit-circle-solid
* @author zhanglili
*/
var IconProhibitCircleSolid =
/*#__PURE__*/
createIcon('prohibit-circle-solid', SVG$4f);

var SVG$4g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M152.6 307.2v-63.8c0-2.2 1.8-4 4-4h711.6c2.2 0 4 1.8 4 4v63.8c0 2.2-1.8 4-4 4H156.6c-2.2 0-4-1.8-4-4zm60-174.2v53.8c0 2.2 1.8 4 4 4h593.9c2.2 0 4-1.8 4-4V133c0-2.2-1.8-4-4-4H216.6c-2.2 0-4 1.8-4 4zM928 878.1c0 8.5-6.7 15.4-15.1 15.4h-801c-8.4 0-15.1-7-15.1-15.4V377.7c0-10.4 8.5-18.8 19-18.8H909c10.5 0 19 8.4 19 18.8v500.4z"
  }));
});

/**
* @file 图标projectlist
* @author zhanglili
*/
var IconProjectlist =
/*#__PURE__*/
createIcon('projectlist', SVG$4g);

var SVG$4h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M896 128L640 896 459 565.05 128.05 384zM794.78 229.22L287.53 398.3l189.32 103.59 100.84-100.83 45.25 45.25-100.83 100.84L625.7 736.47z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标publish
* @author zhanglili
*/
var IconPublish =
/*#__PURE__*/
createIcon('publish', SVG$4h);

var SVG$4i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M298.3 373H196.7c-2.2 0-4-1.8-4-4-2-206.6 97.6-308.3 299.1-305 176.1 6.7 267.4 91.4 274.1 254.2 0 63.2-41.6 132.9-124.6 209.3-76.5 69.8-114.6 131.3-114.6 184.4v40.9c0 2.2-1.8 4-4 4H426c-2.2 0-4-1.8-4-4V687c0-59.8 38.2-127.9 114.6-204.3 66.4-66.4 103-121.3 109.6-164.5-6.7-86.4-53.2-134.6-139.6-144.5-138-6.6-206.3 58.4-204.3 195.2.1 2.3-1.7 4.1-4 4.1zm230 482.7v98c0 2.2-1.8 4-4 4h-100c-2.2 0-4-1.8-4-4v-98c0-2.2 1.8-4 4-4h100c2.2 0 4 1.8 4 4z"
  }));
});

/**
* @file 图标question-mark
* @author zhanglili
*/
var IconQuestionMark =
/*#__PURE__*/
createIcon('question-mark', SVG$4i);

var SVG$4j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M407.6 432.9h-54.8c-2.2 0-4-1.8-4-4-.6-117.2 56.5-174.8 171.2-173 100.8 3.8 153.1 52.4 157 145.6 0 36.2-23.8 76.1-71.4 119.9-43.8 40-65.6 75.2-65.6 105.6v21.7c0 2.2-1.8 4-4 4h-51.9c-2.2 0-4-1.8-4-4v-36c0-34.2 21.9-73.2 65.6-117 38-38 59-69.4 62.8-94.2-3.8-49.5-30.5-77.1-79.9-82.8-78.6-3.6-117.6 33-117.1 110.2.2 2.2-1.6 4-3.9 4zm133.5 278.2v52.7c0 2.2-1.8 4-4 4h-53.8c-2.2 0-4-1.8-4-4v-52.7c0-2.2 1.8-4 4-4h53.8c2.2 0 4 1.8 4 4z"
  }), React.createElement("path", {
    d: "M511.3 62.3c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5 383.5 171.7 383.5 383.5c0 211.9-171.7 383.5-383.5 383.5z"
  }));
});

/**
* @file 图标question-mark-circle-o
* @author zhanglili
*/
var IconQuestionMarkCircleO =
/*#__PURE__*/
createIcon('question-mark-circle-o', SVG$4j);

var SVG$4k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.3 62.3c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm25.8 705.5h-53.8c-2.2 0-4-1.8-4-4v-52.7c0-2.2 1.8-4 4-4h57.8v56.7c0 2.2-1.8 4-4 4zm68.7-246.4c-43.8 40-65.6 75.2-65.6 105.6v21.7c0 2.2-1.8 4-4 4h-51.9c-2.2 0-4-1.8-4-4v-36c0-34.2 21.9-73.2 65.6-117 38-38 59-69.4 62.8-94.2-3.8-49.5-30.5-77.1-79.9-82.8-78.6-3.7-117.6 32.9-117.1 110.2 0 2.2-1.8 4-4 4H353c-2.2 0-4-1.8-4-4-.6-117.2 56.5-174.8 171.2-173 100.8 3.8 153.1 52.4 157 145.6-.1 36.2-23.9 76.2-71.4 119.9z"
  }));
});

/**
* @file 图标question-mark-circle-solid
* @author zhanglili
*/
var IconQuestionMarkCircleSolid =
/*#__PURE__*/
createIcon('question-mark-circle-solid', SVG$4k);

var SVG$4l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M927 926.29H97V96.15h830v830.14zM156.29 867h711.42V155.45H156.29V867z"
  }), React.createElement("path", {
    d: "M627.79 293.38c26.28 24.2 39.83 57.62 39.83 100.29 0 31.96-9.26 59.7-27.04 83.21-7.12 8.51-26.28 26.98-57.61 54.72-15.63 13.55-26.28 26.35-33.41 39.14-9.23 15.63-13.49 32.72-13.49 51.88v16.39H479.2v-16.39c0-23.45 4.26-44.07 12.79-61.84 9.96-21.37 33.41-48.35 71.82-82.52 11.41-11.35 19.86-19.92 24.14-25.59 14.24-17.78 21.36-36.25 21.36-56.17 0-28.43-8.51-50.49-24.14-66.13-16.38-17.08-39.86-24.9-69.74-24.9-35.55 0-61.86 11.35-78.91 34.86-15.63 19.92-23.48 46.9-23.48 81.76H356.9c0-49.8 13.52-89.58 41.95-119.46 28.46-31.33 68.26-46.96 119.47-46.96 45.5.01 81.74 12.12 109.47 37.71zm-88.87 407.49c7.82 7.82 12.1 17.78 12.1 29.88 0 12.8-4.28 22.76-12.82 30.57-8.51 7.82-18.47 12.1-30.57 12.1-12.07 0-22.03-4.29-30.57-12.1-8.54-8.51-12.07-18.47-12.07-30.57 0-12.1 3.53-22.06 12.07-29.88 8.54-8.51 18.5-12.04 30.57-12.04 12.1-.01 22.75 3.52 31.29 12.04z"
  }));
});

/**
* @file 图标question-mark-square
* @author zhanglili
*/
var IconQuestionMarkSquare =
/*#__PURE__*/
createIcon('question-mark-square', SVG$4l);

var SVG$4m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M196.8 505.9c1.8-80.9 34.7-158 92-215.3 58.9-59.2 139-92.4 222.5-92.2 42.5 0 83.7 8.4 122.3 24.7a311.6 311.6 0 0 1 99.9 67.5c9 9 17.5 18.7 25.4 28.7l-55.1 43c-3.2 2.5-3.8 7.1-1.3 10.3 1 1.3 2.4 2.2 4.1 2.6l160.7 39.3c4 .9 7.9-1.5 8.8-5.5.1-.5.2-1 .2-1.5l.8-165.4c0-4-3.2-7.3-7.2-7.3-1.6 0-3.3.5-4.5 1.6l-51.6 40.3C741.1 183.4 629.4 128.9 511.2 129c-209.5 0-379.9 167.9-383.9 376.6-.1 4 3.1 7.4 7.1 7.5h55.1c4 0 7.2-3.2 7.3-7.2zm691.2 7.2h-54.8c-4 0-7.2 3.2-7.3 7.1-.8 39.6-9.2 78.7-24.6 115.2-15.8 37.4-38.6 71.4-67.3 100-58.9 59.2-139 92.4-222.5 92.2-83.5.1-163.5-33-222.4-92.2-9-9-17.5-18.6-25.4-28.7l55-43c3.2-2.5 3.8-7.1 1.3-10.3-1-1.3-2.4-2.2-4.1-2.6l-160.7-39.3c-3.9-.9-7.9 1.5-8.8 5.5-.1.5-.2 1-.2 1.6l-.6 165.5c0 6.1 7 9.6 11.8 5.8l51.6-40.3c72.7 93.2 184.4 147.7 302.6 147.6 209.6 0 379.9-168 383.9-376.6.1-4-3.1-7.4-7.1-7.5h-.4z"
  }));
});

/**
* @file 图标refresh
* @author zhanglili
*/
var IconRefresh =
/*#__PURE__*/
createIcon('refresh', SVG$4m);

var SVG$4n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M772 688l48.8 40.9c-10.3 16.6-21.8 32.5-34.4 47.4C641.2 949.4 383.2 972 210.1 826.8S14.5 423.5 159.7 250.5 562.9 54.8 736 200.1c45.4 38.1 80.4 83.9 104.8 133.9l118.6-47.4L901 520.3 667.2 403.4l115-46c-20.5-40.7-49.5-78-86.6-109.1C549.2 125.4 330.9 144.5 208 291s-103.8 364.7 42.7 487.6 364.7 103.8 487.6-42.7c12.5-15 23.8-31 33.7-47.9zM404 313.1l252.6 198.7c5.3 4.2 5 12.2-.5 16.1L404 702.9V313.1z"
  }));
});

/**
* @file 图标replay
* @author zhanglili
*/
var IconReplay =
/*#__PURE__*/
createIcon('replay', SVG$4n);

var SVG$4o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M883.4 78.1c-3.9-8.2-14.5-14.9-23.6-14.9H155.5c-9.1 0-19.5 6.8-23.1 15.2l-69 159.2 36.9 704.6c.5 9.1 8.3 16.4 17.3 16.4h787.7c9.1 0 16.8-7.4 17.3-16.4l36.9-704.6-76.1-159.5zM417 511.8l-176.5 64.7L417 641.8c1.6.6 2.6 2.1 2.6 3.8v28.6c0 2.8-2.8 4.7-5.4 3.7l-218-83.1c-1.6-.6-2.6-2.1-2.6-3.7V562c0-1.7 1-3.2 2.6-3.7l218-82.5c2.6-1 5.4.9 5.4 3.7V508c0 1.7-1 3.2-2.6 3.8zm60.2 220.1h-25.4c-2.7 0-4.6-2.6-3.8-5.2l96.4-306.4c.5-1.7 2.1-2.8 3.8-2.8h25.7c2.7 0 4.6 2.6 3.8 5.2L481 729.1c-.5 1.7-2.1 2.8-3.8 2.8zm350.8-137L610 678c-2.6 1-5.4-.9-5.4-3.7v-28.6c0-1.7 1-3.2 2.6-3.8l176.5-65.3-176.5-64.7c-1.6-.6-2.6-2.1-2.6-3.8v-28.5c0-2.8 2.8-4.7 5.4-3.7l218 82.5c1.6.6 2.6 2.1 2.6 3.7v29.1c0 1.6-1 3.1-2.6 3.7zm31.8-366.1h-694c-9.1 0-14.1-7-11.2-15.7l26.8-80.5c2.9-8.7 12.5-15.7 21.7-15.7h609.2c9.1 0 19.4 6.8 22.9 15.2l34.6 81.5c3.6 8.4-.8 15.2-10 15.2z"
  }));
});

/**
* @file 图标repository
* @author zhanglili
*/
var IconRepository =
/*#__PURE__*/
createIcon('repository', SVG$4o);

var SVG$4p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M164.6 514.1L458.7 220c3.9-3.9 3.9-10.2 0-14.1l-36-36c-3.9-3.9-10.2-3.9-14.1 0L71.4 507c-3.9 3.9-3.9 10.2 0 14.1l337.3 337.3c3.9 3.9 10.2 3.9 14.1 0l36-36c3.9-3.9 3.9-10.2 0-14.1L164.6 514.1zm493.8 0L952.6 220c3.9-3.9 3.9-10.2 0-14.1l-36-36c-3.9-3.9-10.2-3.9-14.1 0L565.3 507c-3.9 3.9-3.9 10.2 0 14.1l337.3 337.3c3.9 3.9 10.2 3.9 14.1 0l36-36c3.9-3.9 3.9-10.2 0-14.1L658.4 514.1z"
  }));
});

/**
* @file 图标retract
* @author zhanglili
*/
var IconRetract =
/*#__PURE__*/
createIcon('retract', SVG$4p);

var SVG$4q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M437.9 686.9c0-23 2.6-45.4 7.6-66.9-145.1 16.7-349.4 84.7-349.4 203.2v103.5h465.5c-74.9-53.4-123.7-140.9-123.7-239.8zm57.6-175c47.1-63.6 119.2-107.5 201.8-117.3 13-27.1 20.2-57.4 20.2-89.4C717.6 190.7 625 98 510.5 98s-207.1 92.8-207.1 207.2c-.1 109.5 84.6 199 192.1 206.7z"
  }), React.createElement("path", {
    d: "M706.8 460.3c-121.9 0-220.7 98.8-220.7 220.7s98.8 220.7 220.7 220.7c121.9 0 220.7-98.8 220.7-220.7s-98.8-220.7-220.7-220.7zm138.4 141.8L681.7 789.5c-.9 1-2.4 1.1-3.5.3l-114.6-92.7c-1.1-.9-1.2-2.5-.2-3.6l29.2-32.1c.9-1 2.3-1.1 3.4-.2l79.6 64.5 131.1-155.4c.9-1 2.4-1.2 3.5-.3l34.8 28.6c.9.9 1.1 2.5.2 3.5z"
  }));
});

/**
* @file 图标reviewer
* @author zhanglili
*/
var IconReviewer =
/*#__PURE__*/
createIcon('reviewer', SVG$4q);

var SVG$4r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M258.8 853.4c-2.2 1.9-3.5 4.7-3.5 7.7v87.6c0 8.8 10.5 13.5 17.1 7.7l488.9-438.3c4.7-4.1 4.7-11.4 0-15.5L272.4 65.3c-6.7-5.9-17.1-1.1-17.1 7.7v88.7c0 2.9 1.3 5.7 3.5 7.7L638.5 511 258.8 853.4z"
  }));
});

/**
* @file 图标right
* @author zhanglili
*/
var IconRight =
/*#__PURE__*/
createIcon('right', SVG$4r);

var SVG$4s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M290.6 954.5l438.8-438.6c3.9-3.9 3.9-10.2 0-14.1L290.6 63.1"
  }));
});

/**
* @file 图标right-solid
* @author zhanglili
*/
var IconRightSolid =
/*#__PURE__*/
createIcon('right-solid', SVG$4s);

var SVG$4t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M887.7 196.1l-31.4-.5c-.8 0-80.5-1.6-172.2-38-92-36.6-151.9-78.7-153.7-80h.1l-19.1-13.5-19 13.5h.1c-2 1.5-61.1 43.2-153.7 80-91.6 36.3-179.5 38-180.3 38l-30.7.5v379.4c-1 85 50.8 180.9 141.3 263.1 39.4 35.8 83.2 66.2 126.7 87.9 43.4 21.6 83.4 33.1 115.7 33.1 66.1 0 159.6-47.4 238.2-120.9 87.8-82 138.1-177.9 138.1-263.2l-.1-379.4zm-54.6 377c0 153.4-225.3 329.1-320.7 329.1-47.8 0-126.6-43.8-198.9-106.5C228.7 722.1 191 641 191 573.1V254.2l6.6-.7c73-7.7 125-21.5 171.4-39.9 69.7-27.8 115.4-57.3 139.4-72.4l4-2.5 4 2.5c24.4 15.3 80.6 45 149.5 72.4 61.2 24.3 115.2 35.1 160.7 39.9l6.6.7-.1 318.9z"
  }), React.createElement("path", {
    d: "M591.3 328.7l-138.4-.7-70.2 244.2 95.4-4.7-39 168.9L639.9 459l-113 14.4 64.4-144.7z"
  }));
});

/**
* @file 图标risk
* @author zhanglili
*/
var IconRisk =
/*#__PURE__*/
createIcon('risk', SVG$4t);

var SVG$4u = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M471.8 555.6c-202.7 49.3-305.3-3.9-308.1-5.1-17.5-7.6-25.5-5.1-32.9 9.8-1.4 2.8-10.5 27.6-17.1 44.1-.8 2-2 5.2-2 8.9v.4c.1 5.7 3 12.6 14.5 17.9 21.1 9.5 71.8 27.8 152.6 30.6 18.3 2.8 21.8 15.8 16.6 31.8l-28.6 93c-8 28.4 9.6 42.5 27.6 42.7h.5c7.3 0 14.5-2.4 20.2-6.9 4.4-3.5 193.5-160.3 193.5-160.3 16-14.5 44.6-37.2 74.8-41.8 129.2-15.9 202.8 8.1 216.1 13 8.5 3.1 18 6 27.3-9.7 4-6.7 18.7-47 19-56.9.4-11.1-10.3-14.9-13.9-16-.1 0-.3-.1-.4-.2-15.2-5.3-44.4-13.6-86.8-18.3-18.3-2-40.6-3.5-66.7-3.5-53.4 0-122.7 6.2-206.2 26.5",
    mask: "url(#mask-2_2_)",
    transform: "translate(19 17.757)"
  }), React.createElement("path", {
    d: "M488.6 375.2c-202.7 49.3-305.3-3.9-308.1-5.1-17.5-7.6-25.5-5.1-32.9 9.8-1.4 2.8-10.5 27.6-17.1 44.1-2 5.1-6.8 18.2 12.5 27.2 22.9 10.3 80.7 31 173.9 31 57.5 0 119.5-8 184-23.6 191-46.4 299-11.4 315.4-5.3 8.5 3.2 18 6 27.3-9.7 4-6.7 18.7-47 19-56.9.4-11.1-10.3-14.9-13.9-16-.1-.1-.3-.1-.4-.2-15.2-5.3-44.4-13.6-86.8-18.3-18.3-2-40.6-3.5-66.6-3.5-53.5 0-122.8 6.2-206.3 26.5",
    mask: "url(#mask-4_2_)",
    transform: "translate(19.259 14.879)"
  }), React.createElement("path", {
    d: "M500.6 196.3c-202.7 49.3-305.3-3.9-308.1-5.1-17.5-7.6-25.5-5.1-32.9 9.8-1.4 2.8-10.5 27.6-17.1 44.1-2 5.1-6.8 18.2 12.5 27.2 22.9 10.3 80.7 31 173.9 31 57.6 0 119.5-8 184-23.6 191-46.4 299-11.4 315.4-5.3 8.5 3.1 18 6 27.3-9.7 4-6.7 18.7-47 19-56.9.4-11.1-10.3-14.9-13.9-16-.1-.1-.3-.1-.4-.2-15.2-5.3-44.4-13.6-86.8-18.3-18.3-2-40.6-3.5-66.6-3.5-53.5 0-122.8 6.2-206.3 26.5",
    mask: "url(#mask-6_2_)",
    transform: "translate(19.453 12)"
  }));
});

/**
* @file 图标ruliu
* @author zhanglili
*/
var IconRuliu =
/*#__PURE__*/
createIcon('ruliu', SVG$4u);

var SVG$4v = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M234.2 339.8l267.7 339.8c4.8 6.1 12.7 6.1 17.5 0L787 339.8"
  }));
});

/**
* @file 图标sdown-solid
* @author zhanglili
*/
var IconSDownSolid =
/*#__PURE__*/
createIcon('sdown-solid', SVG$4v);

var SVG$4w = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M472.4 62.7c225.8 0 408.8 183 408.8 408.8.1 97.2-34.5 191.2-97.5 265.1l166.9 166.9c12.8 12.8 12.8 33.5 0 46.3s-33.5 12.8-46.3 0l-166.8-167c-73.9 63.1-167.9 97.7-265.1 97.6-225.8 0-408.8-183-408.8-408.8s183-408.9 408.8-408.9zm0 65.4C282.7 128.1 129 281.9 129 471.5S282.7 815 472.4 815s343.4-153.8 343.4-343.5S662 128.1 472.4 128.1z"
  }));
});

/**
* @file 图标search
* @author zhanglili
*/
var IconSearch =
/*#__PURE__*/
createIcon('search', SVG$4w);

var SVG$4x = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513.1 896.5H129.4V128.9h767.5v383.3H960V64H64v896.3h449.1v-63.8z"
  }), React.createElement("path", {
    d: "M255.1 255.7h510.2v64H255.1v-64zm-1.3 192H638v64H253.8v-64zm.4 192h256.1v64H254.2v-64zm386.3 0V959h319V639.7h-319zM895 895.6H705V704h190v191.6z"
  }));
});

/**
* @file 图标set-template
* @author zhanglili
*/
var IconSetTemplate =
/*#__PURE__*/
createIcon('set-template', SVG$4x);

var SVG$4y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("path", {
    d: "M640 64v120.32a335.16 335.16 0 0 1 91.52 53.12l49.28-28.16 55-32 32 55 64 111.36 32 55-55 32-49.28 28.16a320 320 0 0 1 0 106.24l49.28 28.16 55 32-32 55-64 111.36-32 55-55-32-49.28-28.16A335.16 335.16 0 0 1 640 839.68V960H384V839.68a335.16 335.16 0 0 1-91.52-53.12l-49.28 28.16-55 32-32-55-64-111.36-32-55 55-32 49.28-28.16a320 320 0 0 1 0-106.24l-49.28-28.24-55-32 32-55 64-111.36 32-55 55 32 49.28 28.16a335.16 335.16 0 0 1 91.52-53.2V64zm-64 64H448v105.6a245.06 245.06 0 0 0-64 22.4 191.79 191.79 0 0 0-32 19.84 256.1 256.1 0 0 0-51.2 43.52l-57-32.64-33.28-19.2-64 111.36 33.28 19.2 56.32 32-.46 1.41A256 256 0 0 0 224 494.08a167.37 167.37 0 0 0 0 17.92 168.52 168.52 0 0 0 .64 19.2 256.09 256.09 0 0 0 12.16 64l-56.32 32-33.28 19.2 64 111.36 33.28-19.2 57-32.64a256.1 256.1 0 0 0 51.2 43.52A191.76 191.76 0 0 0 384 768a245 245 0 0 0 64 24.32V896h128V790.4a245.06 245.06 0 0 0 64-22.4 192.12 192.12 0 0 0 31.36-19.2 256.1 256.1 0 0 0 51.2-43.52l57 32.64 33.28 19.2 64-113.28-33.28-19.2-56.32-32 .46-1.41a256 256 0 0 0 11.7-62.59 167.37 167.37 0 0 0 0-17.92 167.37 167.37 0 0 0 0-17.92 256.09 256.09 0 0 0-12.16-64l56.32-32 33.28-19.2-64-111.36-33.28 19.2-57 32.64a256.1 256.1 0 0 0-51.2-43.52A191.76 191.76 0 0 0 640 256a245 245 0 0 0-64-24.32zm-64 224a160 160 0 1 1-160 160 160 160 0 0 1 160-160zm0 64a96 96 0 1 0 96 96 96 96 0 0 0-96-96z",
    "data-name": "\u56FE\u5C42 1"
  })));
});

/**
* @file 图标setting-alt
* @author zhanglili
*/
var IconSettingAlt =
/*#__PURE__*/
createIcon('setting-alt', SVG$4y);

var SVG$4z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M757.97 629.497c-33.366 0-63.919 11.3-88.459 30.165L416.405 507.818c1.212-7.76 2.085-15.713 2.085-23.812 0-8.147-.873-16.053-2.085-23.812L669.511 308.35c24.54 18.865 55.093 30.165 88.459 30.165 80.311 0 145.491-65.131 145.491-145.491S838.281 47.533 757.97 47.533s-145.491 65.131-145.491 145.491c0 8.099.873 16.053 2.134 23.812L361.507 368.728c-24.539-18.915-55.141-30.214-88.507-30.214-80.36 0-145.491 65.131-145.491 145.491 0 80.311 65.131 145.491 145.491 145.491 33.366 0 63.968-11.3 88.507-30.165l253.106 151.844c-1.261 7.76-2.134 15.664-2.134 23.812 0 80.311 65.18 145.491 145.491 145.491s145.491-65.18 145.491-145.491-65.18-145.49-145.491-145.49z"
  }));
});

/**
* @file 图标share
* @author zhanglili
*/
var IconShare =
/*#__PURE__*/
createIcon('share', SVG$4z);

var SVG$4A = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M469 156.6l-.1 170-10.4 1.1c-185.6 23.8-329 182.4-329 374.5 0 14.8.9 29.3 2.6 43.5l13.6 111 57-96.3 9.6-15.3c56-85.4 143.5-145.3 243.3-166.3l13.3-2.5.2 180 424.1-299.9L469 156.6zm76.2 147.1l216.1 152.8-216.1 152.8V492.8l-40.6 2.7-19.9 1.7c-99 10.8-190.2 53.2-261.6 118.7l-6.4 6 2.7-9.2c38-122.7 152.5-211.8 287.7-211.8h38.1v-97.2z"
  }));
});

/**
* @file 图标share-to
* @author zhanglili
*/
var IconShareTo =
/*#__PURE__*/
createIcon('share-to', SVG$4A);

var SVG$4B = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M339.2 525.3c-152.7.1-211.1 50-244.4 94.1 4.9-35.3 19.1-77.8 50.1-112.6 41.2-46.2 107.5-70.5 194.4-70.5 8.4 0 15.3-6.6 15.3-14.7v-66.3l158.5 126.1-158.6 127.1V540c0-3.9-1.6-7.7-4.5-10.4-2.9-2.8-6.8-4.3-10.8-4.3m-259 181h.5c7.7-.2 12.6-6.1 13.2-13.5.5-5.5 15.7-138 229.5-137.8l.5 84.7c0 5.7 3.4 10.9 8.7 13.3 5.3 2.5 11.7 1.7 16.2-2l197.9-158.6c3.5-2.8 5.6-7 5.6-11.4s-2.1-8.6-5.6-11.4l-197.9-157c-4.5-3.6-10.9-4.3-16.2-1.9-5.3 2.5-8.7 7.6-8.7 13.3l-.5 82.8c-88.7 2.7-157.4 30.3-201.9 80.7C49 569.5 65.2 688.7 66 693.7c1.2 7.3 6.7 12.6 14.2 12.6M796 472.9H684.8v-98.7c0-13.4-11.4-24.3-25.5-24.3s-25.5 10.9-25.5 24.3v246.5c0 13.4 11.4 24.3 25.5 24.3s25.5-10.9 25.5-24.3V522H796v98.7c0 13.4 11.4 24.3 25.5 24.3h.5c14.1 0 25.5-10.9 25.5-24.3V374.2c0-13.4-11.4-24.3-25.5-24.3h-.5c-14.1 0-25.5 10.9-25.5 24.3v98.7zM933.9 350c-14 0-25.4 11.2-25.4 25.1v183.8c0 13.9 11.4 25.1 25.4 25.1s25.4-11.2 25.4-25.1V375.1c0-13.9-11.4-25.1-25.4-25.1m0 244.2c-14 0-25.4 11.4-25.4 25.4 0 14 11.4 25.4 25.4 25.4 14 0 25.4-11.4 25.4-25.4 0-14.1-11.4-25.4-25.4-25.4"
  }));
});

/**
* @file 图标share-to-hi
* @author zhanglili
*/
var IconShareToHi =
/*#__PURE__*/
createIcon('share-to-hi', SVG$4B);

var SVG$4C = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M270 365v75.7l-4.6.5c-82.7 10.6-146.5 81.3-146.5 166.8 0 6.6.4 13.1 1.2 19.4l6.1 49.5 25.4-42.9 4.3-6.8c25-38 63.9-64.7 108.4-74.1l5.9-1.1.1 80.2L459 498.5 270 365zm33.9 65.5l96.2 68-96.2 68v-51.9l-18.1 1.2-8.9.8c-44.1 4.8-84.7 23.7-116.5 52.9l-2.8 2.7 1.2-4.1c17-54.6 68-94.3 128.2-94.3h17l-.1-43.3z"
  }), React.createElement("path", {
    d: "M648 555.6c-108 26.3-162.7-2.1-164.2-2.7-9.3-4-13.6-2.7-17.5 5.2-.8 1.5-5.6 14.7-9.1 23.5-.4 1.1-1.1 2.8-1.1 4.7v.2c0 3 1.6 6.7 7.7 9.5 11.2 5 38.3 14.8 81.3 16.3 9.8 1.5 11.6 8.4 8.9 17L538.8 679c-4.3 15.2 5.1 22.7 14.7 22.7h.2c3.9 0 7.7-1.3 10.8-3.7 2.3-1.9 103.1-85.4 103.1-85.4 8.5-7.7 23.7-19.8 39.9-22.3 68.8-8.5 108.1 4.3 115.1 6.9 4.5 1.7 9.6 3.2 14.6-5.2 2.1-3.6 10-25 10.1-30.3.2-5.9-5.5-7.9-7.4-8.5-.1 0-.2-.1-.2-.1-8.1-2.8-23.6-7.3-46.2-9.7-9.8-1.1-21.6-1.9-35.5-1.9-28.5 0-65.5 3.3-110 14.1",
    mask: "url(#mask-2_2_)",
    transform: "translate(19 17.757)"
  }), React.createElement("path", {
    d: "M656.9 460.9c-108 26.3-162.7-2.1-164.2-2.7-9.3-4-13.6-2.7-17.5 5.2-.8 1.5-5.6 14.7-9.1 23.5-1.1 2.7-3.6 9.7 6.7 14.5 12.2 5.5 43 16.5 92.6 16.5 30.7 0 63.6-4.2 98-12.6 101.7-24.7 159.3-6.1 168.1-2.8 4.5 1.7 9.6 3.2 14.6-5.2 2.1-3.6 10-25 10.1-30.3.2-5.9-5.5-7.9-7.4-8.5-.1 0-.2-.1-.2-.1-8.1-2.8-23.6-7.3-46.2-9.7-9.8-1.1-21.6-1.9-35.5-1.9-28.6 0-65.5 3.3-110 14.1",
    mask: "url(#mask-4_2_)",
    transform: "translate(19.259 14.879)"
  }), React.createElement("path", {
    d: "M663.2 366.9c-108 26.3-162.7-2.1-164.2-2.7-9.3-4-13.6-2.7-17.5 5.2-.8 1.5-5.6 14.7-9.1 23.5-1.1 2.7-3.6 9.7 6.7 14.5 12.2 5.5 43 16.5 92.6 16.5 30.7 0 63.6-4.2 98-12.6 101.7-24.7 159.3-6.1 168.1-2.8 4.5 1.7 9.6 3.2 14.6-5.2 2.1-3.6 10-25 10.1-30.3.2-5.9-5.5-7.9-7.4-8.5-.1 0-.2-.1-.2-.1-8.1-2.8-23.6-7.3-46.2-9.7-9.8-1.1-21.6-1.9-35.5-1.9-28.6 0-65.5 3.3-110 14.1",
    mask: "url(#mask-6_2_)",
    transform: "translate(19.453 12)"
  }));
});

/**
* @file 图标share-to-ruliu
* @author zhanglili
*/
var IconShareToRuliu =
/*#__PURE__*/
createIcon('share-to-ruliu', SVG$4C);

var SVG$4D = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M76.3 117.8H42.8c-3.2 0-5.8 2.6-5.8 5.8v1c0 3.2 2.6 5.8 5.8 5.8h17.7l-33.4 33.4c-2.2 2.2-2.2 5.9 0 8.2l.7.6c2.2 2.2 5.9 2.2 8.2 0l33.7-33.7v19c0 3.2 2.6 5.8 5.8 5.8h1c3.2 0 5.8-2.6 5.8-5.8v-33.6c0-.9-.2-1.7-.5-2.4-.7-2.5-2.9-4.2-5.5-4.1zm48.9-36.5h33.6c3.2 0 5.8-2.6 5.8-5.8v-1c0-3.2-2.6-5.8-5.8-5.8h-18l33.5-33.4c2.2-2.2 2.2-5.9 0-8.2l-.6-.6c-2.2-2.2-5.9-2.2-8.2 0l-33.8 33.7v-19c0-3.2-2.6-5.8-5.8-5.8h-1c-3.2 0-5.8 2.6-5.8 5.8v33.6c.2.9.3 1.7.6 2.4.8 2.5 3 4.2 5.5 4.1z"
  }));
});

/**
* @file 图标shrink-arrow
* @author zhanglili
*/
var IconShrinkArrow =
/*#__PURE__*/
createIcon('shrink-arrow', SVG$4D);

var SVG$4E = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M127.9 89.5c0 3.4-2.8 6.2-6.2 6.2H62.3c-3.4 0-6.2-2.8-6.2-6.2s2.8-6.2 6.2-6.2h59.3c3.5-.1 6.3 2.7 6.3 6.2zm40.7 77.6c-2.4 2.4-6.4 2.4-8.8 0l-28.2-28c-10.9 8.8-24.7 14.2-39.8 14.2-34.8 0-63.1-28.3-63.1-63.1S57 27.1 91.8 27.1s63.1 28.3 63.1 63.1c0 15.2-5.4 29.2-14.4 40.1l28.1 28c2.4 2.4 2.5 6.4 0 8.8zm-25.7-76.9c0-28.2-22.9-51.1-51.1-51.1S40.7 62 40.7 90.2c0 28.2 22.9 51.1 51.1 51.1s51.1-23 51.1-51.1z"
  }));
});

/**
* @file 图标shrink-glass
* @author zhanglili
*/
var IconShrinkGlass =
/*#__PURE__*/
createIcon('shrink-glass', SVG$4E);

var SVG$4F = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M704.1 255.8H320.7c-141.2 0-255.6 114.4-255.6 255.6S179.5 767 320.7 767h383.5c141.1 0 255.5-114.4 255.5-255.6S845.3 255.8 704.1 255.8zm-340.8 426c-94.1 0-170.4-76.3-170.4-170.4S269.2 341 363.3 341s170.4 76.3 170.4 170.4-76.3 170.4-170.4 170.4z"
  }));
});

/**
* @file 图标shutdown
* @author zhanglili
*/
var IconShutdown =
/*#__PURE__*/
createIcon('shutdown', SVG$4F);

var SVG$4G = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M704.1 255.8H320.7c-141.2 0-255.6 114.4-255.6 255.6S179.5 767 320.6 767h383.5c141.2 0 255.6-114.4 255.6-255.6S845.3 255.8 704.1 255.8zm-42.6 426c-94.1 0-170.4-76.3-170.4-170.4S567.4 341 661.5 341s170.4 76.3 170.4 170.4-76.3 170.4-170.4 170.4z"
  }));
});

/**
* @file 图标shutup
* @author zhanglili
*/
var IconShutup =
/*#__PURE__*/
createIcon('shutup', SVG$4G);

var SVG$4H = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M959.33 511.19c0-246.93-200.12-447.05-447.05-447.05S65.23 264.26 65.23 511.19s200.12 447.05 447.05 447.05c246.94 0 447.05-200.12 447.05-447.05zm-829.8 0c0-211.37 171.39-382.76 382.76-382.76s382.75 171.39 382.75 382.76-171.39 382.76-382.75 382.76-382.76-171.39-382.76-382.76zm386.8-224.63c-3.92-3.92-10.35-3.92-14.17 0l-32.25 32.25c-3.92 3.92-3.92 10.25 0 14.16l174.3 174.2-174.3 174.2c-3.92 3.92-3.92 10.25 0 14.16l32.25 32.25a10.007 10.007 0 0 0 14.17 0l174.3-174.2 46.31-46.41-46.31-46.41-174.3-174.2zM346.52 457.95h112.52v112.52H346.52V457.95z"
  }));
});

/**
* @file 图标skip
* @author zhanglili
*/
var IconSkip =
/*#__PURE__*/
createIcon('skip', SVG$4H);

var SVG$4I = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "1024",
    height: "1024"
  }, props), React.createElement("path", {
    d: "M512 64c247.424 0 448 200.576 448 448S759.424 960 512 960 64 759.424 64 512 264.576 64 512 64zm0 64c-212.077 0-384 171.923-384 384s171.923 384 384 384 384-171.923 384-384-171.923-384-384-384zm170 177v220.698l61.752-61.752 45.255 45.255L649 649.208 508.993 509.201l45.255-45.255L618 527.698V369H407v337h-64V305h339z"
  }));
});

/**
* @file 图标skiped
* @author zhanglili
*/
var IconSkiped =
/*#__PURE__*/
createIcon('skiped', SVG$4I);

var SVG$4J = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 812.83 765.58"
  }, props), React.createElement("path", {
    d: "M155.61 418.73a28.36 28.36 0 0 1-27.12 20.06H28.35a28.36 28.36 0 0 1 0-56.71h79.15l47.57-155.86c8.48-27.78 48.29-26.35 54.76 2l56.05 245.36 113.08-452.1c7.58-30.34 51.48-27.86 55.61 3.13l76.38 572.81 104.46-370.63c7.76-27.49 46.7-27.57 54.55-.11l44.47 155.38h70a28.36 28.36 0 0 1 0 56.71h-91.38a28.37 28.37 0 0 1-27.27-20.55l-22.88-80-114.68 406.7c-8.36 29.64-51.33 26.57-55.4-4l-74.86-561.7-105.81 423.11c-7.19 28.94-48.51 28.51-55.19-.54l-58.71-257.21z"
  }));
});

/**
* @file 图标sla-target-value
* @author zhanglili
*/
var IconSLATargetValue =
/*#__PURE__*/
createIcon('sla-target-value', SVG$4J);

var SVG$4K = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M510 66c246.9 0 447 200.1 447 447S756.9 960 510 960 63 759.9 63 513 263.1 66 510 66zm278.6 264.7c-16.4-16.6-34.5-4.8-50.9 11.8L472.9 578.3 358.2 502c-16.4-16.6-43-16.6-59.4 0s-16.4 37.1 0 53.7L443.2 702c16.4 16.6 43 16.6 59.4 0l276-317.9c16.3-16.6 26.4-36.8 10-53.4z"
  }));
});

/**
* @file 图标standard
* @author zhanglili
*/
var IconStandard =
/*#__PURE__*/
createIcon('standard', SVG$4K);

var SVG$4L = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M171.455 81.791c-1.181-3.616-4.502-6.273-8.486-6.863l-36.678-5.314-2.804-5.682c-1.402-2.73-4.87-3.986-7.601-2.73-1.329.664-2.288 1.919-2.878 3.321-.516 1.402 0 3.468.664 4.797l2.73 5.534c1.475 3.025 4.428 5.166 7.675 5.534l35.719 5.24-25.756 25.165c-2.436 2.288-3.468 5.682-2.878 9.004l6.125 35.571-31.881-16.826c-1.475-.738-3.1-1.181-4.723-1.181s-3.173.369-4.723 1.181l-31.881 16.752 6.125-35.571c.591-3.321-.516-6.716-2.878-9.004L41.199 85.628l35.719-5.166c3.321-.516 6.199-2.583 7.675-5.534l16.015-32.398 2.804 5.682c1.402 2.73 4.87 4.059 7.601 2.804 1.329-.664 2.657-1.771 3.1-3.1s-.148-3.395-.812-4.723l-3.468-7.011c-1.697-3.543-5.24-5.682-9.225-5.682-3.764 0-7.38 2.361-9.151 5.904l-16.678 33.21-36.752 5.313c-4.059.591-7.306 3.247-8.486 6.863-1.255 3.838-.295 7.897 2.583 10.627l26.789 26.124-6.347 36.9c-.664 3.838.886 7.675 4.059 10.036 3.1 2.288 7.084 2.657 10.701.812l33.135-17.417 33.135 17.417c1.475.812 3.1 1.181 4.797 1.181 2.066 0 4.207-.664 5.977-1.919 3.173-2.288 4.723-6.125 4.059-10.036l-6.347-36.899 27.01-26.199c2.658-2.73 3.617-6.789 2.363-10.626z"
  }));
});

/**
* @file 图标star-dash
* @author zhanglili
*/
var IconStarDash =
/*#__PURE__*/
createIcon('star-dash', SVG$4L);

var SVG$4M = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M10.05 2a.17.17 0 0 1 .17.13l2.54 5.2L18.4 8a.18.18 0 0 1 .1.33L14.11 12l1.27 5.76a.17.17 0 0 1-.06.2.2.2 0 0 1-.22 0l-5-2.95L5 18a.2.2 0 0 1-.22 0 .19.19 0 0 1-.07-.2L6 12 1.59 8.3a.19.19 0 0 1-.07-.2.18.18 0 0 1 .13-.1l5.69-.65 2.53-5.2a.19.19 0 0 1 .18-.15z"
  }))));
});

/**
* @file 图标star-filled
* @author zhanglili
*/
var IconStarFilled =
/*#__PURE__*/
createIcon('star-filled', SVG$4M);

var SVG$4N = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M770.363 935.738a28.131 28.131 0 0 1-13.102-3.235L511.763 803.437 266.267 932.503c-13.767 7.238-30.796 1.946-38.035-11.822a28.165 28.165 0 0 1-2.83-17.869l46.886-273.364L73.678 435.85c-11.139-10.856-11.368-28.686-.513-39.825a28.16 28.16 0 0 1 16.122-8.214l274.473-39.883L486.509 99.213c6.882-13.948 23.768-19.676 37.716-12.794a28.162 28.162 0 0 1 12.794 12.794l122.748 248.715 274.473 39.883c15.393 2.239 26.058 16.533 23.819 31.926a28.17 28.17 0 0 1-8.21 16.113l-198.61 193.598 46.885 273.364c2.63 15.33-7.666 29.89-22.997 32.52a28.078 28.078 0 0 1-4.764.406zm-258.6-192.283c4.502 0 9.003 1.078 13.105 3.235L732.96 856.092l-39.742-231.713a28.158 28.158 0 0 1 8.1-24.929l168.349-164.1-232.653-33.806a28.163 28.163 0 0 1-21.205-15.406L511.763 175.316l-104.046 210.82a28.164 28.164 0 0 1-21.205 15.407L153.86 435.349l168.349 164.099a28.17 28.17 0 0 1 8.1 24.929L290.567 856.09l208.09-109.401a28.151 28.151 0 0 1 13.106-3.234z"
  }));
});

/**
* @file 图标star-o
* @author zhanglili
*/
var IconStarO =
/*#__PURE__*/
createIcon('star-o', SVG$4N);

var SVG$4O = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    "data-name": "\u56FE\u5C42 2"
  }, React.createElement("g", {
    "data-name": "\u56FE\u5C42 1"
  }, React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "none"
  }), React.createElement("path", {
    d: "M10.05 2a.17.17 0 0 1 .17.13l2.54 5.2L18.4 8a.18.18 0 0 1 .1.33L14.11 12l1.27 5.76a.17.17 0 0 1-.06.2.2.2 0 0 1-.22 0l-5-2.95L5 18a.2.2 0 0 1-.22 0 .19.19 0 0 1-.07-.2L6 12 1.59 8.3a.19.19 0 0 1-.07-.2.18.18 0 0 1 .13-.1l5.69-.65 2.53-5.2a.19.19 0 0 1 .18-.15zm1.72 6.73L10.05 5.2 8.33 8.73l-3.43.39 2.75 2.32-.82 3.72 3.22-1.88 3.22 1.88-.82-3.72 2.74-2.32z"
  }))));
});

/**
* @file 图标star-outlined
* @author zhanglili
*/
var IconStarOutlined =
/*#__PURE__*/
createIcon('star-outlined', SVG$4O);

var SVG$4P = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M109.5 32.8l14.8 30.1c1.6 3.2 4.6 5.4 8.2 5.9l33.2 4.8c8.9 1.3 12.5 12.2 6 18.5l-24 23.4c-2.6 2.5-3.7 6.1-3.1 9.6l5.7 33.1c1.5 8.9-7.8 15.6-15.7 11.4L104.9 154c-3.2-1.7-6.9-1.7-10.1 0l-29.7 15.6c-8 4.2-17.3-2.6-15.7-11.4l5.7-33.1c.6-3.5-.6-7.1-3.1-9.6L28 92.1c-6.4-6.3-2.9-17.2 6-18.5l33.2-4.8c3.5-.5 6.6-2.7 8.2-5.9l14.8-30.1c3.9-8.1 15.4-8.1 19.3 0z"
  }));
});

/**
* @file 图标star-solid
* @author zhanglili
*/
var IconStarSolid =
/*#__PURE__*/
createIcon('star-solid', SVG$4P);

var SVG$4Q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.9 65.2c247.5 0 448 200.6 448 448 0 247.5-200.5 448-448 448s-448-200.5-448-448 200.5-448 448-448zm0 831.6c211.8 0 383.6-171.6 383.6-383.6 0-211.8-171.8-383.6-383.6-383.6S128.3 301.4 128.3 513.2s171.8 383.6 383.6 383.6zm1.5-124.3c-142.1 0-257.2-115.1-257.2-257s115.2-257 257.2-257 257.2 115.1 257.2 257-115.1 257-257.2 257z"
  }));
});

/**
* @file 图标static-circle-o
* @author zhanglili
*/
var IconStaticCircleO =
/*#__PURE__*/
createIcon('static-circle-o', SVG$4Q);

var SVG$4R = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M116.9 925.9h760v39.3l78.9-70.8c1.8-1.6 1.8-4.3 0-5.9l-79.6-73.4-.2 41.5H173.5V195.3h47.7l-75.7-90.7c-1.6-1.9-4.6-1.9-6.2 0l-74.9 90.7H106l.9 720.6c0 5.5 4.5 10 10 10zm381.6-428.1v101.7c0 2-2.4 3.7-5.4 3.7H254.9c-3 0-5.4-1.7-5.4-3.7V497.8c0-2 2.4-3.7 5.4-3.7H493c3.1 0 5.5 1.7 5.5 3.7zm0 172.7v101.7c0 2-2.4 3.7-5.4 3.7H254.9c-3 0-5.4-1.7-5.4-3.7V670.5c0-2 2.4-3.7 5.4-3.7H493c3.1 0 5.5 1.7 5.5 3.7zm-10-284.5h-229c-5.5 0-10-4.5-10-10V249c0-5.5 4.5-10 10-10h229c5.5 0 10 4.5 10 10v127c0 5.5-4.5 10-10 10z"
  }), React.createElement("path", {
    d: "M808.5 498.7v101.7c0 2-2.4 3.7-5.4 3.7H564.9c-3 0-5.4-1.7-5.4-3.7V498.7c0-2 2.4-3.7 5.4-3.7H803c3.1 0 5.5 1.7 5.5 3.7zm0 172.7v101.7c0 2-2.4 3.7-5.4 3.7H564.9c-3 0-5.4-1.7-5.4-3.7V671.4c0-2 2.4-3.7 5.4-3.7H803c3.1 0 5.5 1.7 5.5 3.7zm-10-284.4h-229c-5.5 0-10-4.5-10-10V250c0-5.5 4.5-10 10-10h229c5.5 0 10 4.5 10 10v127c0 5.5-4.5 10-10 10z"
  }));
});

/**
* @file 图标story-mapping
* @author zhanglili
*/
var IconStoryMapping =
/*#__PURE__*/
createIcon('story-mapping', SVG$4R);

var SVG$4S = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "none",
    d: "M595.6 827.9l319.7-319.7c15.1-15.1 15.1-39.5 0-54.6-15.1-15.1-39.5-15.1-54.6 0L540.9 773.2c-15.1 15.1-15.1 39.5 0 54.6 15.1 15.1 39.6 15.1 54.7.1z"
  }), React.createElement("path", {
    d: "M169.6 916.3l743-729.1c16.6-16.3 16.9-43 .6-59.6-16.3-16.6-43-16.9-59.6-.6l-743 729.1c-16.6 16.3-16.9 43-.6 59.6 16.4 16.7 43 16.9 59.6.6zm394.6-.2l348.7-348.7c16.5-16.5 16.5-43.1 0-59.6s-43.1-16.5-59.6 0L504.6 856.5c-16.5 16.5-16.5 43.1 0 59.6 16.4 16.4 43.1 16.4 59.6 0z"
  }));
});

/**
* @file 图标stretch
* @author zhanglili
*/
var IconStretch =
/*#__PURE__*/
createIcon('stretch', SVG$4S);

var SVG$4T = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M951.7 509.5c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.2 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z"
  }), React.createElement("path", {
    d: "M475.3 686.8L289.5 536.6c-1.8-1.4-2-4.1-.4-5.8l47.3-52c1.4-1.6 3.8-1.8 5.5-.4l129 104.5L683.4 331c1.4-1.7 3.9-1.9 5.6-.5l56.4 46.3c1.7 1.4 2 4 .5 5.7l-265 303.8c-1.5 1.6-3.9 1.8-5.6.5z"
  }));
});

/**
* @file 图标success-circle-o
* @author zhanglili
*/
var IconSuccessCircleO =
/*#__PURE__*/
createIcon('success-circle-o', SVG$4T);

var SVG$4U = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.4 65.2c-247 0-447.2 200.2-447.2 447.2s200.2 447.2 447.2 447.2 447.2-200.2 447.2-447.2S758.4 65.2 511.4 65.2zm-29.3 624.2L294.7 537.9c-1.3-1.1-1.5-3.1-.3-4.4l48.7-53.5c1.1-1.2 2.9-1.3 4.1-.3l129.7 105.1L690 332.3c1.1-1.3 2.9-1.4 4.2-.4l57.9 47.6c1.3 1.1 1.5 3 .4 4.3L486.2 689c-1.1 1.2-2.9 1.4-4.1.4z"
  }));
});

/**
* @file 图标success-solid
* @author zhanglili
*/
var IconSuccessSolid =
/*#__PURE__*/
createIcon('success-solid', SVG$4U);

var SVG$4V = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M788.4 684.2L520.7 344.4c-4.8-6.1-12.7-6.1-17.5 0L235.6 684.2"
  }));
});

/**
* @file 图标sup-solid
* @author zhanglili
*/
var IconSUpSolid =
/*#__PURE__*/
createIcon('sup-solid', SVG$4V);

var SVG$4W = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M728.9 950.6L502.1 639.8l146.4-1.8-2.9-448 168.8-4.1-.2 454.2 146.2 2.6-231.5 307.9zM291 72.9L64.2 383.8l146.4 1.8-2.9 448 168.8 4.1-.2-454.2 146.2-2.6L291 72.9z"
  }));
});

/**
* @file 图标swap
* @author zhanglili
*/
var IconSwap =
/*#__PURE__*/
createIcon('swap', SVG$4W);

var SVG$4X = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M744 482.5L404.1 142.6H64.2v339.9l339.9 339.9s102 102 204 0l136-136c-.1 0 101.9-102-.1-203.9zm-543.9-136c-37.5 0-68-30.4-68-68 0-37.5 30.4-68 68-68s68 30.4 68 68-30.4 68-68 68z"
  }), React.createElement("path", {
    d: "M914 482.5L574.1 142.6c-68-34-68 34-68 34S738.5 408.9 846 516.5c28.4 28.4 68 68 0 136l-170 170c-34 68 34 68 34 68l204-204c102-102.1 0-204 0-204z"
  }));
});

/**
* @file 图标tag
* @author zhanglili
*/
var IconTag =
/*#__PURE__*/
createIcon('tag', SVG$4X);

var SVG$4Y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.6 1000.7"
  }, props), React.createElement("path", {
    d: "M874.2 394.3L857 229.4c-2.3-21.5-5.2-32.7-12-44.3-2.3-3.9-4.9-7.6-7.8-10.9-1.8-1.9-3.5-3.8-5.4-5.6-2.1-1.9-4.2-3.8-6.6-5.5-2.1-1.5-4.2-3-6.5-4.2-11.7-6.7-22.8-9.6-44.4-11.7l-163.3-16c-15.2-1.5-22.8-1.6-31.4-.1-2.3.4-4.5.8-6.6 1.4-2.1.5-4 1.1-5.9 1.8-1.8.7-3.7 1.4-5.5 2.3-2.1 1-4.2 2.1-6.2 3.3-7.6 4.5-13.4 9.3-24.2 20.1L157.6 533.4c-17.3 17.3-24.7 28.3-29.2 43.1-2.3 7.4-3.3 14.8-3.1 22.3.1 6.5 1.2 13.1 3.1 19.5 4.5 14.8 11.9 25.7 29.2 43.1l186.9 186.9c17.3 17.3 28.3 24.7 43.1 29.2 4 1.2 8 2.1 12 2.5 3 .4 6.1.6 9.1.6 2.4 0 4.7-.1 7-.4 4.7-.4 9.3-1.4 13.9-2.8 14.8-4.5 25.7-11.9 43.1-29.2L800.8 520c5.8-5.8 8.2-13.7 7.2-21.2-.4-2.8-1.1-5.5-2.4-8.1-1.3-2.4-2.8-4.7-4.8-6.6-2.8-2.8-6.2-4.9-9.8-6.1s-7.4-1.6-11.1-1.2c-5.4.6-10.8 3-15.1 7.3L436.6 812.4c-11.9 11.9-16.2 14.8-21.8 16.5-2.2.6-4.3.9-6.4.9-2 0-4-.3-6-.9-5.7-1.7-10-4.6-21.8-16.5l-187-187c-11.9-11.9-14.8-16.2-16.5-21.8-.4-1.4-.7-2.8-.8-4.2-.3-2.7.1-5.4.8-8.2 1.7-5.7 4.6-10 16.5-21.8L567 195.8c8.1-8.1 10.7-10.3 13.8-12.1 1.6-.8 2.9-1.5 4.5-1.9.8-.3 1.7-.4 2.5-.6 3.5-.6 7-.5 18.2.6l163.3 16.1c15.1 1.5 19.5 2.7 24.1 5.3 1.7 1 3.2 2.1 4.5 3.3 1.3 1.3 2.4 2.7 3.4 4.4 2.7 4.5 3.9 9.1 5.4 24.1l17 164.5c1.3 11.3 1.3 14.8.7 18.4-1.1 7.4.9 14.5 5.3 19.9 3.8 4.8 9.3 8.2 15.8 9.2 7.1 1.1 13.9-.7 19.2-4.7 5.1-3.8 8.7-9.5 9.8-16.3 1.4-9 1.3-16.4-.3-31.7z"
  }), React.createElement("path", {
    d: "M607.2 290.9c-29.8 29.8-29.8 78 0 107.8 29.7 29.7 78 29.8 107.8 0 29.8-29.8 29.8-78 0-107.8-29.8-29.8-78-29.8-107.8 0zm71.8 71.9c-9.9 9.9-26 9.9-35.9 0s-9.9-26 0-35.9c9.9-9.9 26-9.9 35.9 0s9.9 26 0 35.9z"
  }));
});

/**
* @file 图标tag-o
* @author zhanglili
*/
var IconTagO =
/*#__PURE__*/
createIcon('tag-o', SVG$4Y);

var SVG$4Z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M810.1 927.23l.61-118.17 116.95.61-68.92-68.93a413.647 413.647 0 0 0 68.92-229.17C927.66 282 741.57 95.91 512 95.91 282.43 95.91 96.34 282 96.34 511.57c0 229.57 186.09 415.66 415.66 415.66 81.51.11 161.24-23.86 229.17-68.92l68.93 68.92zm-48.7-415.66c.01 56.55-19.3 111.4-54.73 155.47l-39.53-39.53c24.28-32.38 38.84-72.45 38.84-115.94 0-106.97-87.01-193.98-193.97-193.98-106.97 0-193.98 87.01-193.98 193.98 0 106.96 87.01 193.97 193.98 193.97 41.84-.02 82.54-13.65 115.95-38.84l39.53 39.53c-42.69 34.15-96.7 54.73-155.48 54.73-137.52 0-249.4-111.88-249.4-249.39 0-137.52 111.88-249.4 249.4-249.4 137.5 0 249.39 111.88 249.39 249.4zM573.23 611.98a117.038 117.038 0 0 1-61.22 17.36c-64.94 0-117.77-52.83-117.77-117.77S447.07 393.8 512.01 393.8s117.77 52.83 117.77 117.77a116.92 116.92 0 0 1-17.36 61.22l-52.78-52.77c.5-2.76.86-5.56.86-8.45 0-26.74-21.76-48.5-48.49-48.5-26.74 0-48.5 21.76-48.5 48.5s21.75 48.49 48.5 48.49c2.83-.03 5.66-.32 8.45-.86l52.77 52.78z",
    clipRule: "evenodd"
  }));
});

/**
* @file 图标target
* @author zhanglili
*/
var IconTarget =
/*#__PURE__*/
createIcon('target', SVG$4Z);

var SVG$4_ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("use", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    overflow: "visible",
    xlinkHref: "#a"
  }));
});

/**
* @file 图标task
* @author zhanglili
*/
var IconTask =
/*#__PURE__*/
createIcon('task', SVG$4_);

var SVG$4$ = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M920 704.2H106c-4.4 0-8 3.6-8 8v175.4c0 4.4 3.6 8 8 8h814c4.4 0 8-3.6 8-8V712.2c0-4.4-3.6-8-8-8zm-87 124.7c0 2.2-1.8 4-4 4H580.1c-2.2 0-4-1.8-4-4v-57c0-2.2 1.8-4 4-4H829c2.2 0 4 1.8 4 4v57zm88-409.7H107c-4.4 0-8 3.6-8 8v175.4c0 4.4 3.6 8 8 8h814c4.4 0 8-3.6 8-8V427.2c0-4.4-3.6-8-8-8zm-87 124.7c0 2.2-1.8 4-4 4H581.1c-2.2 0-4-1.8-4-4v-57c0-2.2 1.8-4 4-4H830c2.2 0 4 1.8 4 4v57zm87-415.7H107c-4.4 0-8 3.6-8 8v175.4c0 4.4 3.6 8 8 8h814c4.4 0 8-3.6 8-8V136.2c0-4.4-3.6-8-8-8zm-87 124.7c0 2.2-1.8 4-4 4H581.1c-2.2 0-4-1.8-4-4v-57c0-2.2 1.8-4 4-4H830c2.2 0 4 1.8 4 4v57z"
  }));
});

/**
* @file 图标task-solid
* @author zhanglili
*/
var IconTaskSolid =
/*#__PURE__*/
createIcon('task-solid', SVG$4$);

var SVG$50 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M409 512.3c-57.2 0-103.5-46.4-103.5-103.5S351.8 305.2 409 305.2s103.5 46.4 103.5 103.5S466.1 512.3 409 512.3zm0-51.7c28.6 0 51.8-23.2 51.8-51.8 0-28.6-23.2-51.8-51.8-51.8-28.6 0-51.8 23.2-51.8 51.8 0 28.6 23.2 51.8 51.8 51.8zM201.9 305.2c-57.2 0-103.5-46.4-103.5-103.5S144.7 98.2 201.9 98.2s103.5 46.4 103.5 103.5S259 305.2 201.9 305.2zm0-51.7c28.6 0 51.8-23.2 51.8-51.8s-23.2-51.8-51.8-51.8-51.8 23.2-51.8 51.8 23.2 51.8 51.8 51.8zm621.2 258.8c-57.2 0-103.5-46.4-103.5-103.5S766 305.3 823.1 305.3s103.5 46.4 103.5 103.5-46.3 103.5-103.5 103.5zm0-51.7c28.6 0 51.8-23.2 51.8-51.8 0-28.6-23.2-51.8-51.8-51.8s-51.8 23.2-51.8 51.8c.1 28.6 23.2 51.8 51.8 51.8zm0 465.9c-57.2 0-103.5-46.4-103.5-103.5 0-57.2 46.4-103.5 103.5-103.5S926.7 765.8 926.7 823c0 57.1-46.4 103.5-103.6 103.5zm0-51.8c28.6 0 51.8-23.2 51.8-51.8 0-28.6-23.2-51.8-51.8-51.8s-51.8 23.2-51.8 51.8c.1 28.7 23.2 51.8 51.8 51.8zM409 926.5c-57.2 0-103.5-46.4-103.5-103.5 0-57.2 46.4-103.5 103.5-103.5S512.5 765.8 512.5 823c0 57.1-46.4 103.5-103.5 103.5zm0-51.8c28.6 0 51.8-23.2 51.8-51.8 0-28.6-23.2-51.8-51.8-51.8-28.6 0-51.8 23.2-51.8 51.8 0 28.7 23.2 51.8 51.8 51.8z"
  }), React.createElement("path", {
    d: "M564.3 408.8c0-14.3 11.6-25.9 25.9-25.9h159.9v51.8H590.2c-14.3 0-25.9-11.6-25.9-25.9zm-77.7 440v-51.7h263.7v51.7zM849 726.1h-51.8V486.4H849zm-414.6 18.6h-51.8V485.8h51.8zM318.2 382.9v51.8h-90.5c-28.6 0-51.8-23.2-51.8-51.8V279.4h51.8v103.5h90.5z"
  }));
});

/**
* @file 图标technological-process
* @author zhanglili
*/
var IconTechnologicalProcess =
/*#__PURE__*/
createIcon('technological-process', SVG$50);

var SVG$51 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512.9 757.9v67c0 5.5-4.5 10-10 10H74.8c-5.5 0-10-4.5-10-10v-67c0-5.5 4.5-10 10-10h428.1c5.5 0 10 4.5 10 10zm448-186v67c0 5.5-4.5 10-10 10H74.8c-5.5 0-10-4.5-10-10v-67c0-5.5 4.5-10 10-10h876.1c5.5 0 10 4.5 10 10zm0-186v67c0 5.5-4.5 10-10 10H74.8c-5.5 0-10-4.5-10-10v-67c0-5.5 4.5-10 10-10h876.1c5.5 0 10 4.5 10 10zm0-186v67c0 5.5-4.5 10-10 10H74.8c-5.5 0-10-4.5-10-10v-67c0-5.5 4.5-10 10-10h876.1c5.5 0 10 4.5 10 10z"
  }));
});

/**
* @file 图标text
* @author zhanglili
*/
var IconText =
/*#__PURE__*/
createIcon('text', SVG$51);

var SVG$52 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M621.6 636.1H878c44.7 0 81.3-36.6 81.3-81.3v-81.3c0-10.6-2-20.3-5.7-29.7L830.9 157.3c-12.2-29.3-41.1-49.6-74.8-49.6H390.3c-44.7 0-81.3 36.6-81.3 81.3v406.5c0 22.4 8.9 42.7 24 57.3l267.5 267.9 43.1-42.7c11-11 17.9-26.4 17.9-43.1l-1.2-13-38.7-185.8zm-20.5 200.8L375.2 610.6l-.6-.6c-3.8-3.7-5.9-8.7-5.9-14.6V189c0-11.8 9.9-21.7 21.7-21.7h365.8c8.9 0 16.5 5.1 20 13.4l122 284.8.7 1.8-.7-1.8c1.1 2.9 1.6 5.3 1.6 7.9v81.3c0 11.8-9.9 21.7-21.7 21.7H548.3l14.9 71.7M65.1 107.7v487.8h162.6V107.7H65.1zm0 59.6h162.6l-59.6-59.6v487.8l59.6-59.6H65.1l59.6 59.6V107.7l-59.6 59.6z"
  }));
});

/**
* @file 图标thumbdown-o
* @author zhanglili
*/
var IconThumbdownO =
/*#__PURE__*/
createIcon('thumbdown-o', SVG$52);

var SVG$53 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M64.2 106.9H227v488.2H64.2V106.9zm895.1 447.6c0 44.8-36.6 81.4-81.4 81.4H621.2l38.7 185.9 1.2 13c0 16.7-6.9 32.1-17.9 43.1l-43.1 42.7-267.8-268c-15.1-14.6-24-35-24-57.4V188.3c0-44.8 36.6-81.4 81.4-81.4h366.2c33.8 0 62.7 20.3 74.9 49.6l122.9 286.8c3.7 9.4 5.7 19.1 5.7 29.7v77.7l-.4.4.3 3.4z"
  }));
});

/**
* @file 图标thumbdown-solid
* @author zhanglili
*/
var IconThumbdownSolid =
/*#__PURE__*/
createIcon('thumbdown-solid', SVG$53);

var SVG$54 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M621.2 390.7H878c44.8 0 81.4 36.6 81.4 81.4v81.4c0 10.6-2 20.3-5.7 29.7l-123 286.9c-12.2 29.3-41.1 49.6-74.9 49.6H389.6c-44.8 0-81.4-36.6-81.4-81.4V431.4c0-22.4 9-42.7 24-57.4L600 105.9l43.1 42.7c11 11 17.9 26.5 17.9 43.1l-1.2 13-38.6 186zm-20.5-201L374.5 416.2l-.6.6c-3.8 3.7-5.9 8.7-5.9 14.6v406.9c0 11.8 9.9 21.7 21.7 21.7h366.2c8.9 0 16.5-5.1 20-13.5l122.2-285.1.1-.2-.1.2c1.1-2.9 1.6-5.3 1.6-8V472c0-11.8-9.9-21.7-21.7-21.7H547.8l14.9-71.8M64.1 919.7V431.4h162.8v488.3H64.1zm0-59.6h162.8l-59.7 59.7V431.5l59.7 59.7H64.1l59.7-59.7v488.3l-59.7-59.7z"
  }));
});

/**
* @file 图标thumbup-o
* @author zhanglili
*/
var IconThumbupO =
/*#__PURE__*/
createIcon('thumbup-o', SVG$54);

var SVG$55 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M64.8 920.1h162.8V431.6H64.8v488.5zm895.6-447.8c0-44.8-36.6-81.4-81.4-81.4H622.1l38.7-186 1.2-13c0-16.7-6.9-32.2-17.9-43.2L600.9 106 333 374.2c-15.1 14.7-24 35-24 57.4v407.1c0 44.8 36.6 81.4 81.4 81.4h366.4c33.8 0 62.7-20.4 74.9-49.7l122.9-287c3.7-9.4 5.7-19.1 5.7-29.7V476l-.4-.4.5-3.3z"
  }));
});

/**
* @file 图标thumbup-solid
* @author zhanglili
*/
var IconThumbupSolid =
/*#__PURE__*/
createIcon('thumbup-solid', SVG$55);

var SVG$56 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M951.7 509.5c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.2 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z"
  }), React.createElement("path", {
    d: "M548 540V297c0-5.5-4.5-10-10-10h-50c-5.5 0-10 4.5-10 10v303c0 5.5 4.5 10 10 10h303c5.5 0 10-4.5 10-10v-50c0-5.5-4.5-10-10-10H548z"
  }));
});

/**
* @file 图标time-circle-o
* @author zhanglili
*/
var IconTimeCircleO =
/*#__PURE__*/
createIcon('time-circle-o', SVG$56);

var SVG$57 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M506.7 64.5c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445-199.2-445-445-445zM801 600c0 5.5-4.5 10-10 10H488c-5.5 0-10-4.5-10-10V297c0-5.5 4.5-10 10-10h50c5.5 0 10 4.5 10 10v243h243c5.5 0 10 4.5 10 10v50z"
  }));
});

/**
* @file 图标time-circle-solid
* @author zhanglili
*/
var IconTimeCircleSolid =
/*#__PURE__*/
createIcon('time-circle-solid', SVG$57);

var SVG$58 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M524.437 587.739V387.678c0-4.528-3.705-8.233-8.233-8.233h-41.165c-4.528 0-8.233 3.705-8.233 8.233v249.459c0 4.528 3.705 8.233 8.233 8.233h249.459c4.528 0 8.233-3.705 8.233-8.233v-41.165c0-4.528-3.705-8.233-8.233-8.233H524.437zM369.702 76.361v40.084c0 4.528 3.705 8.233 8.233 8.233h249.459c4.528 0 8.233-3.705 8.233-8.233V75.281c0-4.528-3.705-8.233-8.233-8.233H427.333l-48.104-.178c-5.256-.02-9.527 4.236-9.527 9.491z"
  }), React.createElement("path", {
    d: "M483.252 226.411h40.084c4.528 0 8.233-3.705 8.233-8.233V94.803c0-4.528-3.705-8.233-8.233-8.233h-41.165c-4.528 0-8.233 3.705-8.233 8.233v122.081h-.178c-.019 5.256 4.236 9.527 9.492 9.527zM260.913 341.127l29.711-26.908c3.356-3.04 3.615-8.273.576-11.629l-82.82-91.446c-3.04-3.356-8.273-3.615-11.629-.576l-30.511 27.633c-3.356 3.04-3.615 8.273-.576 11.629l81.951 90.487-.132.12c3.514 3.909 9.535 4.218 13.43.69z"
  }), React.createElement("path", {
    d: "M776.662 319.395l63.003-69.565c3.039-3.356 2.78-8.589-.576-11.629l-30.511-27.633c-3.356-3.039-8.589-2.78-11.629.576l-61.835 68.276c-63.24-51.963-144.195-83.158-232.449-83.158-202.366 0-366.368 164-366.368 366.367s164.001 366.367 366.367 366.367 366.368-164.001 366.368-366.367c0-93.354-34.902-178.543-92.37-243.234zm-273.997 556.91c-173.221 0-313.677-140.454-313.677-313.676s140.455-313.676 313.676-313.676S816.34 389.408 816.34 562.629 675.886 876.305 502.665 876.305z"
  }));
});

/**
* @file 图标timer-o
* @author zhanglili
*/
var IconTimerO =
/*#__PURE__*/
createIcon('timer-o', SVG$58);

var SVG$59 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M512 570.5c-32.7 0-59.3-26.5-59.3-59.3V215.3c-175.2 10.4-316.2 157.8-316.2 335.4 0 184.2 151.7 336 335.9 336 177.6 0 325-141 335.4-316.2H512zm0-39.6h316.2c10.9 0 19.8 8.8 19.8 19.8 0 206.1-169.4 375.5-375.5 375.5S97 756.8 97 550.7s169.4-375.5 375.5-375.5c10.9 0 19.8 8.8 19.8 19.8v316.2c-.1 10.9 8.8 19.7 19.7 19.7z"
  }), React.createElement("path", {
    d: "M571.3 432.1c0 10.9 8.8 19.8 19.8 19.8h295.8c-4.8-81.9-39.5-159.5-97.8-217.8-58.3-58.3-135.9-93-217.8-97.8v295.8zm-39.5 0V115.9c0-10.9 8.8-19.8 19.8-19.8 99.5 0 195.1 39.6 265.5 110s110 166 110 265.5c0 10.9-8.8 19.8-19.8 19.8H591c-32.7 0-59.2-26.5-59.2-59.3z"
  }));
});

/**
* @file 图标titan
* @author zhanglili
*/
var IconTitan =
/*#__PURE__*/
createIcon('titan', SVG$59);

var SVG$5a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M948.917 53.57v86.573H83.186V53.57h865.731zM516.051 183.43l432.866 420.01H696.989l.996 315.862H335.243V603.44H83.186l432.865-420.01z"
  }));
});

/**
* @file 图标top
* @author zhanglili
*/
var IconTop =
/*#__PURE__*/
createIcon('top', SVG$5a);

var SVG$5b = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "15.167 -16.333 1000.636 1000.678"
  }, props), React.createElement("path", {
    d: "M948.351 51.14v86.573H82.619V51.14h865.732zM515.485 303.616L731.287 513.01H608.144l.278 88.277.718 227.585H422.677V513.009H299.683l215.802-209.393m0-122.616L82.619 601.009h252.058v315.862h362.742l-.996-315.862h251.928L515.485 181z"
  }));
});

/**
* @file 图标top-o
* @author zhanglili
*/
var IconTopO =
/*#__PURE__*/
createIcon('top-o', SVG$5b);

var SVG$5c = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M559.5 149.6c-215.2 0-391.8 170.2-398.2 385.4H64.9l128.5 160.6L321.8 535h-96.3c6.4-179.8 154.1-321.1 334-321.1 186.3 0 337.2 150.9 337.2 337.2s-151 337.1-337.2 337.1v64.2c221.6 0 401.4-179.8 401.4-401.4S781.1 149.6 559.5 149.6z"
  }));
});

/**
* @file 图标undo
* @author zhanglili
*/
var IconUndo =
/*#__PURE__*/
createIcon('undo', SVG$5c);

var SVG$5d = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M859.4 514.1L565.3 220c-3.9-3.9-3.9-10.2 0-14.1l36-36c3.9-3.9 10.2-3.9 14.1 0L952.6 507c3.9 3.9 3.9 10.2 0 14.1L615.4 858.4c-3.9 3.9-10.2 3.9-14.1 0l-36-36c-3.9-3.9-3.9-10.2 0-14.1l294.1-294.2zm-493.8 0L71.4 220c-3.9-3.9-3.9-10.2 0-14.1l36-36c3.9-3.9 10.2-3.9 14.1 0L458.7 507c3.9 3.9 3.9 10.2 0 14.1L121.5 858.4c-3.9 3.9-10.2 3.9-14.1 0l-36-36c-3.9-3.9-3.9-10.2 0-14.1l294.2-294.2z"
  }));
});

/**
* @file 图标unfold
* @author zhanglili
*/
var IconUnfold =
/*#__PURE__*/
createIcon('unfold', SVG$5d);

var SVG$5e = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M706 376.6c139.9 0 254.2 114.4 254.2 254.2C960.2 770.7 845.9 885 706 885c-139.8 0-254.2-114.3-254.2-254.2.1-139.9 114.4-254.2 254.2-254.2zm134.9 167.5l-51.3-51.3L565 717.3l51.4 51.4 224.5-224.6zm-431.5 86.6c0 90.2 40.8 171.3 104.8 225.8H65.7S50.2 752.8 113 707.2c17.7-12.9 38.4-20.2 59.8-26 54.2-14.3 115.4-18.6 158.4-76.5 0 0 22.1-25.6-27.9-88-50.1-62.6-54.3-162-41.6-238.8 12.5-76.8 83.4-128.1 156.9-128.1 73.7 0 144.6 51.2 157 128.2 4.3 26 6.6 54.7 5.9 83.7-101.3 47.2-172.1 150.2-172.1 269z"
  }));
});

/**
* @file 图标unknown-user
* @author zhanglili
*/
var IconUnknownUser =
/*#__PURE__*/
createIcon('unknown-user', SVG$5e);

var SVG$5f = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "1024",
    height: "1024"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h1024v1024H0z"
  }), React.createElement("path", {
    d: "M472.5 132C657.24 132 807 281.76 807 466.5c0 81.178-28.917 155.602-77.013 213.533l156.5 156.5-55.154 55.154L673.525 733.88C617.564 776.02 547.949 801 472.5 801 287.76 801 138 651.24 138 466.5S287.76 132 472.5 132zm0 78C330.839 210 216 324.839 216 466.5S330.839 723 472.5 723 729 608.161 729 466.5 614.161 210 472.5 210z"
  })));
});

/**
* @file 图标unless-test-icon
* @author zhanglili
*/
var IconUnlessTestIcon =
/*#__PURE__*/
createIcon('unless-test-icon', SVG$5f);

var SVG$5g = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513.1 896.5H129.4V128.9h767.5v383.3H960V64H64v896.3h449.1v-63.8z"
  }), React.createElement("path", {
    d: "M255.1 255.7h510.2v64H255.1v-64zm-1.3 192H638v64H253.8v-64zm.4 192h256.1v64H254.2v-64zm431.538 2.65l269.546 269.546-45.254 45.255-269.546-269.547z"
  }), React.createElement("path", {
    d: "M640.527 911.962l269.547-269.546 45.254 45.254-269.546 269.547z"
  }));
});

/**
* @file 图标unset-template
* @author zhanglili
*/
var IconUnsetTemplate =
/*#__PURE__*/
createIcon('unset-template', SVG$5g);

var SVG$5h = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.9 382.4l341.6 379.7c2 2.2 4.8 3.5 7.7 3.5h88.7c8.8 0 13.6-10.4 7.7-17.1L520.3 259.6c-4.1-4.7-11.4-4.7-15.5 0L66.5 748.5c-5.8 6.6-1.1 17.1 7.7 17.1h87.6c3 0 5.8-1.3 7.7-3.5l342.4-379.7z"
  }));
});

/**
* @file 图标up
* @author zhanglili
*/
var IconUp =
/*#__PURE__*/
createIcon('up', SVG$5h);

var SVG$5i = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M862.8 512.2v350.9H157.7V512.2h-96V959c0 5.5 4.5 10 10 10h877c5.5 0 10-4.5 10-10V512.2h-95.9z"
  }), React.createElement("path", {
    d: "M462.8 202.1v555.7c0 5.5 4.5 10 10 10h74.8c5.5 0 10-4.5 10-10V204.4l166.6 166.5c3.9 3.9 10.2 3.9 14.1 0l34.9-34.9c3.9-3.9 3.9-10.2 0-14.1L524.2 73c-7.8-7.8-20.5-7.8-28.3 0L247 321.9c-3.9 3.9-3.9 10.2 0 14.1l33.9 33.9c3.9 3.9 10.2 3.9 14.1 0l167.8-167.8z"
  }));
});

/**
* @file 图标upload
* @author zhanglili
*/
var IconUpload =
/*#__PURE__*/
createIcon('upload', SVG$5i);

var SVG$5j = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M260.8 853.4c-2.2 1.9-3.5 4.7-3.5 7.7v87.6c0 8.8 10.5 13.5 17.1 7.7l488.9-438.3c4.7-4.1 4.7-11.4 0-15.5L274.4 65.3c-6.7-5.9-17.1-1.1-17.1 7.7v88.7c0 2.9 1.3 5.7 3.5 7.7L640.5 511 260.8 853.4z"
  }));
});

/**
* @file 图标up-right
* @author zhanglili
*/
var IconUpRight =
/*#__PURE__*/
createIcon('up-right', SVG$5j);

var SVG$5k = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M956.3 765.7L524.7 334c-7.8-7.8-20.5-7.8-28.3 0L64.8 765.7"
  }));
});

/**
* @file 图标up-solid
* @author zhanglili
*/
var IconUpSolid =
/*#__PURE__*/
createIcon('up-solid', SVG$5k);

var SVG$5l = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M490.688 576c-143.36 0-256-112.64-256-256s112.64-256 256-256 256 112.64 256 256-112.64 256-256 256zm0-64c105.6 0 192-86.4 192-192s-86.4-192-192-192-192 86.4-192 192 86.4 192 192 192z"
  }), React.createElement("path", {
    d: "M511.104 576c-212.48 0-383.936 186.304-383.936 391.104H64C64.256 705.92 268.032 512 511.104 512v64zm401.408 250.368a34.112 34.112 0 0 0 8.512 37.76l8.64 8.064-7.04 9.6c-10.88 14.72-23.68 27.84-38.208 38.848l-9.408 7.168-8.256-8.512a34.048 34.048 0 0 0-58.56 24.896l.448 11.84-11.712 1.792a190.848 190.848 0 0 1-54.528.448l-11.776-1.6.256-11.84a34.112 34.112 0 0 0-59.008-23.808l-8.064 8.64-9.6-7.04a191.616 191.616 0 0 1-38.912-38.144l-7.168-9.472 8.512-8.192a34.112 34.112 0 0 0-24.832-58.624l-11.84.448-1.792-11.712a190.848 190.848 0 0 1-.448-54.528l1.6-11.776 11.84.256a34.112 34.112 0 0 0 23.808-59.008l-8.64-8.064 7.04-9.6c10.88-14.72 23.68-27.84 38.208-38.848l9.408-7.168 8.256 8.512a34.048 34.048 0 0 0 58.56-24.896l-.448-11.84 11.712-1.792c18.048-2.752 36.352-2.88 54.528-.448l11.776 1.6-.256 11.84a34.112 34.112 0 0 0 59.008 23.808l8.064-8.64 9.6 7.04c14.72 10.816 27.776 23.68 38.912 38.144l7.168 9.472-8.512 8.192a34.112 34.112 0 0 0 24.832 58.624l11.84-.448 1.792 11.712c2.752 18.048 2.88 36.352.448 54.528l-1.6 11.776-11.84-.256a34.112 34.112 0 0 0-32.32 21.248zM768 864a96 96 0 1 0 0-192 96 96 0 0 0 0 192z"
  }));
});

/**
* @file 图标user-center
* @author zhanglili
*/
var IconUserCenter =
/*#__PURE__*/
createIcon('user-center', SVG$5l);

var SVG$5m = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M361.8 582.5c7.3-2.7 16.7-5.3 27.1-12.3 15.7-10.1 27.6-30.8-1.5-56.4-95.9-142.5-61-236.6-46.4-272.3-13.4-5.3-27.8-8-42.2-8h-5.2c-92.3 0-116.9 85.6-118.4 134-1.1 113.8 66.7 158.5 66.7 158.5s4.2 5.9 4.2 23.5c0 3.7-2.6 15.9-6.8 19.1C201.2 600 75 632.5 66.1 700.6c-4.7 19.6-2.1 39.9-1 58.5 20.8 16.5 87.1 29.8 87.1 29.8s5.7-17 10.9-45.2c8.4-41.6 63.7-109.1 198.7-161.2zM958 699.6c-8.5-67.5-133.9-99.9-171.6-131.3-4.6-3.7-6.6-15.4-6.6-19.1 0-17.5 4.1-23.4 4.1-23.4s66.9-45.2 65.9-158.3c-2-47.8-30.2-133.9-117.3-133.9h-5c-16.7-.3-33.2 3.2-48.4 10.1 18.6 66.4 41.3 187.6-53.4 268.9-37.2 58.5 86.1 93 67 83.4 111.7 53.1 141.4 94.1 150 136.1 7 35.1 10.6 56.9 10.6 56.9s83.6-13.3 105.2-30.8c1.1-18.8 4.1-39-.5-58.6zM582.7 577.7c-5.3-4.4-8.4-19.8-8.4-24.7 0-22 5.3-29.6 5.3-29.6s86.4-49 84.8-203.4c-2.1-61.5-38.4-171.9-150.7-171.9h-6.3C390.2 148.1 358.6 258 356.5 320c-1.6 145.6 84.9 203.2 84.9 203.2s10.6 12.6 10.6 34.6c0 5-8.5 15.4-13.7 19.8-48 40.1-221.5 80.7-232.5 167.5-9 36.8-60.1 95 110.7 118.7 46.9 6.6 111.3 10.4 197.8 10.4 397 0 314.8-80.2 303.7-127.4-12.3-87.3-187.4-129-235.3-169.1z"
  }));
});

/**
* @file 图标user-group
* @author zhanglili
*/
var IconUserGroup =
/*#__PURE__*/
createIcon('user-group', SVG$5m);

var SVG$5n = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M663.8 434c0-71.5-58-129.5-129.5-129.5s-129.5 58-129.5 129.5c0 57.1 37 105.6 88.3 122.8-75.5 21.1-131.4 98.2-131.4 179.3H707c0-81.1-56-158.2-131.4-179.3 51.2-17.2 88.2-65.7 88.2-122.8zM157.5 293.7h-37.1v-72.9h37.1V64.2l735.3.7c8.1 0 14.7 6.6 14.7 18.1v865.2c0 4.8-6.6 11.4-14.7 11.4H157.5V736.2h-36.7v-73.9h36.7V515h-36.7v-74.9h36.7V293.7zm78.9 592.2l580.2-.8c8.1 0 14.7-6.6 14.7-14.7V154.6c0-8.1-6.6-14.7-14.7-14.6l-580.2-.3v746.2z"
  }));
});

/**
* @file 图标user-info-o
* @author zhanglili
*/
var IconUserInfoO =
/*#__PURE__*/
createIcon('user-info-o', SVG$5n);

var SVG$5o = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M378.4 592c11.4 0 24.1.6 37.7 1.9-66.6 24.9-122 62.9-126.7 114l-.3 7v111.7H65.5v-78.2c0-104 208.4-156.4 312.9-156.4zm268.1 0c104.4 0 312.8 52.4 312.8 156.4v78.2H333.7v-78.2c0-104 208.4-156.4 312.8-156.4zM378.4 201c38.3 0 73.4 13.8 100.6 36.6-34.2 28.7-55.9 71.7-55.9 119.8s21.7 91.2 55.9 119.8c-27.2 22.8-62.2 36.6-100.6 36.6-86.4 0-156.4-70-156.4-156.4S291.9 201 378.4 201zm268.1 0c86.4 0 156.4 70 156.4 156.4s-70 156.4-156.4 156.4-156.4-70-156.4-156.4S560.1 201 646.5 201z"
  }));
});

/**
* @file 图标users
* @author zhanglili
*/
var IconUsers =
/*#__PURE__*/
createIcon('users', SVG$5o);

var SVG$5p = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M511.3 512c-115 0-208.1-93.1-208.1-208.1s93-208.2 208.1-208.2 208.1 93.1 208.1 208.1S626.3 512 511.3 512zm0 104c138.9 0 416.3 69.7 416.3 208.1v104.1H95v-104C95 685.8 372.4 616 511.3 616z"
  }));
});

/**
* @file 图标user-solid
* @author zhanglili
*/
var IconUserSolid =
/*#__PURE__*/
createIcon('user-solid', SVG$5p);

var SVG$5q = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M433.2 211.7l68.9-68.9v738.1L433.2 812h527.2l-68.9 68.9V142.8l68.9 68.9H433.2zm527.2-58.9v718.1c0 5.5-4.5 10-10 10H443.2c-5.5 0-10-4.5-10-10V152.8c0-5.5 4.5-10 10-10h507.2c5.5 0 10 4.5 10 10zm-886.3-10h296.3c5.5 0 10 4.5 10 10v85.4c0 5.5-4.5 10-10 10H74.1c-5.5 0-10-4.5-10-10v-85.4c0-5.5 4.5-10 10-10zm0 210.9h296.3c5.5 0 10 4.5 10 10v85.4c0 5.5-4.5 10-10 10H74.1c-5.5 0-10-4.5-10-10v-85.4c0-5.5 4.5-10 10-10zm0 210.8h296.3c5.5 0 10 4.5 10 10V660c0 5.5-4.5 10-10 10H74.1c-5.5 0-10-4.5-10-10v-85.5c0-5.5 4.5-10 10-10zm0 210.9h296.3c5.5 0 10 4.5 10 10v85.4c0 5.5-4.5 10-10 10H74.1c-5.5 0-10-4.5-10-10v-85.4c0-5.5 4.5-10 10-10z"
  }));
});

/**
* @file 图标viewlist
* @author zhanglili
*/
var IconViewlist =
/*#__PURE__*/
createIcon('viewlist', SVG$5q);

var SVG$5r = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513.3 62.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5 383.5 171.7 383.5 383.5c0 211.9-171.7 383.5-383.5 383.5z"
  }), React.createElement("path", {
    d: "M371.5 605.2c3.1-3.2 3.7-8 1.5-11.9-35.4-61.2-26.9-140.7 25.4-193.1 52.3-52.3 134.4-63.4 195.7-28.3 3.9 2.2 8.8 1.6 12-1.6l32.4-32.4c4.5-4.5 3.7-11.9-1.5-15.4-87.3-57.8-208.5-45.7-285.3 31.1-76.5 76.5-85.4 195.2-28.3 282.1 3.8 5.8 12.1 6.7 17 1.8l31.1-32.3zm281.2-189.5c-3.2 3.2-3.9 8.3-1.5 12.2 36.9 61.7 26.3 145.3-26.7 198.4-53.1 53.1-131.5 58.4-192.8 21.1-3.9-2.4-9-1.8-12.2 1.5l-31.8 31.8c-4.4 4.4-3.8 11.9 1.4 15.3 86.9 58 202.8 51.2 279.5-25.5s88.8-197.8 31.2-285.1c-3.5-5.3-10.9-6-15.4-1.5l-31.7 31.8z"
  }));
});

/**
* @file 图标waiting-circle-o
* @author zhanglili
*/
var IconWaitingCircleO =
/*#__PURE__*/
createIcon('waiting-circle-o', SVG$5r);

var SVG$5s = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M513.3 62.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zM371.5 605.2l-31.1 32.3c-4.9 4.9-13.2 4-17-1.8-57.1-86.9-48.2-205.6 28.3-282.1 76.8-76.8 198-88.9 285.3-31.1 5.2 3.5 6 10.9 1.5 15.4l-32.4 32.4c-3.2 3.2-8.1 3.8-12 1.6-61.3-35.1-143.4-24-195.7 28.3-52.3 52.4-60.8 131.9-25.4 193.1 2.2 3.9 1.6 8.7-1.5 11.9zm297.1 65.3C591.9 747.2 476 754 389.1 696c-5.2-3.4-5.8-10.9-1.4-15.3l31.8-31.8c3.2-3.3 8.3-3.9 12.2-1.5 61.3 37.3 139.7 32 192.8-21.1 53-53.1 63.6-136.7 26.7-198.4-2.4-3.9-1.7-9 1.5-12.2l31.7-31.8c4.5-4.5 11.9-3.8 15.4 1.5 57.6 87.3 45.5 208.4-31.2 285.1z"
  }));
});

/**
* @file 图标waiting-solid
* @author zhanglili
*/
var IconWaitingSolid =
/*#__PURE__*/
createIcon('waiting-solid', SVG$5s);

var SVG$5t = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "20",
    height: "20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.73 14.139h1.589v-1.505H8.73v1.505zm-.007-2.2h1.587V6.845H8.723v5.094zM9.5 5.011a5.475 5.475 0 1 0 0 10.949 5.475 5.475 0 0 0 0-10.95zM16 10.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
  }));
});

/**
* @file 图标warn
* @author zhanglili
*/
var IconWarn =
/*#__PURE__*/
createIcon('warn', SVG$5t);

var SVG$5u = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M535.8 755.2h-45.5c-5.5 0-10-4.5-10-10v-61.5c0-5.5 4.5-10 10-10h45.5c5.5 0 10 4.5 10 10v61.5c0 5.5-4.5 10-10 10zm0-132.1h-44.5c-5.5 0-10-4.5-10-10V470.2c0-5.5 4.5-10 10-10h44.5c5.5 0 10 4.5 10 10v142.9c0 5.5-4.5 10-10 10z"
  }), React.createElement("path", {
    d: "M504.3 142.4L73.7 886.3c-3.9 6.7 1 15 8.7 15h861.3c7.7 0 12.5-8.3 8.7-15L521.7 142.4c-3.9-6.6-13.5-6.6-17.4 0zm8.7 104.7l347.4 593.8H171.8L513 247.1z"
  }));
});

/**
* @file 图标warning-o
* @author zhanglili
*/
var IconWarningO =
/*#__PURE__*/
createIcon('warning-o', SVG$5u);

var SVG$5v = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M951.3 883.3L520.7 139.4c-3.9-6.7-13.5-6.7-17.3 0L72.7 883.3c-3.9 6.7 1 15 8.7 15h861.3c7.7 0 12.5-8.3 8.6-15zM544.8 742.2c0 5.5-4.5 10-10 10h-45.5c-5.5 0-10-4.5-10-10v-61.5c0-5.5 4.5-10 10-10h45.5c5.5 0 10 4.5 10 10v61.5zm0-132.1c0 5.5-4.5 10-10 10h-44.5c-5.5 0-10-4.5-10-10V467.2c0-5.5 4.5-10 10-10h44.5c5.5 0 10 4.5 10 10v142.9z"
  }));
});

/**
* @file 图标warning-solid
* @author zhanglili
*/
var IconWarningSolid =
/*#__PURE__*/
createIcon('warning-solid', SVG$5v);

var SVG$5w = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 200"
  }, props), React.createElement("path", {
    d: "M94.4 93.7H19.8V19.1h74.6v74.6zm-59.6-15h44.6V34.1H34.8v44.6zm109.1 14.1l-37.2-37.2 37.2-37.2 37.2 37.2-37.2 37.2zM128 55.6l15.9 15.9 15.9-15.9-15.9-15.9L128 55.6zM94.4 180.9H19.8v-74.6h74.6v74.6zm-59.6-15h44.6v-44.6H34.8v44.6zm145.9 15h-74.6v-74.6h74.6v74.6zm-59.6-15h44.6v-44.6h-44.6v44.6z"
  }));
});

/**
* @file 图标window-tro
* @author zhanglili
*/
var IconWindowTRO =
/*#__PURE__*/
createIcon('window-tro', SVG$5w);

var SVG$5x = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M881.3 341.1L610.1 66.5c-1.9-1.9-4.4-3-7.1-3H143.4l-.4 884.2c0 5.5 4.5 10 10 10h721.4c5.5 0 10-4.5 10-10l-.2-599.6c0-2.6-1-5.1-2.9-7zM571.7 139.3L812 379.6l.2 502.3H216.4l.5-742.6"
  }), React.createElement("path", {
    d: "M297.5 654.8h440.1c5.5 0 10 4.5 10 10v73.5c0 5.5-4.5 10-10 10H297.5c-5.5 0-10-4.5-10-10v-73.5c0-5.5 4.5-10 10-10zm0-187.1h440.1c5.5 0 10 4.5 10 10v73.5c0 5.5-4.5 10-10 10H297.5c-5.5 0-10-4.5-10-10v-73.5c0-5.5 4.5-10 10-10zm243.2-284.9l218.1 216.9H540.7V182.8z"
  }));
});

/**
* @file 图标word-o
* @author zhanglili
*/
var IconWordO =
/*#__PURE__*/
createIcon('word-o', SVG$5x);

var SVG$5y = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M137.9 74.2l-.5 875.3c0 5.5 4.5 10 10 10h729.4c5.5 0 10-4.5 10-10.1l-3.6-600.3c0-2.6-1.1-5.2-2.9-7l-275.1-275c-1.9-1.9-4.4-2.9-7.1-2.9H147.9c-5.5 0-10 4.5-10 10zm108.6 665.6v-73.6c0-5.5 4.5-10 10-10h511.8c5.5 0 10 4.5 10 10v73.6c0 5.5-4.5 10-10 10H256.5c-5.5 0-10-4.5-10-10zm531.8-177.2H256.5c-5.5 0-10-4.5-10-10V479c0-5.5 4.5-10 10-10h511.8c5.5 0 10 4.5 10 10v83.6zm-207.1-443l257.5 257.5H571.2V119.6z"
  }));
});

/**
* @file 图标word-solid
* @author zhanglili
*/
var IconWordSolid =
/*#__PURE__*/
createIcon('word-solid', SVG$5y);

var SVG$5z = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    "data-name": "\u56FE\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    d: "M780.61 327.25H496a35.38 35.38 0 0 0 0 70.75h284.61a35.38 35.38 0 0 0 0-70.77zm0 171.88H544.28a35.38 35.38 0 1 0 0 70.77H780.6a35.38 35.38 0 0 0 0-70.77zm0 0"
  }), React.createElement("path", {
    d: "M963.06 272A106.27 106.27 0 0 0 856.9 165.8H388A106.28 106.28 0 0 0 281.82 272v26c-76.2 16.88-133.56 86.93-133.56 170.68a176 176 0 0 0 58.34 130.87C124.25 640.9 67 725.82 67 824.72a35.38 35.38 0 0 0 70.77 0c0-100 80.3-181.34 179.08-181.52h.67c98.78.19 179.08 81.49 179.08 181.52A35.36 35.36 0 0 0 532 860.1c.73 0 1.34-.37 2.06-.41s1.33.41 2.05.41h229.22a35.38 35.38 0 0 0 0-70.77h-89.78V732H856.9a106.27 106.27 0 0 0 106.16-106.19V341.74m-70.77 0v284.07a35.45 35.45 0 0 1-35.39 35.39H506.15a250.34 250.34 0 0 0-78.35-61.65 176 176 0 0 0 58.35-130.93c0-83.75-57.36-153.8-133.57-170.69V272A35.41 35.41 0 0 1 388 236.57h468.9A35.43 35.43 0 0 1 892.29 272m-287.5 460v57.37h-40.95c-2.8-19.93-7.33-39.21-14.49-57.37zM415.38 468.61c0 57.11-43.76 103.53-97.67 103.82-.17 0-.33-.05-.5-.05s-.33.05-.5.05c-53.92-.28-97.71-46.71-97.71-103.82 0-57.29 44-103.91 98.17-103.91s98.17 46.62 98.17 103.91zm0 0"
  }));
});

/**
* @file 图标workplace
* @author zhanglili
*/
var IconWorkplace =
/*#__PURE__*/
createIcon('workplace', SVG$5z);

export { IconAGroup, IconAIassemblylineo, IconAPI, IconAdaptiveWidth, IconAdd, IconAddBranch, IconAddCircleO, IconAddCircleSolid, IconAddCommentSolid, IconAddFolderSolid, IconAddGroup, IconAddSolid, IconAdmin, IconAdminCircleO, IconAdminCircleSolid, IconAgilePipelineLeft, IconAngleDownCircleO, IconAngleLeftCircleO, IconAngleRightCircleO, IconAngleUpCircleO, IconApplication, IconArrowCollapse, IconArrowDown, IconArrowLeft, IconArrowRight, IconArrowUp, IconArrowUpSolid, IconArrowWideUp, IconArticle, IconAttentionSolid, IconAutomatic, IconBackoff, IconBasket, IconBatch, IconBlock, IconBoardDash, IconBookO, IconBox, IconBranch, IconBranchCreate, IconBreakLine, IconBreakLink, IconBugSolid, IconCCOS, IconCI, IconCOS, IconCalendarO, IconCancelO, IconCancelSolid, IconCard, IconCardShow, IconCardZoom, IconCase, IconCategory, IconCentralizedassemblylineo, IconCheckSolid, IconCheckboxO, IconCheckboxSolid, IconCircleO, IconCircleSolid, IconCleanFormat, IconClip, IconClipAlt, IconClose, IconCloseCircleO, IconCloseCircleSolid, IconCloudDownload, IconCloudIDE, IconCode, IconCollapseAll, IconCollection, IconCollectionO, IconCollectionSolid, IconCommentAlt, IconCommentO, IconCommentSolid, IconCommentsO, IconCommentsSolid, IconCommit, IconCompress, IconContents, IconCopy, IconCopySolid, IconCubeO, IconCycle, IconCycleCircleO, IconCycleCircleSolid, IconDA, IconDASearch, IconDailyActiveUser, IconDailyAverageAdjustment, IconDarkMode, IconDashAGroup, IconDashCardZoom, IconDashCode, IconDashComments, IconDashDA, IconDashDashboard, IconDashDocument, IconDashListLevel, IconDashPipeline, IconDashPlan, IconDashPlantrack, IconDashSearch, IconDashStoryMapping, IconDashWheel, IconDashWorkplace, IconDashboardO, IconDelete, IconDependency, IconDependent, IconDeploy, IconDeployO, IconDepotDeploy, IconDevProfile, IconDevelopmentEcology, IconDiscussionSolid, IconDistribution, IconDocO, IconDocumentO, IconDown, IconDownSolid, IconDownload, IconDrag, IconDualPaperO, IconDualPaperSolid, IconENS, IconEarth, IconEdition, IconEditorP, IconEffectiveness, IconEllipsisSolid, IconEllipsisSolidSlim, IconEnlargeArrow, IconEnlargeGlass, IconEnter, IconExclamation, IconExitFullscreen, IconExpandAll, IconExpandCode, IconExport, IconEyeIgnore, IconEyeOpen, IconFailCircleO, IconFailCircleSolid, IconFarseer, IconFeedbackSolid, IconFile, IconFileTree, IconFilterDash, IconFilterO, IconFilterSolid, IconFolderDash, IconFolderO, IconFolderSolid, IconForward, IconFullscreen, IconFullscreenDash, IconGearO, IconGroupExpansion, IconGroupPrint, IconGroupRetract, IconGroupingSolid, IconHandUpO, IconHeadphone, IconHelp, IconHelpDash, IconHelpO, IconHelpTitle, IconHi, IconHiLogo, IconHistory, IconHome, IconHorn, IconHornCircleO, IconHornCircleSolid, IconICafe, IconICafeCircleO, IconICafeWord, IconICodeCompare, IconICodeTag, IconICodeWord, IconIDE, IconIDEClient, IconIP, IconIPipe, IconIPipeWord, IconIRepo, IconIcodeRepoAdd, IconInfoCircleO, IconInfoCircleSolid, IconInformation, IconIssueO, IconKey, IconLeft, IconLeftSolid, IconLetterDifference, IconLightMode, IconLimitDownload, IconLink, IconLinkBlank, IconList, IconListHeader, IconListLevel, IconLoading, IconLoadingCircleSolid, IconLoadingQuarterCircleSolid, IconLockCloseSolid, IconM, IconMailO, IconMailSolid, IconManager, IconManifest, IconMap, IconMathAverage, IconMathCount, IconMathMax, IconMathMin, IconMathSum, IconMedalO, IconMerge, IconMergeRequest, IconMesh, IconMessage, IconMessageDash, IconMessageO, IconMinusSquare, IconModeSwitc, IconModeSwitch, IconMonthlyReport, IconMore, IconMyPublish, IconNPS, IconNewICafe, IconNewsSolid, IconNewsSolidO, IconNineDots, IconNotDownload, IconNotice, IconNoticeO, IconNoticeSolid, IconNumberOfAccessProducts, IconObjective, IconOneToOneMapping, IconOpenBox, IconOpenFolderDash, IconOpenFolderO, IconOpenSource, IconOsO, IconOsSolid, IconPauseO, IconPenCircleO, IconPenCircleSolid, IconPenSolid, IconPenSolidO, IconPenWithPaperO, IconPhase, IconPilotight, IconPin, IconPipeline, IconPlantrack, IconPlay, IconPlayCircleO, IconPlayCircleSolid, IconPluginList, IconPluginMarket, IconPluginMarketBold, IconPlusSquare, IconPrint, IconProcessSolid, IconProhibitCircleO, IconProhibitCircleSolid, IconProjectlist, IconPublish, IconQuestionMark, IconQuestionMarkCircleO, IconQuestionMarkCircleSolid, IconQuestionMarkSquare, IconRefresh, IconReplay, IconRepository, IconRetract, IconReviewer, IconRight, IconRightSolid, IconRisk, IconRuliu, IconSDownSolid, IconSLATargetValue, IconSUpSolid, IconSearch, IconSetTemplate, IconSettingAlt, IconShare, IconShareTo, IconShareToHi, IconShareToRuliu, IconShrinkArrow, IconShrinkGlass, IconShutdown, IconShutup, IconSkip, IconSkiped, IconStandard, IconStarDash, IconStarFilled, IconStarO, IconStarOutlined, IconStarSolid, IconStaticCircleO, IconStoryMapping, IconStretch, IconSuccessCircleO, IconSuccessSolid, IconSwap, IconTag, IconTagO, IconTarget, IconTask, IconTaskSolid, IconTechnologicalProcess, IconText, IconThumbdownO, IconThumbdownSolid, IconThumbupO, IconThumbupSolid, IconTimeCircleO, IconTimeCircleSolid, IconTimerO, IconTitan, IconTop, IconTopO, IconUndo, IconUnfold, IconUnknownUser, IconUnlessTestIcon, IconUnsetTemplate, IconUp, IconUpRight, IconUpSolid, IconUpload, IconUserCenter, IconUserGroup, IconUserInfoO, IconUserSolid, IconUsers, IconViewlist, IconWaitingCircleO, IconWaitingSolid, IconWarn, IconWarningO, IconWarningSolid, IconWindowTRO, IconWordO, IconWordSolid, IconWorkplace };
//# sourceMappingURL=index.js.map
